import { Component} from "@wordpress/element";
import { __ } from "@wordpress/i18n";
import { withSelect } from "@wordpress/data";
import { isBlobURL } from "@wordpress/blob";
import { PanelBody, BaseControl, ColorPicker, FontSizePicker, RangeControl, TextControl, SelectControl, Button, ButtonGroup, Tooltip, TextareaControl, ToggleControl, TabPanel, MenuItem, Notice, RadioControl, ColorIndicator, Panel, Spinner} from "@wordpress/components";
import { __experimentalGetSettings } from '@wordpress/date';
import {__experimentalPanelColorGradientSettings as PanelColorGradientSettings, __experimentalColorGradientControl as ColorGradientControl,RichText, InspectorControls, MediaPlaceholder, PanelColorSettings, InnerBlocks, ColorPaletteControl} from '@wordpress/block-editor';

// Font Family
const bubiOptionsFont=[
    {label: __('Anton','bubiblock-slider'), value: 'Anton'+',sans-serif'},
    {label: __('IBM Plex Sans','bubiblock-slider'), value: 'IBM Plex Sans'+',sans-serif'},
    {label: __('Inconsolata','bubiblock-slider'), value: 'Inconsolata'+',monospace'},
    {label: __('Montserrat','bubiblock-slider'), value: 'Montserrat'+',sans-serif'},
    {label: __('Orbitron','bubiblock-slider'), value: 'Orbitron'+',sans-serif'},
    {label: __('Oxygen','bubiblock-slider'), value: 'Oxygen'+',sans-serif'},
 ]

const bubiOptionsWeight=[
    {label: __('100','bubiblock-slider'), value: '100'},
    {label: __('200','bubiblock-slider'), value: '200'},
    {label: __('300','bubiblock-slider'), value: '300'},
    {label: __('400','bubiblock-slider'), value: '400'},
    {label: __('500','bubiblock-slider'), value: '500'},
    {label: __('600','bubiblock-slider'), value: '600'},
    {label: __('700','bubiblock-slider'), value: '700'},
    {label: __('800','bubiblock-slider'), value: '800'},
    {label: __('900','bubiblock-slider'), value: '900'},
]

// Effect Slider
const bubiOptionsEffectAnimate=[
    {label: __('No Effect','bubiblock-slider'), value: 'df-no-effect'},
    {label: __('Bounce','bubiblock-slider'), value: 'animate__bounce'},
    {label: __('Swing','bubiblock-slider'), value: 'animate__swing'},
    {label: __('Tada','bubiblock-slider'), value: 'animate__tada'},
    {label: __('Fade In','bubiblock-slider'), value: 'animate__fadeIn'},
    {label: __('Fade In Down','bubiblock-slider'), value: 'animate__fadeInDown'},
    {label: __('Fade In Left','bubiblock-slider'), value: 'animate__fadeInLeft'},
    {label: __('Fade In Right','bubiblock-slider'), value: 'animate__fadeInRight'},
    {label: __('Fade In Up','bubiblock-slider'), value: 'animate__fadeInUp'},
    {label: __('Fade Out','bubiblock-slider'), value: 'animate__fadeOut'},
    {label: __('Flip In X','bubiblock-slider'), value: 'animate__flipInX'},
    {label: __('Rotate In','bubiblock-slider'), value: 'animate__rotateIn'},
    {label: __('Zoom In','bubiblock-slider'), value: 'animate__zoomIn'},
    {label: __('Zoom In Down','bubiblock-slider'), value: 'animate__zoomInDown'},
    {label: __('Zoom In Left','bubiblock-slider'), value: 'animate__zoomInLeft'},
    {label: __('Zoom In Right','bubiblock-slider'), value: 'animate__zoomInRight'},
    {label: __('Zoom In Up','bubiblock-slider'), value: 'animate__zoomInUp'},
    {label: __('Slide In Down','bubiblock-slider'), value: 'animate__slideInDown'},
    {label: __('Slide In Left','bubiblock-slider'), value: 'animate__slideInLeft'},
    {label: __('Slide In Right','bubiblock-slider'), value: 'animate__slideInRight'},
    {label: __('Slide In Up','bubiblock-slider'), value: 'animate__slideInUp'},
]

const bubiOptionEffectSpeed= [
    {label: __('Fast','bubiblock-slider'), value: 'animate__fast'},
    {label: __('Slow','bubiblock-slider'), value: 'animate__slow'},
    {label: __('Slower','bubiblock-slider'), value: 'animate__slower'},
]

const bubiOptionEffectDalay =[
    {label: __('None','bubiblock-slider'), value: 'animate__delay-0s'},
    {label: __('One second','bubiblock-slider'), value: 'animate__delay-1s'},
    {label: __('Four seconds','bubiblock-slider'), value: 'animate__delay-4s'},
]

const bubiOptionEffectRepeat =[
    {label: __('Repeat 1','bubiblock-slider'), value: 'animate__repeat-1'},
    {label: __('Repeat 2','bubiblock-slider'), value: 'animate__repeat-2'},
]

// Custom color palette
const bubiColors = [
    { name: __('purple','bubiblock-slider'), color: '#8321D2' },
    { name: __('turquoise','bubiblock-slider'), color: '#6FE1DA' },
    { name: __('yellow','bubiblock-slider'), color: '#fbe901' },
    { name: __('pink','bubiblock-slider'), color: '#f0b9ff' },
    { name: __('black','bubiblock-slider'), color: '#000' },
    { name: __('white','bubiblock-slider'), color: '#fff' },
];

// Custom color gradient
const bubiGradients=[
    {
        name: __('Aqua Spray','bubiblock-slider'),
        gradient:
            'linear-gradient(90deg, #00d2ff 0%, #3a47d5 100%)',
        slug: 'aqua-spray',
    },
    {
        name: __('Shady Lane','bubiblock-slider'),
        gradient:
            'linear-gradient(90deg, #3F2B96 0%, #A8C0FF 100%)',
        slug: 'shady-lane',
    },
    {
        name: __('Disco Club','bubiblock-slider'),
        gradient:
            'linear-gradient(90deg, #FC466B 0%, #3F5EFB 100%)',
        slug: 'disco-club',
    },
    {
        name: __('Kale Salad','bubiblock-slider'),
        gradient:
            'linear-gradient(90deg, #00C9FF 0%, #92FE9D 100%)',
        slug: 'kale-salad',
    },
    {
        name: __('Bloody Mimosa','bubiblock-slider'),
        gradient:
            'linear-gradient(90deg, #d53369 0%, #daae51 100%)',
        slug: 'bloody-mimosa',
    },
    {
        name: __('Mello Yellow','bubiblock-slider'),
        gradient:
            'linear-gradient(90deg, #f8ff00 0%, #3ad59f 100%)',
        slug: 'mello-yellow',
    },
];

class SliderEdit extends Component {

    state = {
        selectedLink: null
    }

    // General Settings
    onChangeBubiblcok_fontfamily = (bubiblcok_fontfamily) => {
        this.props.setAttributes({bubiblcok_fontfamily})
    }

    onChangeBubiblcok_fontfamily_weight = (bubiblcok_fontfamily_weight) => {
        this.props.setAttributes({bubiblcok_fontfamily_weight})
    }

    onChangeBubiblcok_fontfamily_descritpion = (bubiblcok_fontfamily_descritpion) => {
        this.props.setAttributes({bubiblcok_fontfamily_descritpion})
    }

    onChangeBubiblcok_fontfamily_weight_description = (bubiblcok_fontfamily_weight_description) => {
        this.props.setAttributes({bubiblcok_fontfamily_weight_description})
    }

    onChangeBubiblcok_fontfamily_button = (bubiblcok_fontfamily_button) => {
        this.props.setAttributes({bubiblcok_fontfamily_button})
    }

    onChangeBubiblcok_fontfamily_weight_button = (bubiblcok_fontfamily_weight_button) => {
        this.props.setAttributes({bubiblcok_fontfamily_weight_button})
    }

    onChangeHeight_slider = (height_slider) => {
        this.props.setAttributes({height_slider})
    }

    onChangeDf_height_slider_auto = (df_height_slider_auto) => {
        this.props.setAttributes({df_height_slider_auto})
    }

    onChangeHeight_slider_table = (height_slider_table) => {
        this.props.setAttributes({height_slider_table})
    }

    onChangeHeight_slider_mobile = (height_slider_mobile) => {
        this.props.setAttributes({height_slider_mobile})
    }

    onChangeBubiblock_full_slider = (bubiblock_full_slider) => {
        this.props.setAttributes({bubiblock_full_slider})
    }

    onChangeBubiblock_padding_slider = (bubiblock_padding_slider) => {
        this.props.setAttributes({bubiblock_padding_slider})
    }

    onChangeBubiblock_padding_b_slider = (bubiblock_padding_b_slider) => {
        this.props.setAttributes({bubiblock_padding_b_slider})
    }

    onChangeBubiblock_padding_slider_table = (bubiblock_padding_block_slider_table) => {
        this.props.setAttributes({bubiblock_padding_block_slider_table})
    }

    onChangeBubiblock_padding_b_slider_table = (bubiblock_padding_b_block_slider_table) => {
        this.props.setAttributes({bubiblock_padding_b_block_slider_table})
    }

    onChangeBubiblock_padding_block_slider_mobile = (bubiblock_padding_block_slider_mobile) => {
        this.props.setAttributes({bubiblock_padding_block_slider_mobile})
    }

    onChangeBubiblock_padding_b_block_slider_mobile = (bubiblock_padding_b_block_slider_mobile) => {
        this.props.setAttributes({bubiblock_padding_b_block_slider_mobile})
    }

    onChangeBubiblock_radius_slider = (bubiblock_radius_slider) => {
        this.props.setAttributes({bubiblock_radius_slider})
    }

    onChangeBubiblock_carousle_touch = ( bubiblock_carousle_touch) => {
        this.props.setAttributes({ bubiblock_carousle_touch})
    }

    onChangeBubiblock_padding_block_slider = ( bubiblock_padding_block_slider) => {
        this.props.setAttributes({ bubiblock_padding_block_slider})
    }

    onChangeBubiblock_padding_b_block_slider = ( bubiblock_padding_b_block_slider) => {
        this.props.setAttributes({ bubiblock_padding_b_block_slider})
    }

    onChangeBubiopacityblock_slider = ( bubiopacityblock_slider) => {
        this.props.setAttributes({ bubiopacityblock_slider})
    }

    onChangeDf_arrow_slider_type = (df_arrow_slider_type) => {
        this.props.setAttributes({df_arrow_slider_type})
    }

    onChangeDf_size_arrow = (df_size_arrow) => {
        this.props.setAttributes({df_size_arrow})
    }

    onChangeDf_size_arrow_table = (df_size_arrow_table) => {
        this.props.setAttributes({df_size_arrow_table})
    }

    onChangeDf_size_arrow_mobile = (df_size_arrow_mobile) => {
        this.props.setAttributes({df_size_arrow_mobile})
    }

    onChangeBubi_marginarrow = (bubi_marginarrow) => {
        this.props.setAttributes({bubi_marginarrow})
    }

    onChangeBubiopacityarrow = (bubiopacityarrow) => {
        this.props.setAttributes({bubiopacityarrow})
    }

    onChangeBubiopacityhoverarrow = (bubiopacityhoverarrow) => {
        this.props.setAttributes({bubiopacityhoverarrow})
    }

    onChangeDf_dot_slider_type = (df_dot_slider_type) => {
        this.props.setAttributes({df_dot_slider_type})
    }

    onChangeDf_width_dot = (df_width_dot) => {
        this.props.setAttributes({df_width_dot})
    }

    onChangeDf_height_dot = (df_height_dot) => {
        this.props.setAttributes({df_height_dot})
    }

    onChangeBubiblock_height_dot_active = (bubiblock_height_dot_active) => {
        this.props.setAttributes({bubiblock_height_dot_active})
    }

    onChangeDf_bottom_dot = (df_bottom_dot) => {
        this.props.setAttributes({df_bottom_dot})
    }

    componentDidMount() {
        const { attributes, setAttributes } = this.props;
        const { url, id } = attributes;
        if(url && isBlobURL(url) && !id) {
            setAttributes({
                url: '',
                alt: ''
            })
        }
    }
    // Slider 1
    onSelectImage = ({id, url, alt}) => {
        this.props.setAttributes({
            id, url, alt
        })
    }
    onSelectURL = (url) => {
        this.props.setAttributes({
            url,
            id: null,
            alt: ''
        })
    }
    onUploadError = (message) => {
        const { noticeOperations } = this.props;
        noticeOperations.createErrorNotice( message );
    }
    removeImage = () => {
        this.props.setAttributes({
            id: null,
            url: '',
            alt: ''
        })
    }
    updateAlt = (alt) => {
        this.props.setAttributes({
            alt
        })
    }

    onChangeDf_cover_img1 = (df_cover_img1) => {
        this.props.setAttributes({df_cover_img1})
    }

    onChangeDf_focalPoint_img_1 = (df_focalPoint_img_1) => {
        this.props.setAttributes({df_focalPoint_img_1})
    }

    onChangeDf_focalPoint_y_img_1 = (df_focalPoint_y_img_1) => {
        this.props.setAttributes({df_focalPoint_y_img_1})
    }

    onChangeDf_mask_slider_1 = (df_mask_slider_1) => {
        this.props.setAttributes({df_mask_slider_1})
    }

    onChangeDf_opacity_mask_1 = (df_opacity_mask_1) => {
        this.props.setAttributes({df_opacity_mask_1})
    }

    onChangeEffectcaption1 = (effectcaption1) => {
        this.props.setAttributes({effectcaption1})
    }

    onChangeDf_speed_effectcaption1 = ( df_speed_effectcaption1) => {
        this.props.setAttributes({ df_speed_effectcaption1})
    }

    onChangeDf_delay_effectcaption1 = ( df_delay_effectcaption1) => {
        this.props.setAttributes({ df_delay_effectcaption1})
    }

    onChangeDf_repeat_effectcaption1 = ( df_repeat_effectcaption1) => {
        this.props.setAttributes({ df_repeat_effectcaption1})
    }

    onChangeEffectinfo1 = (effectinfo1) => {
        this.props.setAttributes({effectinfo1})
    }

    onChangeDf_speed_effectinfo1 = ( df_speed_effectinfo1) => {
        this.props.setAttributes({ df_speed_effectinfo1})
    }

    onChangeDf_delay_effectinfo1 = ( df_delay_effectinfo1) => {
        this.props.setAttributes({ df_delay_effectinfo1})
    }

    onChangeDf_repeat_effectinfo1 = ( df_repeat_effectinfo1) => {
        this.props.setAttributes({ df_repeat_effectinfo1})
    }

    onChangeEffectbutton1 = (effectbutton1) => {
        this.props.setAttributes({effectbutton1})
    }

    onChangeDf_speed_effectbutton1 = ( df_speed_effectbutton1) => {
        this.props.setAttributes({ df_speed_effectbutton1})
    }

    onChangeDf_delay_effectbutton1 = ( df_delay_effectbutton1) => {
        this.props.setAttributes({ df_delay_effectbutton1})
    }

    onChangeDf_repeat_effectbutton1 = ( df_repeat_effectbutton1) => {
        this.props.setAttributes({ df_repeat_effectbutton1})
    }

    onChangeMargin_bottom_caption1 = (margin_bottom_caption1) => {
        this.props.setAttributes({margin_bottom_caption1})
    }

    onChangeMargin_bottom_table_caption1 = (margin_bottom_table_caption1) => {
        this.props.setAttributes({margin_bottom_table_caption1})
    }

    onChangeMargin_bottom_mobile_caption1 = (margin_bottom_mobile_caption1) => {
        this.props.setAttributes({margin_bottom_mobile_caption1})
    }

    onChangeMargin_bottom_info1 = (margin_bottom_info1) => {
        this.props.setAttributes({margin_bottom_info1})
    }

    onChangeMargin_bottom_table_info1 = (margin_bottom_table_info1) => {
        this.props.setAttributes({margin_bottom_table_info1})
    }

    onChangeMargin_bottom_mobile_info1 = (margin_bottom_mobile_info1) => {
        this.props.setAttributes({margin_bottom_mobile_info1})
    }

    onChangeMargin_bottom_button1 = (margin_bottom_button1) => {
        this.props.setAttributes({margin_bottom_button1})
    }

    onChangeMargin_bottom_table_button1 = (margin_bottom_table_button1) => {
        this.props.setAttributes({margin_bottom_table_button1})
    }

    onChangeMargin_bottom_mobile_button1 = (margin_bottom_mobile_button1) => {
        this.props.setAttributes({margin_bottom_mobile_button1})
    }

    onChangeTitle1 = (title1) => {
        this.props.setAttributes({title1})
    }

    onChangeInfo1 = (info1) => {
        this.props.setAttributes({info1})
    }

    onChangeButton1 = (button1) => {
        this.props.setAttributes({button1})
    }

    onChangeFontsizetitle1 = (fontsizetitle1) => {
        this.props.setAttributes({fontsizetitle1})
    }

    onChangeFontsizetitle1table = (fontsizetitle1table) => {
        this.props.setAttributes({fontsizetitle1table})
    }

    onChangeFontsizetitle1mobile = (fontsizetitle1mobile) => {
        this.props.setAttributes({fontsizetitle1mobile})
    }

    onChangeFontsizeinfo1 = (fontsizeinfo1) => {
        this.props.setAttributes({fontsizeinfo1})
    }

    onChangeFontsizeinfo1table = (fontsizeinfo1table) => {
        this.props.setAttributes({fontsizeinfo1table})
    }

    onChangeFontsizeinfo1mobile = (fontsizeinfo1mobile) => {
        this.props.setAttributes({fontsizeinfo1mobile})
    }

    onChangeFontsizebutton1 = (fontsizebutton1) => {
        this.props.setAttributes({fontsizebutton1})
    }

    onChangeFontsizebutton1table = (fontsizebutton1table) => {
        this.props.setAttributes({fontsizebutton1table})
    }

    onChangeFontsizebutton1mobile = (fontsizebutton1mobile) => {
        this.props.setAttributes({fontsizebutton1mobile})
    }

    onChangeDf_enable_divide_1 = ( df_enable_divide_1) => {
        this.props.setAttributes({ df_enable_divide_1})
    }

    onChangeDf_height_divide_1 = ( df_height_divide_1) => {
        this.props.setAttributes({ df_height_divide_1})
    }

    onChangeDf_height_table_divide_1 = ( df_height_table_divide_1) => {
        this.props.setAttributes({ df_height_table_divide_1})
    }

    onChangeDf_height_mobile_divide_1 = ( df_height_mobile_divide_1) => {
        this.props.setAttributes({ df_height_mobile_divide_1})
    }

    onChangeBubiblock_dalay_divide_1 = ( bubiblock_dalay_divide_1) => {
        this.props.setAttributes({ bubiblock_dalay_divide_1})
    }

    onChangeDf_enable_divide_bottom_1 = ( df_enable_divide_bottom_1) => {
        this.props.setAttributes({ df_enable_divide_bottom_1})
    }

    onChangeDf_height_divide_bottom_1 = ( df_height_divide_bottom_1) => {
        this.props.setAttributes({ df_height_divide_bottom_1})
    }

    onChangeDf_height_table_divide_bottom_1 = ( df_height_table_divide_bottom_1) => {
        this.props.setAttributes({ df_height_table_divide_bottom_1})
    }

    onChangeDf_height_mobile_divide_bottom_1 = ( df_height_mobile_divide_bottom_1) => {
        this.props.setAttributes({ df_height_mobile_divide_bottom_1})
    }

    onChangeBubiblock_dalay_divide_1_bottom = (  bubiblock_dalay_divide_1_bottom) => {
        this.props.setAttributes({  bubiblock_dalay_divide_1_bottom})
    }

    // Slider 2
    onSelectURL2 = (imageUrl_2) => {
        this.props.setAttributes({
            imageUrl_2,
            id2: null,
            alt2: ''
        })
    }
    onUploadError2 = (message) => {
        const { noticeOperations } = this.props;
        noticeOperations.createErrorNotice( message );
    }
    removeImage2 = () => {
        this.props.setAttributes({
            id2: null,
            imageUrl_2: '',
            alt2: ''
        })
    }
    updateAlt2 = (alt2) => {
        this.props.setAttributes({
            alt2
        })
    }
    onChangeDf_cover_img2 = (df_cover_img2) => {
        this.props.setAttributes({df_cover_img2})
    }

    onChangeDf_focalPoint_img_2 = (df_focalPoint_img_2) => {
        this.props.setAttributes({df_focalPoint_img_2})
    }

    onChangeDf_focalPoint_y_img_2 = (df_focalPoint_y_img_2) => {
        this.props.setAttributes({df_focalPoint_y_img_2})
    }

    onChangeDf_mask_slider_2 = (df_mask_slider_2) => {
        this.props.setAttributes({df_mask_slider_2})
    }

    onChangeDf_opacity_mask_2 = (df_opacity_mask_2) => {
        this.props.setAttributes({df_opacity_mask_2})
    }

    onChangeEffectcaption2 = (effectcaption2) => {
        this.props.setAttributes({effectcaption2})
    }

    onChangeDf_speed_effectcaption2 = ( df_speed_effectcaption2) => {
        this.props.setAttributes({ df_speed_effectcaption2})
    }

    onChangeDf_delay_effectcaption2 = ( df_delay_effectcaption2) => {
        this.props.setAttributes({ df_delay_effectcaption2})
    }

    onChangeDf_repeat_effectcaption2 = ( df_repeat_effectcaption2) => {
        this.props.setAttributes({ df_repeat_effectcaption2})
    }

    onChangeEffectinfo2 = (effectinfo2) => {
        this.props.setAttributes({effectinfo2})
    }

    onChangeDf_speed_effectinfo2 = ( df_speed_effectinfo2) => {
        this.props.setAttributes({ df_speed_effectinfo2})
    }

    onChangeDf_delay_effectinfo2 = ( df_delay_effectinfo2) => {
        this.props.setAttributes({ df_delay_effectinfo2})
    }

    onChangeDf_repeat_effectinfo2 = ( df_repeat_effectinfo2) => {
        this.props.setAttributes({ df_repeat_effectinfo2})
    }

    onChangeEffectbutton2 = (effectbutton2) => {
        this.props.setAttributes({effectbutton2})
    }

    onChangeDf_speed_effectbutton2= ( df_speed_effectbutton2) => {
        this.props.setAttributes({ df_speed_effectbutton2})
    }

    onChangeDf_delay_effectbutton2 = ( df_delay_effectbutton2) => {
        this.props.setAttributes({ df_delay_effectbutton2})
    }

    onChangeDf_repeat_effectbutton2 = ( df_repeat_effectbutton2) => {
        this.props.setAttributes({ df_repeat_effectbutton2})
    }

    onChangeMargin_bottom_caption2 = (margin_bottom_caption2) => {
        this.props.setAttributes({margin_bottom_caption2})
    }

    onChangeMargin_bottom_table_caption2 = (margin_bottom_table_caption2) => {
        this.props.setAttributes({margin_bottom_table_caption2})
    }

    onChangeMargin_bottom_mobile_caption2 = (margin_bottom_mobile_caption2) => {
        this.props.setAttributes({margin_bottom_mobile_caption2})
    }

    onChangeMargin_bottom_info2 = (margin_bottom_info2) => {
        this.props.setAttributes({margin_bottom_info2})
    }

    onChangeMargin_bottom_table_info2 = (margin_bottom_table_info2) => {
        this.props.setAttributes({margin_bottom_table_info2})
    }

    onChangeMargin_bottom_mobile_info2 = (margin_bottom_mobile_info2) => {
        this.props.setAttributes({margin_bottom_mobile_info2})
    }

    onChangeMargin_bottom_button2 = (margin_bottom_button2) => {
        this.props.setAttributes({margin_bottom_button2})
    }

    onChangeMargin_bottom_table_button2 = (margin_bottom_table_button2) => {
        this.props.setAttributes({margin_bottom_table_button2})
    }

    onChangeMargin_bottom_mobile_button2 = (margin_bottom_mobile_button2) => {
        this.props.setAttributes({margin_bottom_mobile_button2})
    }

    onChangeTitle2 = (title2) => {
        this.props.setAttributes({title2})
    }

    onChangeInfo2 = (info2) => {
        this.props.setAttributes({info2})
    }

    onChangeButton2 = (button2) => {
        this.props.setAttributes({button2})
    }

    onChangeFontsizetitle2 = (fontsizetitle2) => {
        this.props.setAttributes({fontsizetitle2})
    }

    onChangeFontsizetitle2table = (fontsizetitle2table) => {
        this.props.setAttributes({fontsizetitle2table})
    }

    onChangeFontsizetitle2mobile = (fontsizetitle2mobile) => {
        this.props.setAttributes({fontsizetitle2mobile})
    }

    onChangeFontsizeinfo2 = (fontsizeinfo2) => {
        this.props.setAttributes({fontsizeinfo2})
    }

    onChangeFontsizeinfo2table = (fontsizeinfo2table) => {
        this.props.setAttributes({fontsizeinfo2table})
    }

    onChangeFontsizeinfo2mobile = (fontsizeinfo2mobile) => {
        this.props.setAttributes({fontsizeinfo2mobile})
    }

    onChangeFontsizebutton2 = (fontsizebutton2) => {
        this.props.setAttributes({fontsizebutton2})
    }

    onChangeFontsizebutton2table = (fontsizebutton2table) => {
        this.props.setAttributes({fontsizebutton2table})
    }

    onChangeFontsizebutton2mobile = (fontsizebutton2mobile) => {
        this.props.setAttributes({fontsizebutton2mobile})
    }

    onChangeDf_enable_divide_2 = ( df_enable_divide_2) => {
        this.props.setAttributes({ df_enable_divide_2})
    }

    onChangeDf_height_divide_2 = ( df_height_divide_2) => {
        this.props.setAttributes({ df_height_divide_2})
    }

    onChangeDf_height_table_divide_2 = ( df_height_table_divide_2) => {
        this.props.setAttributes({ df_height_table_divide_2})
    }

    onChangeDf_height_mobile_divide_2 = ( df_height_mobile_divide_2) => {
        this.props.setAttributes({ df_height_mobile_divide_2})
    }

    onChangeBubiblock_dalay_divide_2 = ( bubiblock_dalay_divide_2) => {
        this.props.setAttributes({ bubiblock_dalay_divide_2})
    }

    onChangeDf_enable_divide_bottom_2 = ( df_enable_divide_bottom_2) => {
        this.props.setAttributes({ df_enable_divide_bottom_2})
    }

    onChangeDf_height_divide_bottom_2 = ( df_height_divide_bottom_2) => {
        this.props.setAttributes({ df_height_divide_bottom_2})
    }

    onChangeDf_height_table_divide_bottom_2 = ( df_height_table_divide_bottom_2) => {
        this.props.setAttributes({ df_height_table_divide_bottom_2})
    }

    onChangeDf_height_mobile_divide_bottom_2 = ( df_height_mobile_divide_bottom_2) => {
        this.props.setAttributes({ df_height_mobile_divide_bottom_2})
    }

    onChangeBubiblock_dalay_divide_2_bottom = (  bubiblock_dalay_divide_2_bottom) => {
        this.props.setAttributes({  bubiblock_dalay_divide_2_bottom})
    }

    // Slider 3
    onSelectURL3 = (imageUrl_3) => {
        this.props.setAttributes({
            imageUrl_3,
            id3: null,
            alt3: ''
        })
    }
    onUploadError3 = (message) => {
        const { noticeOperations } = this.props;
        noticeOperations.createErrorNotice( message );
    }
    removeImage3 = () => {
        this.props.setAttributes({
            id3: null,
            imageUrl_3: '',
            alt3: ''
        })
    }
    updateAlt3 = (alt3) => {
        this.props.setAttributes({
            alt3
        })
    }

    onChangeDf_cover_img3 = (df_cover_img3) => {
        this.props.setAttributes({df_cover_img3})
    }

    onChangeDf_focalPoint_img_3 = (df_focalPoint_img_3) => {
        this.props.setAttributes({df_focalPoint_img_3})
    }

    onChangeDf_focalPoint_y_img_3 = (df_focalPoint_y_img_3) => {
        this.props.setAttributes({df_focalPoint_y_img_3})
    }

    onChangeDf_mask_slider_3 = (df_mask_slider_3) => {
        this.props.setAttributes({df_mask_slider_3})
    }

    onChangeDf_opacity_mask_3 = (df_opacity_mask_3) => {
        this.props.setAttributes({df_opacity_mask_3})
    }

    onChangeEffectcaption3 = (effectcaption3) => {
        this.props.setAttributes({effectcaption3})
    }

    onChangeDf_speed_effectcaption3 = ( df_speed_effectcaption3) => {
        this.props.setAttributes({ df_speed_effectcaption3})
    }

    onChangeDf_delay_effectcaption3 = ( df_delay_effectcaption3) => {
        this.props.setAttributes({ df_delay_effectcaption3})
    }

    onChangeDf_repeat_effectcaption3 = ( df_repeat_effectcaption3) => {
        this.props.setAttributes({ df_repeat_effectcaption3})
    }

    onChangeEffectinfo3 = (effectinfo3) => {
        this.props.setAttributes({effectinfo3})
    }

    onChangeDf_speed_effectinfo3 = ( df_speed_effectinfo3) => {
        this.props.setAttributes({ df_speed_effectinfo3})
    }

    onChangeDf_delay_effectinfo3 = ( df_delay_effectinfo3) => {
        this.props.setAttributes({ df_delay_effectinfo3})
    }

    onChangeDf_repeat_effectinfo3 = ( df_repeat_effectinfo3) => {
        this.props.setAttributes({ df_repeat_effectinfo3})
    }

    onChangeEffectbutton3 = (effectbutton3) => {
        this.props.setAttributes({effectbutton3})
    }

    onChangeDf_speed_effectbutton3 = ( df_speed_effectbutton3) => {
        this.props.setAttributes({ df_speed_effectbutton3})
    }

    onChangeDf_delay_effectbutton3 = ( df_delay_effectbutton3) => {
        this.props.setAttributes({ df_delay_effectbutton3})
    }

    onChangeDf_repeat_effectbutton3 = ( df_repeat_effectbutton3) => {
        this.props.setAttributes({ df_repeat_effectbutton3})
    }

    onChangeMargin_bottom_caption3 = (margin_bottom_caption3) => {
        this.props.setAttributes({margin_bottom_caption3})
    }

    onChangeMargin_bottom_table_caption3 = (margin_bottom_table_caption3) => {
        this.props.setAttributes({margin_bottom_table_caption3})
    }

    onChangeMargin_bottom_mobile_caption3 = (margin_bottom_mobile_caption3) => {
        this.props.setAttributes({margin_bottom_mobile_caption3})
    }

    onChangeMargin_bottom_info3 = (margin_bottom_info3) => {
        this.props.setAttributes({margin_bottom_info3})
    }

    onChangeMargin_bottom_table_info3 = (margin_bottom_table_info3) => {
        this.props.setAttributes({margin_bottom_table_info3})
    }

    onChangeMargin_bottom_mobile_info3 = (margin_bottom_mobile_info3) => {
        this.props.setAttributes({margin_bottom_mobile_info3})
    }

    onChangeMargin_bottom_button3 = (margin_bottom_button3) => {
        this.props.setAttributes({margin_bottom_button3})
    }

    onChangeMargin_bottom_table_button3 = (margin_bottom_table_button3) => {
        this.props.setAttributes({margin_bottom_table_button3})
    }

    onChangeMargin_bottom_mobile_button3 = (margin_bottom_mobile_button3) => {
        this.props.setAttributes({margin_bottom_mobile_button3})
    }

    onChangeTitle3 = (title3) => {
        this.props.setAttributes({title3})
    }

    onChangeInfo3 = (info3) => {
        this.props.setAttributes({info3})
    }

    onChangeButton3 = (button3) => {
        this.props.setAttributes({button3})
    }

    onChangeFontsizetitle3 = (fontsizetitle3) => {
        this.props.setAttributes({fontsizetitle3})
    }

    onChangeFontsizetitle3table = (fontsizetitle3table) => {
        this.props.setAttributes({fontsizetitle3table})
    }

    onChangeFontsizetitle3mobile = (fontsizetitle3mobile) => {
        this.props.setAttributes({fontsizetitle3mobile})
    }

    onChangeFontsizeinfo3 = (fontsizeinfo3) => {
        this.props.setAttributes({fontsizeinfo3})
    }

    onChangeFontsizeinfo3table = (fontsizeinfo3table) => {
        this.props.setAttributes({fontsizeinfo3table})
    }

    onChangeFontsizeinfo3mobile = (fontsizeinfo3mobile) => {
        this.props.setAttributes({fontsizeinfo3mobile})
    }

    onChangeFontsizebutton3 = (fontsizebutton3) => {
        this.props.setAttributes({fontsizebutton3})
    }

    onChangeFontsizebutton3table = (fontsizebutton3table) => {
        this.props.setAttributes({fontsizebutton3table})
    }

    onChangeFontsizebutton3mobile = (fontsizebutton3mobile) => {
        this.props.setAttributes({fontsizebutton3mobile})
    }

    onChangeDf_enable_divide_3 = ( df_enable_divide_3) => {
        this.props.setAttributes({ df_enable_divide_3})
    }

    onChangeDf_height_divide_3 = ( df_height_divide_3) => {
        this.props.setAttributes({ df_height_divide_3})
    }

    onChangeDf_height_table_divide_3 = ( df_height_table_divide_3) => {
        this.props.setAttributes({ df_height_table_divide_3})
    }

    onChangeDf_height_mobile_divide_3 = ( df_height_mobile_divide_3) => {
        this.props.setAttributes({ df_height_mobile_divide_3})
    }

    onChangeBubiblock_dalay_divide_3 = ( bubiblock_dalay_divide_3) => {
        this.props.setAttributes({ bubiblock_dalay_divide_3})
    }

    onChangeDf_enable_divide_bottom_3 = ( df_enable_divide_bottom_3) => {
        this.props.setAttributes({ df_enable_divide_bottom_3})
    }

    onChangeDf_height_divide_bottom_3 = ( df_height_divide_bottom_3) => {
        this.props.setAttributes({ df_height_divide_bottom_3})
    }

    onChangeDf_height_table_divide_bottom_3 = ( df_height_table_divide_bottom_3) => {
        this.props.setAttributes({ df_height_table_divide_bottom_3})
    }

    onChangeDf_height_mobile_divide_bottom_3 = ( df_height_mobile_divide_bottom_3) => {
        this.props.setAttributes({ df_height_mobile_divide_bottom_3})
    }

    onChangeBubiblock_dalay_divide_3_bottom = (  bubiblock_dalay_divide_3_bottom) => {
        this.props.setAttributes({  bubiblock_dalay_divide_3_bottom})
    }

    // Slider 4
    onSelectURL4 = (imageUrl_4) => {
        this.props.setAttributes({
            imageUrl_4,
            id4: null,
            alt4: ''
        })
    }
    onUploadError4 = (message) => {
        const { noticeOperations } = this.props;
        noticeOperations.createErrorNotice( message );
    }
    removeImage4 = () => {
        this.props.setAttributes({
            id4: null,
            imageUrl_4: '',
            alt4: ''
        })
    }
    updateAlt4 = (alt4) => {
        this.props.setAttributes({
            alt4
        })
    }

    onChangeTitle4 = (title4) => {
        this.props.setAttributes({title4})
    }

    onChangeInfo4 = (info4) => {
        this.props.setAttributes({info4})
    }

    onChangeButton4 = (button4) => {
        this.props.setAttributes({button4})
    }

    // Slider 5
    onSelectURL5 = (imageUrl_5) => {
        this.props.setAttributes({
            imageUrl_5,
            id5: null,
            alt5: ''
        })
    }
    onUploadError5 = (message) => {
        const { noticeOperations } = this.props;
        noticeOperations.createErrorNotice( message );
    }
    removeImage5 = () => {
        this.props.setAttributes({
            id5: null,
            imageUrl_5: '',
            alt5: ''
        })
    }
    updateAlt5 = (alt5) => {
        this.props.setAttributes({
            alt5
        })
    }

    onChangeTitle5 = (title5) => {
        this.props.setAttributes({title5})
    }

    onChangeInfo5 = (info5) => {
        this.props.setAttributes({info5})
    }

    onChangeButton5 = (button5) => {
        this.props.setAttributes({button5})
    }

    render() {

        const { className, attributes, setAttributes, noticeUI, noticeUI2,noticeUI3,noticeUI4,noticeUI5} = this.props;
        const {
            bubiblock_padding_caption,
            bubiblock_padding_table_caption,
            bubiblock_padding_mobile_caption,
            bubiblock_padding_table_slider,
            bubiblock_padding_b_table_slider,
            bubiblock_padding_mobile_slider,
            bubiblock_padding_b_mobile_slider,
            bubiblock_display_button_table_caption,
            bubiblock_display_button_mobile_caption,
            bubiblcok_fontfamily,
            bubiblock_typography_custom,
            bubiblcok_fontfamily_weight,
            bubiblock_line_height_title,
            bubiblcok_fontfamily_descritpion,
            bubiblcok_fontfamily_weight_description,
            bubiblock_line_height_info,
            bubiblcok_fontfamily_button,
            bubiblcok_fontfamily_weight_button,
            df_resp,
            height_slider,
            df_height_slider_auto,
            height_slider_table,
            height_slider_mobile,
            bubiblock_full_slider,
            bubiblock_padding_slider,
            bubiblock_padding_b_slider,
            bubiblock_radius_slider,
            bubiblock_background_color_slider,
            bubiblock_background_gradient_slider,
            df_interval_slider,
            bubiblock_speed_slider,
            bubiblock_speed_flip_slider,
            bubiblock_id_slider,
            df_pause_slider,
            df_effect_slider,
            bubiblock_show_slider_desktop,
            bubiblock_show_slider_table,
            bubiblock_show_slider_mobile,
            bubiblock_carousle_touch,
            bubi_block_content_slider,
            bubiblock_padding_block_slider,
            bubiblock_padding_b_block_slider,
            bubiblock_padding_block_slider_table,
            bubiblock_padding_b_block_slider_table,
            bubiblock_padding_block_slider_mobile,
            bubiblock_padding_b_block_slider_mobile,
            bubiblock_background_color_block_slider,
            bubiopacityblock_slider,
            df_arrow_slider,
            df_arrow_slider_table,
            df_arrow_slider_mobile,
            bubi_arrow_position,
            df_color_arrow,
            bubiopacityarrow,
            bubiopacityhoverarrow,
            df_padding_arrow,
            df_arrow_slider_type,
            df_radius_arrow,
            df_size_arrow,
            df_size_arrow_table,
            df_size_arrow_mobile,
            bubi_marginarrow,
            df_dot_slider,
            df_dot_slider_table,
            df_dot_slider_mobile,
            df_dot_slider_type,
            df_width_dot,
            df_height_dot,
            bubiblock_height_dot_active,
            df_color_progress_dot,
            df_bottom_dot,
            df_color_dot,
            //Slider 1
            df_slider_chose_1,
            df_mask_slider_1,
            background_color_solid_mask_1,
            df_opacity_mask_1,
            effectcaption1,
            df_speed_effectcaption1,
            df_delay_effectcaption1,
            df_repeat_effectcaption1,
            margin_bottom_caption1,
            margin_bottom_table_caption1,
            margin_bottom_mobile_caption1,
            margin_bottom_info1,
            margin_bottom_table_info1,
            margin_bottom_mobile_info1,
            effectinfo1,
            df_speed_effectinfo1,
            df_delay_effectinfo1,
            df_repeat_effectinfo1,
            title1,
            fontsizetitle1,
            fontsizetitle1table,
            fontsizetitle1mobile,
            info1,
            fontsizeinfo1,
            fontsizeinfo1table,
            fontsizeinfo1mobile,
            margin_bottom_button1,
            margin_bottom_table_button1,
            margin_bottom_mobile_button1,
            effectbutton1,
            df_speed_effectbutton1,
            df_delay_effectbutton1,
            df_repeat_effectbutton1,
            alignment_title1,
            alignment_info1,
            button1,
            fontsizebutton1,
            fontsizebutton1table,
            fontsizebutton1mobile,
            alignment_button1,
            padding_link_button1,
            padding_right_link_button1,
            border_radius_top_left_link_button1,
            border_radius_top_right_link_button1,
            border_radius_bottom_left_link_button1,
            border_radius_bottom_right_link_button1,
            border_size_link_button1,
            df_background_color_link_button1,
            df_background_color_hover_link_button1,
            df_color_link_button1,
            df_color_hover_link_button1,
            df_border_color_link_button1,
            df_background_color_transparent_link_button1,
            alt,
            id,
            url,
            df_cover_img1,
            df_focalPoint_img_1,
            df_focalPoint_y_img_1,
            df_background_color_slider_1,
            df_enable_divide_1,
            divide_1,
            df_color_divide_1,
            df_height_divide_1,
            df_height_table_divide_1,
            df_height_mobile_divide_1,
            bubiblock_dalay_divide_1,
            df_enable_divide_bottom_1,
            divide_bottom_1,
            df_color_divide_bottom_1,
            df_height_divide_bottom_1,
            df_height_table_divide_bottom_1,
            df_height_mobile_divide_bottom_1,
            bubiblock_dalay_divide_1_bottom,
            bubiblock_link_slider_1,
            bubiblock_link_tab_slider_1,
            // Slider 2
            df_slider_chose_2,
            df_mask_slider_2,
            background_color_solid_mask_2,
            background_color_gradient_mask_2,
            df_opacity_mask_2,
            effectcaption2,
            df_speed_effectcaption2,
            df_delay_effectcaption2,
            df_repeat_effectcaption2,
            margin_bottom_caption2,
            margin_bottom_table_caption2,
            margin_bottom_mobile_caption2,
            margin_bottom_info2,
            margin_bottom_table_info2,
            margin_bottom_mobile_info2,
            effectinfo2,
            df_speed_effectinfo2,
            df_delay_effectinfo2,
            df_repeat_effectinfo2,
            title2,
            fontsizetitle2,
            fontsizetitle2table,
            fontsizetitle2mobile,
            info2,
            fontsizeinfo2,
            fontsizeinfo2table,
            fontsizeinfo2mobile,
            margin_bottom_button2,
            margin_bottom_table_button2,
            margin_bottom_mobile_button2,
            effectbutton2,
            df_speed_effectbutton2,
            df_delay_effectbutton2,
            df_repeat_effectbutton2,
            alignment_title2,
            alignment_info2,
            button2,
            fontsizebutton2,
            fontsizebutton2table,
            fontsizebutton2mobile,
            alignment_button2,
            padding_link_button2,
            padding_right_link_button2,
            border_radius_top_left_link_button2,
            border_radius_top_right_link_button2,
            border_radius_bottom_left_link_button2,
            border_radius_bottom_right_link_button2,
            border_size_link_button2,
            df_background_color_link_button2,
            df_background_color_hover_link_button2,
            df_color_link_button2,
            df_color_hover_link_button2,
            df_border_color_link_button2,
            df_background_color_transparent_link_button2,
            alt2,
            id2,
            imageUrl_2,
            df_cover_img2,
            df_focalPoint_img_2,
            df_focalPoint_y_img_2,
            df_background_color_slider_2,
            df_enable_divide_2,
            divide_2,
            df_color_divide_2,
            df_height_divide_2,
            df_height_table_divide_2,
            df_height_mobile_divide_2,
            bubiblock_dalay_divide_2,
            df_enable_divide_bottom_2,
            divide_bottom_2,
            df_color_divide_bottom_2,
            df_height_divide_bottom_2,
            df_height_table_divide_bottom_2,
            df_height_mobile_divide_bottom_2,
            bubiblock_dalay_divide_2_bottom,
            bubiblock_link_slider_2,
            bubiblock_link_tab_slider_2,
            // Slider 3
            bubiblock_add_slider_3,
            df_slider_chose_3,
            df_mask_slider_3,
            background_color_solid_mask_3,
            background_color_gradient_mask_3,
            df_opacity_mask_3,
            effectcaption3,
            df_speed_effectcaption3,
            df_delay_effectcaption3,
            df_repeat_effectcaption3,
            margin_bottom_caption3,
            margin_bottom_table_caption3,
            margin_bottom_mobile_caption3,
            margin_bottom_info3,
            margin_bottom_table_info3,
            margin_bottom_mobile_info3,
            effectinfo3,
            df_speed_effectinfo3,
            df_delay_effectinfo3,
            df_repeat_effectinfo3,
            title3,
            fontsizetitle3,
            fontsizetitle3table,
            fontsizetitle3mobile,
            info3,
            fontsizeinfo3,
            fontsizeinfo3table,
            fontsizeinfo3mobile,
            margin_bottom_button3,
            margin_bottom_table_button3,
            margin_bottom_mobile_button3,
            effectbutton3,
            df_speed_effectbutton3,
            df_delay_effectbutton3,
            df_repeat_effectbutton3,
            alignment_title3,
            alignment_info3,
            button3,
            fontsizebutton3,
            fontsizebutton3table,
            fontsizebutton3mobile,
            alignment_button3,
            padding_link_button3,
            padding_right_link_button3,
            border_radius_top_left_link_button3,
            border_radius_top_right_link_button3,
            border_radius_bottom_left_link_button3,
            border_radius_bottom_right_link_button3,
            border_size_link_button3,
            df_background_color_link_button3,
            df_background_color_hover_link_button3,
            df_color_link_button3,
            df_color_hover_link_button3,
            df_border_color_link_button3,
            df_background_color_transparent_link_button3,
            alt3,
            id3,
            imageUrl_3,
            df_cover_img3,
            df_focalPoint_img_3,
            df_focalPoint_y_img_3,
            df_background_color_slider_3,
            df_enable_divide_3,
            divide_3,
            df_color_divide_3,
            df_height_divide_3,
            df_height_table_divide_3,
            df_height_mobile_divide_3,
            bubiblock_dalay_divide_3,
            df_enable_divide_bottom_3,
            divide_bottom_3,
            df_color_divide_bottom_3,
            df_height_divide_bottom_3,
            df_height_table_divide_bottom_3,
            df_height_mobile_divide_bottom_3,
            bubiblock_dalay_divide_3_bottom,
            bubiblock_link_slider_3,
            bubiblock_link_tab_slider_3,
            // Slider 4
            bubiblock_add_slider_4,
            df_slider_chose_4,
            df_mask_slider_4,
            background_color_solid_mask_4,
            background_color_gradient_mask_4,
            df_opacity_mask_4,
            effectcaption4,
            df_speed_effectcaption4,
            df_delay_effectcaption4,
            df_repeat_effectcaption4,
            margin_bottom_caption4,
            margin_bottom_table_caption4,
            margin_bottom_mobile_caption4,
            margin_bottom_info4,
            margin_bottom_table_info4,
            margin_bottom_mobile_info4,
            effectinfo4,
            df_speed_effectinfo4,
            df_delay_effectinfo4,
            df_repeat_effectinfo4,
            title4,
            fontsizetitle4,
            fontsizetitle4table,
            fontsizetitle4mobile,
            info4,
            fontsizeinfo4,
            fontsizeinfo4table,
            fontsizeinfo4mobile,
            margin_bottom_button4,
            margin_bottom_table_button4,
            margin_bottom_mobile_button4,
            effectbutton4,
            df_speed_effectbutton4,
            df_delay_effectbutton4,
            df_repeat_effectbutton4,
            alignment_title4,
            alignment_info4,
            button4,
            fontsizebutton4,
            fontsizebutton4table,
            fontsizebutton4mobile,
            alignment_button4,
            padding_link_button4,
            padding_right_link_button4,
            border_radius_top_left_link_button4,
            border_radius_top_right_link_button4,
            border_radius_bottom_left_link_button4,
            border_radius_bottom_right_link_button4,
            border_size_link_button4,
            df_background_color_link_button4,
            df_background_color_hover_link_button4,
            df_color_link_button4,
            df_color_hover_link_button4,
            df_border_color_link_button4,
            df_background_color_transparent_link_button4,
            alt4,
            id4,
            imageUrl_4,
            df_cover_img4,
            df_focalPoint_img_4,
            df_focalPoint_y_img_4,
            df_background_color_slider_4,
            df_enable_divide_4,
            divide_4,
            df_color_divide_4,
            df_height_divide_4,
            df_height_table_divide_4,
            df_height_mobile_divide_4,
            bubiblock_dalay_divide_4,
            df_enable_divide_bottom_4,
            divide_bottom_4,
            df_color_divide_bottom_4,
            df_height_divide_bottom_4,
            df_height_table_divide_bottom_4,
            df_height_mobile_divide_bottom_4,
            bubiblock_dalay_divide_4_bottom,
            bubiblock_link_slider_4,
            bubiblock_link_tab_slider_4,
            // Slider 5
            bubiblock_add_slider_5,
            df_slider_chose_5,
            df_mask_slider_5,
            background_color_solid_mask_5,
            background_color_gradient_mask_5,
            df_opacity_mask_5,
            effectcaption5,
            df_speed_effectcaption5,
            df_delay_effectcaption5,
            df_repeat_effectcaption5,
            margin_bottom_caption5,
            margin_bottom_table_caption5,
            margin_bottom_mobile_caption5,
            margin_bottom_info5,
            margin_bottom_table_info5,
            margin_bottom_mobile_info5,
            effectinfo5,
            df_speed_effectinfo5,
            df_delay_effectinfo5,
            df_repeat_effectinfo5,
            title5,
            fontsizetitle5,
            fontsizetitle5table,
            fontsizetitle5mobile,
            info5,
            fontsizeinfo5,
            fontsizeinfo5table,
            fontsizeinfo5mobile,
            margin_bottom_button5,
            margin_bottom_table_button5,
            margin_bottom_mobile_button5,
            effectbutton5,
            df_speed_effectbutton5,
            df_delay_effectbutton5,
            df_repeat_effectbutton5,
            alignment_title5,
            alignment_info5,
            button5,
            fontsizebutton5,
            fontsizebutton5table,
            fontsizebutton5mobile,
            alignment_button5,
            padding_link_button5,
            padding_right_link_button5,
            border_radius_top_left_link_button5,
            border_radius_top_right_link_button5,
            border_radius_bottom_left_link_button5,
            border_radius_bottom_right_link_button5,
            border_size_link_button5,
            df_background_color_link_button5,
            df_background_color_hover_link_button5,
            df_color_link_button5,
            df_color_hover_link_button5,
            df_border_color_link_button5,
            df_background_color_transparent_link_button5,
            alt5,
            id5,
            imageUrl_5,
            df_cover_img5,
            df_focalPoint_img_5,
            df_focalPoint_y_img_5,
            df_background_color_slider_5,
            df_enable_divide_5,
            divide_5,
            df_color_divide_5,
            df_height_divide_5,
            df_height_table_divide_5,
            df_height_mobile_divide_5,
            bubiblock_dalay_divide_5,
            df_enable_divide_bottom_5,
            divide_bottom_5,
            df_color_divide_bottom_5,
            df_height_divide_bottom_5,
            df_height_table_divide_bottom_5,
            df_height_mobile_divide_bottom_5,
            bubiblock_dalay_divide_5_bottom,
            bubiblock_link_slider_5,
            bubiblock_link_tab_slider_5,

        } = attributes;

        const dateFormat = __experimentalGetSettings().formats.date;

        // Editor Responsive
        {(df_resp=='desktop')  &&
            document.styleSheets[0].addRule('.editor-styles-wrapper','height:100%;width:100%;margin:0;min-height:100%;max-height:100%');
        }
        {(df_resp=='table') &&
            document.styleSheets[0].addRule('.editor-styles-wrapper','height:1024px; width: 780px; margin: 72px auto!important; flex-grow: 0;min-height: 1024px; max-height: 1024px;overflow-y: auto;');
        }
        {(df_resp=='mobile')  &&
            document.styleSheets[0].addRule('.editor-styles-wrapper','height:768px; width: 360px; margin: 72px auto!important; flex-grow: 0;min-height: 768px; max-height: 768px;overflow-y: auto;');
        }
        // Padding Slider
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.desktop','padding-left:'+bubiblock_padding_slider+'px;'+'padding-right:'+bubiblock_padding_slider+'px;'+'padding-top:'+bubiblock_padding_b_slider+'px;'+'padding-bottom:'+bubiblock_padding_b_slider+'px');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.table','padding-left:'+bubiblock_padding_table_slider+'px;'+'padding-right:'+bubiblock_padding_table_slider+'px;'+'padding-top:'+bubiblock_padding_b_table_slider+'px;'+'padding-bottom:'+bubiblock_padding_b_table_slider+'px');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.mobile','padding-left:'+bubiblock_padding_mobile_slider+'px;'+'padding-right:'+bubiblock_padding_mobile_slider+'px;'+'padding-top:'+bubiblock_padding_b_mobile_slider+'px;'+'padding-bottom:'+bubiblock_padding_b_mobile_slider+'px');
        // Padding Caption
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.desktop .carousel-caption','margin-left:'+ bubiblock_padding_caption +'px;');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.table .carousel-caption','margin-left:'+ bubiblock_padding_table_caption +'px;');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.mobile .carousel-caption','margin-left:'+ bubiblock_padding_mobile_caption +'px;');
        // Button Caption
        if(bubiblock_display_button_table_caption !=1 ){
            document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.table .carousel-caption button','display: none;');
        }
        if(bubiblock_display_button_table_caption !=0 ){
            document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.table .carousel-caption button','display: initial;');
        }
        if(bubiblock_display_button_mobile_caption !=1){
            document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.mobile .carousel-caption button','display: none;');
        }
        if(bubiblock_display_button_mobile_caption !=0 ){
            document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.mobile .carousel-caption button','display: initial;');
        }

        // Height slider
        if(df_height_slider_auto != 1){
            document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.desktop .carousel-item.active','height:'+ height_slider +'px!important;');
            document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.desktop .carousel-item.active img.img-cap','min-height:'+ height_slider +'px!important;');
            document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.desktop .carousel-item.active video','min-height:'+ height_slider +'px!important;');
            document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.desktop .carousel-item','height:'+ height_slider +'px!important;');
            document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.desktop .carousel-item img.img-cap','min-height:'+ height_slider +'px!important;');
            document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.desktop .carousel-item video','min-height:'+ height_slider +'px!important;');
            document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.table .carousel-item.active','height:'+ height_slider_table +'px!important;');
            document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.table .carousel-item.active img.img-cap','min-height:'+ height_slider_table +'px!important;');
            document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.table .carousel-item.active video','min-height:'+ height_slider_table +'px!important;');
            document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.table .carousel-item','height:'+ height_slider_table +'px!important;');
            document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.table .carousel-item img.img-cap','min-height:'+ height_slider_table +'px!important;');
            document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.table .carousel-item video','min-height:'+ height_slider_table +'px!important;');
            document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.mobile .carousel-item.active','height:'+ height_slider_mobile +'px!important;');
            document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.mobile .carousel-item.active img.img-cap','min-height:'+ height_slider_mobile +'px!important;');
            document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.mobile .carousel-item.active video','min-height:'+ height_slider_mobile +'px!important;');
            document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.mobile .carousel-item','height:'+ height_slider_mobile +'px!important;');
            document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.mobile .carousel-item img.img-cap','min-height:'+ height_slider_mobile +'px!important;');
            document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.mobile .carousel-item video','min-height:'+ height_slider_mobile +'px!important;');
        }
        if(df_height_slider_auto != 0){
            document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.desktop .carousel-item.active','height:auto!important;');
            document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.desktop .carousel-item.active img.img-cap','min-height:auto!important;');
            document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.desktop .carousel-item.active video','min-height:auto!important;');
            document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.desktop .carousel-item','height:auto!important;');
            document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.desktop .carousel-item img.img-cap','min-height:auto!important;');
            document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.desktop .carousel-item video','min-height:auto!important;');
            document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.table .carousel-item.active','height:auto!important;');
            document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.table .carousel-item.active img.img-cap','min-height:auto!important;');
            document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.table .carousel-item.active video','min-height:auto!important;');
            document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.table .carousel-item','height:auto!important;');
            document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.table .carousel-item img.img-cap','min-height:auto!important;');
            document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.table .carousel-item video','min-height:auto!important;');
            document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.mobile .carousel-item.active','height:auto!important;');
            document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.mobile .carousel-item.active img.img-cap','min-height:auto!important;');
            document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.mobile .carousel-item.active video','min-height:auto!important;');
            document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.mobile .carousel-item','height:auto!important;');
            document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.mobile .carousel-item img.img-cap','min-height:auto!important;');
            document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.mobile .carousel-item video','min-height:auto!important;');
        }
        // Caption block
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.desktop .bubiblock-block','padding-left:'+bubiblock_padding_block_slider+'px;'+'padding-right:'+bubiblock_padding_block_slider+'px;'+'padding-top:'+bubiblock_padding_b_block_slider+'px;'+'padding-bottom:'+bubiblock_padding_b_block_slider+'px');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.table .bubiblock-block','padding-left:'+bubiblock_padding_block_slider_table+'px;'+'padding-right:'+bubiblock_padding_block_slider_table+'px;'+'padding-top:'+bubiblock_padding_b_block_slider_table+'px;'+'padding-bottom:'+bubiblock_padding_b_block_slider_table+'px');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.mobile .bubiblock-block','padding-left:'+bubiblock_padding_block_slider_mobile+'px;'+'padding-right:'+bubiblock_padding_block_slider_mobile+'px;'+'padding-top:'+bubiblock_padding_b_block_slider_mobile+'px;'+'padding-bottom:'+bubiblock_padding_b_block_slider_mobile+'px');
        // Arrow
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.desktop .df-carousel-control-prev.df-arrow-false','display:none;');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.desktop .df-carousel-control-next.df-arrow-false','display:none;');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.table .df-carousel-control-prev.df-arrow-table-false','display:none;');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.table .df-carousel-control-next.df-arrow-table-false','display:none;');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.mobile .df-carousel-control-prev.df-arrow-mobile-false','display:none');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.mobile .df-carousel-control-next.df-arrow-mobile-false','display:none');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.table .df-carousel-control-prev i','font-size:'+ df_size_arrow_table +'px!important;');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.table .df-carousel-control-next i','font-size:'+ df_size_arrow_table +'px!important;');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.mobile .df-carousel-control-prev i','font-size:'+ df_size_arrow_mobile +'px!important;');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.mobile .df-carousel-control-next i','font-size:'+ df_size_arrow_mobile +'px!important;');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+' .carousel-control-next.df-carousel-control-next:hover','opacity:'+ bubiopacityhoverarrow+'!important' );
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+' .carousel-control-prev.df-carousel-control-prev:hover','opacity:'+ bubiopacityhoverarrow+'!important' );
        // Dots
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.desktop .df-dot-false.carousel-indicators','display:none;');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.table .df-dot-table-false.carousel-indicators','display:none;');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.mobile .df-dot-mobile-false.carousel-indicators','display:none!important;');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+' .carousel-indicators.difftrue li.active::after','height:'+bubiblock_height_dot_active+'px; width: 100%;position: absolute; transition: height .25s ease-in-out;bottom: 0;background-color:'+df_color_dot);
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+' .carousel-indicators.difftrue li','transition:height .25s ease-in-out;');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+' .carousel-indicators.progtrue li.active::after','width: 100%!important;  transition: width '+df_interval_slider+'ms ease-out;top: 0;height:'+df_height_dot+'px;background-color:'+df_color_progress_dot);
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+' .carousel-indicators.progtrue li::after','width:0!important;transition: width '+df_interval_slider+'ms ease-in;position: absolute;top: 0; height:'+df_height_dot+'px;');
        //Speed slider
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+' .carousel-item.df-slider-slide','-webkit-transition: -webkit-transform '+bubiblock_speed_slider+'s ease-in-out;transition: -webkit-transform '+bubiblock_speed_slider+'s ease-in-out;-o-transition: -o-transform '+bubiblock_speed_slider+'s ease-in-out;transition: transform '+bubiblock_speed_slider+'s ease-in-out;transition: transform '+bubiblock_speed_slider+'s ease-in-out, -webkit-transform '+bubiblock_speed_slider+'s ease-in-out, -o-transform '+bubiblock_speed_slider+'s ease-in-out;');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+' .carousel-item.bubiblock-flip',' transition: '+bubiblock_speed_flip_slider+'s cubic-bezier(0.175, 0.885, 0.32, 1.275) ;-webkit-transition: '+bubiblock_speed_flip_slider+'s cubic-bezier(0.175, 0.885, 0.32, 1.275);transform-style: preserve-3d;-webkit-style: preserve-3d;');
        // Border radius item
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+' .carousel-item img.img-cap,#carouselDFControlslider'+bubiblock_id_slider+',#carouselDFControlslider'+bubiblock_id_slider+' .carousel-item video,#carouselDFControlslider'+bubiblock_id_slider+' .carousel-item .bubiblock-color-slider-item,#carouselDFControlslider'+bubiblock_id_slider+' .carousel-item iframe','border-radius:'+bubiblock_radius_slider+'%');
        // Font Family
        if(bubiblock_typography_custom != 0){
            document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+' h4','font-family:'+  bubiblcok_fontfamily );
            document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+' h4','font-weight:'+bubiblcok_fontfamily_weight);
            document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+' h4','line-height:'+bubiblock_line_height_title);
            document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+' p','font-family:'+bubiblcok_fontfamily_descritpion);
            document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+' p','font-weight:'+bubiblcok_fontfamily_weight_description);
            document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+' p.bubiblock-p-capt','line-height:'+bubiblock_line_height_info);
            document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+' button p','font-family:'+bubiblcok_fontfamily_button);
            document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+' button p','font-weight:'+bubiblcok_fontfamily_weight_button);
            document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+' button a','font-family:'+bubiblcok_fontfamily_button);
            document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+' button a','font-weight:'+bubiblcok_fontfamily_weight_button);
        }
        // Slider 1
        // title
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.table h4.wp-block-bubiblock-slider-slider__title','bottom:'+ margin_bottom_table_caption1 +'px!important;');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.mobile h4.wp-block-bubiblock-slider-slider__title','bottom:'+ margin_bottom_mobile_caption1 +'px!important;');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.table h4.wp-block-bubiblock-slider-slider__title','font-size:'+ fontsizetitle1table +'px!important;');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.mobile h4.wp-block-bubiblock-slider-slider__title','font-size:'+ fontsizetitle1mobile +'px!important;');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.table h4.wp-block-bubiblock-slider-slider__title.df-caption-table-false','display:none;');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.mobile h4.wp-block-bubiblock-slider-slider__title.df-caption-mobile-false','display:none!important;');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.table p.wp-block-bubiblock-slider-slider__info.df-caption-table-false','display:none;');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.mobile p.wp-block-bubiblock-slider-slider__info.df-caption-mobile-false','display:none!important;');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.table .link-button-1.df-caption-table-false','display:none;');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.mobile .link-button-1.df-caption-mobile-false','display:none!important;');
        // info
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.table p.wp-block-bubiblock-slider-slider__info','bottom:'+ margin_bottom_table_info1 +'px!important;');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.mobile p.wp-block-bubiblock-slider-slider__info','bottom:'+ margin_bottom_mobile_info1 +'px!important;');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.table p.wp-block-bubiblock-slider-slider__info','font-size:'+ fontsizeinfo1table +'px!important;');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.mobile p.wp-block-bubiblock-slider-slider__info','font-size:'+ fontsizeinfo1mobile +'px!important;');
        // button
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.table .link-button-1','bottom:'+ margin_bottom_table_button1 +'px!important;');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.mobile .link-button-1','bottom:'+ margin_bottom_mobile_button1 +'px!important;');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.table .button-slider p','font-size:'+ fontsizebutton1table +'px!important;');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.mobile .button-slider p','font-size:'+ fontsizebutton1mobile +'px!important;');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+' .link-button-1 button.button-slider:hover','background-color:'+ df_background_color_hover_link_button1+'!important');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+' .link-button-1 button.button-slider:hover');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+' .link-button-1 button.button-slider:hover','background:'+ df_background_color_hover_link_button1+'!important');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+' .link-button-1 button.button-slider:hover');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+' button.button-slider:hover p','color:'+ df_color_hover_link_button1 +'!important;');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+' button.button-slider:hover span','color:'+ df_color_hover_link_button1 +'!important;');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+' button.button-slider:hover a','color:'+ df_color_hover_link_button1 +'!important;');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+' .link-button-1 button.button-slider.df-trasparent-color-button1-true','background-color: transparent!important;');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+' .link-button-1 button.button-slider.df-trasparent-color-button1-true','background: transparent!important;');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+' .link-button-1 button.button-slider.df-trasparent-color-button1-true:hover','background-color: '+ df_background_color_hover_link_button1 +'!important;');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+' .link-button-1 button.button-slider.df-trasparent-color-button1-true:hover','background: '+ df_background_color_hover_link_button1 +'!important;');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+' .link-button-1 button.button-slider.df-trasparent-color-button1-true:hover');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+' .link-button-1 button.button-slider.df-trasparent-color-button1-true:hover');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+' .link-button-1 a','color: '+ df_color_link_button1 +'!important' );
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+' .link-button-1 p','color: '+ df_color_link_button1 +'!important' );
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+' .link-button-1 span','color: '+ df_color_link_button1 +'!important' );

        // divide top
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.desktop .df-divide-1','height:'+ df_height_divide_1 +'px');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.table .df-divide-1','height:'+ df_height_table_divide_1 +'px!important;');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.mobile .df-divide-1','height:'+ df_height_mobile_divide_1 +'px!important;');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+' .carousel-item.active .df-divide-1','transition: max-height '+bubiblock_dalay_divide_1+'s ease-in;');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+' .df-divide-1','transition: max-height '+bubiblock_dalay_divide_1+'s ease-out;');
        // divide bottom
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.desktop .df-divide-bottom-1','height:'+ df_height_divide_bottom_1 +'px');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.table .df-divide-bottom-1','height:'+ df_height_table_divide_bottom_1 +'px!important;');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.mobile .df-divide-bottom-1','height:'+ df_height_mobile_divide_bottom_1 +'px!important;');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+' .carousel-item.active .df-divide-bottom-1','transition: max-height '+bubiblock_dalay_divide_1_bottom+'s ease-in;');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+' .df-divide-bottom-1','transition: max-height '+bubiblock_dalay_divide_1_bottom+'s ease-out;');

        // Slider 2
         // title
         document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.table h4.wp-block-bubiblock-slider-slider__title_2','bottom:'+ margin_bottom_table_caption2 +'px!important;');
         document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.mobile h4.wp-block-bubiblock-slider-slider__title_2','bottom:'+ margin_bottom_mobile_caption2 +'px!important;');
         document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.table h4.wp-block-bubiblock-slider-slider__title_2','font-size:'+ fontsizetitle2table +'px!important;');
         document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.mobile h4.wp-block-bubiblock-slider-slider__title_2','font-size:'+ fontsizetitle2mobile +'px!important;');
         document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.table h4.wp-block-bubiblock-slider-slider__title_2.df-caption-table-false','display:none;');
         document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.mobile h4.wp-block-bubiblock-slider-slider__title_2.df-caption-mobile-false','display:none!important;');
         document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.table p.wp-block-bubiblock-slider-slider__info_2.df-caption-table-false','display:none;');
         document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.mobile p.wp-block-bubiblock-slider-slider__info_2.df-caption-mobile-false','display:none!important;');
         document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.table .link-button-2.df-caption-table-false','display:none;');
         document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.mobile .link-button-2.df-caption-mobile-false','display:none!important;');
         // info
         document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.table p.wp-block-bubiblock-slider-slider__info_2','bottom:'+ margin_bottom_table_info2 +'px!important;');
         document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.mobile p.wp-block-bubiblock-slider-slider__info_2','bottom:'+ margin_bottom_mobile_info2 +'px!important;');
         document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.table p.wp-block-bubiblock-slider-slider__info_2','font-size:'+ fontsizeinfo2table +'px!important;');
         document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.mobile p.wp-block-bubiblock-slider-slider__info_2','font-size:'+ fontsizeinfo2mobile +'px!important;');
         // button
         document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.table .link-button-2','bottom:'+ margin_bottom_table_button2 +'px!important;');
         document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.mobile .link-button-2','bottom:'+ margin_bottom_mobile_button2 +'px!important;');
         document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.table .button-slider2 p','font-size:'+ fontsizebutton2table +'px!important;');
         document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.mobile .button-slider2 p','font-size:'+ fontsizebutton2mobile +'px!important;');
         document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+' .link-button-2 button.button-slider2:hover','background-color:'+ df_background_color_hover_link_button2+'!important');
         document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+' .link-button-2 button.button-slider2:hover');
         document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+' .link-button-2 button.button-slider2:hover','background:'+ df_background_color_hover_link_button2+'!important');
         document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+' .link-button-2 button.button-slider2:hover');
         document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+' button.button-slider2:hover p','color:'+ df_color_hover_link_button2 +'!important;');
         document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+' button.button-slider2:hover span','color:'+ df_color_hover_link_button2 +'!important;');
         document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+' button.button-slider2:hover a','color:'+ df_color_hover_link_button2 +'!important;');
         document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+' .link-button-2 button.button-slider2.df-trasparent-color-button2-true','background-color: transparent!important;');
         document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+' .link-button-2 button.button-slider2.df-trasparent-color-button2-true','background: transparent!important;');
         document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+' .link-button-2 button.button-slider2.df-trasparent-color-button2-true:hover','background-color: '+ df_background_color_hover_link_button2 +'!important;');
         document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+' .link-button-2 button.button-slider2.df-trasparent-color-button2-true:hover','background: '+ df_background_color_hover_link_button2 +'!important;');
         document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+' .link-button-2 button.button-slider2.df-trasparent-color-button2-true:hover');
         document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+' .link-button-2 button.button-slider2.df-trasparent-color-button2-true:hover');
         document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+' .link-button-2 a','color: '+ df_color_link_button2 +'!important' );
         document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+' .link-button-2 p','color: '+ df_color_link_button2 +'!important' );
         document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+' .link-button-2 span','color: '+ df_color_link_button2 +'!important' );
         // divide top
         document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.desktop .df-divide-2','height:'+ df_height_divide_2 +'px');
         document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.table .df-divide-2','height:'+ df_height_table_divide_2 +'px!important;');
         document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.mobile .df-divide-2','height:'+ df_height_mobile_divide_2 +'px!important;');
         document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+' .carousel-item.active .df-divide-2','transition: max-height '+bubiblock_dalay_divide_2+'s ease-in;');
         document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+' .df-divide-2','transition: max-height '+bubiblock_dalay_divide_2+'s ease-out;');
         // divide bottom
         document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.desktop .df-divide-bottom-2','height:'+ df_height_divide_bottom_2 +'px');
         document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.table .df-divide-bottom-2','height:'+ df_height_table_divide_bottom_2 +'px!important;');
         document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.mobile .df-divide-bottom-2','height:'+ df_height_mobile_divide_bottom_2 +'px!important;');
         document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+' .carousel-item.active .df-divide-bottom-2','transition: max-height '+bubiblock_dalay_divide_2_bottom+'s ease-in;');
         document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+' .df-divide-bottom-2','transition: max-height '+bubiblock_dalay_divide_2_bottom+'s ease-out;');

        // Slider 3
        // title
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.table h4.wp-block-bubiblock-slider-slider__title_3','bottom:'+ margin_bottom_table_caption3 +'px!important;');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.mobile h4.wp-block-bubiblock-slider-slider__title_3','bottom:'+ margin_bottom_mobile_caption3 +'px!important;');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.table h4.wp-block-bubiblock-slider-slider__title_3','font-size:'+ fontsizetitle3table +'px!important;');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.mobile h4.wp-block-bubiblock-slider-slider__title_3','font-size:'+ fontsizetitle3mobile +'px!important;');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.table h4.wp-block-bubiblock-slider-slider__title_3.df-caption-table-false','display:none;');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.mobile h4.wp-block-bubiblock-slider-slider__title_3.df-caption-mobile-false','display:none!important;');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.table p.wp-block-bubiblock-slider-slider__info_3.df-caption-table-false','display:none;');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.mobile p.wp-block-bubiblock-slider-slider__info_3.df-caption-mobile-false','display:none!important;');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.table .link-button-3.df-caption-table-false','display:none;');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.mobile .link-button-3.df-caption-mobile-false','display:none!important;');
        // info
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.table p.wp-block-bubiblock-slider-slider__info_3','bottom:'+ margin_bottom_table_info3 +'px!important;');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.mobile p.wp-block-bubiblock-slider-slider__info_3','bottom:'+ margin_bottom_mobile_info3 +'px!important;');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.table p.wp-block-bubiblock-slider-slider__info_3','font-size:'+ fontsizeinfo3table +'px!important;');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.mobile p.wp-block-bubiblock-slider-slider__info_3','font-size:'+ fontsizeinfo3mobile +'px!important;');
        // button
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.table .link-button-3','bottom:'+ margin_bottom_table_button3 +'px!important;');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.mobile .link-button-3','bottom:'+ margin_bottom_mobile_button3 +'px!important;');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.table .button-slider3 p','font-size:'+ fontsizebutton3table +'px!important;');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.mobile .button-slider3 p','font-size:'+ fontsizebutton3mobile +'px!important;');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+' .link-button-3 button.button-slider3:hover','background-color:'+ df_background_color_hover_link_button3+'!important');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+' .link-button-3 button.button-slider3:hover');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+' .link-button-3 button.button-slider3:hover','background:'+ df_background_color_hover_link_button3+'!important');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+' .link-button-3 button.button-slider3:hover');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+' button.button-slider3:hover p','color:'+ df_color_hover_link_button3 +'!important;');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+' button.button-slider3:hover span','color:'+ df_color_hover_link_button3 +'!important;');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+' button.button-slider3:hover a','color:'+ df_color_hover_link_button3 +'!important;');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+' .link-button-3 button.button-slider3.df-trasparent-color-button3-true','background-color: transparent!important;');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+' .link-button-3 button.button-slider3.df-trasparent-color-button3-true','background: transparent!important;');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+' .link-button-3 button.button-slider3.df-trasparent-color-button3-true:hover','background-color: '+ df_background_color_hover_link_button3 +'!important;');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+' .link-button-3 button.button-slider3.df-trasparent-color-button3-true:hover','background: '+ df_background_color_hover_link_button3 +'!important;');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+' .link-button-3 button.button-slider3.df-trasparent-color-button3-true:hover');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+' .link-button-3 button.button-slider3.df-trasparent-color-button3-true:hover');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+' .link-button-3 a','color: '+ df_color_link_button3 +'!important' );
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+' .link-button-3 p','color: '+ df_color_link_button3 +'!important' );
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+' .link-button-3 span','color: '+ df_color_link_button3 +'!important' );
        // divide top
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.desktop .df-divide-3','height:'+ df_height_divide_3 +'px');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.table .df-divide-3','height:'+ df_height_table_divide_3 +'px!important;');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.mobile .df-divide-3','height:'+ df_height_mobile_divide_3 +'px!important;');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+' .carousel-item.active .df-divide-3','transition: max-height '+bubiblock_dalay_divide_3+'s ease-in;');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+' .df-divide-3','transition: max-height '+bubiblock_dalay_divide_3+'s ease-out;');
        // divide bottom
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.desktop .df-divide-bottom-3','height:'+ df_height_divide_bottom_3 +'px');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.table .df-divide-bottom-3','height:'+ df_height_table_divide_bottom_3 +'px!important;');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.mobile .df-divide-bottom-3','height:'+ df_height_mobile_divide_bottom_3 +'px!important;');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+' .carousel-item.active .df-divide-bottom-3','transition: max-height '+bubiblock_dalay_divide_3_bottom+'s ease-in;');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+' .df-divide-bottom-3','transition: max-height '+bubiblock_dalay_divide_3_bottom+'s ease-out;');

        // Slider 4
        // title
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.table h4.wp-block-bubiblock-slider-slider__title_4','bottom:'+ margin_bottom_table_caption4 +'px!important;');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.mobile h4.wp-block-bubiblock-slider-slider__title_4','bottom:'+ margin_bottom_mobile_caption4 +'px!important;');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.table h4.wp-block-bubiblock-slider-slider__title_4','font-size:'+ fontsizetitle4table +'px!important;');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.mobile h4.wp-block-bubiblock-slider-slider__title_4','font-size:'+ fontsizetitle4mobile +'px!important;');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.table h4.wp-block-bubiblock-slider-slider__title_4.df-caption-table-false','display:none;');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.mobile h4.wp-block-bubiblock-slider-slider__title_4.df-caption-mobile-false','display:none!important;');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.table p.wp-block-bubiblock-slider-slider__info_4.df-caption-table-false','display:none;');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.mobile p.wp-block-bubiblock-slider-slider__info_4.df-caption-mobile-false','display:none!important;');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.table .link-button-4.df-caption-table-false','display:none;');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.mobile .link-button-4.df-caption-mobile-false','display:none!important;');
        // info
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.table p.wp-block-bubiblock-slider-slider__info_4','bottom:'+ margin_bottom_table_info4 +'px!important;');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.mobile p.wp-block-bubiblock-slider-slider__info_4','bottom:'+ margin_bottom_mobile_info4 +'px!important;');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.table p.wp-block-bubiblock-slider-slider__info_4','font-size:'+ fontsizeinfo4table +'px!important;');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.mobile p.wp-block-bubiblock-slider-slider__info_4','font-size:'+ fontsizeinfo4mobile +'px!important;');
        // button
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.table .link-button-4','bottom:'+ margin_bottom_table_button4 +'px!important;');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.mobile .link-button-4','bottom:'+ margin_bottom_mobile_button4 +'px!important;');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.table .button-slider4 p','font-size:'+ fontsizebutton4table +'px!important;');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.mobile .button-slider4 p','font-size:'+ fontsizebutton4mobile +'px!important;');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+' .link-button-4 button.button-slider4:hover','background-color:'+ df_background_color_hover_link_button4+'!important');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+' .link-button-4 button.button-slider4:hover');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+' .link-button-4 button.button-slider4:hover','background:'+ df_background_color_hover_link_button4+'!important');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+' .link-button-4 button.button-slider4:hover');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+' button.button-slider4:hover p','color:'+ df_color_hover_link_button4 +'!important;');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+' button.button-slider4:hover span','color:'+ df_color_hover_link_button4 +'!important;');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+' button.button-slider4:hover a','color:'+ df_color_hover_link_button4 +'!important;');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+' .link-button-4 button.button-slider4.df-trasparent-color-button4-true','background-color: transparent!important;');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+' .link-button-4 button.button-slider4.df-trasparent-color-button4-true','background: transparent!important;');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+' .link-button-4 button.button-slider4.df-trasparent-color-button4-true:hover','background-color: '+ df_background_color_hover_link_button4 +'!important;');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+' .link-button-4 button.button-slider4.df-trasparent-color-button4-true:hover','background: '+ df_background_color_hover_link_button4 +'!important;');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+' .link-button-4 button.button-slider4.df-trasparent-color-button4-true:hover');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+' .link-button-4 button.button-slider4.df-trasparent-color-button4-true:hover');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+' .link-button-4 a','color: '+ df_color_link_button4 +'!important' );
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+' .link-button-4 p','color: '+ df_color_link_button4 +'!important' );
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+' .link-button-4 span','color: '+ df_color_link_button4 +'!important' );
        // divide top
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.desktop .df-divide-4','height:'+ df_height_divide_4 +'px');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.table .df-divide-4','height:'+ df_height_table_divide_4 +'px!important;');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.mobile .df-divide-4','height:'+ df_height_mobile_divide_4 +'px!important;');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+' .carousel-item.active .df-divide-4','transition: max-height '+bubiblock_dalay_divide_4+'s ease-in;');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+' .df-divide-4','transition: max-height '+bubiblock_dalay_divide_4+'s ease-out;');
        // divide bottom
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.desktop .df-divide-bottom-4','height:'+ df_height_divide_bottom_4 +'px');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.table .df-divide-bottom-4','height:'+ df_height_table_divide_bottom_4 +'px!important;');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.mobile .df-divide-bottom-4','height:'+ df_height_mobile_divide_bottom_4 +'px!important;');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+' .carousel-item.active .df-divide-bottom-4','transition: max-height '+bubiblock_dalay_divide_4_bottom+'s ease-in;');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+' .df-divide-bottom-4','transition: max-height '+bubiblock_dalay_divide_4_bottom+'s ease-out;');

        // Slider 5
        // title
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.table h4.wp-block-bubiblock-slider-slider__title_5','bottom:'+ margin_bottom_table_caption5 +'px!important;');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.mobile h4.wp-block-bubiblock-slider-slider__title_5','bottom:'+ margin_bottom_mobile_caption5 +'px!important;');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.table h4.wp-block-bubiblock-slider-slider__title_5','font-size:'+ fontsizetitle5table +'px!important;');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.mobile h4.wp-block-bubiblock-slider-slider__title_5','font-size:'+ fontsizetitle5mobile +'px!important;');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.table h4.wp-block-bubiblock-slider-slider__title_5.df-caption-table-false','display:none;');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.mobile h4.wp-block-bubiblock-slider-slider__title_5.df-caption-mobile-false','display:none!important;');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.table p.wp-block-bubiblock-slider-slider__info_5.df-caption-table-false','display:none;');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.mobile p.wp-block-bubiblock-slider-slider__info_5.df-caption-mobile-false','display:none!important;');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.table .link-button-5.df-caption-table-false','display:none;');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.mobile .link-button-5.df-caption-mobile-false','display:none!important;');
        // info
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.table p.wp-block-bubiblock-slider-slider__info_5','bottom:'+ margin_bottom_table_info5 +'px!important;');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.mobile p.wp-block-bubiblock-slider-slider__info_5','bottom:'+ margin_bottom_mobile_info5 +'px!important;');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.table p.wp-block-bubiblock-slider-slider__info_5','font-size:'+ fontsizeinfo5table +'px!important;');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.mobile p.wp-block-bubiblock-slider-slider__info_5','font-size:'+ fontsizeinfo5mobile +'px!important;');
        // button
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.table .link-button-5','bottom:'+ margin_bottom_table_button5 +'px!important;');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.mobile .link-button-5','bottom:'+ margin_bottom_mobile_button5 +'px!important;');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.table .button-slider5 p','font-size:'+ fontsizebutton5table +'px!important;');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.mobile .button-slider5 p','font-size:'+ fontsizebutton5mobile +'px!important;');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+' .link-button-5 button.button-slider5:hover','background-color:'+ df_background_color_hover_link_button5+'!important');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+' .link-button-5 button.button-slider5:hover');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+' .link-button-5 button.button-slider5:hover','background:'+ df_background_color_hover_link_button5+'!important');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+' .link-button-5 button.button-slider5:hover');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+' button.button-slider5:hover p','color:'+ df_color_hover_link_button5 +'!important;');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+' button.button-slider5:hover span','color:'+ df_color_hover_link_button5 +'!important;');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+' button.button-slider5:hover a','color:'+ df_color_hover_link_button5 +'!important;');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+' .link-button-5 button.button-slider5.df-trasparent-color-button5-true','background-color: transparent!important;');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+' .link-button-5 button.button-slider5.df-trasparent-color-button5-true','background: transparent!important;');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+' .link-button-5 button.button-slider5.df-trasparent-color-button5-true:hover','background-color: '+ df_background_color_hover_link_button5 +'!important;');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+' .link-button-5 button.button-slider5.df-trasparent-color-button5-true:hover','background: '+ df_background_color_hover_link_button5 +'!important;');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+' .link-button-5 button.button-slider5.df-trasparent-color-button5-true:hover');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+' .link-button-5 button.button-slider5.df-trasparent-color-button5-true:hover');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+' .link-button-5 a','color: '+ df_color_link_button5 +'!important' );
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+' .link-button-5 p','color: '+ df_color_link_button5 +'!important' );
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+' .link-button-5 span','color: '+ df_color_link_button5 +'!important' );
        // divide top
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.desktop .df-divide-5','height:'+ df_height_divide_5 +'px');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.table .df-divide-5','height:'+ df_height_table_divide_5 +'px!important;');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.mobile .df-divide-5','height:'+ df_height_mobile_divide_5 +'px!important;');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+' .carousel-item.active .df-divide-5','transition: max-height '+bubiblock_dalay_divide_5+'s ease-in;');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+' .df-divide-5','transition: max-height '+bubiblock_dalay_divide_5+'s ease-out;');
        // divide bottom
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.desktop .df-divide-bottom-5','height:'+ df_height_divide_bottom_5 +'px');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.table .df-divide-bottom-5','height:'+ df_height_table_divide_bottom_5 +'px!important;');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+'.mobile .df-divide-bottom-5','height:'+ df_height_mobile_divide_bottom_5 +'px!important;');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+' .carousel-item.active .df-divide-bottom-5','transition: max-height '+bubiblock_dalay_divide_5_bottom+'s ease-in;');
        document.styleSheets[0].addRule('#carouselDFControlslider'+bubiblock_id_slider+' .df-divide-bottom-5','transition: max-height '+bubiblock_dalay_divide_5_bottom+'s ease-out;');

        // Divide Slider
        const bubiOptionsDivideTop=[
            { label: <svg className={'df-flip-editor'} viewBox="0 0 1000 100" height="100%" width="100%" preserveAspectRatio="none" fill="#007cba"><path d="M1000,40c0,0 -120.077,-38.076 -250,-38c-129.923,0.076 -345.105,78 -500,78c-154.895,0 -250,-30 -250,-30l0,50l1000,0l0,-60Z"></path></svg>, value: 'svg-1' },
            { label: <svg viewBox="0 0 500 65" height="100%" width="100%" preserveAspectRatio="none" fill="#007cba"><polygon points="500 0 0 0 0 65 250 25 500 65 500 0"/></svg>, value: 'svg-2' },
            { label: <svg viewBox="0 0 500 81" height="100%" width="100%" preserveAspectRatio="none" fill="#007cba"><path d="M0,45.68C59,60,146,81.07,250,81c103-.07,192-19,250-35.32V0H0Z" transform="translate(0 0)"/></svg>, value: 'svg-3' },
            { label: <svg viewBox="0 0 500 46.42" height="100%" width="100%" preserveAspectRatio="none" fill="#007cba"><g><path d="M500,22.64s-194.23,1.13-213,5.44c-34.74,8-37,18.34-37,18.34s-2-11.25-30.5-18.24C198.56,23.05,0,22.64,0,22.64V0H500Z"/></g></svg>, value: 'svg-4' },
        ]

        const bubiOptionsDivideBottom=[
            { label: <svg className={'df-flip-bottom'} viewBox="0 0 1000 100" height="100%" width="100%" preserveAspectRatio="none" fill="#007cba"><path d="M1000,40c0,0 -120.077,-38.076 -250,-38c-129.923,0.076 -345.105,78 -500,78c-154.895,0 -250,-30 -250,-30l0,50l1000,0l0,-60Z"></path></svg>, value: 'svg-1' },
            { label:  <svg viewBox="0 0 500 65" height="100%" width="100%" preserveAspectRatio="none" fill="#007cba"><polygon points="500 0 0 0 0 65 250 25 500 65 500 0"/></svg>, value: 'svg-2' },
            { label: <svg viewBox="0 0 500 81" height="100%" width="100%" preserveAspectRatio="none" fill="#007cba"><path d="M0,45.68C59,60,146,81.07,250,81c103-.07,192-19,250-35.32V0H0Z" transform="translate(0 0)"/></svg>, value: 'svg-3' },
            { label: <svg viewBox="0 0 500 46.42" height="100%" width="100%" preserveAspectRatio="none" fill="#007cba"><g><path d="M500,22.64s-194.23,1.13-213,5.44c-34.74,8-37,18.34-37,18.34s-2-11.25-30.5-18.24C198.56,23.05,0,22.64,0,22.64V0H500Z"/></g></svg>, value: 'svg-4' },
        ]

        return(
            <>
                <InspectorControls>
                    <PanelBody // General
                        icon={'admin-tools'}
                        className={'bubiblock-variation'}
                        title={__('General', 'bubiblock-slider')}
                        initialOpen={true}
                    >
                        <h6 className="df-inspector">{ __('Multiple Slider on the same page', 'bubiblock-slider')}</h6>
                        <SelectControl
                            label={__("ID","bubiblock-slider")}
                            help={__('If you insert more sliders on the same page you have to set different ID! Important: when you have many sliders on the same page when using responsive controls, always return the control to "Desktop" before saving!','bubiblocks-slider')}
                            options={[
                                {label: __('One','bubiblock-slider'), value: 'one'},
                                {label: __('Two','bubiblock-slider'), value: 'two'},
                                {label: __('Three','bubiblock-slider'), value: 'three'},
                                {label: __('Four','bubiblock-slider'), value: 'four'},
                                {label: __('Five','bubiblock-slider'), value: 'five'},
                            ]}
                            onChange={(val) => setAttributes({ bubiblock_id_slider: val })}
                            value={bubiblock_id_slider}
                        />
                        <h6 className="df-inspector">{ __('Show Slider', 'bubiblock-slider')}</h6>
                        <ToggleControl
                            label={ __( 'Show on Desktop','bubiblock-slider' ) }
                            checked={bubiblock_show_slider_desktop}
                            onChange={ (newValue) => setAttributes({bubiblock_show_slider_desktop: newValue}) }
                        />
                        <ToggleControl
                            label={ __( 'Show on Table','bubiblock-slider' ) }
                            checked={bubiblock_show_slider_table}
                            onChange={ (newValue) => setAttributes({bubiblock_show_slider_table: newValue}) }
                        />
                        <ToggleControl
                            label={ __( 'Show on Mobile','bubiblock-slider' ) }
                            checked={bubiblock_show_slider_mobile}
                            onChange={ (newValue) => setAttributes({bubiblock_show_slider_mobile: newValue}) }
                        />
                         <ButtonGroup
                            className={'df-button-group bubiblock-no-margin bubi-width-two'}
                        >
                            <h6 className="df-inspector bubi-mt-0">{ __('Slide Content', 'bubiblock-slider')}</h6>
                            <p className="df-inspector">{__('Each slide can have its own content or are child blocks fixed on top of all slides.','bubiblock-slider')}</p>
                            <Button
                                isSecondary
                                isPrimary={bubi_block_content_slider == 'bubiblock-block-slider'} onClick={() => setAttributes({ bubi_block_content_slider: 'bubiblock-block-slider' })}
                            >
                                {__('Fixed Content','bubiblock-slider')}
                            </Button>
                            <Button
                                isSecondary
                                isPrimary={bubi_block_content_slider == 'bubiblock-content-slider'} onClick={() => setAttributes({ bubi_block_content_slider: 'bubiblock-content-slider' })}
                            >
                                {__('Changing Content','bubiblock-slider')}
                            </Button>
                        </ButtonGroup>
                        <ButtonGroup
                            className={'df-button-group bubiblock-no-margin bubi-width-one bubi-mt-1'}
                        >
                            <Button
                                isSecondary
                                isPrimary={bubi_block_content_slider == 'bubiblock-blockcontent-slider'} onClick={() => setAttributes({ bubi_block_content_slider: 'bubiblock-blockcontent-slider' })}
                            >
                                {__('Fixed and Changing Content','bubiblock-slider')}
                            </Button>
                        </ButtonGroup>
                        {(bubi_block_content_slider == 'bubiblock-blockcontent-slider') &&
                            <Notice
                                status="info"
                                isDismissible={ false }
                            >
                                {__('First enter the Changing Content, then the Fixed Content!','bubiblock-slider')}
                            </Notice>
                        }
                        {(bubi_block_content_slider == 'bubiblock-block-slider') ==! (bubi_block_content_slider =='bubiblock-blockcontent-slider') &&
                        <>
                        <h6 class="df-inspector">{ __('Spacing', 'bubiblock-slider')}</h6>
                        <ButtonGroup
                            className={'df-button-group'}
                        >
                            <div class="df-group-button-resp">
                                <div class="bubi-col-6">
                                    <h6>{ __('Padding', 'bubiblock-slider')}</h6>
                                </div>
                                <div class="bubi-col-6">
                                    <Button
                                        icon={'laptop'}
                                        isSecondary
                                        className={'df-resp-button'}
                                        isPrimary={df_resp == 'desktop'} onClick={() => setAttributes({ df_resp: 'desktop' })}
                                    >
                                    </Button>
                                    <Button
                                        icon={'tablet'}
                                        isSecondary
                                        className={'df-resp-button'}
                                        isPrimary={df_resp == 'table'} onClick={() => setAttributes({ df_resp: 'table' })}
                                    >
                                    </Button>
                                    <Button
                                        icon={'smartphone'}
                                        isSecondary
                                        className={'df-resp-button'}
                                        isPrimary={df_resp == 'mobile'} onClick={() => setAttributes({ df_resp: 'mobile' })}
                                    >
                                    </Button>
                                </div>
                            </div>
                        </ButtonGroup>
                        {df_resp == 'desktop'&&
                            <>
                            <RangeControl
                                help={__('Px Unit(Desktop)','bubiblock-slider')}
                                beforeIcon={'arrow-left-alt'}
                                afterIcon={'arrow-right-alt'}
                                allowReset
                                resetFallbackValue={15}
                                step={1}
                                withInputField={false}
                                separatorType="none"
                                trackColor="#007cba"
                                isShiftStepEnabled
                                marks={[
                                    {
                                        value: 0,
                                        label: __('0','bubiblock-slider'),
                                    },
                                    {
                                        value: 30,
                                        label: __('30','bubiblock-slider'),
                                    },
                                    {
                                        value: 60,
                                        label: __('60','bubiblock-slider'),
                                    },
                                    {
                                        value: 90,
                                        label: __('90','bubiblock-slider'),
                                    },
                                    {
                                        value: 120,
                                        label: __('120','bubiblock-slider'),
                                    },
                                    {
                                        value: 150,
                                        label: __('150','bubiblock-slider'),
                                    },
                                ]}
                                railColor="#02abff"
                                value={ bubiblock_padding_block_slider }
                                onChange={ this.onChangeBubiblock_padding_block_slider }
                                min={ 0 }
                                max={ 150}
                            />
                            <RangeControl
                                help={__('Px Unit(Desktop)','bubiblock-slider')}
                                beforeIcon={'arrow-down-alt'}
                                afterIcon={'arrow-up-alt'}
                                allowReset
                                resetFallbackValue={15}
                                step={1}
                                withInputField={false}
                                separatorType="none"
                                trackColor="#007cba"
                                isShiftStepEnabled
                                marks={[
                                    {
                                        value: 0,
                                        label: __('0','bubiblock-slider'),
                                    },
                                    {
                                        value: 30,
                                        label: __('30','bubiblock-slider'),
                                    },
                                    {
                                        value: 60,
                                        label: __('60','bubiblock-slider'),
                                    },
                                    {
                                        value: 90,
                                        label: __('90','bubiblock-slider'),
                                    },
                                    {
                                        value: 120,
                                        label: __('120','bubiblock-slider'),
                                    },
                                    {
                                        value: 150,
                                        label: __('150','bubiblock-slider'),
                                    },
                                ]}
                                railColor="#02abff"
                                value={bubiblock_padding_b_block_slider }
                                onChange={ this.onChangeBubiblock_padding_b_block_slider }
                                min={ 0 }
                                max={ 150}
                            />
                            </>
                        }
                        {df_resp == 'table'&&
                                <>
                                <RangeControl
                                    help={__('Px Unit(Table)','bubiblock-slider')}
                                    beforeIcon={'arrow-left-alt'}
                                    afterIcon={'arrow-right-alt'}
                                    allowReset
                                    resetFallbackValue={10}
                                    step={1}
                                    withInputField={false}
                                    separatorType="none"
                                    trackColor="#007cba"
                                    isShiftStepEnabled
                                    marks={[
                                        {
                                            value: 0,
                                            label: __('0','bubiblock-slider'),
                                        },
                                        {
                                            value: 30,
                                            label: __('30','bubiblock-slider'),
                                        },
                                        {
                                            value: 60,
                                            label: __('60','bubiblock-slider'),
                                        },
                                        {
                                            value: 90,
                                            label: __('90','bubiblock-slider'),
                                        },
                                        {
                                            value: 120,
                                            label: __('120','bubiblock-slider'),
                                        },
                                        {
                                            value: 150,
                                            label: __('150','bubiblock-slider'),
                                        },
                                    ]}
                                    railColor="#02abff"
                                    value={ bubiblock_padding_block_slider_table }
                                    onChange={ this.onChangeBubiblock_padding_slider_table }
                                    min={ 0 }
                                    max={ 150}
                                />
                                <RangeControl
                                    help={__('Px Unit(Table)','bubiblock-slider')}
                                    beforeIcon={'arrow-down-alt'}
                                    afterIcon={'arrow-up-alt'}
                                    allowReset
                                    resetFallbackValue={10}
                                    step={1}
                                    withInputField={false}
                                    separatorType="none"
                                    trackColor="#007cba"
                                    isShiftStepEnabled
                                    marks={[
                                        {
                                            value: 0,
                                            label: __('0','bubiblock-slider'),
                                        },
                                        {
                                            value: 30,
                                            label: __('30','bubiblock-slider'),
                                        },
                                        {
                                            value: 60,
                                            label: __('60','bubiblock-slider'),
                                        },
                                        {
                                            value: 90,
                                            label: __('90','bubiblock-slider'),
                                        },
                                        {
                                            value: 120,
                                            label: __('120','bubiblock-slider'),
                                        },
                                        {
                                            value: 150,
                                            label: __('150','bubiblock-slider'),
                                        },
                                    ]}
                                    railColor="#02abff"
                                    value={bubiblock_padding_b_block_slider_table }
                                    onChange={ this.onChangeBubiblock_padding_b_slider_table }
                                    min={ 0 }
                                    max={ 150}
                                />
                                </>
                            }
                            {df_resp == 'mobile'&&
                                <>
                                <RangeControl
                                    help={__('Px Unit(Mobile)','bubiblock-slider')}
                                    beforeIcon={'arrow-left-alt'}
                                    afterIcon={'arrow-right-alt'}
                                    allowReset
                                    resetFallbackValue={5}
                                    step={1}
                                    withInputField={false}
                                    separatorType="none"
                                    trackColor="#007cba"
                                    isShiftStepEnabled
                                    marks={[
                                        {
                                            value: 0,
                                            label: __('0','bubiblock-slider'),
                                        },
                                        {
                                            value: 30,
                                            label: __('30','bubiblock-slider'),
                                        },
                                        {
                                            value: 60,
                                            label: __('60','bubiblock-slider'),
                                        },
                                        {
                                            value: 90,
                                            label: __('90','bubiblock-slider'),
                                        },
                                        {
                                            value: 120,
                                            label: __('120','bubiblock-slider'),
                                        },
                                        {
                                            value: 150,
                                            label: __('150','bubiblock-slider'),
                                        },
                                    ]}
                                    railColor="#02abff"
                                    value={ bubiblock_padding_block_slider_mobile }
                                    onChange={ this.onChangeBubiblock_padding_block_slider_mobile }
                                    min={ 0 }
                                    max={ 150}
                                />
                                <RangeControl
                                    help={__('Px Unit(Mobile)','bubiblock-slider')}
                                    beforeIcon={'arrow-down-alt'}
                                    afterIcon={'arrow-up-alt'}
                                    allowReset
                                    resetFallbackValue={5}
                                    step={1}
                                    withInputField={false}
                                    separatorType="none"
                                    trackColor="#007cba"
                                    isShiftStepEnabled
                                    marks={[
                                        {
                                            value: 0,
                                            label: __('0','bubiblock-slider'),
                                        },
                                        {
                                            value: 30,
                                            label: __('30','bubiblock-slider'),
                                        },
                                        {
                                            value: 60,
                                            label: __('60','bubiblock-slider'),
                                        },
                                        {
                                            value: 90,
                                            label: __('90','bubiblock-slider'),
                                        },
                                        {
                                            value: 120,
                                            label: __('120','bubiblock-slider'),
                                        },
                                        {
                                            value: 150,
                                            label: __('150','bubiblock-slider'),
                                        },
                                    ]}
                                    railColor="#02abff"
                                    value={bubiblock_padding_b_block_slider_mobile }
                                    onChange={ this.onChangeBubiblock_padding_b_block_slider_mobile }
                                    min={ 0 }
                                    max={ 150}
                                />
                                </>
                            }
                            <h6 id={'bg'} class="df-inspector" >{ __('Background Color', 'bubiblock-slider')}
                            {bubiblock_background_color_block_slider &&
                                <ColorIndicator
                                    colorValue={ bubiblock_background_color_block_slider }
                                />
                            }
                            </h6>
                            <div class={'legend-color-none'}>
                                <ColorPaletteControl
                                    value={  bubiblock_background_color_block_slider}
                                    colors={ bubiColors }
                                    onChange={ (newValue) => setAttributes({ bubiblock_background_color_block_slider: newValue}) }
                                />
                            </div>
                            <RangeControl
                                label={__('Opacity','bubiblock-slider')}
                                beforeIcon={'hidden'}
                                afterIcon={'visibility'}
                                allowReset
                                resetFallbackValue={1}
                                step={.1}
                                withInputField={false}
                                separatorType="none"
                                trackColor="#007cba"
                                isShiftStepEnabled
                                marks={[
                                    {
                                        value: 0,
                                        label: __('0','bubiblock-slider'),
                                    },
                                    {
                                        value: .2,
                                        label: __('.2','bubiblock-slider'),
                                    },

                                    {
                                        value: .4,
                                        label: __('.4','bubiblock-slider'),
                                    },
                                    {
                                        value: .6,
                                        label: __('.6','bubiblock-slider'),
                                    },
                                    {
                                        value: .8,
                                        label: __('.8','bubiblock-slider'),
                                    },
                                    {
                                        value: 1,
                                        label: __('1','bubiblock-slider'),
                                    },
                                ]}
                                railColor="#02abff"
                                value={ bubiopacityblock_slider }
                                onChange={ this.onChangeBubiopacityblock_slider }
                                min={ 0 }
                                max={ 1}
                            />
                        </>
                        }
                        <h6 className="df-inspector">{ __('Carousel Touch', 'bubiblock-slider')}</h6>
                        <p className="df-inspector">{__('This setting will only be visible in the Front-end!','bubiblock-slider')}</p>
                        <ToggleControl
                            checked={bubiblock_carousle_touch}
                            onChange={this.onChangeBubiblock_carousle_touch}
                        />
                    </PanelBody>
                    <PanelBody // Styles
                        icon={'admin-appearance'}
                        className={'bubiblock-variation'}
                        title={__('Styles', 'bubiblock-slider')}
                        initialOpen={false}
                    >
                    <h6 class="df-inspector">{ __('Size', 'bubiblock-slider')}</h6>
                    <ButtonGroup
                        className={'df-button-group'}
                    >
                        <div class="df-group-button-resp">
                            <div class="bubi-col-6">
                                <h6>{ __('Height', 'bubiblock-slider')}</h6>
                            </div>
                            <div class="bubi-col-6">
                                <Button
                                    icon={'laptop'}
                                    isSecondary
                                    className={'df-resp-button'}
                                    isPrimary={df_resp == 'desktop'} onClick={() => setAttributes({ df_resp: 'desktop' })}
                                >
                                </Button>
                                <Button
                                    icon={'tablet'}
                                    isSecondary
                                    className={'df-resp-button'}
                                    isPrimary={df_resp == 'table'} onClick={() => setAttributes({ df_resp: 'table' })}
                                >
                                </Button>
                                <Button
                                    icon={'smartphone'}
                                    isSecondary
                                    className={'df-resp-button'}
                                    isPrimary={df_resp == 'mobile'} onClick={() => setAttributes({ df_resp: 'mobile' })}
                                >
                                </Button>
                            </div>
                        </div>
                        {df_height_slider_auto !=1 &&
                            <>
                                {(df_resp=='desktop' ) &&
                                    <RangeControl
                                        label={__("Fixed (Desktop)","bubiblock-slider")}
                                        help={__("Px unit","bubiblock-slider")}
                                        value={ height_slider }
                                        onChange={ this.onChangeHeight_slider }
                                        min={200}
                                        max={2000}
                                    />
                                }
                                {(df_resp=='table' ) &&
                                    <RangeControl
                                        label={__("Fixed (Tablet)","bubiblock-slider")}
                                        help={__("Px unit","bubiblock-slider")}
                                        value={ height_slider_table }
                                        onChange={ this.onChangeHeight_slider_table }
                                        min={200}
                                        max={1800}
                                    />
                                }
                                {(df_resp=='mobile' ) &&
                                    <RangeControl
                                        label={__("Fixed (Mobile)","bubiblock-slider")}
                                        help={__("Px unit","bubiblock-slider")}
                                        value={ height_slider_mobile }
                                        onChange={ this.onChangeHeight_slider_mobile }
                                        min={100}
                                        max={1500}
                                    />
                                }
                            </>
                        }
                        {(df_resp=='desktop' ) &&
                            <>
                            <ToggleControl
                                label={ __( 'Adaptive Height Slider','bubiblock-slider' ) }
                                checked={df_height_slider_auto}
                                onChange={this.onChangeDf_height_slider_auto}
                            />
                            {df_height_slider_auto &&
                                <Notice
                                    status="info"
                                    isDismissible={ false }
                                >
                                    {__('Important: if you set height auto you have to insert images of equal size! Do not use this function if you have background color slides!If you use video and images together we recommend using this function, the size for the images must be 1024x576 px','bubiblock-slider')}
                                </Notice>
                            }
                            <ToggleControl
                                label={ __( 'Full width Background Slider','bubiblock-slider' ) }
                                checked={bubiblock_full_slider}
                                onChange={this.onChangeBubiblock_full_slider}
                            />
                            {bubiblock_full_slider &&
                                <Notice
                                    status="info"
                                    isDismissible={ false }
                                >
                                    {__('Full Width Background Slider preview is not available in the editor, check the live site to see it in action. Alternatively, if your theme supports it, you can use the "Change Alignment" block from the Toolbar and select "Full Width".','bubiblock-slider')}
                                </Notice>
                            }
                            </>
                        }
                        </ButtonGroup>
                        <h6 class="df-inspector">{ __('Spacing', 'bubiblock-slider')}</h6>
                        <ButtonGroup
                            className={'df-button-group'}
                        >
                            <div class="df-group-button-resp">
                                <div class="bubi-col-6">
                                    <h6>{ __('Padding', 'bubiblock-slider')}</h6>
                                </div>
                                <div class="bubi-col-6">
                                    <Button
                                        icon={'laptop'}
                                        isSecondary
                                        className={'df-resp-button'}
                                        isPrimary={df_resp == 'desktop'} onClick={() => setAttributes({ df_resp: 'desktop' })}
                                    >
                                    </Button>
                                    <Button
                                        icon={'tablet'}
                                        isSecondary
                                        className={'df-resp-button'}
                                        isPrimary={df_resp == 'table'} onClick={() => setAttributes({ df_resp: 'table' })}
                                    >
                                    </Button>
                                    <Button
                                        icon={'smartphone'}
                                        isSecondary
                                        className={'df-resp-button'}
                                        isPrimary={df_resp == 'mobile'} onClick={() => setAttributes({ df_resp: 'mobile' })}
                                    >
                                    </Button>
                                </div>
                            </div>
                            {(df_resp=='desktop' ) &&
                                <>
                                <RangeControl
                                    help={__('Px Unit(Desktop)','bubiblock-slider')}
                                    beforeIcon={'arrow-left-alt'}
                                    afterIcon={'arrow-right-alt'}
                                    allowReset
                                    resetFallbackValue={0}
                                    step={1}
                                    withInputField={false}
                                    separatorType="none"
                                    trackColor="#007cba"
                                    isShiftStepEnabled
                                    marks={[
                                        {
                                            value: 0,
                                            label: __('0','bubiblock-slider'),
                                        },
                                        {
                                            value: 20,
                                            label: __('20','bubiblock-slider'),
                                        },
                                        {
                                            value: 40,
                                            label: __('40','bubiblock-slider'),
                                        },
                                        {
                                            value: 60,
                                            label: __('60','bubiblock-slider'),
                                        },
                                        {
                                            value: 80,
                                            label: __('80','bubiblock-slider'),
                                        },
                                        {
                                            value: 100,
                                            label: __('100','bubiblock-slider'),
                                        },
                                    ]}
                                    railColor="#02abff"
                                    value={ bubiblock_padding_slider }
                                    onChange={ this.onChangeBubiblock_padding_slider }
                                    min={ 0 }
                                    max={ 100}
                                />
                                <RangeControl
                                    help={__('Px Unit(Desktop)','bubiblock-slider')}
                                    beforeIcon={'arrow-down-alt'}
                                    afterIcon={'arrow-up-alt'}
                                    allowReset
                                    resetFallbackValue={0}
                                    step={1}
                                    withInputField={false}
                                    separatorType="none"
                                    trackColor="#007cba"
                                    isShiftStepEnabled
                                    marks={[
                                        {
                                            value: 0,
                                            label: __('0','bubiblock-slider'),
                                        },
                                        {
                                            value: 20,
                                            label: __('20','bubiblock-slider'),
                                        },
                                        {
                                            value: 40,
                                            label: __('40','bubiblock-slider'),
                                        },
                                        {
                                            value: 60,
                                            label: __('60','bubiblock-slider'),
                                        },
                                        {
                                            value: 80,
                                            label: __('80','bubiblock-slider'),
                                        },
                                        {
                                            value: 100,
                                            label: __('100','bubiblock-slider'),
                                        },
                                    ]}
                                    railColor="#02abff"
                                    value={ bubiblock_padding_b_slider }
                                    onChange={ this.onChangeBubiblock_padding_b_slider }
                                    min={ 0 }
                                    max={ 100}
                                />
                                </>
                            }
                            {(df_resp=='table' ) &&
                                <>
                                <RangeControl
                                    help={__('Px Unit(Table)','bubiblock-slider')}
                                    beforeIcon={'arrow-left-alt'}
                                    afterIcon={'arrow-right-alt'}
                                    allowReset
                                    resetFallbackValue={0}
                                    step={1}
                                    withInputField={false}
                                    separatorType="none"
                                    trackColor="#007cba"
                                    isShiftStepEnabled
                                    marks={[
                                        {
                                            value: 0,
                                            label: __('0','bubiblock-slider'),
                                        },
                                        {
                                            value: 20,
                                            label: __('20','bubiblock-slider'),
                                        },
                                        {
                                            value: 40,
                                            label: __('40','bubiblock-slider'),
                                        },
                                        {
                                            value: 60,
                                            label: __('60','bubiblock-slider'),
                                        },
                                        {
                                            value: 80,
                                            label: __('80','bubiblock-slider'),
                                        },
                                        {
                                            value: 100,
                                            label: __('100','bubiblock-slider'),
                                        },
                                    ]}
                                    railColor="#02abff"
                                    value={ bubiblock_padding_table_slider }
                                    onChange={(val) => setAttributes({bubiblock_padding_table_slider: val})}
                                    min={ 0 }
                                    max={ 100}
                                />
                                <RangeControl
                                    help={__('Px Unit(Table)','bubiblock-slider')}
                                    beforeIcon={'arrow-down-alt'}
                                    afterIcon={'arrow-up-alt'}
                                    allowReset
                                    resetFallbackValue={0}
                                    step={1}
                                    withInputField={false}
                                    separatorType="none"
                                    trackColor="#007cba"
                                    isShiftStepEnabled
                                    marks={[
                                        {
                                            value: 0,
                                            label: __('0','bubiblock-slider'),
                                        },
                                        {
                                            value: 20,
                                            label: __('20','bubiblock-slider'),
                                        },
                                        {
                                            value: 40,
                                            label: __('40','bubiblock-slider'),
                                        },
                                        {
                                            value: 60,
                                            label: __('60','bubiblock-slider'),
                                        },
                                        {
                                            value: 80,
                                            label: __('80','bubiblock-slider'),
                                        },
                                        {
                                            value: 100,
                                            label: __('100','bubiblock-slider'),
                                        },
                                    ]}
                                    railColor="#02abff"
                                    value={ bubiblock_padding_b_table_slider }
                                    onChange={(val) => setAttributes({bubiblock_padding_b_table_slider: val})}
                                    min={ 0 }
                                    max={ 100}
                                />
                                </>
                            }
                            {(df_resp=='mobile' ) &&
                                 <>
                                 <RangeControl
                                     help={__('Px Unit(Mobile)','bubiblock-slider')}
                                     beforeIcon={'arrow-left-alt'}
                                     afterIcon={'arrow-right-alt'}
                                     allowReset
                                     resetFallbackValue={0}
                                     step={1}
                                     withInputField={false}
                                     separatorType="none"
                                     trackColor="#007cba"
                                     isShiftStepEnabled
                                     marks={[
                                         {
                                             value: 0,
                                             label: __('0','bubiblock-slider'),
                                         },
                                         {
                                             value: 20,
                                             label: __('20','bubiblock-slider'),
                                         },
                                         {
                                             value: 40,
                                             label: __('40','bubiblock-slider'),
                                         },
                                         {
                                             value: 60,
                                             label: __('60','bubiblock-slider'),
                                         },
                                         {
                                             value: 80,
                                             label: __('80','bubiblock-slider'),
                                         },
                                         {
                                             value: 100,
                                             label: __('100','bubiblock-slider'),
                                         },
                                     ]}
                                     railColor="#02abff"
                                     value={ bubiblock_padding_mobile_slider }
                                     onChange={(val) => setAttributes({bubiblock_padding_mobile_slider: val})}
                                     min={ 0 }
                                     max={ 100}
                                 />
                                 <RangeControl
                                     help={__('Px Unit(Mobile)','bubiblock-slider')}
                                     beforeIcon={'arrow-down-alt'}
                                     afterIcon={'arrow-up-alt'}
                                     allowReset
                                     resetFallbackValue={0}
                                     step={1}
                                     withInputField={false}
                                     separatorType="none"
                                     trackColor="#007cba"
                                     isShiftStepEnabled
                                     marks={[
                                         {
                                             value: 0,
                                             label: __('0','bubiblock-slider'),
                                         },
                                         {
                                             value: 20,
                                             label: __('20','bubiblock-slider'),
                                         },
                                         {
                                             value: 40,
                                             label: __('40','bubiblock-slider'),
                                         },
                                         {
                                             value: 60,
                                             label: __('60','bubiblock-slider'),
                                         },
                                         {
                                             value: 80,
                                             label: __('80','bubiblock-slider'),
                                         },
                                         {
                                             value: 100,
                                             label: __('100','bubiblock-slider'),
                                         },
                                     ]}
                                     railColor="#02abff"
                                     value={ bubiblock_padding_b_mobile_slider }
                                     onChange={(val) => setAttributes({bubiblock_padding_b_mobile_slider: val})}
                                     min={ 0 }
                                     max={ 100}
                                 />
                                 </>
                            }
                        </ButtonGroup>
                         <h6 class="df-inspector">{ __('Padding Caption', 'bubiblock-slider')}</h6>
                        <ButtonGroup
                            className={'df-button-group'}
                        >
                            <div class="df-group-button-resp">
                                <div class="bubi-col-6">
                                    <h6>{ __('Choose', 'bubiblock-slider')}</h6>
                                </div>
                                <div class="bubi-col-6">
                                    <Button
                                        icon={'laptop'}
                                        isSecondary
                                        className={'df-resp-button'}
                                        isPrimary={df_resp == 'desktop'} onClick={() => setAttributes({ df_resp: 'desktop' })}
                                    >
                                    </Button>
                                    <Button
                                        icon={'tablet'}
                                        isSecondary
                                        className={'df-resp-button'}
                                        isPrimary={df_resp == 'table'} onClick={() => setAttributes({ df_resp: 'table' })}
                                    >
                                    </Button>
                                    <Button
                                        icon={'smartphone'}
                                        isSecondary
                                        className={'df-resp-button'}
                                        isPrimary={df_resp == 'mobile'} onClick={() => setAttributes({ df_resp: 'mobile' })}
                                    >
                                    </Button>
                                </div>
                            </div>
                            {(df_resp=='desktop' ) &&
                                <RangeControl
                                    label={__('Left(Desktop)','bubiblock-slider')}
                                    help={__('px Unit','bubiblock-slider')}
                                    beforeIcon={'arrow-left-alt'}
                                    afterIcon={'arrow-right-alt'}
                                    allowReset
                                    resetFallbackValue={0}
                                    step={1}
                                    withInputField={false}
                                    separatorType="none"
                                    trackColor="#007cba"
                                    isShiftStepEnabled
                                    marks={[
                                        {
                                            value: -50,
                                            label: __('-50','bubiblock-slider'),
                                        },
                                        {
                                            value: 0,
                                            label: __('0','bubiblock-slider'),
                                        },
                                        {
                                            value: 50,
                                            label: __('50','bubiblock-slider'),
                                        },
                                        {
                                            value: 100,
                                            label: __('100','bubiblock-slider'),
                                        },
                                    ]}
                                    railColor="#02abff"
                                    value={ bubiblock_padding_caption }
                                    onChange={(val) => setAttributes({bubiblock_padding_caption: val})}
                                    min={ -50 }
                                    max={ 100}
                                />
                            }
                            {(df_resp=='table' ) &&
                                <>
                                <RangeControl
                                    label={__('Left(Table)','bubiblock-slider')}
                                    help={__('px Unit','bubiblock-slider')}
                                    beforeIcon={'arrow-left-alt'}
                                    afterIcon={'arrow-right-alt'}
                                    allowReset
                                    resetFallbackValue={0}
                                    step={1}
                                    withInputField={false}
                                    separatorType="none"
                                    trackColor="#007cba"
                                    isShiftStepEnabled
                                    marks={[
                                        {
                                            value: -50,
                                            label: __('-50','bubiblock-slider'),
                                        },
                                        {
                                            value: 0,
                                            label: __('0','bubiblock-slider'),
                                        },
                                        {
                                            value: 50,
                                            label: __('50','bubiblock-slider'),
                                        },
                                        {
                                            value: 100,
                                            label: __('100','bubiblock-slider'),
                                        },
                                    ]}
                                    railColor="#02abff"
                                    value={ bubiblock_padding_table_caption }
                                    onChange={(val) => setAttributes({bubiblock_padding_table_caption: val})}
                                    min={ -50 }
                                    max={ 100}
                                />
                                <ToggleControl
                                    label={ __('Show Button(Table)','bubiblock-slider' ) }
                                    checked={bubiblock_display_button_table_caption}
                                    onChange={(val) => setAttributes({bubiblock_display_button_table_caption: val})}
                                />
                                </>
                            }
                            {(df_resp=='mobile' ) &&
                                <>
                                <RangeControl
                                    label={__('Left(Mobile)','bubiblock-slider')}
                                    help={__('px Unit','bubiblock-slider')}
                                    beforeIcon={'arrow-left-alt'}
                                    afterIcon={'arrow-right-alt'}
                                    allowReset
                                    resetFallbackValue={0}
                                    step={1}
                                    withInputField={false}
                                    separatorType="none"
                                    trackColor="#007cba"
                                    isShiftStepEnabled
                                    marks={[
                                        {
                                            value: -50,
                                            label: __('-50','bubiblock-slider'),
                                        },
                                        {
                                            value: 0,
                                            label: __('0','bubiblock-slider'),
                                        },
                                        {
                                            value: 50,
                                            label: __('50','bubiblock-slider'),
                                        },
                                        {
                                            value: 100,
                                            label: __('100','bubiblock-slider'),
                                        },
                                    ]}
                                    railColor="#02abff"
                                    value={ bubiblock_padding_mobile_caption }
                                    onChange={(val) => setAttributes({bubiblock_padding_mobile_caption: val})}
                                    min={ -50 }
                                    max={ 100}
                                />
                                <ToggleControl
                                    label={ __('Show Button(Mobile)','bubiblock-slider' ) }
                                    checked={bubiblock_display_button_mobile_caption}
                                    onChange={(val) => setAttributes({bubiblock_display_button_mobile_caption: val})}
                                />
                                </>
                            }
                        </ButtonGroup>
                        <h6 class="df-inspector">{ __('Border', 'bubiblock-slider')}</h6>
                        <RangeControl
                            label={__('Border Radius Item','bubiblock-slider')}
                            help={__('% Unit','bubiblock-slider')}
                            beforeIcon={'fullscreen-alt'}
                            afterIcon={'fullscreen-exit-alt'}
                            allowReset
                            resetFallbackValue={0}
                            step={1}
                            withInputField={false}
                            separatorType="none"
                            trackColor="#007cba"
                            isShiftStepEnabled
                            marks={[
                                {
                                    value: 0,
                                    label: __('0','bubiblock-slider'),
                                },
                                {
                                    value: 10,
                                    label: __('10','bubiblock-slider'),
                                },
                                {
                                    value: 20,
                                    label: __('20','bubiblock-slider'),
                                },
                                {
                                    value: 30,
                                    label: __('30','bubiblock-slider'),
                                },
                                {
                                    value: 40,
                                    label: __('40','bubiblock-slider'),
                                },
                                {
                                    value: 50,
                                    label: __('50','bubiblock-slider'),
                                },
                            ]}
                            railColor="#02abff"
                            value={ bubiblock_radius_slider }
                            onChange={ this.onChangeBubiblock_radius_slider }
                            min={ 0 }
                            max={ 50}
                        />
                        <h6 id={'bg'} class="df-inspector" >{ __('Background Color', 'bubiblock-slider')}
                        {bubiblock_background_color_slider &&
                            <ColorIndicator
                                colorValue={ bubiblock_background_color_slider }
                            />
                        }
                        </h6>
                        <div class={'legend-color-none'}>
                            <ColorPaletteControl
                                value={  bubiblock_background_color_slider}
                                colors={ bubiColors }
                                onChange={ (newValue) => setAttributes({bubiblock_background_color_slider: newValue}) }
                            />
                        </div>
                    </PanelBody>
                    <PanelBody // Typography
                        icon={'editor-spellcheck'}
                        title={__('Typography', 'bubiblock-slider')}
                        initialOpen={false}
                    >
                        <div className={'bubi-mt-2 bubi-mb-2'}>
                        <ToggleControl
                            label={ __('Enable or disable Custom Typography','bubiblock-slider' ) }
                            help={__('You can use the general typography of your site, or choose the BubiBlock typography.To see the result you need to refresh the page!','bubiblock-slider')}
                            checked={bubiblock_typography_custom}
                            onChange={(val) => setAttributes({bubiblock_typography_custom: val})}
                        />
                        </div>
                        {bubiblock_typography_custom &&
                        <TabPanel
                            className="bubiblock-tab-panel"
                            activeClass="bubiblock-active-tab"
                            orientation="horizontal"
                            initialTabName="tab1"
                            onSelect={ (className) => console.log(className) }
                            tabs={ [
                                {
                                    name: 'tab1',
                                    icon:'admin-site-alt',
                                    title: __('Title','bubiblock-slider'),
                                    className: 'tab-one',
                                },
                                {
                                    name: 'tab2',
                                    title:  __('Descritpion','bubiblock-slider'),
                                    className: 'tab-two',
                                },
                                {
                                    name: 'tab3',
                                    title:  __('Button','bubiblock-slider'),
                                    className: 'tab-three',
                                },
                            ] }

                        >
                            {
                                ( tab ) => (
                                    <>
                                    <PanelBody
                                        className={'bubi-tab-1 '+tab.name}
                                    >
                                        <SelectControl
                                            label={__("Font Family","bubiblock-slider")}
                                            options={bubiOptionsFont}
                                            onChange={this.onChangeBubiblcok_fontfamily}
                                            value={bubiblcok_fontfamily}
                                        />
                                        <SelectControl
                                            label={__("Font Weight","bubiblock-slider")}
                                            help={__('Not all fonts support all weights!','bubiblocks-slider')}
                                            options={bubiOptionsWeight}
                                            onChange={this.onChangeBubiblcok_fontfamily_weight}
                                            value={bubiblcok_fontfamily_weight}
                                        />
                                        <RangeControl
                                            label={__('Line Height','bubiblock-slider')}
                                            beforeIcon={'arrow-down-alt'}
                                            afterIcon={'arrow-up-alt'}
                                            allowReset
                                            resetFallbackValue={2}
                                            step={.5}
                                            withInputField={false}
                                            separatorType="none"
                                            trackColor="#007cba"
                                            isShiftStepEnabled
                                            marks={[
                                                {
                                                    value: .5,
                                                    label: __('.5','bubiblock-slider'),
                                                },
                                                {
                                                    value: 1,
                                                    label: __('1','bubiblock-slider'),
                                                },
                                                {
                                                    value: 1.5,
                                                    label: __('1.5','bubiblock-slider'),
                                                },
                                                {
                                                    value: 2,
                                                    label: __('2','bubiblock-slider'),
                                                },
                                                {
                                                    value: 2.5,
                                                    label: __('2.5','bubiblock-slider'),
                                                },
                                                {
                                                    value: 3,
                                                    label: __('3','bubiblock-slider'),
                                                },
                                            ]}
                                            railColor="#02abff"
                                            value={ bubiblock_line_height_title }
                                            onChange={(val) => setAttributes({ bubiblock_line_height_title: val})}
                                            min={ .5 }
                                            max={ 3}
                                        />
                                    </PanelBody>
                                    <PanelBody
                                        className={'bubi-tab-2 '+tab.name}
                                    >
                                     <SelectControl
                                        label={__("Font Family","bubiblock-slider")}
                                        options={bubiOptionsFont}
                                         onChange={this.onChangeBubiblcok_fontfamily_descritpion}
                                         value={bubiblcok_fontfamily_descritpion}
                                    />
                                    <SelectControl
                                        label={__("Font Weight","bubiblock-slider")}
                                        help={__('Not all fonts support all weights!','bubiblocks-slider')}
                                        options={bubiOptionsWeight}
                                        onChange={this.onChangeBubiblcok_fontfamily_weight_description}
                                        value={bubiblcok_fontfamily_weight_description}
                                    />
                                             <RangeControl
                                            label={__('Line Height','bubiblock-slider')}
                                            beforeIcon={'arrow-down-alt'}
                                            afterIcon={'arrow-up-alt'}
                                            allowReset
                                            resetFallbackValue={2}
                                            step={.5}
                                            withInputField={false}
                                            separatorType="none"
                                            trackColor="#007cba"
                                            isShiftStepEnabled
                                            marks={[
                                                {
                                                    value: .5,
                                                    label: __('.5','bubiblock-slider'),
                                                },
                                                {
                                                    value: 1,
                                                    label: __('1','bubiblock-slider'),
                                                },
                                                {
                                                    value: 1.5,
                                                    label: __('1.5','bubiblock-slider'),
                                                },
                                                {
                                                    value: 2,
                                                    label: __('2','bubiblock-slider'),
                                                },
                                                {
                                                    value: 2.5,
                                                    label: __('2.5','bubiblock-slider'),
                                                },
                                                {
                                                    value: 3,
                                                    label: __('3','bubiblock-slider'),
                                                },
                                            ]}
                                            railColor="#02abff"
                                            value={ bubiblock_line_height_info }
                                            onChange={(val) => setAttributes({ bubiblock_line_height_info: val})}
                                            min={ .5 }
                                            max={ 3}
                                        />
                                 </PanelBody>
                                 <PanelBody
                                        className={'bubi-tab-3 '+tab.name}
                                    >
                                     <SelectControl
                                        label={__("Font Family","bubiblock-slider")}
                                        options={bubiOptionsFont}
                                        onChange={this.onChangeBubiblcok_fontfamily_button}
                                        value={bubiblcok_fontfamily_button}
                                    />
                                    <SelectControl
                                        label={__("Font Weight","bubiblock-slider")}
                                        help={__('Not all fonts support all weights!','bubiblocks-slider')}
                                        options={bubiOptionsWeight}
                                        onChange={this.onChangeBubiblcok_fontfamily_weight_button}
                                        value={bubiblcok_fontfamily_weight_button}
                                    />
                                 </PanelBody>
                                 </>
                                )
	                        }
                        </TabPanel>
                        }
                    </PanelBody>
                    <PanelBody // Settings
                        icon={'admin-generic'}
                        title={__('Settings', 'bubiblock-slider')}
                        initialOpen={false}
                    >
                        <h6 className="df-inspector">{ __('Animation', 'bubiblock-slider')}</h6>
                        <ButtonGroup
                            className={'df-button-group bubiblock-no-margin bubi-width-three'}
                        >
                            <Button
                                isSecondary
                                isPrimary={df_effect_slider == 'df-slider-slide'} onClick={() => setAttributes({ df_effect_slider: 'df-slider-slide' })}
                            >
                                {__('Slider','bubiblock-slider')}
                            </Button>
                            <Button
                                isSecondary
                                isPrimary={df_effect_slider == 'carousel-fade'} onClick={() => setAttributes({ df_effect_slider: 'carousel-fade' })}
                            >
                                {__('Fade','bubiblock-slider')}
                            </Button>
                            <Button
                                isSecondary
                                isPrimary={df_effect_slider == 'bubiblock-flip'} onClick={() => setAttributes({ df_effect_slider: 'bubiblock-flip' })}
                            >
                                {__('Flip','bubiblock-slider')}
                            </Button>
                            {(df_effect_slider == 'carousel-fade') &&
                                <Notice
                                    status="info"
                                    isDismissible={ false }
                                >
                                    {__('With this effect you cannot view fixed content!','bubiblock-slider')}
                                </Notice>
                            }
                        </ButtonGroup>
                        <h6 className="df-inspector">{ __('Autoplay', 'bubiblock-slider')}</h6>
                        <p className="df-inspector">{__('To see the result immediately, you need to refresh and reload the page!','bubiblock-slider')}</p>
                        <ButtonGroup
                            className={'df-button-group bubiblock-no-margin bubi-width-two'}
                        >
                            <Button
                                isSecondary
                                isPrimary={df_interval_slider == '5000'} onClick={() => setAttributes({ df_interval_slider: '5000' })}
                            >
                                {__('True','bubiblock-slider')}
                            </Button>
                            <Button
                                isSecondary
                                isPrimary={df_interval_slider == '0'} onClick={() => setAttributes({ df_interval_slider: '0' })}
                            >
                                {__('False','bubiblock-slider')}
                            </Button>
                        </ButtonGroup>
                        {(df_interval_slider  == '5000') &&
                            <>
                            <h6 className="df-inspector">{ __('Pause', 'bubiblock-slider')}</h6>
                            <p className="df-inspector">{__('This setting will only be visible in the Front-end!','bubiblock-slider')}</p>
                            <ButtonGroup
                                className={'df-button-group bubiblock-no-margin bubi-width-two'}
                            >
                                <Button
                                    isSecondary
                                    isPrimary={df_pause_slider == 'hover'} onClick={() => setAttributes({ df_pause_slider: 'hover' })}
                                >
                                    {__('Hover','bubiblock-slider')}
                                </Button>
                                <Button
                                    isSecondary
                                    isPrimary={df_pause_slider == 'false'} onClick={() => setAttributes({ df_pause_slider: 'false' })}
                                >
                                    {__('False','bubiblock-slider')}
                                </Button>
                            </ButtonGroup>
                            </>
                        }
                    </PanelBody>
                    <PanelBody // Arrow Settings
                        icon={'arrow-right-alt2'}
                        title={__('Arrow Settings', 'bubiblock-slider')}
                        initialOpen={false}
                    >
                        <h6 className="df-inspector">{ __('Show Arrows', 'bubiblock-slider')}</h6>
                        <ButtonGroup
                            className={'df-button-group bubiblock-no-margin'}
                        >
                            <div class="df-group-button-resp">
                                <div class="bubi-col-6">
                                    <h6>{ __('Choose', 'bubiblock-slider')}</h6>
                                </div>
                                <div class="bubi-col-6">
                                    <Button
                                        icon={'laptop'}
                                        className={'df-resp-button'}
                                        isSecondary
                                        isPrimary={df_resp == 'desktop'} onClick={() => setAttributes({ df_resp: 'desktop' })}
                                    >
                                    </Button>
                                    <Button
                                        icon={'tablet'}
                                        className={'df-resp-button'}
                                        isSecondary
                                        isPrimary={df_resp == 'table'} onClick={() => setAttributes({ df_resp: 'table' })}
                                    >
                                    </Button>
                                    <Button
                                        icon={'smartphone'}
                                        className={'df-resp-button'}
                                        isSecondary
                                        isPrimary={df_resp == 'mobile'} onClick={() => setAttributes({ df_resp: 'mobile' })}
                                    >
                                    </Button>
                                </div>
                            </div>
                            {(df_resp=='desktop')  &&
                                <div class="bubi-width-two">
                                    <Button
                                        isSecondary
                                        isPrimary={df_arrow_slider == 'df-arrow-true'} onClick={() => setAttributes({ df_arrow_slider: 'df-arrow-true' })}
                                    >
                                        {__('True','bubiblock-slider')}
                                    </Button>
                                    <Button
                                        isSecondary
                                        isPrimary={df_arrow_slider == 'df-arrow-false'} onClick={() => setAttributes({ df_arrow_slider: 'df-arrow-false' })}
                                    >
                                        {__('False','bubiblock-slider')}
                                    </Button>
                                </div>
                            }
                            {(df_resp=='table')  && (df_arrow_slider=='df-arrow-true')  &&
                                <div class="bubi-width-two">
                                    <Button
                                        isSecondary
                                        isPrimary={df_arrow_slider_table == 'df-arrow-table-true'} onClick={() => setAttributes({ df_arrow_slider_table: 'df-arrow-table-true' })}
                                    >
                                        {__('True','bubiblock-slider')}
                                    </Button>
                                    <Button
                                        isSecondary
                                        isPrimary={df_arrow_slider_table == 'df-arrow-table-false'} onClick={() => setAttributes({ df_arrow_slider_table: 'df-arrow-table-false' })}
                                    >
                                        {__('False','bubiblock-slider')}
                                    </Button>
                                </div>
                            }
                            {(df_arrow_slider_table=='df-arrow-table-true') && (df_resp=='mobile')  && (df_arrow_slider=='df-arrow-true')  &&
                                <div class="bubi-width-two">
                                    <Button
                                        isSecondary
                                        isPrimary={df_arrow_slider_mobile == 'df-arrow-mobile-true'} onClick={() => setAttributes({ df_arrow_slider_mobile: 'df-arrow-mobile-true' })}
                                    >
                                        {__('True','bubiblock-slider')}
                                    </Button>
                                    <Button
                                        isSecondary
                                        isPrimary={df_arrow_slider_mobile == 'df-arrow-mobile-false'} onClick={() => setAttributes({ df_arrow_slider_mobile: 'df-arrow-mobile-false' })}
                                    >
                                        {__('False','bubiblock-slider')}
                                    </Button>
                                </div>
                            }

                        </ButtonGroup>
                        {(df_arrow_slider=='df-arrow-true')  &&
                            <>
                            <h6 className="df-inspector">{ __('Arrow type', 'bubiblock-slider')}</h6>
                            <ButtonGroup
                                className={'df-icon-group bubi-mb-2 bubi-width-five'}
                            >
                                <Button
                                    icon={'arrow-right'}
                                    isSecondary
                                    isPrimary={df_arrow_slider_type == 'bubi-arrow-right'} onClick={() => setAttributes({ df_arrow_slider_type: 'bubi-arrow-right' })}
                                >
                                </Button>
                                <Button
                                    icon={'arrow-right-alt'}
                                    isSecondary
                                    isPrimary={df_arrow_slider_type == 'bubi-arrow-right-alt'} onClick={() => setAttributes({ df_arrow_slider_type: 'bubi-arrow-right-alt' })}
                                >
                                </Button>
                                <Button
                                    icon={'arrow-right-alt2'}
                                    isSecondary
                                    isPrimary={df_arrow_slider_type == 'bubi-arrow-right-alt2'} onClick={() => setAttributes({ df_arrow_slider_type: 'bubi-arrow-right-alt2' })}
                                >
                                </Button>
                            </ButtonGroup>
                            <h6 className="df-inspector">{ __('Position', 'bubiblock-slider')}</h6>
                            <ButtonGroup
                                className={'df-icon-group bubi-mb-1 bubi-width-three' }
                            >
                                <Button
                                    isSecondary
                                    isPrimary={bubi_arrow_position == 'arrowtop'} onClick={() => setAttributes({ bubi_arrow_position: 'arrowtop' })}
                                >
                                { __('Top', 'bubiblock-slider')}
                                </Button>
                                <Button
                                    isSecondary
                                    isPrimary={bubi_arrow_position == 'arrowcenter'} onClick={() => setAttributes({ bubi_arrow_position: 'arrowcenter' })}
                                >
                                { __('Center', 'bubiblock-slider')}
                                </Button>
                                <Button
                                    isSecondary
                                    isPrimary={bubi_arrow_position == 'arrowbottom'} onClick={() => setAttributes({ bubi_arrow_position: 'arrowbottom' })}
                                >
                                { __('Bottom', 'bubiblock-slider')}
                                </Button>
                                </ButtonGroup>
                            <h6 className="df-inspector">{ __('Color', 'bubiblock-slider')}
                            {df_color_arrow &&
                                <ColorIndicator
                                    colorValue={ df_color_arrow }
                                />
                            }
                            </h6>
                            <div class={'legend-color-none'}>
                                <p className="df-inspector">{__('Color','bubiblock-slider')}</p>
                                <ColorPaletteControl
                                    value={ df_color_arrow}
                                    colors={ bubiColors }
                                    onChange={ (newValue) => setAttributes({df_color_arrow: newValue}) }
                                    disableCustomColors={ true }
                                />
                            </div>
                            <RangeControl
                                label={__('Opacity','bubiblock-slider')}
                                beforeIcon={'hidden'}
                                afterIcon={'visibility'}
                                allowReset
                                resetFallbackValue={.5}
                                step={.1}
                                withInputField={false}
                                separatorType="none"
                                trackColor="#007cba"
                                isShiftStepEnabled
                                marks={[
                                    {
                                        value: 0,
                                        label: __('0','bubiblock-slider'),
                                    },
                                    {
                                        value: .2,
                                        label: __('.2','bubiblock-slider'),
                                    },

                                    {
                                        value: .4,
                                        label: __('.4','bubiblock-slider'),
                                    },
                                    {
                                        value: .6,
                                        label: __('.6','bubiblock-slider'),
                                    },
                                    {
                                        value: .8,
                                        label: __('.8','bubiblock-slider'),
                                    },
                                    {
                                        value: 1,
                                        label: __('1','bubiblock-slider'),
                                    },
                                ]}
                                railColor="#02abff"
                                value={ bubiopacityarrow }
                                onChange={ this.onChangeBubiopacityarrow }
                                min={ 0 }
                                max={ 1}
                            />
                            <RangeControl
                                label={__('Opacity Hover','bubiblock-slider')}
                                beforeIcon={'hidden'}
                                afterIcon={'visibility'}
                                allowReset
                                resetFallbackValue={1}
                                step={.1}
                                withInputField={false}
                                separatorType="none"
                                trackColor="#007cba"
                                isShiftStepEnabled
                                marks={[
                                    {
                                        value: 0,
                                        label: __('0','bubiblock-slider'),
                                    },
                                    {
                                        value: .2,
                                        label: __('.2','bubiblock-slider'),
                                    },

                                    {
                                        value: .4,
                                        label: __('.4','bubiblock-slider'),
                                    },
                                    {
                                        value: .6,
                                        label: __('.6','bubiblock-slider'),
                                    },
                                    {
                                        value: .8,
                                        label: __('.8','bubiblock-slider'),
                                    },
                                    {
                                        value: 1,
                                        label: __('1','bubiblock-slider'),
                                    },
                                ]}
                                railColor="#02abff"
                                value={ bubiopacityhoverarrow }
                                onChange={ this.onChangeBubiopacityhoverarrow }
                                min={ 0 }
                                max={ 1}
                            />

                            <h6 className="df-inspector">{ __('Spacing', 'bubiblock-slider')}</h6>
                            <RangeControl
                                label={__('Interspace','bubiblock-slider')}
                                help={__('Px Unit','bubiblock-slider')}
                                beforeIcon={'arrow-left-alt'}
                                afterIcon={'arrow-right-alt'}
                                allowReset
                                resetFallbackValue={0}
                                step={1}
                                withInputField={false}
                                separatorType="none"
                                trackColor="#007cba"
                                isShiftStepEnabled
                                marks={[
                                    {
                                        value: -120,
                                        label: __('-120','bubiblock-slider'),
                                    },
                                    {
                                        value: -60,
                                        label: __('-60','bubiblock-slider'),
                                    },

                                    {
                                        value: 0,
                                        label: __('0','bubiblock-slider'),
                                    },
                                    {
                                        value: 60,
                                        label: __('60','bubiblock-slider'),
                                    },
                                    {
                                        value: 120,
                                        label: __('120','bubiblock-slider'),
                                    },
                                ]}
                                railColor="#02abff"
                                value={ bubi_marginarrow }
                                onChange={ this.onChangeBubi_marginarrow }
                                min={ -120 }
                                max={ 120}
                            />
                            <h6 class="df-inspector">{ __('Size', 'bubiblock-slider')}</h6>
                            <ButtonGroup
                                className={'df-button-group'}
                            >
                                <div class="df-group-button-resp">
                                    <div class="bubi-col-6">
                                        <h6>{ __('Choose', 'bubiblock-slider')}</h6>
                                    </div>
                                    <div class="bubi-col-6">
                                        <Button
                                            icon={'laptop'}
                                            className={'df-resp-button'}
                                            isSecondary
                                            isPrimary={df_resp == 'desktop'} onClick={() => setAttributes({ df_resp: 'desktop' })}
                                        >
                                        </Button>
                                        <Button
                                            icon={'tablet'}
                                            className={'df-resp-button'}
                                            isSecondary
                                            isPrimary={df_resp == 'table'} onClick={() => setAttributes({ df_resp: 'table' })}
                                        >
                                        </Button>
                                        <Button
                                            icon={'smartphone'}
                                            className={'df-resp-button'}
                                            isSecondary
                                            isPrimary={df_resp == 'mobile'} onClick={() => setAttributes({ df_resp: 'mobile' })}
                                        >
                                        </Button>
                                    </div>
                                </div>
                                {(df_resp=='desktop')&&
                                    <RangeControl
                                        label={__("Size(Desktop)","bubiblock-slider")}
                                        help={__('px Unit','bubiblock-slider')}
                                        value={ df_size_arrow }
                                        onChange={ this.onChangeDf_size_arrow  }
                                        min={1}
                                        max={200}
                                    />
                                }
                                {(df_resp=='table') && (df_arrow_slider_table=='df-arrow-table-true') &&
                                    <RangeControl
                                        label={__("Size(Table)","bubiblock-slider")}
                                        help={__('px Unit','bubiblock-slider')}
                                        value={ df_size_arrow_table }
                                        onChange={ this.onChangeDf_size_arrow_table  }
                                        min={1}
                                        max={200}
                                    />
                                }
                                {(df_resp=='mobile') && (df_arrow_slider_table=='df-arrow-table-true') && (df_arrow_slider_mobile=='df-arrow-mobile-true') &&
                                    <RangeControl
                                        label={__("Size(Mobile)","bubiblock-slider")}
                                        help={__('px Unit','bubiblock-slider')}
                                        value={ df_size_arrow_mobile }
                                        onChange={ this.onChangeDf_size_arrow_mobile  }
                                        min={1}
                                        max={200}
                                    />
                                }
                            </ButtonGroup>
                            </>
                        }
                    </PanelBody>
                    <PanelBody // Dot Settings
                        icon={'ellipsis'}
                        title={__('Dot Settings', 'bubiblock-slider')}
                        initialOpen={false}
                    >
                        <h6 class="df-inspector">{ __('Show Dots', 'bubiblock-slider')}</h6>
                        <ButtonGroup
                            className={'df-button-group bubiblock-no-margin'}
                        >
                            <div class="df-group-button-resp">
                                <div class="bubi-col-6">
                                    <h6>{ __('Choose', 'bubiblock-slider')}</h6>
                                </div>
                                <div class="bubi-col-6">
                                    <Button
                                        icon={'laptop'}
                                        isSecondary
                                        className={'df-resp-button'}
                                        isPrimary={df_resp == 'desktop'} onClick={() => setAttributes({ df_resp: 'desktop' })}
                                    >
                                    </Button>
                                    <Button
                                        icon={'tablet'}
                                        isSecondary
                                        className={'df-resp-button'}
                                        isPrimary={df_resp == 'table'} onClick={() => setAttributes({ df_resp: 'table' })}
                                    >
                                    </Button>
                                    <Button
                                        icon={'smartphone'}
                                        isSecondary
                                        className={'df-resp-button'}
                                        isPrimary={df_resp == 'mobile'} onClick={() => setAttributes({ df_resp: 'mobile' })}
                                    >
                                    </Button>
                                </div>
                            </div>
                            {(df_resp=='desktop')  &&
                                <div class="bubi-width-two">
                                    <Button
                                        isSecondary
                                        isPrimary={df_dot_slider == 'df-dot-true'} onClick={() => setAttributes({ df_dot_slider: 'df-dot-true' })}
                                    >
                                        {__('True','bubiblock-slider')}
                                    </Button>
                                    <Button
                                        isSecondary
                                        isPrimary={df_dot_slider == 'df-dot-false'} onClick={() => setAttributes({ df_dot_slider: 'df-dot-false' })}
                                    >
                                        {__('False','bubiblock-slider')}
                                    </Button>
                                </div>
                            }
                            {(df_resp=='table')  && (df_dot_slider=='df-dot-true')  &&
                                <div class="bubi-width-two">
                                    <Button
                                        isSecondary
                                        isPrimary={df_dot_slider_table == 'df-dot-table-true'} onClick={() => setAttributes({ df_dot_slider_table: 'df-dot-table-true' })}
                                    >
                                        {__('True','bubiblock-slider')}
                                    </Button>
                                    <Button
                                        isSecondary
                                        isPrimary={df_dot_slider_table == 'df-dot-table-false'} onClick={() => setAttributes({ df_dot_slider_table: 'df-dot-table-false' })}
                                    >
                                        {__('False','bubiblock-slider')}
                                    </Button>
                                </div>
                            }
                            {(df_dot_slider_table=='df-dot-table-true') && (df_resp=='mobile')  && (df_dot_slider=='df-dot-true')  &&
                                <div class="bubi-width-two">
                                    <Button
                                        isSecondary
                                        isPrimary={df_dot_slider_mobile == 'df-dot-mobile-true'} onClick={() => setAttributes({ df_dot_slider_mobile: 'df-dot-mobile-true' })}
                                    >
                                        {__('True','bubiblock-slider')}
                                    </Button>
                                    <Button
                                        isSecondary
                                        isPrimary={df_dot_slider_mobile == 'df-dot-mobile-false'} onClick={() => setAttributes({ df_dot_slider_mobile: 'df-dot-mobile-false' })}
                                    >
                                        {__('False','bubiblock-slider')}
                                    </Button>
                                </div>
                            }
                        </ButtonGroup>
                        {(df_dot_slider=='df-dot-true') &&
                            <>
                                <h6 class="df-inspector">{ __('Dots type', 'bubiblock-slider')}</h6>
                                <SelectControl
                                    options={[
                                        {label: __('Linear','bubiblock-slider'), value: 'df-dot-linear'},
                                        {label: __('Round','bubiblock-slider'), value: 'df-dot-round'},
                                    ]}
                                    onChange={this.onChangeDf_dot_slider_type}
                                    value={df_dot_slider_type}
                                />
                                <h6 class="df-inspector">{ __('Size', 'bubiblock-slider')}</h6>
                                <RangeControl
                                    label={__("Width","bubiblock-slider")}
                                    help={__('px Unit','bubiblock-slider')}
                                    value={ df_width_dot }
                                    onChange={ this.onChangeDf_width_dot  }
                                    min={1}
                                    max={100}
                                />
                                <RangeControl
                                    label={__("Height","bubiblock-slider")}
                                    help={__('px Unit','bubiblock-slider')}
                                    value={ df_height_dot }
                                    onChange={ this.onChangeDf_height_dot  }
                                    min={1}
                                    max={100}
                                />
                                <h6 class="df-inspector">{ __('Spacing', 'bubiblock-slider')}</h6>
                                <RangeControl
                                    label={__('Bottom','bubiblock-slider')}
                                    help={__('Px Unit','bubiblock-slider')}
                                    beforeIcon={'arrow-down-alt'}
                                    afterIcon={'arrow-up-alt'}
                                    allowReset
                                    resetFallbackValue={10}
                                    step={1}
                                    withInputField={false}
                                    separatorType="none"
                                    trackColor="#007cba"
                                    isShiftStepEnabled
                                    marks={[
                                        {
                                            value: 0,
                                            label: __('0','bubiblock-slider'),
                                        },
                                        {
                                            value: 20,
                                            label: __('20','bubiblock-slider'),
                                        },
                                        {
                                            value: 40,
                                            label: __('40','bubiblock-slider'),
                                        },
                                        {
                                            value: 60,
                                            label: __('60','bubiblock-slider'),
                                        },
                                        {
                                            value: 80,
                                            label: __('80','bubiblock-slider'),
                                        },
                                        {
                                            value: 100,
                                            label: __('100','bubiblock-slider'),
                                        },
                                    ]}
                                    railColor="#02abff"
                                    value={ df_bottom_dot }
                                    onChange={ this.onChangeDf_bottom_dot }
                                    min={ 0 }
                                    max={ 100}
                                />
                                <h6 className="df-inspector">{ __('Color', 'bubiblock-slider')}
                                {df_color_dot &&
                                    <ColorIndicator
                                        colorValue={ df_color_dot }
                                    />
                                }
                                </h6>
                                <div class={'legend-color-none'}>
                                    <ColorPaletteControl
                                        value={ df_color_dot}
                                        colors={ bubiColors }
                                        onChange={ (newValue) => setAttributes({df_color_dot: newValue}) }
                                        disableCustomColors={true}
                                    />
                                </div>
                            </>
                        }
                    </PanelBody>
                    <PanelBody // Slider 1
                        icon={'format-image'}
                        title={__('Slides 1', 'bubiblock-slider')}
                        initialOpen={false}
                    >
                        <h6 className="df-inspector bubi-mt-1">{ __('Background type', 'bubiblock-slider')}</h6>
                        <div class="bubi-width-three bubibutton-icon">
                            <ButtonGroup
                                className={'df-button-group bubiblock-no-margin'}
                            >
                                <Tooltip
                                    text= {__('Color','bubiblock-slider')}
                                >
                                    <Button
                                        isPrimary={df_slider_chose_1 == 'df-slider-color-1'}
                                        icon="admin-appearance"
                                        onClick={() => setAttributes({ df_slider_chose_1: 'df-slider-color-1' })}
                                    >
                                    </Button>
                                </Tooltip>
                                <Tooltip
                                    text=  {__('Image','bubiblock-slider')}
                                >
                                    <Button
                                        isPrimary={df_slider_chose_1 == 'df-slider-image-1'}
                                        icon="format-image"
                                        onClick={() => setAttributes({ df_slider_chose_1: 'df-slider-image-1' })}
                                    >
                                    </Button>
                                </Tooltip>
                            </ButtonGroup>
                        </div>
                        {(df_slider_chose_1=='df-slider-image-1' ) &&
                            <>
                                {url?
                                    <>
                                    <img src={url} className={'bubi-mt-2'}/>
                                    {isBlobURL(url) && <Spinner />}
                                    </>
                                    :
                                    <MediaPlaceholder
                                        className={'bubi-mt-2 bubi-mb-2'}
                                        icon="format-image df-icon-img-upload"
                                        onSelect={ this.onSelectImage }
                                        onSelectURL={ this.onSelectURL }
                                        onError={this.onUploadError}
                                        accept="image/*"
                                        allowedTypes={['image']}
                                        notices={ noticeUI }
                                    />
                                }
                                {url &&
                                <>
                                    <MenuItem
                                        icon={ 'trash' }
                                        className={'df-remov-img'}
                                        onClick={ this.removeImage }
                                    >
                                        { __('Remove Image','bubiblock-slider') }
                                    </MenuItem>
                                    <TextareaControl
                                        label={__('Alt Text (Alternative Text)','bubiblock-slider')}
                                        value={ alt}
                                        onChange={ this.updateAlt }
                                        help={__('Alternative text describes your image to people who cant see it. Add a short description with its key details.','bubiblock-slider')}
                                    />
                                    <SelectControl
                                        label={__("Dispaly Size","bubiblock-slider")}
                                        options={[
                                            {label: __('None','bubiblock-slider'), value: 'none'},
                                            {label: __('Containe','bubiblock-slider'), value: 'contain'},
                                            {label: __('Cover','bubiblock-slider'), value: 'cover'},
                                            {label: __('Fill','bubiblock-slider'), value: 'fill'},
                                            {label: __('Scale down','bubiblock-slider'), value: 'scale-down'},
                                            {label: __('Unset','bubiblock-slider'), value: 'unset'},
                                        ]}
                                        onChange={this.onChangeDf_cover_img1}
                                        value={df_cover_img1}
                                    />
                                    {(df_cover_img1=='none')&&
                                    <>
                                        <RangeControl
                                            label={__('Display Position','bubiblock-slider')}
                                            help={__('% Unit','bubiblock-slider')}
                                            beforeIcon={'arrow-left-alt'}
                                            afterIcon={'arrow-right-alt'}
                                            allowReset
                                            resetFallbackValue={50}
                                            step={1}
                                            withInputField={false}
                                            separatorType="none"
                                            trackColor="#007cba"
                                            isShiftStepEnabled
                                            marks={[
                                                {
                                                    value: 0,
                                                    label: __('0','bubiblock-slider'),
                                                },
                                                {
                                                    value: 20,
                                                    label: __('20','bubiblock-slider'),
                                                },
                                                {
                                                    value: 40,
                                                    label: __('40','bubiblock-slider'),
                                                },
                                                {
                                                    value: 60,
                                                    label: __('60','bubiblock-slider'),
                                                },
                                                {
                                                    value: 80,
                                                    label: __('80','bubiblock-slider'),
                                                },
                                                {
                                                    value: 100,
                                                    label: __('100','bubiblock-slider'),
                                                },
                                            ]}
                                            railColor="#02abff"
                                            value={ df_focalPoint_img_1 }
                                            onChange={ this.onChangeDf_focalPoint_img_1 }
                                            min={ 0 }
                                            max={ 100}
                                        />
                                        <RangeControl
                                            label={__('Display Position','bubiblock-slider')}
                                            help={__('% Unit','bubiblock-slider')}
                                            beforeIcon={'arrow-down-alt'}
                                            afterIcon={'arrow-up-alt'}
                                            allowReset
                                            resetFallbackValue={50}
                                            step={1}
                                            withInputField={false}
                                            separatorType="none"
                                            trackColor="#007cba"
                                            isShiftStepEnabled
                                            marks={[
                                                {
                                                    value: 0,
                                                    label: __('0','bubiblock-slider'),
                                                },
                                                {
                                                    value: 20,
                                                    label: __('20','bubiblock-slider'),
                                                },
                                                {
                                                    value: 40,
                                                    label: __('40','bubiblock-slider'),
                                                },
                                                {
                                                    value: 60,
                                                    label: __('60','bubiblock-slider'),
                                                },
                                                {
                                                    value: 80,
                                                    label: __('80','bubiblock-slider'),
                                                },
                                                {
                                                    value: 100,
                                                    label: __('100','bubiblock-slider'),
                                                },
                                            ]}
                                            railColor="#02abff"
                                            value={ df_focalPoint_y_img_1 }
                                            onChange={ this.onChangeDf_focalPoint_y_img_1 }
                                            min={ 0 }
                                            max={ 100}
                                        />
                                        </>
                                    }
                                    <ToggleControl
                                        label={ __( 'Show mask','bubiblock-slider' ) }
                                        checked={df_mask_slider_1}
                                        onChange={this.onChangeDf_mask_slider_1}
                                    />
                                    {df_mask_slider_1 &&
                                        <>
                                        <Notice
                                            status="info"
                                            isDismissible={ false }
                                        >
                                            {__('If you have set the border radius for the slider this control will not work well!','bubiblock-slider')}
                                        </Notice>
                                        <ColorPaletteControl
                                            value={ background_color_solid_mask_1}
                                            colors={ bubiColors }
                                            onChange={ (newValue) => setAttributes({background_color_solid_mask_1: newValue}) }
                                        />
                                        <RangeControl
                                            label={__('Opacity','bubiblock-slider')}
                                            beforeIcon={'hidden'}
                                            afterIcon={'visibility'}
                                            allowReset
                                            resetFallbackValue={.4}
                                            step={.1}
                                            withInputField={false}
                                            separatorType="none"
                                            trackColor="#007cba"
                                            isShiftStepEnabled
                                            marks={[
                                                {
                                                    value: 0,
                                                    label: __('0','bubiblock-slider'),
                                                },
                                                {
                                                    value: 0.2,
                                                    label: __('2','bubiblock-slider'),
                                                },
                                                {
                                                    value: 0.4,
                                                    label: __('4','bubiblock-slider'),
                                                },
                                                {
                                                    value: 0.6,
                                                    label: __('6','bubiblock-slider'),
                                                },
                                                {
                                                    value: 0.8,
                                                    label: __('8','bubiblock-slider'),
                                                },
                                                {
                                                    value: 1.0,
                                                    label: __('10','bubiblock-slider'),
                                                },
                                            ]}
                                            railColor="#02abff"
                                            value={ df_opacity_mask_1 }
                                            onChange={ this.onChangeDf_opacity_mask_1 }
                                            min={ .0 }
                                            max={ 1.0}
                                        />
                                    </>
                                    }
                                    <TextControl
                                        label={__('Link Image','bubiblock-slider')}
                                        value={ bubiblock_link_slider_1 }
                                        onChange={ (newValue) => setAttributes({bubiblock_link_slider_1: newValue}) }
                                        type="url"
                                    />
                                    {bubiblock_link_slider_1 &&
                                        <ButtonGroup
                                                className={'df-button-group bubiblock-no-margin bubi-mb-2'}
                                            >
                                                <p className="df-inspector bubi-mt-1">{ __('Open in new tab', 'bubiblock-slider')}</p>
                                                <div class="bubi-width-two">
                                                <Button
                                                    isSecondary
                                                    isPrimary={bubiblock_link_tab_slider_1 == '_blank'} onClick={() => setAttributes({ bubiblock_link_tab_slider_1: '_blank' })}
                                                >
                                                    {__('True','bubiblock-slider')}
                                                </Button>
                                                <Button
                                                    isSecondary
                                                    isPrimary={bubiblock_link_tab_slider_1 == ''} onClick={() => setAttributes({ bubiblock_link_tab_slider_1: '' })}
                                                >
                                                    {__('False','bubiblock-slider')}
                                                </Button>
                                                </div>
                                        </ButtonGroup>
                                    }
                                </>
                                }
                            </>
                        }
                        {(df_slider_chose_1=='df-slider-color-1' ) &&
                            <>
                            <h6 className="df-inspector bubi-not-background">{ __('Background Color', 'bubiblock-slider')}
                            {df_background_color_slider_1 &&
                                <ColorIndicator
                                    colorValue={ df_background_color_slider_1 }
                                />
                            }
                            </h6>
                            <div class={'legend-color-none'}>
                               <ColorPaletteControl
                                    value={ df_background_color_slider_1}
                                    colors={ bubiColors }
                                    onChange={ (newValue) => setAttributes({df_background_color_slider_1: newValue}) }
                                />
                            </div>
                            </>
                        }
                        <ToggleControl
                            label={ __( 'Dividers Top','bubiblock-slider' ) }
                            checked={df_enable_divide_1}
                            onChange={this.onChangeDf_enable_divide_1}
                        />
                        {df_enable_divide_1 &&
                        <>
                            <RadioControl
                                label={__('Choose', 'df-sidebar-gutenberg')}
                                selected={divide_1}
                                className={'bubiblock-radio-image'}
                                onChange={(val) => setAttributes({divide_1: val})}
                                options={bubiOptionsDivideTop}
                            />
                            <h6 className="df-inspector bubi-not-background">{ __('Color', 'bubiblock-slider')}
                            { df_color_divide_1 &&
                                <ColorIndicator
                                    colorValue={ df_color_divide_1 }
                                />
                            }
                            </h6>
                            <ColorPicker
                                color={df_color_divide_1}
                                onChangeComplete={(newval) => setAttributes({df_color_divide_1: ('rgba(' + newval.rgb.r + ', ' + newval.rgb.g + ', ' + newval.rgb.b + ', ' + newval.rgb.a + ')') })}
                            />
                            <ButtonGroup
                                className={'df-button-group bubiblock-no-margin'}
                            >
                                <div class="df-group-button-resp">
                                    <div class="bubi-col-6">
                                        <h6>{ __('Height', 'bubiblock-slider')}</h6>
                                    </div>
                                    <div class="bubi-col-6">
                                        <Button
                                            icon={'laptop'}
                                            isSecondary
                                            className={'df-resp-button'}
                                            isPrimary={df_resp == 'desktop'} onClick={() => setAttributes({ df_resp: 'desktop' })}
                                        >
                                        </Button>
                                        <Button
                                            icon={'tablet'}
                                            isSecondary
                                            className={'df-resp-button'}
                                            isPrimary={df_resp == 'table'} onClick={() => setAttributes({ df_resp: 'table' })}
                                        >
                                        </Button>
                                        <Button
                                            icon={'smartphone'}
                                            isSecondary
                                            className={'df-resp-button'}
                                            isPrimary={df_resp == 'mobile'} onClick={() => setAttributes({ df_resp: 'mobile' })}
                                        >
                                        </Button>
                                    </div>
                                </div>
                                {(df_resp=='desktop' ) &&
                                    <RangeControl
                                        label={__("Height(Desktop)","bubiblock-slider")}
                                        help={__('Px Unit','bubiblock-slider')}
                                        value={ df_height_divide_1 }
                                        onChange={ this.onChangeDf_height_divide_1 }
                                        min={20}
                                        max={1000}
                                    />
                                }
                                {(df_resp=='table' ) &&
                                    <RangeControl
                                        label={__("Height(Table)","bubiblock-slider")}
                                        help={__('Px Unit','bubiblock-slider')}
                                        value={ df_height_table_divide_1 }
                                        onChange={ this.onChangeDf_height_table_divide_1 }
                                        min={20}
                                        max={1000}
                                    />
                                }
                                {(df_resp=='mobile' ) &&
                                    <RangeControl
                                        label={__("Height(Mobile)","bubiblock-slider")}
                                        help={__('Px Unit','bubiblock-slider')}
                                        value={ df_height_mobile_divide_1 }
                                        onChange={ this.onChangeDf_height_mobile_divide_1 }
                                        min={20}
                                        max={1000}
                                    />
                                }
                            </ButtonGroup>
                            <RangeControl
                                label={__('Delayed appearance','bubiblock-slider')}
                                help={__('S Unit. In the Safari Browser this transition is not supported!','bubiblock-slider')}
                                beforeIcon={'arrow-down-alt'}
                                afterIcon={'arrow-up-alt'}
                                allowReset
                                resetFallbackValue={3}
                                step={1}
                                withInputField={false}
                                separatorType="none"
                                trackColor="#007cba"
                                isShiftStepEnabled
                                marks={[
                                    {
                                        value: 0,
                                        label: __('0','bubiblock-slider'),
                                    },
                                    {
                                        value: 5,
                                        label: __('5','bubiblock-slider'),
                                    },
                                    {
                                        value: 10,
                                        label: __('10','bubiblock-slider'),
                                    },
                                    {
                                        value: 15,
                                        label: __('15','bubiblock-slider'),
                                    },
                                    {
                                        value: 20,
                                        label: __('20','bubiblock-slider'),
                                    },
                                    {
                                        value: 25,
                                        label: __('25','bubiblock-slider'),
                                    },
                                    {
                                        value: 30,
                                        label: __('30','bubiblock-slider'),
                                    },
                                ]}
                                railColor="#02abff"
                                value={ bubiblock_dalay_divide_1 }
                                onChange={ this.onChangeBubiblock_dalay_divide_1}
                                min={ 0 }
                                max={ 30}
                            />
                        </>
                        }
                         <ToggleControl
                            label={ __( 'Dividers Bottom','bubiblock-slider' ) }
                            checked={df_enable_divide_bottom_1}
                            onChange={this.onChangeDf_enable_divide_bottom_1}
                        />
                        {df_enable_divide_bottom_1 &&
                        <>
                            <RadioControl
                                label={__('Choose', 'df-sidebar-gutenberg')}
                                selected={divide_bottom_1}
                                className={'df-radio-control-divide-bottom'}
                                onChange={(val) => setAttributes({divide_bottom_1: val})}
                                options={bubiOptionsDivideBottom}
                            />
                            <h6 className="df-inspector bubi-not-background">{ __('Color', 'bubiblock-slider')}
                            { df_color_divide_bottom_1&&
                                <ColorIndicator
                                    colorValue={ df_color_divide_bottom_1 }
                                />
                            }
                            </h6>
                            <ColorPicker
                                color={df_color_divide_bottom_1}
                                onChangeComplete={(newval) => setAttributes({df_color_divide_bottom_1: ('rgba(' + newval.rgb.r + ', ' + newval.rgb.g + ', ' + newval.rgb.b + ', ' + newval.rgb.a + ')') })}
                            />
                            <ButtonGroup
                                className={'df-button-group bubiblock-no-margin'}
                            >
                                <div class="df-group-button-resp">
                                    <div class="bubi-col-6">
                                        <h6>{ __('Height', 'bubiblock-slider')}</h6>
                                    </div>
                                    <div class="bubi-col-6">
                                        <Button
                                            icon={'laptop'}
                                            isSecondary
                                            className={'df-resp-button'}
                                            isPrimary={df_resp == 'desktop'} onClick={() => setAttributes({ df_resp: 'desktop' })}
                                        >
                                        </Button>
                                        <Button
                                            icon={'tablet'}
                                            isSecondary
                                            className={'df-resp-button'}
                                            isPrimary={df_resp == 'table'} onClick={() => setAttributes({ df_resp: 'table' })}
                                        >
                                        </Button>
                                        <Button
                                            icon={'smartphone'}
                                            isSecondary
                                            className={'df-resp-button'}
                                            isPrimary={df_resp == 'mobile'} onClick={() => setAttributes({ df_resp: 'mobile' })}
                                        >
                                        </Button>
                                    </div>
                                </div>
                                {(df_resp=='desktop' ) &&
                                    <RangeControl
                                        label={__("Height(Desktop)","bubiblock-slider")}
                                        help={__('Px Unit','bubiblock-slider')}
                                        value={ df_height_divide_bottom_1 }
                                        onChange={ this.onChangeDf_height_divide_bottom_1 }
                                        min={20}
                                        max={1000}
                                    />
                                }
                                {(df_resp=='table' ) &&
                                    <RangeControl
                                        label={__("Height(Table)","bubiblock-slider")}
                                        help={__('Px Unit','bubiblock-slider')}
                                        value={ df_height_table_divide_bottom_1 }
                                        onChange={ this.onChangeDf_height_table_divide_bottom_1 }
                                        min={20}
                                        max={1000}
                                    />
                                }
                                {(df_resp=='mobile' ) &&
                                    <RangeControl
                                        label={__("Height(Mobile)","bubiblock-slider")}
                                        help={__('Px Unit','bubiblock-slider')}
                                        value={ df_height_mobile_divide_bottom_1 }
                                        onChange={ this.onChangeDf_height_mobile_divide_bottom_1 }
                                        min={20}
                                        max={1000}
                                    />
                                }
                            </ButtonGroup>
                            <RangeControl
                                label={__('Delayed appearance','bubiblock-slider')}
                                help={__('S Unit. In the Safari Browser this transition is not supported!','bubiblock-slider')}
                                beforeIcon={'arrow-down-alt'}
                                afterIcon={'arrow-up-alt'}
                                allowReset
                                resetFallbackValue={3}
                                step={1}
                                withInputField={false}
                                separatorType="none"
                                trackColor="#007cba"
                                isShiftStepEnabled
                                marks={[
                                    {
                                        value: 0,
                                        label: __('0','bubiblock-slider'),
                                    },
                                    {
                                        value: 5,
                                        label: __('5','bubiblock-slider'),
                                    },
                                    {
                                        value: 10,
                                        label: __('10','bubiblock-slider'),
                                    },
                                    {
                                        value: 15,
                                        label: __('15','bubiblock-slider'),
                                    },
                                    {
                                        value: 20,
                                        label: __('20','bubiblock-slider'),
                                    },
                                    {
                                        value: 25,
                                        label: __('25','bubiblock-slider'),
                                    },
                                    {
                                        value: 30,
                                        label: __('30','bubiblock-slider'),
                                    },
                                ]}
                                railColor="#02abff"
                                value={ bubiblock_dalay_divide_1_bottom }
                                onChange={ this.onChangeBubiblock_dalay_divide_1_bottom}
                                min={ 0 }
                                max={ 30}
                            />
                        </>
                        }
                        {title1 &&
                        <>
                            <h6 class="df-inspector">{ __('Title', 'bubiblock-slider')}</h6>
                            <ButtonGroup
                                className={'df-button-group bubiblock-no-margin'}
                            >
                                <div class="df-group-button-resp">
                                    <div class="bubi-col-6">
                                        <h6>{ __('Choose', 'bubiblock-slider')}</h6>
                                    </div>
                                    <div class="bubi-col-6">
                                        <Button
                                            icon={'laptop'}
                                            isSecondary
                                            className={'df-resp-button'}
                                            isPrimary={df_resp == 'desktop'} onClick={() => setAttributes({ df_resp: 'desktop' })}
                                        >
                                        </Button>
                                        <Button
                                            icon={'tablet'}
                                            isSecondary
                                            className={'df-resp-button'}
                                            isPrimary={df_resp == 'table'} onClick={() => setAttributes({ df_resp: 'table' })}
                                        >
                                        </Button>
                                        <Button
                                            icon={'smartphone'}
                                            isSecondary
                                            className={'df-resp-button'}
                                            isPrimary={df_resp == 'mobile'} onClick={() => setAttributes({ df_resp: 'mobile' })}
                                        >
                                        </Button>
                                    </div>
                                </div>
                                {(df_resp=='desktop') &&
                                    <RangeControl
                                        label={__('Margin','bubiblock-slider')}
                                        help={__('px Unit','bubiblock-slider')}
                                        beforeIcon={'arrow-down-alt'}
                                        afterIcon={'arrow-up-alt'}
                                        allowReset
                                        resetFallbackValue={35}
                                        step={1}
                                        withInputField={false}
                                        separatorType="none"
                                        trackColor="#007cba"
                                        isShiftStepEnabled
                                        marks={[
                                            {
                                                value: -100,
                                                label: __('-100','bubiblock-slider'),
                                            },
                                            {
                                                value: 0,
                                                label: __('0','bubiblock-slider'),
                                            },
                                            {
                                                value: 100,
                                                label: __('100','bubiblock-slider'),
                                            },
                                            {
                                                value: 200,
                                                label: __('200','bubiblock-slider'),
                                            },
                                            {
                                                value: 300,
                                                label: __('300','bubiblock-slider'),
                                            },
                                        ]}
                                        railColor="#02abff"
                                        value={ margin_bottom_caption1 }
                                        onChange={ this.onChangeMargin_bottom_caption1}
                                        min={ -100 }
                                        max={ 300}
                                    />
                                }
                                {(df_resp=='table') &&
                                    <RangeControl
                                        label={__('Margin','bubiblock-slider')}
                                        help={__('px Unit','bubiblock-slider')}
                                        beforeIcon={'arrow-down-alt'}
                                        afterIcon={'arrow-up-alt'}
                                        allowReset
                                        resetFallbackValue={25}
                                        step={1}
                                        withInputField={false}
                                        separatorType="none"
                                        trackColor="#007cba"
                                        isShiftStepEnabled
                                        marks={[
                                            {
                                                value: -50,
                                                label: __('-50','bubiblock-slider'),
                                            },
                                            {
                                                value: 0,
                                                label: __('0','bubiblock-slider'),
                                            },
                                            {
                                                value: 50,
                                                label: __('50','bubiblock-slider'),
                                            },
                                            {
                                                value: 100,
                                                label: __('100','bubiblock-slider'),
                                            },
                                            {
                                                value: 150,
                                                label: __('150','bubiblock-slider'),
                                            },
                                            {
                                                value: 200,
                                                label: __('200','bubiblock-slider'),
                                            },
                                        ]}
                                        railColor="#02abff"
                                        value={ margin_bottom_table_caption1 }
                                        onChange={ this.onChangeMargin_bottom_table_caption1}
                                        min={ -50 }
                                        max={ 200}
                                    />
                                }
                                {(df_resp=='mobile') &&
                                    <RangeControl
                                        label={__('Margin','bubiblock-slider')}
                                        help={__('px Unit','bubiblock-slider')}
                                        beforeIcon={'arrow-down-alt'}
                                        afterIcon={'arrow-up-alt'}
                                        allowReset
                                        resetFallbackValue={15}
                                        step={1}
                                        withInputField={false}
                                        separatorType="none"
                                        trackColor="#007cba"
                                        isShiftStepEnabled
                                        marks={[
                                            {
                                                value: -50,
                                                label: __('-50','bubiblock-slider'),
                                            },
                                            {
                                                value: 0,
                                                label: __('0','bubiblock-slider'),
                                            },
                                            {
                                                value: 50,
                                                label: __('50','bubiblock-slider'),
                                            },
                                            {
                                                value: 100,
                                                label: __('100','bubiblock-slider'),
                                            },
                                            {
                                                value: 150,
                                                label: __('150','bubiblock-slider'),
                                            },
                                            {
                                                value: 200,
                                                label: __('200','bubiblock-slider'),
                                            },
                                        ]}
                                        railColor="#02abff"
                                        value={ margin_bottom_mobile_caption1 }
                                        onChange={ this.onChangeMargin_bottom_mobile_caption1}
                                        min={ -50 }
                                        max={ 200}
                                    />
                                }
                                {(df_resp=='desktop') &&
                                    <FontSizePicker
                                        className={'bubiblock-slider-inspectorcontrols'}
                                        value={fontsizetitle1}
                                        onChange={(val) => setAttributes({fontsizetitle1: val})}
                                        fontSizes={[
                                            { name: __('None', 'bubiblock-slider'), slug: 'none', size: 0 },
                                            { name: __('Small', 'bubiblock-slider'), slug: 'small', size: 22 },
                                            { name: __('Medium', 'bubiblock-slider'), slug: 'medium', size:32 },
                                            { name: __('Large', 'bubiblock-slider'), slug: 'large', size: 52 },
                                            { name: __('Big', 'bubiblock-slider'), slug: 'large', size: 82 },
                                        ]}
                                        withSlider={true}
                                    />
                                    }
                                {(df_resp=='table') &&
                                    <FontSizePicker
                                        value={fontsizetitle1table}
                                        onChange={(val) => setAttributes({fontsizetitle1table: val})}
                                        fontSizes={[
                                            { name: __('None', 'bubiblock-slider'), slug: 'none', size: 0 },
                                            { name: __('Small', 'bubiblock-slider'), slug: 'small', size: 22 },
                                            { name: __('Medium', 'bubiblock-slider'), slug: 'medium', size:32 },
                                            { name: __('Large', 'bubiblock-slider'), slug: 'large', size: 52 },
                                            { name: __('Big', 'bubiblock-slider'), slug: 'large', size: 82 },
                                        ]}
                                        withSlider={true}
                                    />
                                }
                                {(df_resp=='mobile') &&
                                    <FontSizePicker
                                        value={fontsizetitle1mobile}
                                        onChange={(val) => setAttributes({fontsizetitle1mobile: val})}
                                        fontSizes={[
                                            { name: __('None', 'bubiblock-slider'), slug: 'none', size: 0 },
                                            { name: __('Small', 'bubiblock-slider'), slug: 'small', size: 22 },
                                            { name: __('Medium', 'bubiblock-slider'), slug: 'medium', size:32 },
                                            { name: __('Large', 'bubiblock-slider'), slug: 'large', size: 52 },
                                            { name: __('Big', 'bubiblock-slider'), slug: 'large', size: 82 },
                                        ]}
                                        withSlider={true}
                                    />
                                }
                            </ButtonGroup>
                            <RadioControl
                                label={__('Align','bubiblock-slider')}
                                selected={ alignment_title1 }
                                options={ [
                                    { label: 'Left', value: 'left' },
                                    { label: 'Center', value: 'center' },
                                    { label: 'Right', value: 'right' },
                                ] }
                                onChange={ ( newAlign ) => setAttributes( { alignment_title1: newAlign } ) }
                            />
                            <SelectControl
                                label={__("Effect","bubiblock-slider")}
                                options={bubiOptionsEffectAnimate}
                                onChange={this.onChangeEffectcaption1}
                                value={effectcaption1}
                            />
                            <SelectControl
                                label={__("Effect speed","bubiblock-slider")}
                                options={bubiOptionEffectSpeed}
                                onChange={this.onChangeDf_speed_effectcaption1}
                                value={df_speed_effectcaption1}
                            />
                            <SelectControl
                                label={__("Effect delay","bubiblock-slider")}
                                options={bubiOptionEffectDalay}
                                onChange={this.onChangeDf_delay_effectcaption1}
                                value={df_delay_effectcaption1}
                            />
                            <SelectControl
                                label={__("Effect repeat","bubiblock-slider")}
                                options={bubiOptionEffectRepeat}
                                onChange={this.onChangeDf_repeat_effectcaption1}
                                value={df_repeat_effectcaption1}
                            />
                        </>
                        }
                        {info1 &&
                        <>
                            <h6 class="df-inspector">{ __('Info', 'bubiblock-slider')}</h6>
                            <ButtonGroup
                                className={'df-button-group bubiblock-no-margin'}
                            >
                                <div class="df-group-button-resp">
                                    <div class="bubi-col-6">
                                        <h6>{ __('Choose', 'bubiblock-slider')}</h6>
                                    </div>
                                    <div class="bubi-col-6">
                                        <Button
                                            icon={'laptop'}
                                            isSecondary
                                            className={'df-resp-button'}
                                            isPrimary={df_resp == 'desktop'} onClick={() => setAttributes({ df_resp: 'desktop' })}
                                        >
                                        </Button>
                                        <Button
                                            icon={'tablet'}
                                            isSecondary
                                            className={'df-resp-button'}
                                            isPrimary={df_resp == 'table'} onClick={() => setAttributes({ df_resp: 'table' })}
                                        >
                                        </Button>
                                        <Button
                                            icon={'smartphone'}
                                            isSecondary
                                            className={'df-resp-button'}
                                            isPrimary={df_resp == 'mobile'} onClick={() => setAttributes({ df_resp: 'mobile' })}
                                        >
                                        </Button>
                                    </div>
                                </div>
                                {(df_resp=='desktop') &&
                                    <RangeControl
                                        label={__('Margin','bubiblock-slider')}
                                        help={__('px Unit','bubiblock-slider')}
                                        beforeIcon={'arrow-down-alt'}
                                        afterIcon={'arrow-up-alt'}
                                        allowReset
                                        resetFallbackValue={40}
                                        step={1}
                                        withInputField={false}
                                        separatorType="none"
                                        trackColor="#007cba"
                                        isShiftStepEnabled
                                        marks={[
                                            {
                                                value: -100,
                                                label: __('-100','bubiblock-slider'),
                                            },
                                            {
                                                value: 0,
                                                label: __('0','bubiblock-slider'),
                                            },
                                            {
                                                value: 100,
                                                label: __('100','bubiblock-slider'),
                                            },
                                            {
                                                value: 200,
                                                label: __('200','bubiblock-slider'),
                                            },
                                            {
                                                value: 300,
                                                label: __('300','bubiblock-slider'),
                                            },
                                        ]}
                                        railColor="#02abff"
                                        value={ margin_bottom_info1 }
                                        onChange={ this.onChangeMargin_bottom_info1}
                                        min={ -100 }
                                        max={ 300}
                                    />
                                }
                                {(df_resp=='table') &&
                                    <RangeControl
                                        label={__('Margin','bubiblock-slider')}
                                        help={__('px Unit','bubiblock-slider')}
                                        beforeIcon={'arrow-down-alt'}
                                        afterIcon={'arrow-up-alt'}
                                        allowReset
                                        resetFallbackValue={30}
                                        step={1}
                                        withInputField={false}
                                        separatorType="none"
                                        trackColor="#007cba"
                                        isShiftStepEnabled
                                        marks={[
                                            {
                                                value: -50,
                                                label: __('-50','bubiblock-slider'),
                                            },
                                            {
                                                value: 0,
                                                label: __('0','bubiblock-slider'),
                                            },
                                            {
                                                value: 50,
                                                label: __('50','bubiblock-slider'),
                                            },
                                            {
                                                value: 100,
                                                label: __('100','bubiblock-slider'),
                                            },
                                            {
                                                value: 150,
                                                label: __('150','bubiblock-slider'),
                                            },
                                            {
                                                value: 200,
                                                label: __('200','bubiblock-slider'),
                                            },
                                        ]}
                                        railColor="#02abff"
                                        value={ margin_bottom_table_info1 }
                                        onChange={ this.onChangeMargin_bottom_table_info1}
                                        min={ -50 }
                                        max={ 200}
                                    />
                                }
                                {(df_resp=='mobile') &&
                                    <RangeControl
                                        label={__('Margin','bubiblock-slider')}
                                        help={__('px Unit','bubiblock-slider')}
                                        beforeIcon={'arrow-down-alt'}
                                        afterIcon={'arrow-up-alt'}
                                        allowReset
                                        resetFallbackValue={10}
                                        step={1}
                                        withInputField={false}
                                        separatorType="none"
                                        trackColor="#007cba"
                                        isShiftStepEnabled
                                        marks={[
                                            {
                                                value: -50,
                                                label: __('-50','bubiblock-slider'),
                                            },
                                            {
                                                value: 0,
                                                label: __('0','bubiblock-slider'),
                                            },
                                            {
                                                value: 50,
                                                label: __('50','bubiblock-slider'),
                                            },
                                            {
                                                value: 100,
                                                label: __('100','bubiblock-slider'),
                                            },
                                            {
                                                value: 150,
                                                label: __('150','bubiblock-slider'),
                                            },
                                            {
                                                value: 200,
                                                label: __('200','bubiblock-slider'),
                                            },
                                        ]}
                                        railColor="#02abff"
                                        value={ margin_bottom_mobile_info1 }
                                        onChange={ this.onChangeMargin_bottom_mobile_info1}
                                        min={ -50 }
                                        max={ 200}
                                    />
                                }
                                {(df_resp=='desktop') &&
                                    <FontSizePicker
                                        value={fontsizeinfo1}
                                        onChange={(val) => setAttributes({fontsizeinfo1: val})}
                                        fontSizes={[
                                            { name: __('None', 'bubiblock-slider'), slug: 'none', size: 0 },
                                            { name: __('Small', 'bubiblock-slider'), slug: 'small', size: 18 },
                                            { name: __('Medium', 'bubiblock-slider'), slug: 'medium', size:24 },
                                            { name: __('Large', 'bubiblock-slider'), slug: 'large', size: 32 },
                                            { name: __('Big', 'bubiblock-slider'), slug: 'large', size: 52 },
                                        ]}
                                        withSlider={true}
                                    />
                                    }
                                {(df_resp=='table') &&
                                    <FontSizePicker
                                        value={fontsizeinfo1table}
                                        onChange={(val) => setAttributes({fontsizeinfo1table: val})}
                                        fontSizes={[
                                            { name: __('None', 'bubiblock-slider'), slug: 'none', size: 0 },
                                            { name: __('Small', 'bubiblock-slider'), slug: 'small', size: 18 },
                                            { name: __('Medium', 'bubiblock-slider'), slug: 'medium', size:24 },
                                            { name: __('Large', 'bubiblock-slider'), slug: 'large', size: 32 },
                                            { name: __('Big', 'bubiblock-slider'), slug: 'large', size: 52 },
                                        ]}
                                        withSlider={true}
                                    />
                                }
                                {(df_resp=='mobile') &&
                                    <FontSizePicker
                                        value={fontsizeinfo1mobile}
                                        onChange={(val) => setAttributes({fontsizeinfo1mobile: val})}
                                        fontSizes={[
                                            { name: __('None', 'bubiblock-slider'), slug: 'none', size: 0 },
                                            { name: __('Small', 'bubiblock-slider'), slug: 'small', size: 18 },
                                            { name: __('Medium', 'bubiblock-slider'), slug: 'medium', size:24 },
                                            { name: __('Large', 'bubiblock-slider'), slug: 'large', size: 32 },
                                            { name: __('Big', 'bubiblock-slider'), slug: 'large', size: 52 },
                                        ]}
                                        withSlider={true}
                                    />
                                }
                            </ButtonGroup>
                            <RadioControl
                                label={__('Align','bubiblock-slider')}
                                selected={ alignment_info1 }
                                options={ [
                                    { label: 'Left', value: 'left' },
                                    { label: 'Center', value: 'center' },
                                    { label: 'Right', value: 'right' },
                                ] }
                                onChange={ ( newAlign ) => setAttributes( { alignment_info1: newAlign } ) }
                            />
                            <SelectControl
                                label={__("Effect","bubiblock-slider")}
                                options={bubiOptionsEffectAnimate}
                                onChange={this.onChangeEffectinfo1}
                                value={effectinfo1}
                            />
                            <SelectControl
                                label={__("Effect speed","bubiblock-slider")}
                                options={bubiOptionEffectSpeed}
                                onChange={this.onChangeDf_speed_effectinfo1}
                                value={df_speed_effectinfo1}
                            />
                            <SelectControl
                                label={__("Effect delay","bubiblock-slider")}
                                options={bubiOptionEffectDalay}
                                onChange={this.onChangeDf_delay_effectinfo1}
                                value={df_delay_effectinfo1}
                            />
                            <SelectControl
                                label={__("Effect repeat","bubiblock-slider")}
                                options={bubiOptionEffectRepeat}
                                onChange={this.onChangeDf_repeat_effectinfo1}
                                value={df_repeat_effectinfo1}
                            />
                        </>
                        }
                        {button1 &&
                        <>
                            <h6 class="df-inspector">{ __('Button', 'bubiblock-slider')}</h6>
                            <ButtonGroup
                                className={'df-button-group bubiblock-no-margin'}
                            >
                                <div class="df-group-button-resp">
                                    <div class="bubi-col-6">
                                        <h6>{ __('Choose', 'bubiblock-slider')}</h6>
                                    </div>
                                    <div class="bubi-col-6">
                                        <Button
                                            icon={'laptop'}
                                            isSecondary
                                            className={'df-resp-button'}
                                            isPrimary={df_resp == 'desktop'} onClick={() => setAttributes({ df_resp: 'desktop' })}
                                        >
                                        </Button>
                                        <Button
                                            icon={'tablet'}
                                            isSecondary
                                            className={'df-resp-button'}
                                            isPrimary={df_resp == 'table'} onClick={() => setAttributes({ df_resp: 'table' })}
                                        >
                                        </Button>
                                        <Button
                                            icon={'smartphone'}
                                            isSecondary
                                            className={'df-resp-button'}
                                            isPrimary={df_resp == 'mobile'} onClick={() => setAttributes({ df_resp: 'mobile' })}
                                        >
                                        </Button>
                                    </div>
                                </div>
                                {(df_resp=='desktop') &&
                                    <RangeControl
                                        label={__('Margin','bubiblock-slider')}
                                        help={__('px Unit','bubiblock-slider')}
                                        beforeIcon={'arrow-down-alt'}
                                        afterIcon={'arrow-up-alt'}
                                        allowReset
                                        resetFallbackValue={5}
                                        step={1}
                                        withInputField={false}
                                        separatorType="none"
                                        trackColor="#007cba"
                                        isShiftStepEnabled
                                        marks={[
                                            {
                                                value: -100,
                                                label: __('-100','bubiblock-slider'),
                                            },
                                            {
                                                value: 0,
                                                label: __('0','bubiblock-slider'),
                                            },
                                            {
                                                value: 100,
                                                label: __('100','bubiblock-slider'),
                                            },
                                            {
                                                value: 200,
                                                label: __('200','bubiblock-slider'),
                                            },
                                            {
                                                value: 300,
                                                label: __('300','bubiblock-slider'),
                                            },
                                        ]}
                                        railColor="#02abff"
                                        value={ margin_bottom_button1 }
                                        onChange={ this.onChangeMargin_bottom_button1}
                                        min={ -100 }
                                        max={ 300}
                                    />
                                }
                                {(df_resp=='table')  &&
                                    <RangeControl
                                        label={__('Margin','bubiblock-slider')}
                                        help={__('px Unit','bubiblock-slider')}
                                        beforeIcon={'arrow-down-alt'}
                                        afterIcon={'arrow-up-alt'}
                                        allowReset
                                        resetFallbackValue={5}
                                        step={1}
                                        withInputField={false}
                                        separatorType="none"
                                        trackColor="#007cba"
                                        isShiftStepEnabled
                                        marks={[
                                            {
                                                value: -50,
                                                label: __('-50','bubiblock-slider'),
                                            },
                                            {
                                                value: 0,
                                                label: __('0','bubiblock-slider'),
                                            },
                                            {
                                                value: 50,
                                                label: __('50','bubiblock-slider'),
                                            },
                                            {
                                                value: 100,
                                                label: __('100','bubiblock-slider'),
                                            },
                                            {
                                                value: 150,
                                                label: __('150','bubiblock-slider'),
                                            },
                                            {
                                                value: 200,
                                                label: __('200','bubiblock-slider'),
                                            },
                                        ]}
                                        railColor="#02abff"
                                        value={ margin_bottom_table_button1 }
                                        onChange={ this.onChangeMargin_bottom_table_button1}
                                        min={ -50 }
                                        max={ 200}
                                    />
                                }
                                {(df_resp=='mobile') &&
                                    <RangeControl
                                        label={__('Margin','bubiblock-slider')}
                                        help={__('px Unit','bubiblock-slider')}
                                        beforeIcon={'arrow-down-alt'}
                                        afterIcon={'arrow-up-alt'}
                                        allowReset
                                        resetFallbackValue={5}
                                        step={1}
                                        withInputField={false}
                                        separatorType="none"
                                        trackColor="#007cba"
                                        isShiftStepEnabled
                                        marks={[
                                            {
                                                value: -50,
                                                label: __('-50','bubiblock-slider'),
                                            },
                                            {
                                                value: 0,
                                                label: __('0','bubiblock-slider'),
                                            },
                                            {
                                                value: 50,
                                                label: __('50','bubiblock-slider'),
                                            },
                                            {
                                                value: 100,
                                                label: __('100','bubiblock-slider'),
                                            },
                                            {
                                                value: 150,
                                                label: __('150','bubiblock-slider'),
                                            },
                                            {
                                                value: 200,
                                                label: __('200','bubiblock-slider'),
                                            },
                                        ]}
                                        railColor="#02abff"
                                        value={ margin_bottom_mobile_button1 }
                                        onChange={ this.onChangeMargin_bottom_mobile_button1}
                                        min={ -50 }
                                        max={ 200}
                                    />
                                }
                                {(df_resp=='desktop') &&
                                    <FontSizePicker
                                        value={fontsizebutton1}
                                        onChange={(val) => setAttributes({fontsizebutton1: val})}
                                        fontSizes={[
                                            { name: __('Small', 'bubiblock-slider'), slug: 'small', size: 18 },
                                            { name: __('Medium', 'bubiblock-slider'), slug: 'medium', size:24 },
                                            { name: __('Large', 'bubiblock-slider'), slug: 'large', size: 32 },
                                            { name: __('Big', 'bubiblock-slider'), slug: 'large', size: 52 },
                                        ]}
                                        withSlider={true}
                                />
                                    }
                                {(df_resp=='table') &&
                                    <FontSizePicker
                                        value={fontsizebutton1table}
                                        onChange={(val) => setAttributes({fontsizebutton1table: val})}
                                        fontSizes={[
                                            { name: __('Small', 'bubiblock-slider'), slug: 'small', size: 18 },
                                            { name: __('Medium', 'bubiblock-slider'), slug: 'medium', size:24 },
                                            { name: __('Large', 'bubiblock-slider'), slug: 'large', size: 32 },
                                            { name: __('Big', 'bubiblock-slider'), slug: 'large', size: 52 },
                                        ]}
                                        withSlider={true}
                                    />
                                }
                                {(df_resp=='mobile') &&
                                    <FontSizePicker
                                        value={fontsizebutton1mobile}
                                        onChange={(val) => setAttributes({fontsizebutton1mobile: val})}
                                        fontSizes={[
                                            { name: __('Small', 'bubiblock-slider'), slug: 'small', size: 18 },
                                            { name: __('Medium', 'bubiblock-slider'), slug: 'medium', size:24 },
                                            { name: __('Large', 'bubiblock-slider'), slug: 'large', size: 32 },
                                            { name: __('Big', 'bubiblock-slider'), slug: 'large', size: 52 },
                                        ]}
                                        withSlider={true}
                                    />
                                }
                            </ButtonGroup>
                            <RadioControl
                                label={__('Align','bubiblock-slider')}
                                selected={ alignment_button1 }
                                options={ [
                                    { label: 'Left', value: 'left' },
                                    { label: 'Center', value: 'center' },
                                    { label: 'Right', value: 'right' },
                                ] }
                                onChange={ ( newAlign ) => setAttributes( { alignment_button1: newAlign } ) }
                            />
                            <SelectControl
                                label={__("Effect","bubiblock-slider")}
                                options={bubiOptionsEffectAnimate}
                                onChange={this.onChangeEffectbutton1}
                                value={effectbutton1}
                            />
                            <SelectControl
                                label={__("Effect speed","bubiblock-slider")}
                                options={bubiOptionEffectSpeed}
                                onChange={this.onChangeDf_speed_effectbutton1}
                                value={df_speed_effectbutton1}
                            />
                            <SelectControl
                                label={__("Effect delay","bubiblock-slider")}
                                options={bubiOptionEffectDalay}
                                onChange={this.onChangeDf_delay_effectbutton1}
                                value={df_delay_effectbutton1}
                            />
                            <SelectControl
                                label={__("Effect repeat","bubiblock-slider")}
                                options={bubiOptionEffectRepeat}
                                onChange={this.onChangeDf_repeat_effectbutton1}
                                value={df_repeat_effectbutton1}
                            />
                            <RangeControl
                                label={__('Padding top/bottom','bubiblock-slider')}
                                help={__('px Unit','bubiblock-slider')}
                                beforeIcon={'arrow-down-alt'}
                                afterIcon={'arrow-up-alt'}
                                allowReset
                                resetFallbackValue={8}
                                step={1}
                                withInputField={false}
                                separatorType="none"
                                trackColor="#007cba"
                                isShiftStepEnabled
                                marks={[
                                    {
                                        value: 0,
                                        label: __('0','bubiblock-slider'),
                                    },
                                    {
                                        value: 10,
                                        label: __('10','bubiblock-slider'),
                                    },
                                    {
                                        value: 20,
                                        label: __('20','bubiblock-slider'),
                                    },
                                    {
                                        value: 30,
                                        label: __('30','bubiblock-slider'),
                                    },
                                    {
                                        value: 40,
                                        label: __('40','bubiblock-slider'),
                                    },
                                    {
                                        value: 50,
                                        label: __('50','bubiblock-slider'),
                                    },
                                ]}
                                railColor="#02abff"
                                value={ padding_link_button1 }
                                onChange={(val) => setAttributes({ padding_link_button1: val })}
                                min={ 0 }
                                max={ 50}
                            />
                            <RangeControl
                                label={__('Padding left/right','bubiblock-slider')}
                                help={__('px Unit','bubiblock-slider')}
                                beforeIcon={'arrow-left-alt'}
                                afterIcon={'arrow-right-alt'}
                                allowReset
                                resetFallbackValue={20}
                                step={1}
                                withInputField={false}
                                separatorType="none"
                                trackColor="#007cba"
                                isShiftStepEnabled
                                marks={[
                                    {
                                        value: 0,
                                        label: __('0','bubiblock-slider'),
                                    },
                                    {
                                        value: 10,
                                        label: __('10','bubiblock-slider'),
                                    },
                                    {
                                        value: 20,
                                        label: __('20','bubiblock-slider'),
                                    },
                                    {
                                        value: 30,
                                        label: __('30','bubiblock-slider'),
                                    },
                                    {
                                        value: 40,
                                        label: __('40','bubiblock-slider'),
                                    },
                                    {
                                        value: 50,
                                        label: __('50','bubiblock-slider'),
                                    },
                                ]}
                                railColor="#02abff"
                                value={ padding_right_link_button1 }
                                onChange={(val) => setAttributes({ padding_right_link_button1: val })}
                                min={ 0 }
                                max={ 50}
                            />
                            <RangeControl
                                label={__('Border solid','bubiblock-slider')}
                                help={__('Px Unit','bubiblock-slider')}
                                beforeIcon={'star-empty'}
                                afterIcon={'star-filled'}
                                allowReset
                                resetFallbackValue={0}
                                step={1}
                                withInputField={false}
                                separatorType="none"
                                trackColor="#007cba"
                                isShiftStepEnabled
                                marks={[
                                    {
                                        value: 0,
                                        label: __('0','bubiblock-slider'),
                                    },
                                    {
                                        value: 10,
                                        label: __('10','bubiblock-slider'),
                                    },
                                    {
                                        value: 20,
                                        label: __('20','bubiblock-slider'),
                                    },
                                    {
                                        value: 30,
                                        label: __('30','bubiblock-slider'),
                                    },
                                    {
                                        value: 40,
                                        label: __('40','bubiblock-slider'),
                                    },
                                    {
                                        value: 50,
                                        label: __('50','bubiblock-slider'),
                                    },
                                ]}
                                railColor="#02abff"
                                value={ border_size_link_button1 }
                                onChange={(val) => setAttributes({ border_size_link_button1: val })}
                                min={ 0 }
                                max={ 50}
                            />
                            <RangeControl
                                label={__('Border top left radius','bubiblock-slider')}
                                help={__('% Unit','bubiblock-slider')}
                                beforeIcon={'fullscreen-alt'}
                                afterIcon={'fullscreen-exit-alt'}
                                allowReset
                                resetFallbackValue={0}
                                step={1}
                                withInputField={false}
                                separatorType="none"
                                trackColor="#007cba"
                                isShiftStepEnabled
                                marks={[
                                    {
                                        value: 0,
                                        label: __('0','bubiblock-slider'),
                                    },
                                    {
                                        value: 10,
                                        label: __('10','bubiblock-slider'),
                                    },
                                    {
                                        value: 20,
                                        label: __('20','bubiblock-slider'),
                                    },
                                    {
                                        value: 30,
                                        label: __('30','bubiblock-slider'),
                                    },
                                    {
                                        value: 40,
                                        label: __('40','bubiblock-slider'),
                                    },
                                    {
                                        value: 50,
                                        label: __('50','bubiblock-slider'),
                                    },
                                ]}
                                railColor="#02abff"
                                value={ border_radius_top_left_link_button1 }
                                onChange={(val) => setAttributes({ border_radius_top_left_link_button1: val })}
                                min={ 0 }
                                max={ 50}
                            />
                            <RangeControl
                                label={__('Border top right radius','bubiblock-slider')}
                                help={__('% Unit','bubiblock-slider')}
                                beforeIcon={'fullscreen-alt'}
                                afterIcon={'fullscreen-exit-alt'}
                                allowReset
                                resetFallbackValue={0}
                                step={1}
                                withInputField={false}
                                separatorType="none"
                                trackColor="#007cba"
                                isShiftStepEnabled
                                marks={[
                                    {
                                        value: 0,
                                        label: __('0','bubiblock-slider'),
                                    },
                                    {
                                        value: 10,
                                        label: __('10','bubiblock-slider'),
                                    },
                                    {
                                        value: 20,
                                        label: __('20','bubiblock-slider'),
                                    },
                                    {
                                        value: 30,
                                        label: __('30','bubiblock-slider'),
                                    },
                                    {
                                        value: 40,
                                        label: __('40','bubiblock-slider'),
                                    },
                                    {
                                        value: 50,
                                        label: __('50','bubiblock-slider'),
                                    },
                                ]}
                                railColor="#02abff"
                                value={ border_radius_top_right_link_button1 }
                                onChange={(val) => setAttributes({ border_radius_top_right_link_button1: val })}
                                min={ 0 }
                                max={ 50}
                            />
                            <RangeControl
                                label={__('Border bottom left radius','bubiblock-slider')}
                                help={__('% Unit','bubiblock-slider')}
                                beforeIcon={'fullscreen-alt'}
                                afterIcon={'fullscreen-exit-alt'}
                                allowReset
                                resetFallbackValue={0}
                                step={1}
                                withInputField={false}
                                separatorType="none"
                                trackColor="#007cba"
                                isShiftStepEnabled
                                marks={[
                                    {
                                        value: 0,
                                        label: __('0','bubiblock-slider'),
                                    },
                                    {
                                        value: 10,
                                        label: __('10','bubiblock-slider'),
                                    },
                                    {
                                        value: 20,
                                        label: __('20','bubiblock-slider'),
                                    },
                                    {
                                        value: 30,
                                        label: __('30','bubiblock-slider'),
                                    },
                                    {
                                        value: 40,
                                        label: __('40','bubiblock-slider'),
                                    },
                                    {
                                        value: 50,
                                        label: __('50','bubiblock-slider'),
                                    },
                                ]}
                                railColor="#02abff"
                                value={ border_radius_bottom_left_link_button1 }
                                onChange={(val) => setAttributes({ border_radius_bottom_left_link_button1: val })}
                                min={ 0 }
                                max={ 50}
                            />
                            <RangeControl
                                label={__('Border bottom right radius','bubiblock-slider')}
                                help={__('% Unit','bubiblock-slider')}
                                beforeIcon={'fullscreen-alt'}
                                afterIcon={'fullscreen-exit-alt'}
                                allowReset
                                resetFallbackValue={0}
                                step={1}
                                withInputField={false}
                                separatorType="none"
                                trackColor="#007cba"
                                isShiftStepEnabled
                                marks={[
                                    {
                                        value: 0,
                                        label: __('0','bubiblock-slider'),
                                    },
                                    {
                                        value: 10,
                                        label: __('10','bubiblock-slider'),
                                    },
                                    {
                                        value: 20,
                                        label: __('20','bubiblock-slider'),
                                    },
                                    {
                                        value: 30,
                                        label: __('30','bubiblock-slider'),
                                    },
                                    {
                                        value: 40,
                                        label: __('40','bubiblock-slider'),
                                    },
                                    {
                                        value: 50,
                                        label: __('50','bubiblock-slider'),
                                    },
                                ]}
                                railColor="#02abff"
                                value={ border_radius_bottom_right_link_button1 }
                                onChange={(val) => setAttributes({ border_radius_bottom_right_link_button1: val })}
                                min={ 0 }
                                max={ 50}
                            />
                            <h6 id={'bg'} class="df-inspector" >{ __('Background Color', 'bubiblock-slider')}
                            {(df_background_color_transparent_link_button1 == 'df-trasparent-color-button1-false') &&
                                <>
                                {df_background_color_link_button1 &&
                                    <ColorIndicator
                                        colorValue={ df_background_color_link_button1 }
                                    />
                                }
                                </>
                            }
                            {df_background_color_hover_link_button1 &&
                                <ColorIndicator
                                    colorValue={ df_background_color_hover_link_button1 }
                                />
                            }
                            </h6>
                            {(df_background_color_transparent_link_button1 == 'df-trasparent-color-button1-false') &&
                                <div class={'legend-color-none'}>
                                    <ColorPaletteControl
                                        value={ df_background_color_link_button1}
                                        colors={ bubiColors }
                                        onChange={ (newValue) => setAttributes({df_background_color_link_button1: newValue}) }
                                    />
                                </div>
                            }
                            <p className={"df-inspector bubi-mt-1"}>{__('Hover','bubiblock-slider')}</p>
                            <div class={'legend-color-none'}>
                                <ColorPaletteControl
                                    value={ df_background_color_hover_link_button1}
                                    colors={ bubiColors }
                                    onChange={ (newValue) => setAttributes({df_background_color_hover_link_button1: newValue}) }
                                />
                            </div>
                            <h6 className="df-inspector">{ __('Color', 'bubiblock-slider')}
                            {df_color_link_button1 &&
                                <ColorIndicator
                                    colorValue={ df_color_link_button1 }
                                />
                            }
                            {df_color_hover_link_button1 &&
                                <ColorIndicator
                                    colorValue={ df_color_hover_link_button1 }
                                />
                            }
                            {df_border_color_link_button1 &&
                                <ColorIndicator
                                    colorValue={ df_border_color_link_button1 }
                                />
                            }
                            </h6>
                            <div class={'legend-color-none'}>
                                <p className="df-inspector">{__('Color','bubiblock-slider')}</p>
                                <ColorPaletteControl
                                    value={ df_color_link_button1}
                                    colors={ bubiColors }
                                    onChange={ (newValue) => setAttributes({df_color_link_button1: newValue}) }
                                />
                                <p className="df-inspector">{__('Color hover','bubiblock-slider')}</p>
                                <ColorPaletteControl
                                    value={ df_color_hover_link_button1}
                                    colors={ bubiColors }
                                    onChange={ (newValue) => setAttributes({df_color_hover_link_button1: newValue}) }
                                />
                                <p className="df-inspector">{__('Border Color','bubiblock-slider')}</p>
                                <ColorPaletteControl
                                    value={ df_border_color_link_button1}
                                    colors={ bubiColors }
                                    onChange={ (newValue) => setAttributes({df_border_color_link_button1: newValue}) }
                                />
                            </div>
                            <ButtonGroup
                                className={'df-button-group bubiblock-no-margin'}
                            >
                                <h6 className="df-inspector">{ __('Background color transparent', 'bubiblock-slider')}</h6>
                                <div class="bubi-width-two">
                                <Button
                                    isSecondary
                                    isPrimary={df_background_color_transparent_link_button1 == 'df-trasparent-color-button1-true'} onClick={() => setAttributes({ df_background_color_transparent_link_button1: 'df-trasparent-color-button1-true' })}
                                >
                                    {__('True','bubiblock-slider')}
                                </Button>
                                <Button
                                    isSecondary
                                    isPrimary={df_background_color_transparent_link_button1 == 'df-trasparent-color-button1-false'} onClick={() => setAttributes({ df_background_color_transparent_link_button1: 'df-trasparent-color-button1-false' })}
                                >
                                    {__('False','bubiblock-slider')}
                                </Button>
                                </div>
                            </ButtonGroup>
                        </>
                        }
                    </PanelBody>
                    <PanelBody // Slider 2
                        icon={'format-image'}
                        title={__('Slides 2', 'bubiblock-slider')}
                        initialOpen={false}
                        >
                        <h6 className="df-inspector bubi-mt-1">{ __('Background type', 'bubiblock-slider')}</h6>
                        <div class="bubi-width-three bubibutton-icon">
                            <ButtonGroup
                                className={'df-button-group bubiblock-no-margin'}
                            >
                                <Tooltip
                                    text= {__('Color','bubiblock-slider')}
                                >
                                    <Button
                                        isPrimary={df_slider_chose_2 == 'df-slider-color-2'}
                                        icon="admin-appearance"
                                        onClick={() => setAttributes({ df_slider_chose_2: 'df-slider-color-2' })}
                                    >
                                    </Button>
                                </Tooltip>
                                <Tooltip
                                    text=  {__('Image','bubiblock-slider')}
                                >
                                    <Button
                                        isPrimary={df_slider_chose_2 == 'df-slider-image-2'}
                                        icon="format-image"
                                        onClick={() => setAttributes({ df_slider_chose_2: 'df-slider-image-2' })}
                                    >
                                    </Button>
                                </Tooltip>
                            </ButtonGroup>
                        </div>
                        {(df_slider_chose_2=='df-slider-image-2' ) &&
                            <>
                                {imageUrl_2?
                                    <>
                                    <img src={imageUrl_2} className={'bubi-mt-2'}/>
                                    {isBlobURL(imageUrl_2) && <Spinner />}
                                    </>
                                    :
                                    <MediaPlaceholder
                                        className={'bubi-mt-2 bubi-mb-2'}
                                        icon="format-image df-icon-img-upload"
                                        onSelect={ media => { setAttributes({ imageAlt_2: media.alt, imageUrl_2: media.url }); } }
                                        onSelectURL={ this.onSelectURL2 }
                                        onError={this.onUploadError2}
                                        accept="image/*"
                                        allowedTypes={['image']}
                                        notices={ noticeUI2 }
                                    />
                                }
                                {imageUrl_2 &&
                                <>
                                    <MenuItem
                                        icon={ 'trash' }
                                        className={'df-remov-img'}
                                        onClick={ this.removeImage2 }
                                    >
                                        { __('Remove Image','bubiblock-slider') }
                                    </MenuItem>
                                    <TextareaControl
                                        label={__('Alt Text (Alternative Text)','bubiblock-slider')}
                                        value={ alt2}
                                        onChange={ this.updateAlt2 }
                                        help={__('Alternative text describes your image to people who cant see it. Add a short description with its key details.','bubiblock-slider')}
                                    />
                                    <SelectControl
                                        label={__("Dispaly Size","bubiblock-slider")}
                                        options={[
                                            {label: __('None','bubiblock-slider'), value: 'none'},
                                            {label: __('Containe','bubiblock-slider'), value: 'contain'},
                                            {label: __('Cover','bubiblock-slider'), value: 'cover'},
                                            {label: __('Fill','bubiblock-slider'), value: 'fill'},
                                            {label: __('Scale down','bubiblock-slider'), value: 'scale-down'},
                                            {label: __('Unset','bubiblock-slider'), value: 'unset'},
                                        ]}
                                        onChange={this.onChangeDf_cover_img2}
                                        value={df_cover_img2}
                                    />
                                    {(df_cover_img2=='none')&&
                                    <>
                                        <RangeControl
                                            label={__('Display Position','bubiblock-slider')}
                                            help={__('% Unit','bubiblock-slider')}
                                            beforeIcon={'arrow-left-alt'}
                                            afterIcon={'arrow-right-alt'}
                                            allowReset
                                            resetFallbackValue={50}
                                            step={1}
                                            withInputField={false}
                                            separatorType="none"
                                            trackColor="#007cba"
                                            isShiftStepEnabled
                                            marks={[
                                                {
                                                    value: 0,
                                                    label: __('0','bubiblock-slider'),
                                                },
                                                {
                                                    value: 20,
                                                    label: __('20','bubiblock-slider'),
                                                },
                                                {
                                                    value: 40,
                                                    label: __('40','bubiblock-slider'),
                                                },
                                                {
                                                    value: 60,
                                                    label: __('60','bubiblock-slider'),
                                                },
                                                {
                                                    value: 80,
                                                    label: __('80','bubiblock-slider'),
                                                },
                                                {
                                                    value: 100,
                                                    label: __('100','bubiblock-slider'),
                                                },
                                            ]}
                                            railColor="#02abff"
                                            value={ df_focalPoint_img_2 }
                                            onChange={ this.onChangeDf_focalPoint_img_2 }
                                            min={ 0 }
                                            max={ 100}
                                        />
                                        <RangeControl
                                            label={__('Display Position','bubiblock-slider')}
                                            help={__('% Unit','bubiblock-slider')}
                                            beforeIcon={'arrow-down-alt'}
                                            afterIcon={'arrow-up-alt'}
                                            allowReset
                                            resetFallbackValue={50}
                                            step={1}
                                            withInputField={false}
                                            separatorType="none"
                                            trackColor="#007cba"
                                            isShiftStepEnabled
                                            marks={[
                                                {
                                                    value: 0,
                                                    label: __('0','bubiblock-slider'),
                                                },
                                                {
                                                    value: 20,
                                                    label: __('20','bubiblock-slider'),
                                                },
                                                {
                                                    value: 40,
                                                    label: __('40','bubiblock-slider'),
                                                },
                                                {
                                                    value: 60,
                                                    label: __('60','bubiblock-slider'),
                                                },
                                                {
                                                    value: 80,
                                                    label: __('80','bubiblock-slider'),
                                                },
                                                {
                                                    value: 100,
                                                    label: __('100','bubiblock-slider'),
                                                },
                                            ]}
                                            railColor="#02abff"
                                            value={ df_focalPoint_y_img_2 }
                                            onChange={ this.onChangeDf_focalPoint_y_img_2 }
                                            min={ 0 }
                                            max={ 100}
                                        />
                                        </>
                                    }
                                    <ToggleControl
                                        label={ __( 'Show mask','bubiblock-slider' ) }
                                        checked={df_mask_slider_2}
                                        onChange={this.onChangeDf_mask_slider_2}
                                    />
                                    {df_mask_slider_2 &&
                                        <>
                                        <Notice
                                            status="info"
                                            isDismissible={ false }
                                        >
                                            {__('If you have set the border radius for the slider this control will not work well!','bubiblock-slider')}
                                        </Notice>
                                        <ColorGradientControl
                                            colorValue={ background_color_solid_mask_2 }
                                            gradientValue={ background_color_gradient_mask_2 }
                                            colors={ bubiColors }
                                            gradients={ bubiGradients }
                                            onColorChange={ (newValue) => setAttributes({ background_color_solid_mask_2: newValue }) }
                                            onGradientChange={ (newValue) => setAttributes({ background_color_gradient_mask_2: newValue }) }
                                        />
                                        <RangeControl
                                            label={__('Opacity','bubiblock-slider')}
                                            beforeIcon={'hidden'}
                                            afterIcon={'visibility'}
                                            allowReset
                                            resetFallbackValue={.4}
                                            step={.1}
                                            withInputField={false}
                                            separatorType="none"
                                            trackColor="#007cba"
                                            isShiftStepEnabled
                                            marks={[
                                                {
                                                    value: 0,
                                                    label: __('0','bubiblock-slider'),
                                                },
                                                {
                                                    value: 0.2,
                                                    label: __('2','bubiblock-slider'),
                                                },
                                                {
                                                    value: 0.4,
                                                    label: __('4','bubiblock-slider'),
                                                },
                                                {
                                                    value: 0.6,
                                                    label: __('6','bubiblock-slider'),
                                                },
                                                {
                                                    value: 0.8,
                                                    label: __('8','bubiblock-slider'),
                                                },
                                                {
                                                    value: 1.0,
                                                    label: __('10','bubiblock-slider'),
                                                },
                                            ]}
                                            railColor="#02abff"
                                            value={ df_opacity_mask_2 }
                                            onChange={ this.onChangeDf_opacity_mask_2 }
                                            min={ .0 }
                                            max={ 1.0}
                                        />
                                    </>
                                    }
                                    <TextControl
                                        label={__('Link Image','bubiblock-slider')}
                                        value={ bubiblock_link_slider_2 }
                                        onChange={ (newValue) => setAttributes({bubiblock_link_slider_2: newValue}) }
                                        type="url"
                                    />
                                    {bubiblock_link_slider_2 &&
                                        <ButtonGroup
                                                className={'df-button-group bubiblock-no-margin bubi-mb-2'}
                                            >
                                                <p className="df-inspector bubi-mt-1">{ __('Open in new tab', 'bubiblock-slider')}</p>
                                                <div class="bubi-width-two">
                                                <Button
                                                    isSecondary
                                                    isPrimary={bubiblock_link_tab_slider_2 == '_blank'} onClick={() => setAttributes({ bubiblock_link_tab_slider_2: '_blank' })}
                                                >
                                                    {__('True','bubiblock-slider')}
                                                </Button>
                                                <Button
                                                    isSecondary
                                                    isPrimary={bubiblock_link_tab_slider_2 == ''} onClick={() => setAttributes({ bubiblock_link_tab_slider_2: '' })}
                                                >
                                                    {__('False','bubiblock-slider')}
                                                </Button>
                                                </div>
                                        </ButtonGroup>
                                    }
                                </>
                                }
                            </>
                        }
                        {(df_slider_chose_2=='df-slider-color-2' ) &&
                            <>
                            <h6 className="df-inspector bubi-not-background">{ __('Background Color', 'bubiblock-slider')}
                            {df_background_color_slider_2 &&
                                <ColorIndicator
                                    colorValue={ df_background_color_slider_2 }
                                />
                            }
                            </h6>
                            <div class={'legend-color-none'}>
                                <ColorPaletteControl
                                    value={ df_background_color_slider_2}
                                    colors={ bubiColors }
                                    onChange={ (newValue) => setAttributes({df_background_color_slider_2: newValue}) }
                                />
                            </div>
                            </>
                        }
                        <ToggleControl
                            label={ __( 'Dividers Top','bubiblock-slider' ) }
                            checked={df_enable_divide_2}
                            onChange={this.onChangeDf_enable_divide_2}
                        />
                        {df_enable_divide_2 &&
                        <>
                            <RadioControl
                                label={__('Choose', 'df-sidebar-gutenberg')}
                                selected={divide_2}
                                className={'bubiblock-radio-image'}
                                onChange={(val) => setAttributes({divide_2: val})}
                                options={bubiOptionsDivideTop}
                            />
                            <h6 className="df-inspector bubi-not-background">{ __('Color', 'bubiblock-slider')}
                            { df_color_divide_2 &&
                                <ColorIndicator
                                    colorValue={ df_color_divide_2 }
                                />
                            }
                            </h6>
                            <ColorPicker
                                color={df_color_divide_2}
                                onChangeComplete={(newval) => setAttributes({df_color_divide_2: ('rgba(' + newval.rgb.r + ', ' + newval.rgb.g + ', ' + newval.rgb.b + ', ' + newval.rgb.a + ')') })}
                            />
                            <ButtonGroup
                                className={'df-button-group bubiblock-no-margin'}
                            >
                                <div class="df-group-button-resp">
                                    <div class="bubi-col-6">
                                        <h6>{ __('Height', 'bubiblock-slider')}</h6>
                                    </div>
                                    <div class="bubi-col-6">
                                        <Button
                                            icon={'laptop'}
                                            isSecondary
                                            className={'df-resp-button'}
                                            isPrimary={df_resp == 'desktop'} onClick={() => setAttributes({ df_resp: 'desktop' })}
                                        >
                                        </Button>
                                        <Button
                                            icon={'tablet'}
                                            isSecondary
                                            className={'df-resp-button'}
                                            isPrimary={df_resp == 'table'} onClick={() => setAttributes({ df_resp: 'table' })}
                                        >
                                        </Button>
                                        <Button
                                            icon={'smartphone'}
                                            isSecondary
                                            className={'df-resp-button'}
                                            isPrimary={df_resp == 'mobile'} onClick={() => setAttributes({ df_resp: 'mobile' })}
                                        >
                                        </Button>
                                    </div>
                                </div>
                                {(df_resp=='desktop' ) &&
                                    <RangeControl
                                        label={__("Height(Desktop)","bubiblock-slider")}
                                        help={__('Px Unit','bubiblock-slider')}
                                        value={ df_height_divide_2 }
                                        onChange={ this.onChangeDf_height_divide_2 }
                                        min={20}
                                        max={1000}
                                    />
                                }
                                {(df_resp=='table' ) &&
                                    <RangeControl
                                        label={__("Height(Table)","bubiblock-slider")}
                                        help={__('Px Unit','bubiblock-slider')}
                                        value={ df_height_table_divide_2 }
                                        onChange={ this.onChangeDf_height_table_divide_2 }
                                        min={20}
                                        max={1000}
                                    />
                                }
                                {(df_resp=='mobile' ) &&
                                    <RangeControl
                                        label={__("Height(Mobile)","bubiblock-slider")}
                                        help={__('Px Unit','bubiblock-slider')}
                                        value={ df_height_mobile_divide_2 }
                                        onChange={ this.onChangeDf_height_mobile_divide_2 }
                                        min={20}
                                        max={1000}
                                    />
                                }
                            </ButtonGroup>
                            <RangeControl
                                label={__('Delayed appearance','bubiblock-slider')}
                                help={__('S Unit. In the Safari Browser this transition is not supported!','bubiblock-slider')}
                                beforeIcon={'arrow-down-alt'}
                                afterIcon={'arrow-up-alt'}
                                allowReset
                                resetFallbackValue={2}
                                step={1}
                                withInputField={false}
                                separatorType="none"
                                trackColor="#007cba"
                                isShiftStepEnabled
                                marks={[
                                    {
                                        value: 0,
                                        label: __('0','bubiblock-slider'),
                                    },
                                    {
                                        value: 5,
                                        label: __('5','bubiblock-slider'),
                                    },
                                    {
                                        value: 10,
                                        label: __('10','bubiblock-slider'),
                                    },
                                    {
                                        value: 15,
                                        label: __('15','bubiblock-slider'),
                                    },
                                    {
                                        value: 20,
                                        label: __('20','bubiblock-slider'),
                                    },
                                    {
                                        value: 25,
                                        label: __('25','bubiblock-slider'),
                                    },
                                    {
                                        value: 30,
                                        label: __('30','bubiblock-slider'),
                                    },
                                ]}
                                railColor="#02abff"
                                value={ bubiblock_dalay_divide_2 }
                                onChange={ this.onChangeBubiblock_dalay_divide_2}
                                min={ 0 }
                                max={ 20}
                            />
                        </>
                        }
                        <ToggleControl
                            label={ __( 'Dividers Bottom','bubiblock-slider' ) }
                            checked={df_enable_divide_bottom_2}
                            onChange={this.onChangeDf_enable_divide_bottom_2}
                        />
                        {df_enable_divide_bottom_2 &&
                        <>
                            <RadioControl
                                label={__('Choose', 'df-sidebar-gutenberg')}
                                selected={divide_bottom_2}
                                className={'df-radio-control-divide-bottom'}
                                onChange={(val) => setAttributes({divide_bottom_2: val})}
                                options={bubiOptionsDivideBottom}
                            />
                            <h6 className="df-inspector bubi-not-background">{ __('Color', 'bubiblock-slider')}
                            { df_color_divide_bottom_2&&
                                <ColorIndicator
                                    colorValue={ df_color_divide_bottom_2 }
                                />
                            }
                            </h6>
                            <ColorPicker
                                color={df_color_divide_bottom_2}
                                onChangeComplete={(newval) => setAttributes({df_color_divide_bottom_2: ('rgba(' + newval.rgb.r + ', ' + newval.rgb.g + ', ' + newval.rgb.b + ', ' + newval.rgb.a + ')') })}
                            />
                            <ButtonGroup
                                className={'df-button-group bubiblock-no-margin'}
                            >
                                <div class="df-group-button-resp">
                                    <div class="bubi-col-6">
                                        <h6>{ __('Height', 'bubiblock-slider')}</h6>
                                    </div>
                                    <div class="bubi-col-6">
                                        <Button
                                            icon={'laptop'}
                                            isSecondary
                                            className={'df-resp-button'}
                                            isPrimary={df_resp == 'desktop'} onClick={() => setAttributes({ df_resp: 'desktop' })}
                                        >
                                        </Button>
                                        <Button
                                            icon={'tablet'}
                                            isSecondary
                                            className={'df-resp-button'}
                                            isPrimary={df_resp == 'table'} onClick={() => setAttributes({ df_resp: 'table' })}
                                        >
                                        </Button>
                                        <Button
                                            icon={'smartphone'}
                                            isSecondary
                                            className={'df-resp-button'}
                                            isPrimary={df_resp == 'mobile'} onClick={() => setAttributes({ df_resp: 'mobile' })}
                                        >
                                        </Button>
                                    </div>
                                </div>
                                {(df_resp=='desktop' ) &&
                                    <RangeControl
                                        label={__("Height(Desktop)","bubiblock-slider")}
                                        help={__('Px Unit','bubiblock-slider')}
                                        value={ df_height_divide_bottom_2 }
                                        onChange={ this.onChangeDf_height_divide_bottom_2 }
                                        min={20}
                                        max={1000}
                                    />
                                }
                                {(df_resp=='table' ) &&
                                    <RangeControl
                                        label={__("Height(Table)","bubiblock-slider")}
                                        help={__('Px Unit','bubiblock-slider')}
                                        value={ df_height_table_divide_bottom_2 }
                                        onChange={ this.onChangeDf_height_table_divide_bottom_2 }
                                        min={20}
                                        max={1000}
                                    />
                                }
                                {(df_resp=='mobile' ) &&
                                    <RangeControl
                                        label={__("Height(Mobile)","bubiblock-slider")}
                                        help={__('Px Unit','bubiblock-slider')}
                                        value={ df_height_mobile_divide_bottom_2 }
                                        onChange={ this.onChangeDf_height_mobile_divide_bottom_2 }
                                        min={20}
                                        max={1000}
                                    />
                                }
                            </ButtonGroup>
                            <RangeControl
                                label={__('Delayed appearance','bubiblock-slider')}
                                help={__('S Unit. In the Safari Browser this transition is not supported!','bubiblock-slider')}
                                beforeIcon={'arrow-down-alt'}
                                afterIcon={'arrow-up-alt'}
                                allowReset
                                resetFallbackValue={2}
                                step={1}
                                withInputField={false}
                                separatorType="none"
                                trackColor="#007cba"
                                isShiftStepEnabled
                                marks={[
                                    {
                                        value: 0,
                                        label: __('0','bubiblock-slider'),
                                    },
                                    {
                                        value: 5,
                                        label: __('5','bubiblock-slider'),
                                    },
                                    {
                                        value: 10,
                                        label: __('10','bubiblock-slider'),
                                    },
                                    {
                                        value: 15,
                                        label: __('15','bubiblock-slider'),
                                    },
                                    {
                                        value: 20,
                                        label: __('20','bubiblock-slider'),
                                    },
                                    {
                                        value: 25,
                                        label: __('25','bubiblock-slider'),
                                    },
                                    {
                                        value: 30,
                                        label: __('30','bubiblock-slider'),
                                    },
                                ]}
                                railColor="#02abff"
                                value={ bubiblock_dalay_divide_2_bottom }
                                onChange={ this.onChangeBubiblock_dalay_divide_2_bottom}
                                min={ 0 }
                                max={ 20}
                            />
                        </>
                        }
                        {title2 &&
                        <>
                            <h6 class="df-inspector">{ __('Title', 'bubiblock-slider')}</h6>
                            <ButtonGroup
                                className={'df-button-group bubiblock-no-margin'}
                            >
                                <div class="df-group-button-resp">
                                    <div class="bubi-col-6">
                                        <h6>{ __('Choose', 'bubiblock-slider')}</h6>
                                    </div>
                                    <div class="bubi-col-6">
                                        <Button
                                            icon={'laptop'}
                                            isSecondary
                                            className={'df-resp-button'}
                                            isPrimary={df_resp == 'desktop'} onClick={() => setAttributes({ df_resp: 'desktop' })}
                                        >
                                        </Button>
                                        <Button
                                            icon={'tablet'}
                                            isSecondary
                                            className={'df-resp-button'}
                                            isPrimary={df_resp == 'table'} onClick={() => setAttributes({ df_resp: 'table' })}
                                        >
                                        </Button>
                                        <Button
                                            icon={'smartphone'}
                                            isSecondary
                                            className={'df-resp-button'}
                                            isPrimary={df_resp == 'mobile'} onClick={() => setAttributes({ df_resp: 'mobile' })}
                                        >
                                        </Button>
                                    </div>
                                </div>
                                {(df_resp=='desktop') &&
                                    <RangeControl
                                        label={__('Margin','bubiblock-slider')}
                                        help={__('px Unit','bubiblock-slider')}
                                        beforeIcon={'arrow-down-alt'}
                                        afterIcon={'arrow-up-alt'}
                                        allowReset
                                        resetFallbackValue={25}
                                        step={1}
                                        withInputField={false}
                                        separatorType="none"
                                        trackColor="#007cba"
                                        isShiftStepEnabled
                                        marks={[
                                            {
                                                value: -100,
                                                label: __('-100','bubiblock-slider'),
                                            },
                                            {
                                                value: 0,
                                                label: __('0','bubiblock-slider'),
                                            },
                                            {
                                                value: 100,
                                                label: __('100','bubiblock-slider'),
                                            },
                                            {
                                                value: 200,
                                                label: __('200','bubiblock-slider'),
                                            },
                                            {
                                                value: 300,
                                                label: __('300','bubiblock-slider'),
                                            },
                                        ]}
                                        railColor="#02abff"
                                        value={ margin_bottom_caption2 }
                                        onChange={ this.onChangeMargin_bottom_caption2}
                                        min={ -100 }
                                        max={ 300}
                                    />
                                }
                                {(df_resp=='table') &&
                                    <RangeControl
                                        label={__('Margin','bubiblock-slider')}
                                        help={__('px Unit','bubiblock-slider')}
                                        beforeIcon={'arrow-down-alt'}
                                        afterIcon={'arrow-up-alt'}
                                        allowReset
                                        resetFallbackValue={25}
                                        step={1}
                                        withInputField={false}
                                        separatorType="none"
                                        trackColor="#007cba"
                                        isShiftStepEnabled
                                        marks={[
                                            {
                                                value: -50,
                                                label: __('-50','bubiblock-slider'),
                                            },
                                            {
                                                value: 0,
                                                label: __('0','bubiblock-slider'),
                                            },
                                            {
                                                value: 50,
                                                label: __('50','bubiblock-slider'),
                                            },
                                            {
                                                value: 100,
                                                label: __('100','bubiblock-slider'),
                                            },
                                            {
                                                value: 150,
                                                label: __('150','bubiblock-slider'),
                                            },
                                            {
                                                value: 200,
                                                label: __('200','bubiblock-slider'),
                                            },
                                        ]}
                                        railColor="#02abff"
                                        value={ margin_bottom_table_caption2 }
                                        onChange={ this.onChangeMargin_bottom_table_caption2}
                                        min={ -50 }
                                        max={ 200}
                                    />
                                }
                                {(df_resp=='mobile') &&
                                    <RangeControl
                                        label={__('Margin','bubiblock-slider')}
                                        help={__('px Unit','bubiblock-slider')}
                                        beforeIcon={'arrow-down-alt'}
                                        afterIcon={'arrow-up-alt'}
                                        allowReset
                                        resetFallbackValue={15}
                                        step={1}
                                        withInputField={false}
                                        separatorType="none"
                                        trackColor="#007cba"
                                        isShiftStepEnabled
                                        marks={[
                                            {
                                                value: -50,
                                                label: __('-50','bubiblock-slider'),
                                            },
                                            {
                                                value: 0,
                                                label: __('0','bubiblock-slider'),
                                            },
                                            {
                                                value: 50,
                                                label: __('50','bubiblock-slider'),
                                            },
                                            {
                                                value: 100,
                                                label: __('100','bubiblock-slider'),
                                            },
                                            {
                                                value: 150,
                                                label: __('150','bubiblock-slider'),
                                            },
                                            {
                                                value: 200,
                                                label: __('200','bubiblock-slider'),
                                            },
                                        ]}
                                        railColor="#02abff"
                                        value={ margin_bottom_mobile_caption2 }
                                        onChange={ this.onChangeMargin_bottom_mobile_caption2}
                                        min={ -50 }
                                        max={ 200}
                                    />
                                }
                                {(df_resp=='desktop') &&
                                    <FontSizePicker
                                        className={'bubiblock-slider-inspectorcontrols'}
                                        value={fontsizetitle2}
                                        onChange={(val) => setAttributes({fontsizetitle2: val})}
                                        fontSizes={[
                                            { name: __('None', 'bubiblock-slider'), slug: 'none', size: 0 },
                                            { name: __('Small', 'bubiblock-slider'), slug: 'small', size: 22 },
                                            { name: __('Medium', 'bubiblock-slider'), slug: 'medium', size:22 },
                                            { name: __('Large', 'bubiblock-slider'), slug: 'large', size: 52 },
                                            { name: __('Big', 'bubiblock-slider'), slug: 'large', size: 82 },
                                        ]}
                                        withSlider={true}
                                    />
                                    }
                                {(df_resp=='table') &&
                                    <FontSizePicker
                                        value={fontsizetitle2table}
                                        onChange={(val) => setAttributes({fontsizetitle2table: val})}
                                        fontSizes={[
                                            { name: __('None', 'bubiblock-slider'), slug: 'none', size: 0 },
                                            { name: __('Small', 'bubiblock-slider'), slug: 'small', size: 22 },
                                            { name: __('Medium', 'bubiblock-slider'), slug: 'medium', size:22 },
                                            { name: __('Large', 'bubiblock-slider'), slug: 'large', size: 52 },
                                            { name: __('Big', 'bubiblock-slider'), slug: 'large', size: 82 },
                                        ]}
                                        withSlider={true}
                                    />
                                }
                                {(df_resp=='mobile')&&
                                    <FontSizePicker
                                        value={fontsizetitle2mobile}
                                        onChange={(val) => setAttributes({fontsizetitle2mobile: val})}
                                        fontSizes={[
                                            { name: __('None', 'bubiblock-slider'), slug: 'none', size: 0 },
                                            { name: __('Small', 'bubiblock-slider'), slug: 'small', size: 22 },
                                            { name: __('Medium', 'bubiblock-slider'), slug: 'medium', size:22 },
                                            { name: __('Large', 'bubiblock-slider'), slug: 'large', size: 52 },
                                            { name: __('Big', 'bubiblock-slider'), slug: 'large', size: 82 },
                                        ]}
                                        withSlider={true}
                                    />
                                }
                            </ButtonGroup>
                            <RadioControl
                                label={__('Align','bubiblock-slider')}
                                selected={ alignment_title2 }
                                options={ [
                                    { label: 'Left', value: 'left' },
                                    { label: 'Center', value: 'center' },
                                    { label: 'Right', value: 'right' },
                                ] }
                                onChange={ ( newAlign ) => setAttributes( { alignment_title2: newAlign } ) }
                            />
                            <SelectControl
                                label={__("Effect","bubiblock-slider")}
                                options={bubiOptionsEffectAnimate}
                                onChange={this.onChangeEffectcaption2}
                                value={effectcaption2}
                            />
                            <SelectControl
                                label={__("Effect speed","bubiblock-slider")}
                                options={bubiOptionEffectSpeed}
                                onChange={this.onChangeDf_speed_effectcaption2}
                                value={df_speed_effectcaption2}
                            />
                            <SelectControl
                                label={__("Effect delay","bubiblock-slider")}
                                options={bubiOptionEffectDalay}
                                onChange={this.onChangeDf_delay_effectcaption2}
                                value={df_delay_effectcaption2}
                            />
                            <SelectControl
                                label={__("Effect repeat","bubiblock-slider")}
                                options={bubiOptionEffectRepeat}
                                onChange={this.onChangeDf_repeat_effectcaption2}
                                value={df_repeat_effectcaption2}
                            />
                        </>
                        }
                        {info2 &&
                        <>
                            <h6 class="df-inspector">{ __('Info', 'bubiblock-slider')}</h6>
                            <ButtonGroup
                                className={'df-button-group bubiblock-no-margin'}
                            >
                                <div class="df-group-button-resp">
                                    <div class="bubi-col-6">
                                        <h6>{ __('Choose', 'bubiblock-slider')}</h6>
                                    </div>
                                    <div class="bubi-col-6">
                                        <Button
                                            icon={'laptop'}
                                            isSecondary
                                            className={'df-resp-button'}
                                            isPrimary={df_resp == 'desktop'} onClick={() => setAttributes({ df_resp: 'desktop' })}
                                        >
                                        </Button>
                                        <Button
                                            icon={'tablet'}
                                            isSecondary
                                            className={'df-resp-button'}
                                            isPrimary={df_resp == 'table'} onClick={() => setAttributes({ df_resp: 'table' })}
                                        >
                                        </Button>
                                        <Button
                                            icon={'smartphone'}
                                            isSecondary
                                            className={'df-resp-button'}
                                            isPrimary={df_resp == 'mobile'} onClick={() => setAttributes({ df_resp: 'mobile' })}
                                        >
                                        </Button>
                                    </div>
                                </div>
                                {(df_resp=='desktop') &&
                                    <RangeControl
                                        label={__('Margin','bubiblock-slider')}
                                        help={__('px Unit','bubiblock-slider')}
                                        beforeIcon={'arrow-down-alt'}
                                        afterIcon={'arrow-up-alt'}
                                        allowReset
                                        resetFallbackValue={40}
                                        step={1}
                                        withInputField={false}
                                        separatorType="none"
                                        trackColor="#007cba"
                                        isShiftStepEnabled
                                        marks={[
                                            {
                                                value: -100,
                                                label: __('-100','bubiblock-slider'),
                                            },
                                            {
                                                value: 0,
                                                label: __('0','bubiblock-slider'),
                                            },
                                            {
                                                value: 100,
                                                label: __('100','bubiblock-slider'),
                                            },
                                            {
                                                value: 200,
                                                label: __('200','bubiblock-slider'),
                                            },
                                            {
                                                value: 300,
                                                label: __('300','bubiblock-slider'),
                                            },
                                        ]}
                                        railColor="#02abff"
                                        value={ margin_bottom_info2 }
                                        onChange={ this.onChangeMargin_bottom_info2}
                                        min={ -100 }
                                        max={ 300}
                                    />
                                }
                                {(df_resp=='table') &&
                                    <RangeControl
                                        label={__('Margin','bubiblock-slider')}
                                        help={__('px Unit','bubiblock-slider')}
                                        beforeIcon={'arrow-down-alt'}
                                        afterIcon={'arrow-up-alt'}
                                        allowReset
                                        resetFallbackValue={20}
                                        step={1}
                                        withInputField={false}
                                        separatorType="none"
                                        trackColor="#007cba"
                                        isShiftStepEnabled
                                        marks={[
                                            {
                                                value: -50,
                                                label: __('-50','bubiblock-slider'),
                                            },
                                            {
                                                value: 0,
                                                label: __('0','bubiblock-slider'),
                                            },
                                            {
                                                value: 50,
                                                label: __('50','bubiblock-slider'),
                                            },
                                            {
                                                value: 100,
                                                label: __('100','bubiblock-slider'),
                                            },
                                            {
                                                value: 150,
                                                label: __('150','bubiblock-slider'),
                                            },
                                            {
                                                value: 200,
                                                label: __('200','bubiblock-slider'),
                                            },
                                        ]}
                                        railColor="#02abff"
                                        value={ margin_bottom_table_info2 }
                                        onChange={ this.onChangeMargin_bottom_table_info2}
                                        min={ -50 }
                                        max={ 200}
                                    />
                                }
                                {(df_resp=='mobile') &&
                                    <RangeControl
                                        label={__('Margin','bubiblock-slider')}
                                        help={__('px Unit','bubiblock-slider')}
                                        beforeIcon={'arrow-down-alt'}
                                        afterIcon={'arrow-up-alt'}
                                        allowReset
                                        resetFallbackValue={10}
                                        step={1}
                                        withInputField={false}
                                        separatorType="none"
                                        trackColor="#007cba"
                                        isShiftStepEnabled
                                        marks={[
                                            {
                                                value: -50,
                                                label: __('-50','bubiblock-slider'),
                                            },
                                            {
                                                value: 0,
                                                label: __('0','bubiblock-slider'),
                                            },
                                            {
                                                value: 50,
                                                label: __('50','bubiblock-slider'),
                                            },
                                            {
                                                value: 100,
                                                label: __('100','bubiblock-slider'),
                                            },
                                            {
                                                value: 150,
                                                label: __('150','bubiblock-slider'),
                                            },
                                            {
                                                value: 200,
                                                label: __('200','bubiblock-slider'),
                                            },
                                        ]}
                                        railColor="#02abff"
                                        value={ margin_bottom_mobile_info2 }
                                        onChange={ this.onChangeMargin_bottom_mobile_info2}
                                        min={ -50 }
                                        max={ 200}
                                    />
                                }
                                {(df_resp=='desktop') &&
                                    <FontSizePicker
                                        value={fontsizeinfo2}
                                        onChange={(val) => setAttributes({fontsizeinfo2: val})}
                                        fontSizes={[
                                            { name: __('None', 'bubiblock-slider'), slug: 'none', size: 0 },
                                            { name: __('Small', 'bubiblock-slider'), slug: 'small', size: 18 },
                                            { name: __('Medium', 'bubiblock-slider'), slug: 'medium', size:24 },
                                            { name: __('Large', 'bubiblock-slider'), slug: 'large', size: 22 },
                                            { name: __('Big', 'bubiblock-slider'), slug: 'large', size: 52 },
                                        ]}
                                        withSlider={true}
                                    />
                                    }
                                {(df_resp=='table') &&
                                    <FontSizePicker
                                        value={fontsizeinfo2table}
                                        onChange={(val) => setAttributes({fontsizeinfo2table: val})}
                                        fontSizes={[
                                            { name: __('None', 'bubiblock-slider'), slug: 'none', size: 0 },
                                            { name: __('Small', 'bubiblock-slider'), slug: 'small', size: 18 },
                                            { name: __('Medium', 'bubiblock-slider'), slug: 'medium', size:24 },
                                            { name: __('Large', 'bubiblock-slider'), slug: 'large', size: 22 },
                                            { name: __('Big', 'bubiblock-slider'), slug: 'large', size: 52 },
                                        ]}
                                        withSlider={true}
                                    />
                                }
                                {(df_resp=='mobile') &&
                                    <FontSizePicker
                                        value={fontsizeinfo2mobile}
                                        onChange={(val) => setAttributes({fontsizeinfo2mobile: val})}
                                        fontSizes={[
                                            { name: __('None', 'bubiblock-slider'), slug: 'none', size: 0 },
                                            { name: __('Small', 'bubiblock-slider'), slug: 'small', size: 18 },
                                            { name: __('Medium', 'bubiblock-slider'), slug: 'medium', size:24 },
                                            { name: __('Large', 'bubiblock-slider'), slug: 'large', size: 22 },
                                            { name: __('Big', 'bubiblock-slider'), slug: 'large', size: 52 },
                                        ]}
                                        withSlider={true}
                                    />
                                }
                            </ButtonGroup>
                            <RadioControl
                                label={__('Align','bubiblock-slider')}
                                selected={ alignment_info2 }
                                options={ [
                                    { label: 'Left', value: 'left' },
                                    { label: 'Center', value: 'center' },
                                    { label: 'Right', value: 'right' },
                                ] }
                                onChange={ ( newAlign ) => setAttributes( { alignment_info2: newAlign } ) }
                            />
                            <SelectControl
                                label={__("Effect","bubiblock-slider")}
                                options={bubiOptionsEffectAnimate}
                                onChange={this.onChangeEffectinfo2}
                                value={effectinfo2}
                            />
                            <SelectControl
                                label={__("Effect speed","bubiblock-slider")}
                                options={bubiOptionEffectSpeed}
                                onChange={this.onChangeDf_speed_effectinfo2}
                                value={df_speed_effectinfo2}
                            />
                            <SelectControl
                                label={__("Effect delay","bubiblock-slider")}
                                options={bubiOptionEffectDalay}
                                onChange={this.onChangeDf_delay_effectinfo2}
                                value={df_delay_effectinfo2}
                            />
                            <SelectControl
                                label={__("Effect repeat","bubiblock-slider")}
                                options={bubiOptionEffectRepeat}
                                onChange={this.onChangeDf_repeat_effectinfo2}
                                value={df_repeat_effectinfo2}
                            />
                        </>
                        }
                        {button2 &&
                        <>
                            <h6 class="df-inspector">{ __('Button', 'bubiblock-slider')}</h6>
                            <ButtonGroup
                                className={'df-button-group bubiblock-no-margin'}
                            >
                                <div class="df-group-button-resp">
                                    <div class="bubi-col-6">
                                        <h6>{ __('Choose', 'bubiblock-slider')}</h6>
                                    </div>
                                    <div class="bubi-col-6">
                                        <Button
                                            icon={'laptop'}
                                            isSecondary
                                            className={'df-resp-button'}
                                            isPrimary={df_resp == 'desktop'} onClick={() => setAttributes({ df_resp: 'desktop' })}
                                        >
                                        </Button>
                                        <Button
                                            icon={'tablet'}
                                            isSecondary
                                            className={'df-resp-button'}
                                            isPrimary={df_resp == 'table'} onClick={() => setAttributes({ df_resp: 'table' })}
                                        >
                                        </Button>
                                        <Button
                                            icon={'smartphone'}
                                            isSecondary
                                            className={'df-resp-button'}
                                            isPrimary={df_resp == 'mobile'} onClick={() => setAttributes({ df_resp: 'mobile' })}
                                        >
                                        </Button>
                                    </div>
                                </div>
                                {(df_resp=='desktop') &&
                                    <RangeControl
                                        label={__('Margin','bubiblock-slider')}
                                        help={__('px Unit','bubiblock-slider')}
                                        beforeIcon={'arrow-down-alt'}
                                        afterIcon={'arrow-up-alt'}
                                        allowReset
                                        resetFallbackValue={5}
                                        step={1}
                                        withInputField={false}
                                        separatorType="none"
                                        trackColor="#007cba"
                                        isShiftStepEnabled
                                        marks={[
                                            {
                                                value: -100,
                                                label: __('-100','bubiblock-slider'),
                                            },
                                            {
                                                value: 0,
                                                label: __('0','bubiblock-slider'),
                                            },
                                            {
                                                value: 100,
                                                label: __('100','bubiblock-slider'),
                                            },
                                            {
                                                value: 200,
                                                label: __('200','bubiblock-slider'),
                                            },
                                            {
                                                value: 300,
                                                label: __('300','bubiblock-slider'),
                                            },
                                        ]}
                                        railColor="#02abff"
                                        value={ margin_bottom_button2 }
                                        onChange={ this.onChangeMargin_bottom_button2}
                                        min={ -100 }
                                        max={ 300}
                                    />
                                }
                                {(df_resp=='table') &&
                                    <RangeControl
                                        label={__('Margin','bubiblock-slider')}
                                        help={__('px Unit','bubiblock-slider')}
                                        beforeIcon={'arrow-down-alt'}
                                        afterIcon={'arrow-up-alt'}
                                        allowReset
                                        resetFallbackValue={5}
                                        step={1}
                                        withInputField={false}
                                        separatorType="none"
                                        trackColor="#007cba"
                                        isShiftStepEnabled
                                        marks={[
                                            {
                                                value: -50,
                                                label: __('-50','bubiblock-slider'),
                                            },
                                            {
                                                value: 0,
                                                label: __('0','bubiblock-slider'),
                                            },
                                            {
                                                value: 50,
                                                label: __('50','bubiblock-slider'),
                                            },
                                            {
                                                value: 100,
                                                label: __('100','bubiblock-slider'),
                                            },
                                            {
                                                value: 150,
                                                label: __('150','bubiblock-slider'),
                                            },
                                            {
                                                value: 200,
                                                label: __('200','bubiblock-slider'),
                                            },
                                        ]}
                                        railColor="#02abff"
                                        value={ margin_bottom_table_button2 }
                                        onChange={ this.onChangeMargin_bottom_table_button2}
                                        min={ -50 }
                                        max={ 200}
                                    />
                                }
                                {(df_resp=='mobile') &&
                                    <RangeControl
                                        label={__('Margin','bubiblock-slider')}
                                        help={__('px Unit','bubiblock-slider')}
                                        beforeIcon={'arrow-down-alt'}
                                        afterIcon={'arrow-up-alt'}
                                        allowReset
                                        resetFallbackValue={5}
                                        step={1}
                                        withInputField={false}
                                        separatorType="none"
                                        trackColor="#007cba"
                                        isShiftStepEnabled
                                        marks={[
                                            {
                                                value: -50,
                                                label: __('-50','bubiblock-slider'),
                                            },
                                            {
                                                value: 0,
                                                label: __('0','bubiblock-slider'),
                                            },
                                            {
                                                value: 50,
                                                label: __('50','bubiblock-slider'),
                                            },
                                            {
                                                value: 100,
                                                label: __('100','bubiblock-slider'),
                                            },
                                            {
                                                value: 150,
                                                label: __('150','bubiblock-slider'),
                                            },
                                            {
                                                value: 200,
                                                label: __('200','bubiblock-slider'),
                                            },
                                        ]}
                                        railColor="#02abff"
                                        value={ margin_bottom_mobile_button2 }
                                        onChange={ this.onChangeMargin_bottom_mobile_button2}
                                        min={ -50 }
                                        max={ 200}
                                    />
                                }
                                {(df_resp=='desktop') &&
                                    <FontSizePicker
                                        value={fontsizebutton2}
                                        onChange={(val) => setAttributes({fontsizebutton2: val})}
                                        fontSizes={[
                                            { name: __('Small', 'bubiblock-slider'), slug: 'small', size: 18 },
                                            { name: __('Medium', 'bubiblock-slider'), slug: 'medium', size:24 },
                                            { name: __('Large', 'bubiblock-slider'), slug: 'large', size: 22 },
                                            { name: __('Big', 'bubiblock-slider'), slug: 'large', size: 52 },
                                        ]}
                                        withSlider={true}
                                />
                                    }
                                {(df_resp=='table')  &&
                                    <FontSizePicker
                                        value={fontsizebutton2table}
                                        onChange={(val) => setAttributes({fontsizebutton2table: val})}
                                        fontSizes={[
                                            { name: __('Small', 'bubiblock-slider'), slug: 'small', size: 18 },
                                            { name: __('Medium', 'bubiblock-slider'), slug: 'medium', size:24 },
                                            { name: __('Large', 'bubiblock-slider'), slug: 'large', size: 22 },
                                            { name: __('Big', 'bubiblock-slider'), slug: 'large', size: 52 },
                                        ]}
                                        withSlider={true}
                                    />
                                }
                                {(df_resp=='mobile') &&
                                    <FontSizePicker
                                        value={fontsizebutton2mobile}
                                        onChange={(val) => setAttributes({fontsizebutton2mobile: val})}
                                        fontSizes={[
                                            { name: __('Small', 'bubiblock-slider'), slug: 'small', size: 18 },
                                            { name: __('Medium', 'bubiblock-slider'), slug: 'medium', size:24 },
                                            { name: __('Large', 'bubiblock-slider'), slug: 'large', size: 22 },
                                            { name: __('Big', 'bubiblock-slider'), slug: 'large', size: 52 },
                                        ]}
                                        withSlider={true}
                                    />
                                }
                            </ButtonGroup>
                            <RadioControl
                                label={__('Align','bubiblock-slider')}
                                selected={ alignment_button2 }
                                options={ [
                                    { label: 'Left', value: 'left' },
                                    { label: 'Center', value: 'center' },
                                    { label: 'Right', value: 'right' },
                                ] }
                                onChange={ ( newAlign ) => setAttributes( { alignment_button2: newAlign } ) }
                            />
                            <SelectControl
                                label={__("Effect","bubiblock-slider")}
                                options={bubiOptionsEffectAnimate}
                                onChange={this.onChangeEffectbutton2}
                                value={effectbutton2}
                            />
                            <SelectControl
                                label={__("Effect speed","bubiblock-slider")}
                                options={bubiOptionEffectSpeed}
                                onChange={this.onChangeDf_speed_effectbutton2}
                                value={df_speed_effectbutton2}
                            />
                            <SelectControl
                                label={__("Effect delay","bubiblock-slider")}
                                options={bubiOptionEffectDalay}
                                onChange={this.onChangeDf_delay_effectbutton2}
                                value={df_delay_effectbutton2}
                            />
                            <SelectControl
                                label={__("Effect repeat","bubiblock-slider")}
                                options={bubiOptionEffectRepeat}
                                onChange={this.onChangeDf_repeat_effectbutton2}
                                value={df_repeat_effectbutton2}
                            />
                            <RangeControl
                                label={__('Padding top/bottom','bubiblock-slider')}
                                help={__('px Unit','bubiblock-slider')}
                                beforeIcon={'arrow-down-alt'}
                                afterIcon={'arrow-up-alt'}
                                allowReset
                                resetFallbackValue={8}
                                step={1}
                                withInputField={false}
                                separatorType="none"
                                trackColor="#007cba"
                                isShiftStepEnabled
                                marks={[
                                    {
                                        value: 0,
                                        label: __('0','bubiblock-slider'),
                                    },
                                    {
                                        value: 10,
                                        label: __('10','bubiblock-slider'),
                                    },
                                    {
                                        value: 20,
                                        label: __('20','bubiblock-slider'),
                                    },
                                    {
                                        value: 30,
                                        label: __('30','bubiblock-slider'),
                                    },
                                    {
                                        value: 40,
                                        label: __('40','bubiblock-slider'),
                                    },
                                    {
                                        value: 50,
                                        label: __('50','bubiblock-slider'),
                                    },
                                ]}
                                railColor="#02abff"
                                value={ padding_link_button2 }
                                onChange={(val) => setAttributes({ padding_link_button2: val })}
                                min={ 0 }
                                max={ 50}
                            />
                            <RangeControl
                                label={__('Padding left/right','bubiblock-slider')}
                                help={__('px Unit','bubiblock-slider')}
                                beforeIcon={'arrow-left-alt'}
                                afterIcon={'arrow-right-alt'}
                                allowReset
                                resetFallbackValue={20}
                                step={1}
                                withInputField={false}
                                separatorType="none"
                                trackColor="#007cba"
                                isShiftStepEnabled
                                marks={[
                                    {
                                        value: 0,
                                        label: __('0','bubiblock-slider'),
                                    },
                                    {
                                        value: 10,
                                        label: __('10','bubiblock-slider'),
                                    },
                                    {
                                        value: 20,
                                        label: __('20','bubiblock-slider'),
                                    },
                                    {
                                        value: 30,
                                        label: __('30','bubiblock-slider'),
                                    },
                                    {
                                        value: 40,
                                        label: __('40','bubiblock-slider'),
                                    },
                                    {
                                        value: 50,
                                        label: __('50','bubiblock-slider'),
                                    },
                                ]}
                                railColor="#02abff"
                                value={ padding_right_link_button2 }
                                onChange={(val) => setAttributes({ padding_right_link_button2: val })}
                                min={ 0 }
                                max={ 50}
                            />
                            <RangeControl
                                label={__('Border solid','bubiblock-slider')}
                                help={__('Px Unit','bubiblock-slider')}
                                beforeIcon={'star-empty'}
                                afterIcon={'star-filled'}
                                allowReset
                                resetFallbackValue={0}
                                step={1}
                                withInputField={false}
                                separatorType="none"
                                trackColor="#007cba"
                                isShiftStepEnabled
                                marks={[
                                    {
                                        value: 0,
                                        label: __('0','bubiblock-slider'),
                                    },
                                    {
                                        value: 10,
                                        label: __('10','bubiblock-slider'),
                                    },
                                    {
                                        value: 20,
                                        label: __('20','bubiblock-slider'),
                                    },
                                    {
                                        value: 30,
                                        label: __('30','bubiblock-slider'),
                                    },
                                    {
                                        value: 40,
                                        label: __('40','bubiblock-slider'),
                                    },
                                    {
                                        value: 50,
                                        label: __('50','bubiblock-slider'),
                                    },
                                ]}
                                railColor="#02abff"
                                value={ border_size_link_button2 }
                                onChange={(val) => setAttributes({ border_size_link_button2: val })}
                                min={ 0 }
                                max={ 50}
                            />
                            <RangeControl
                                label={__('Border top left radius','bubiblock-slider')}
                                help={__('% Unit','bubiblock-slider')}
                                beforeIcon={'fullscreen-alt'}
                                afterIcon={'fullscreen-exit-alt'}
                                allowReset
                                resetFallbackValue={0}
                                step={1}
                                withInputField={false}
                                separatorType="none"
                                trackColor="#007cba"
                                isShiftStepEnabled
                                marks={[
                                    {
                                        value: 0,
                                        label: __('0','bubiblock-slider'),
                                    },
                                    {
                                        value: 10,
                                        label: __('10','bubiblock-slider'),
                                    },
                                    {
                                        value: 20,
                                        label: __('20','bubiblock-slider'),
                                    },
                                    {
                                        value: 30,
                                        label: __('30','bubiblock-slider'),
                                    },
                                    {
                                        value: 40,
                                        label: __('40','bubiblock-slider'),
                                    },
                                    {
                                        value: 50,
                                        label: __('50','bubiblock-slider'),
                                    },
                                ]}
                                railColor="#02abff"
                                value={ border_radius_top_left_link_button2 }
                                onChange={(val) => setAttributes({ border_radius_top_left_link_button2: val })}
                                min={ 0 }
                                max={ 50}
                            />
                            <RangeControl
                                label={__('Border top right radius','bubiblock-slider')}
                                help={__('% Unit','bubiblock-slider')}
                                beforeIcon={'fullscreen-alt'}
                                afterIcon={'fullscreen-exit-alt'}
                                allowReset
                                resetFallbackValue={0}
                                step={1}
                                withInputField={false}
                                separatorType="none"
                                trackColor="#007cba"
                                isShiftStepEnabled
                                marks={[
                                    {
                                        value: 0,
                                        label: __('0','bubiblock-slider'),
                                    },
                                    {
                                        value: 10,
                                        label: __('10','bubiblock-slider'),
                                    },
                                    {
                                        value: 20,
                                        label: __('20','bubiblock-slider'),
                                    },
                                    {
                                        value: 30,
                                        label: __('30','bubiblock-slider'),
                                    },
                                    {
                                        value: 40,
                                        label: __('40','bubiblock-slider'),
                                    },
                                    {
                                        value: 50,
                                        label: __('50','bubiblock-slider'),
                                    },
                                ]}
                                railColor="#02abff"
                                value={ border_radius_top_right_link_button2 }
                                onChange={(val) => setAttributes({ border_radius_top_right_link_button2: val })}
                                min={ 0 }
                                max={ 50}
                            />
                            <RangeControl
                                label={__('Border bottom left radius','bubiblock-slider')}
                                help={__('% Unit','bubiblock-slider')}
                                beforeIcon={'fullscreen-alt'}
                                afterIcon={'fullscreen-exit-alt'}
                                allowReset
                                resetFallbackValue={0}
                                step={1}
                                withInputField={false}
                                separatorType="none"
                                trackColor="#007cba"
                                isShiftStepEnabled
                                marks={[
                                    {
                                        value: 0,
                                        label: __('0','bubiblock-slider'),
                                    },
                                    {
                                        value: 10,
                                        label: __('10','bubiblock-slider'),
                                    },
                                    {
                                        value: 20,
                                        label: __('20','bubiblock-slider'),
                                    },
                                    {
                                        value: 30,
                                        label: __('30','bubiblock-slider'),
                                    },
                                    {
                                        value: 40,
                                        label: __('40','bubiblock-slider'),
                                    },
                                    {
                                        value: 50,
                                        label: __('50','bubiblock-slider'),
                                    },
                                ]}
                                railColor="#02abff"
                                value={ border_radius_bottom_left_link_button2 }
                                onChange={(val) => setAttributes({ border_radius_bottom_left_link_button2: val })}
                                min={ 0 }
                                max={ 50}
                            />
                            <RangeControl
                                label={__('Border bottom right radius','bubiblock-slider')}
                                help={__('% Unit','bubiblock-slider')}
                                beforeIcon={'fullscreen-alt'}
                                afterIcon={'fullscreen-exit-alt'}
                                allowReset
                                resetFallbackValue={0}
                                step={1}
                                withInputField={false}
                                separatorType="none"
                                trackColor="#007cba"
                                isShiftStepEnabled
                                marks={[
                                    {
                                        value: 0,
                                        label: __('0','bubiblock-slider'),
                                    },
                                    {
                                        value: 10,
                                        label: __('10','bubiblock-slider'),
                                    },
                                    {
                                        value: 20,
                                        label: __('20','bubiblock-slider'),
                                    },
                                    {
                                        value: 30,
                                        label: __('30','bubiblock-slider'),
                                    },
                                    {
                                        value: 40,
                                        label: __('40','bubiblock-slider'),
                                    },
                                    {
                                        value: 50,
                                        label: __('50','bubiblock-slider'),
                                    },
                                ]}
                                railColor="#02abff"
                                value={ border_radius_bottom_right_link_button2 }
                                onChange={(val) => setAttributes({ border_radius_bottom_right_link_button2: val })}
                                min={ 0 }
                                max={ 50}
                            />
                            <h6 id={'bg'} class="df-inspector" >{ __('Background Color', 'bubiblock-slider')}
                            {(df_background_color_transparent_link_button2 == 'df-trasparent-color-button2-false') &&
                                <>
                                {df_background_color_link_button2 &&
                                    <ColorIndicator
                                        colorValue={ df_background_color_link_button2 }
                                    />
                                }
                                </>
                            }
                            {df_background_color_hover_link_button2 &&
                                <ColorIndicator
                                    colorValue={ df_background_color_hover_link_button2 }
                                />
                            }
                            </h6>
                            {(df_background_color_transparent_link_button2 == 'df-trasparent-color-button2-false') &&
                                <div class={'legend-color-none'}>
                                    <ColorPaletteControl
                                        value={ df_background_color_link_button2}
                                        colors={ bubiColors }
                                        onChange={ (newValue) => setAttributes({df_background_color_link_button2: newValue}) }
                                    />
                                </div>
                            }
                            <p className={"df-inspector bubi-mt-1"}>{__('Hover','bubiblock-slider')}</p>
                            <div class={'legend-color-none'}>
                                    <ColorPaletteControl
                                        value={ df_background_color_hover_link_button2}
                                        colors={ bubiColors }
                                        onChange={ (newValue) => setAttributes({df_background_color_hover_link_button2: newValue}) }
                                    />
                            </div>
                            <h6 className="df-inspector">{ __('Color', 'bubiblock-slider')}
                            {df_color_link_button2 &&
                                <ColorIndicator
                                    colorValue={ df_color_link_button2 }
                                />
                            }
                            {df_color_hover_link_button2 &&
                                <ColorIndicator
                                    colorValue={ df_color_hover_link_button2 }
                                />
                            }
                            {df_border_color_link_button2 &&
                                <ColorIndicator
                                    colorValue={ df_border_color_link_button2 }
                                />
                            }
                            </h6>
                            <div class={'legend-color-none'}>
                                <p className="df-inspector">{__('Color','bubiblock-slider')}</p>
                                <ColorPaletteControl
                                    value={ df_color_link_button2}
                                    colors={ bubiColors }
                                    onChange={ (newValue) => setAttributes({df_color_link_button2: newValue}) }
                                />
                                <p className="df-inspector">{__('Color hover','bubiblock-slider')}</p>
                                <ColorPaletteControl
                                    value={ df_color_hover_link_button2}
                                    colors={ bubiColors }
                                    onChange={ (newValue) => setAttributes({df_color_hover_link_button2: newValue}) }
                                />
                                <p className="df-inspector">{__('Border Color','bubiblock-slider')}</p>
                                <ColorPaletteControl
                                    value={ df_border_color_link_button2}
                                    colors={ bubiColors }
                                    onChange={ (newValue) => setAttributes({df_border_color_link_button2: newValue}) }
                                />
                            </div>
                            <ButtonGroup
                                className={'df-button-group bubiblock-no-margin'}
                            >
                                <h6 className="df-inspector">{ __('Background color transparent', 'bubiblock-slider')}</h6>
                                <div class="bubi-width-two">
                                <Button
                                    isSecondary
                                    isPrimary={df_background_color_transparent_link_button2 == 'df-trasparent-color-button2-true'} onClick={() => setAttributes({ df_background_color_transparent_link_button2: 'df-trasparent-color-button2-true' })}
                                >
                                    {__('True','bubiblock-slider')}
                                </Button>
                                <Button
                                    isSecondary
                                    isPrimary={df_background_color_transparent_link_button2 == 'df-trasparent-color-button2-false'} onClick={() => setAttributes({ df_background_color_transparent_link_button2: 'df-trasparent-color-button2-false' })}
                                >
                                    {__('False','bubiblock-slider')}
                                </Button>
                                </div>
                            </ButtonGroup>
                        </>
                        }
                    </PanelBody>
                    <Panel
                        className={'bubiblock-add-slider'}
                    >
                        <ToggleControl
                            label={__( 'Add Slides','bubiblock-slider' ) }
                            help={__('Important: if you want to remove this slider make sure you are with the carousel on the first or second slider!','bubiblock-slider')}
                            checked={bubiblock_add_slider_3}
                            onChange={(val) => setAttributes({ bubiblock_add_slider_3: val })}
                        />
                    </Panel>
                    {bubiblock_add_slider_3 &&
                        <>
                        <PanelBody // Slider 3
                            icon={'format-image'}
                            title={__('Slides 3', 'bubiblock-slider')}
                            initialOpen={false}
                            >
                            <h6 className="df-inspector bubi-mt-1">{ __('Background type', 'bubiblock-slider')}</h6>
                            <div class="bubi-width-three bubibutton-icon">
                                <ButtonGroup
                                    className={'df-button-group bubiblock-no-margin'}
                                >
                                    <Tooltip
                                        text= {__('Color','bubiblock-slider')}
                                    >
                                        <Button
                                            isPrimary={df_slider_chose_3 == 'df-slider-color-3'}
                                            icon="admin-appearance"
                                            onClick={() => setAttributes({ df_slider_chose_3: 'df-slider-color-3' })}
                                        >
                                        </Button>
                                    </Tooltip>
                                    <Tooltip
                                        text=  {__('Image','bubiblock-slider')}
                                    >
                                        <Button
                                            isPrimary={df_slider_chose_3 == 'df-slider-image-3'}
                                            icon="format-image"
                                            onClick={() => setAttributes({ df_slider_chose_3: 'df-slider-image-3' })}
                                        >
                                        </Button>
                                    </Tooltip>
                                </ButtonGroup>
                            </div>
                            {(df_slider_chose_3=='df-slider-image-3' ) &&
                                <>
                                    {imageUrl_3?
                                        <>
                                        <img src={imageUrl_3} className={'bubi-mt-2'}/>
                                        {isBlobURL(imageUrl_3) && <Spinner />}
                                        </>
                                        :
                                        <MediaPlaceholder
                                            className={'bubi-mt-2 bubi-mb-2'}
                                            icon="format-image df-icon-img-upload"
                                            onSelect={ media => { setAttributes({ imageAlt_3: media.alt, imageUrl_3: media.url }); } }
                                            onSelectURL={ this.onSelectURL3 }
                                            onError={this.onUploadError3}
                                            accept="image/*"
                                            allowedTypes={['image']}
                                            notices={ noticeUI3 }
                                        />
                                    }
                                    {imageUrl_3 &&
                                    <>
                                        <MenuItem
                                            icon={ 'trash' }
                                            className={'df-remov-img'}
                                            onClick={ this.removeImage3 }
                                        >
                                            { __('Remove Image','bubiblock-slider') }
                                        </MenuItem>
                                        <TextareaControl
                                            label={__('Alt Text (Alternative Text)','bubiblock-slider')}
                                            value={ alt3}
                                            onChange={ this.updateAlt3 }
                                            help={__('Alternative text describes your image to people who cant see it. Add a short description with its key details.','bubiblock-slider')}
                                        />
                                        <SelectControl
                                            label={__("Dispaly Size","bubiblock-slider")}
                                            options={[
                                                {label: __('None','bubiblock-slider'), value: 'none'},
                                                {label: __('Containe','bubiblock-slider'), value: 'contain'},
                                                {label: __('Cover','bubiblock-slider'), value: 'cover'},
                                                {label: __('Fill','bubiblock-slider'), value: 'fill'},
                                                {label: __('Scale down','bubiblock-slider'), value: 'scale-down'},
                                                {label: __('Unset','bubiblock-slider'), value: 'unset'},
                                            ]}
                                            onChange={this.onChangeDf_cover_img3}
                                            value={df_cover_img3}
                                        />
                                        {(df_cover_img3=='none')&&
                                        <>
                                            <RangeControl
                                                label={__('Display Position','bubiblock-slider')}
                                                help={__('% Unit','bubiblock-slider')}
                                                beforeIcon={'arrow-left-alt'}
                                                afterIcon={'arrow-right-alt'}
                                                allowReset
                                                resetFallbackValue={50}
                                                step={1}
                                                withInputField={false}
                                                separatorType="none"
                                                trackColor="#007cba"
                                                isShiftStepEnabled
                                                marks={[
                                                    {
                                                        value: 0,
                                                        label: __('0','bubiblock-slider'),
                                                    },
                                                    {
                                                        value: 20,
                                                        label: __('20','bubiblock-slider'),
                                                    },
                                                    {
                                                        value: 40,
                                                        label: __('40','bubiblock-slider'),
                                                    },
                                                    {
                                                        value: 60,
                                                        label: __('60','bubiblock-slider'),
                                                    },
                                                    {
                                                        value: 80,
                                                        label: __('80','bubiblock-slider'),
                                                    },
                                                    {
                                                        value: 100,
                                                        label: __('100','bubiblock-slider'),
                                                    },
                                                ]}
                                                railColor="#02abff"
                                                value={ df_focalPoint_img_3 }
                                                onChange={ this.onChangeDf_focalPoint_img_3 }
                                                min={ 0 }
                                                max={ 100}
                                            />
                                            <RangeControl
                                                label={__('Display Position','bubiblock-slider')}
                                                help={__('% Unit','bubiblock-slider')}
                                                beforeIcon={'arrow-down-alt'}
                                                afterIcon={'arrow-up-alt'}
                                                allowReset
                                                resetFallbackValue={50}
                                                step={1}
                                                withInputField={false}
                                                separatorType="none"
                                                trackColor="#007cba"
                                                isShiftStepEnabled
                                                marks={[
                                                    {
                                                        value: 0,
                                                        label: __('0','bubiblock-slider'),
                                                    },
                                                    {
                                                        value: 20,
                                                        label: __('20','bubiblock-slider'),
                                                    },
                                                    {
                                                        value: 40,
                                                        label: __('40','bubiblock-slider'),
                                                    },
                                                    {
                                                        value: 60,
                                                        label: __('60','bubiblock-slider'),
                                                    },
                                                    {
                                                        value: 80,
                                                        label: __('80','bubiblock-slider'),
                                                    },
                                                    {
                                                        value: 100,
                                                        label: __('100','bubiblock-slider'),
                                                    },
                                                ]}
                                                railColor="#02abff"
                                                value={ df_focalPoint_y_img_3 }
                                                onChange={ this.onChangeDf_focalPoint_y_img_3 }
                                                min={ 0 }
                                                max={ 100}
                                            />
                                            </>
                                        }
                                        <ToggleControl
                                            label={ __( 'Show mask','bubiblock-slider' ) }
                                            checked={df_mask_slider_3}
                                            onChange={this.onChangeDf_mask_slider_3}
                                        />
                                        {df_mask_slider_3 &&
                                            <>
                                            <Notice
                                                status="info"
                                                isDismissible={ false }
                                            >
                                                {__('If you have set the border radius for the slider this control will not work well!','bubiblock-slider')}
                                            </Notice>
                                            <ColorGradientControl
                                                colorValue={ background_color_solid_mask_3 }
                                                gradientValue={ background_color_gradient_mask_3 }
                                                colors={ bubiColors }
                                                gradients={ bubiGradients }
                                                onColorChange={ (newValue) => setAttributes({ background_color_solid_mask_3: newValue }) }
                                                onGradientChange={ (newValue) => setAttributes({ background_color_gradient_mask_3: newValue }) }
                                            />
                                            <RangeControl
                                                label={__('Opacity','bubiblock-slider')}
                                                beforeIcon={'hidden'}
                                                afterIcon={'visibility'}
                                                allowReset
                                                resetFallbackValue={.4}
                                                step={.1}
                                                withInputField={false}
                                                separatorType="none"
                                                trackColor="#007cba"
                                                isShiftStepEnabled
                                                marks={[
                                                    {
                                                        value: 0,
                                                        label: __('0','bubiblock-slider'),
                                                    },
                                                    {
                                                        value: 0.2,
                                                        label: __('2','bubiblock-slider'),
                                                    },
                                                    {
                                                        value: 0.4,
                                                        label: __('4','bubiblock-slider'),
                                                    },
                                                    {
                                                        value: 0.6,
                                                        label: __('6','bubiblock-slider'),
                                                    },
                                                    {
                                                        value: 0.8,
                                                        label: __('8','bubiblock-slider'),
                                                    },
                                                    {
                                                        value: 1.0,
                                                        label: __('10','bubiblock-slider'),
                                                    },
                                                ]}
                                                railColor="#02abff"
                                                value={ df_opacity_mask_3 }
                                                onChange={ this.onChangeDf_opacity_mask_3 }
                                                min={ .0 }
                                                max={ 1.0}
                                            />
                                        </>
                                        }
                                        <TextControl
                                            label={__('Link Image','bubiblock-slider')}
                                            value={ bubiblock_link_slider_3 }
                                            onChange={ (newValue) => setAttributes({bubiblock_link_slider_3: newValue}) }
                                            type="url"
                                        />
                                        {bubiblock_link_slider_3 &&
                                            <ButtonGroup
                                                    className={'df-button-group bubiblock-no-margin bubi-mb-2'}
                                                >
                                                    <p className="df-inspector bubi-mt-1">{ __('Open in new tab', 'bubiblock-slider')}</p>
                                                    <div class="bubi-width-two">
                                                    <Button
                                                        isSecondary
                                                        isPrimary={bubiblock_link_tab_slider_3 == '_blank'} onClick={() => setAttributes({ bubiblock_link_tab_slider_3: '_blank' })}
                                                    >
                                                        {__('True','bubiblock-slider')}
                                                    </Button>
                                                    <Button
                                                        isSecondary
                                                        isPrimary={bubiblock_link_tab_slider_3 == ''} onClick={() => setAttributes({ bubiblock_link_tab_slider_3: '' })}
                                                    >
                                                        {__('False','bubiblock-slider')}
                                                    </Button>
                                                    </div>
                                            </ButtonGroup>
                                        }
                                    </>
                                    }
                                </>
                            }
                            {(df_slider_chose_3=='df-slider-color-3' ) &&
                                <>
                                <h6 className="df-inspector bubi-not-background">{ __('Background Color', 'bubiblock-slider')}
                                {df_background_color_slider_3 &&
                                    <ColorIndicator
                                        colorValue={ df_background_color_slider_3 }
                                    />
                                }
                                </h6>
                                <div class={'legend-color-none'}>
                                    <ColorPaletteControl
                                        value={ df_background_color_slider_3}
                                        colors={ bubiColors }
                                        onChange={ (newValue) => setAttributes({df_background_color_slider_3: newValue}) }
                                    />
                                </div>
                                </>
                            }
                            <ToggleControl
                                label={ __( 'Dividers Top','bubiblock-slider' ) }
                                checked={df_enable_divide_3}
                                onChange={this.onChangeDf_enable_divide_3}
                            />
                            {df_enable_divide_3 &&
                            <>
                                <RadioControl
                                    label={__('Choose', 'df-sidebar-gutenberg')}
                                    selected={divide_3}
                                    className={'bubiblock-radio-image'}
                                    onChange={(val) => setAttributes({divide_3: val})}
                                    options={bubiOptionsDivideTop}
                                />
                                <h6 className="df-inspector bubi-not-background">{ __('Color', 'bubiblock-slider')}
                                { df_color_divide_3 &&
                                    <ColorIndicator
                                        colorValue={ df_color_divide_3 }
                                    />
                                }
                                </h6>
                                <ColorPicker
                                    color={df_color_divide_3}
                                    onChangeComplete={(newval) => setAttributes({df_color_divide_3: ('rgba(' + newval.rgb.r + ', ' + newval.rgb.g + ', ' + newval.rgb.b + ', ' + newval.rgb.a + ')') })}
                                />
                                <ButtonGroup
                                    className={'df-button-group bubiblock-no-margin'}
                                >
                                    <div class="df-group-button-resp">
                                        <div class="bubi-col-6">
                                            <h6>{ __('Height', 'bubiblock-slider')}</h6>
                                        </div>
                                        <div class="bubi-col-6">
                                            <Button
                                                icon={'laptop'}
                                                isSecondary
                                                className={'df-resp-button'}
                                                isPrimary={df_resp == 'desktop'} onClick={() => setAttributes({ df_resp: 'desktop' })}
                                            >
                                            </Button>
                                            <Button
                                                icon={'tablet'}
                                                isSecondary
                                                className={'df-resp-button'}
                                                isPrimary={df_resp == 'table'} onClick={() => setAttributes({ df_resp: 'table' })}
                                            >
                                            </Button>
                                            <Button
                                                icon={'smartphone'}
                                                isSecondary
                                                className={'df-resp-button'}
                                                isPrimary={df_resp == 'mobile'} onClick={() => setAttributes({ df_resp: 'mobile' })}
                                            >
                                            </Button>
                                        </div>
                                    </div>
                                    {(df_resp=='desktop' ) &&
                                        <RangeControl
                                            label={__("Height(Desktop)","bubiblock-slider")}
                                            help={__('Px Unit','bubiblock-slider')}
                                            value={ df_height_divide_3 }
                                            onChange={ this.onChangeDf_height_divide_3 }
                                            min={20}
                                            max={1000}
                                        />
                                    }
                                    {(df_resp=='table' ) &&
                                        <RangeControl
                                            label={__("Height(Table)","bubiblock-slider")}
                                            help={__('Px Unit','bubiblock-slider')}
                                            value={ df_height_table_divide_3 }
                                            onChange={ this.onChangeDf_height_table_divide_3 }
                                            min={20}
                                            max={1000}
                                        />
                                    }
                                    {(df_resp=='mobile' ) &&
                                        <RangeControl
                                            label={__("Height(Mobile)","bubiblock-slider")}
                                            help={__('Px Unit','bubiblock-slider')}
                                            value={ df_height_mobile_divide_3 }
                                            onChange={ this.onChangeDf_height_mobile_divide_3 }
                                            min={20}
                                            max={1000}
                                        />
                                    }
                                </ButtonGroup>
                                <RangeControl
                                    label={__('Delayed appearance','bubiblock-slider')}
                                    help={__('S Unit. In the Safari Browser this transition is not supported!','bubiblock-slider')}
                                    beforeIcon={'arrow-down-alt'}
                                    afterIcon={'arrow-up-alt'}
                                    allowReset
                                    resetFallbackValue={3}
                                    step={1}
                                    withInputField={false}
                                    separatorType="none"
                                    trackColor="#007cba"
                                    isShiftStepEnabled
                                    marks={[
                                        {
                                            value: 0,
                                            label: __('0','bubiblock-slider'),
                                        },
                                        {
                                            value: 5,
                                            label: __('5','bubiblock-slider'),
                                        },
                                        {
                                            value: 10,
                                            label: __('10','bubiblock-slider'),
                                        },
                                        {
                                            value: 15,
                                            label: __('15','bubiblock-slider'),
                                        },
                                        {
                                            value: 20,
                                            label: __('20','bubiblock-slider'),
                                        },
                                        {
                                            value: 25,
                                            label: __('25','bubiblock-slider'),
                                        },
                                        {
                                            value: 30,
                                            label: __('30','bubiblock-slider'),
                                        },
                                    ]}
                                    railColor="#02abff"
                                    value={ bubiblock_dalay_divide_3 }
                                    onChange={ this.onChangeBubiblock_dalay_divide_3}
                                    min={ 0 }
                                    max={ 30}
                                />
                            </>
                            }
                            <ToggleControl
                                label={ __( 'Dividers Bottom','bubiblock-slider' ) }
                                checked={df_enable_divide_bottom_3}
                                onChange={this.onChangeDf_enable_divide_bottom_3}
                            />
                            {df_enable_divide_bottom_3 &&
                            <>
                                <RadioControl
                                    label={__('Choose', 'df-sidebar-gutenberg')}
                                    selected={divide_bottom_3}
                                    className={'df-radio-control-divide-bottom'}
                                    onChange={(val) => setAttributes({divide_bottom_3: val})}
                                    options={bubiOptionsDivideBottom}
                                />
                                <h6 className="df-inspector bubi-not-background">{ __('Color', 'bubiblock-slider')}
                                { df_color_divide_bottom_3&&
                                    <ColorIndicator
                                        colorValue={ df_color_divide_bottom_3 }
                                    />
                                }
                                </h6>
                                <ColorPicker
                                    color={df_color_divide_bottom_3}
                                    onChangeComplete={(newval) => setAttributes({df_color_divide_bottom_3: ('rgba(' + newval.rgb.r + ', ' + newval.rgb.g + ', ' + newval.rgb.b + ', ' + newval.rgb.a + ')') })}
                                />
                                <ButtonGroup
                                    className={'df-button-group bubiblock-no-margin'}
                                >
                                    <div class="df-group-button-resp">
                                        <div class="bubi-col-6">
                                            <h6>{ __('Height', 'bubiblock-slider')}</h6>
                                        </div>
                                        <div class="bubi-col-6">
                                            <Button
                                                icon={'laptop'}
                                                isSecondary
                                                className={'df-resp-button'}
                                                isPrimary={df_resp == 'desktop'} onClick={() => setAttributes({ df_resp: 'desktop' })}
                                            >
                                            </Button>
                                            <Button
                                                icon={'tablet'}
                                                isSecondary
                                                className={'df-resp-button'}
                                                isPrimary={df_resp == 'table'} onClick={() => setAttributes({ df_resp: 'table' })}
                                            >
                                            </Button>
                                            <Button
                                                icon={'smartphone'}
                                                isSecondary
                                                className={'df-resp-button'}
                                                isPrimary={df_resp == 'mobile'} onClick={() => setAttributes({ df_resp: 'mobile' })}
                                            >
                                            </Button>
                                        </div>
                                    </div>
                                    {(df_resp=='desktop' ) &&
                                        <RangeControl
                                            label={__("Height(Desktop)","bubiblock-slider")}
                                            help={__('Px Unit','bubiblock-slider')}
                                            value={ df_height_divide_bottom_3 }
                                            onChange={ this.onChangeDf_height_divide_bottom_3 }
                                            min={20}
                                            max={1000}
                                        />
                                    }
                                    {(df_resp=='table' ) &&
                                        <RangeControl
                                            label={__("Height(Table)","bubiblock-slider")}
                                            help={__('Px Unit','bubiblock-slider')}
                                            value={ df_height_table_divide_bottom_3 }
                                            onChange={ this.onChangeDf_height_table_divide_bottom_3 }
                                            min={20}
                                            max={1000}
                                        />
                                    }
                                    {(df_resp=='mobile' ) &&
                                        <RangeControl
                                            label={__("Height(Mobile)","bubiblock-slider")}
                                            help={__('Px Unit','bubiblock-slider')}
                                            value={ df_height_mobile_divide_bottom_3 }
                                            onChange={ this.onChangeDf_height_mobile_divide_bottom_3 }
                                            min={20}
                                            max={1000}
                                        />
                                    }
                                </ButtonGroup>
                                <RangeControl
                                    label={__('Delayed appearance','bubiblock-slider')}
                                    help={__('S Unit. In the Safari Browser this transition is not supported!','bubiblock-slider')}
                                    beforeIcon={'arrow-down-alt'}
                                    afterIcon={'arrow-up-alt'}
                                    allowReset
                                    resetFallbackValue={3}
                                    step={1}
                                    withInputField={false}
                                    separatorType="none"
                                    trackColor="#007cba"
                                    isShiftStepEnabled
                                    marks={[
                                        {
                                            value: 0,
                                            label: __('0','bubiblock-slider'),
                                        },
                                        {
                                            value: 5,
                                            label: __('5','bubiblock-slider'),
                                        },
                                        {
                                            value: 10,
                                            label: __('10','bubiblock-slider'),
                                        },
                                        {
                                            value: 15,
                                            label: __('15','bubiblock-slider'),
                                        },
                                        {
                                            value: 20,
                                            label: __('20','bubiblock-slider'),
                                        },
                                        {
                                            value: 25,
                                            label: __('25','bubiblock-slider'),
                                        },
                                        {
                                            value: 30,
                                            label: __('30','bubiblock-slider'),
                                        },
                                    ]}
                                    railColor="#02abff"
                                    value={ bubiblock_dalay_divide_3_bottom }
                                    onChange={ this.onChangeBubiblock_dalay_divide_3_bottom}
                                    min={ 0 }
                                    max={ 30}
                                />
                            </>
                            }
                            {title3 &&
                            <>
                                <h6 class="df-inspector">{ __('Title', 'bubiblock-slider')}</h6>
                                <ButtonGroup
                                    className={'df-button-group bubiblock-no-margin'}
                                >
                                    <div class="df-group-button-resp">
                                        <div class="bubi-col-6">
                                            <h6>{ __('Choose', 'bubiblock-slider')}</h6>
                                        </div>
                                        <div class="bubi-col-6">
                                            <Button
                                                icon={'laptop'}
                                                isSecondary
                                                className={'df-resp-button'}
                                                isPrimary={df_resp == 'desktop'} onClick={() => setAttributes({ df_resp: 'desktop' })}
                                            >
                                            </Button>
                                            <Button
                                                icon={'tablet'}
                                                isSecondary
                                                className={'df-resp-button'}
                                                isPrimary={df_resp == 'table'} onClick={() => setAttributes({ df_resp: 'table' })}
                                            >
                                            </Button>
                                            <Button
                                                icon={'smartphone'}
                                                isSecondary
                                                className={'df-resp-button'}
                                                isPrimary={df_resp == 'mobile'} onClick={() => setAttributes({ df_resp: 'mobile' })}
                                            >
                                            </Button>
                                        </div>
                                    </div>
                                    {(df_resp=='desktop') &&
                                        <RangeControl
                                            label={__('Margin','bubiblock-slider')}
                                            help={__('px Unit','bubiblock-slider')}
                                            beforeIcon={'arrow-down-alt'}
                                            afterIcon={'arrow-up-alt'}
                                            allowReset
                                            resetFallbackValue={35}
                                            step={1}
                                            withInputField={false}
                                            separatorType="none"
                                            trackColor="#007cba"
                                            isShiftStepEnabled
                                            marks={[
                                                {
                                                    value: -100,
                                                    label: __('-100','bubiblock-slider'),
                                                },
                                                {
                                                    value: 0,
                                                    label: __('0','bubiblock-slider'),
                                                },
                                                {
                                                    value: 100,
                                                    label: __('100','bubiblock-slider'),
                                                },
                                                {
                                                    value: 200,
                                                    label: __('200','bubiblock-slider'),
                                                },
                                                {
                                                    value: 300,
                                                    label: __('300','bubiblock-slider'),
                                                },
                                            ]}
                                            railColor="#02abff"
                                            value={ margin_bottom_caption3 }
                                            onChange={ this.onChangeMargin_bottom_caption3}
                                            min={ -100 }
                                            max={ 300}
                                        />
                                    }
                                    {(df_resp=='table') &&
                                        <RangeControl
                                            label={__('Margin','bubiblock-slider')}
                                            help={__('px Unit','bubiblock-slider')}
                                            beforeIcon={'arrow-down-alt'}
                                            afterIcon={'arrow-up-alt'}
                                            allowReset
                                            resetFallbackValue={25}
                                            step={1}
                                            withInputField={false}
                                            separatorType="none"
                                            trackColor="#007cba"
                                            isShiftStepEnabled
                                            marks={[
                                                {
                                                    value: -50,
                                                    label: __('-50','bubiblock-slider'),
                                                },
                                                {
                                                    value: 0,
                                                    label: __('0','bubiblock-slider'),
                                                },
                                                {
                                                    value: 50,
                                                    label: __('50','bubiblock-slider'),
                                                },
                                                {
                                                    value: 100,
                                                    label: __('100','bubiblock-slider'),
                                                },
                                                {
                                                    value: 150,
                                                    label: __('150','bubiblock-slider'),
                                                },
                                                {
                                                    value: 200,
                                                    label: __('200','bubiblock-slider'),
                                                },
                                            ]}
                                            railColor="#02abff"
                                            value={ margin_bottom_table_caption3 }
                                            onChange={ this.onChangeMargin_bottom_table_caption3}
                                            min={ -50 }
                                            max={ 200}
                                        />
                                    }
                                    {(df_resp=='mobile') &&
                                        <RangeControl
                                            label={__('Margin','bubiblock-slider')}
                                            help={__('px Unit','bubiblock-slider')}
                                            beforeIcon={'arrow-down-alt'}
                                            afterIcon={'arrow-up-alt'}
                                            allowReset
                                            resetFallbackValue={15}
                                            step={1}
                                            withInputField={false}
                                            separatorType="none"
                                            trackColor="#007cba"
                                            isShiftStepEnabled
                                            marks={[
                                                {
                                                    value: -50,
                                                    label: __('-50','bubiblock-slider'),
                                                },
                                                {
                                                    value: 0,
                                                    label: __('0','bubiblock-slider'),
                                                },
                                                {
                                                    value: 50,
                                                    label: __('50','bubiblock-slider'),
                                                },
                                                {
                                                    value: 100,
                                                    label: __('100','bubiblock-slider'),
                                                },
                                                {
                                                    value: 150,
                                                    label: __('150','bubiblock-slider'),
                                                },
                                                {
                                                    value: 200,
                                                    label: __('200','bubiblock-slider'),
                                                },
                                            ]}
                                            railColor="#02abff"
                                            value={ margin_bottom_mobile_caption3 }
                                            onChange={ this.onChangeMargin_bottom_mobile_caption3}
                                            min={ -50 }
                                            max={ 200}
                                        />
                                    }
                                    {(df_resp=='desktop') &&
                                        <FontSizePicker
                                            className={'bubiblock-slider-inspectorcontrols'}
                                            value={fontsizetitle3}
                                            onChange={(val) => setAttributes({fontsizetitle3: val})}
                                            fontSizes={[
                                                { name: __('None', 'bubiblock-slider'), slug: 'none', size: 0 },
                                                { name: __('Small', 'bubiblock-slider'), slug: 'small', size: 22 },
                                                { name: __('Medium', 'bubiblock-slider'), slug: 'medium', size:32 },
                                                { name: __('Large', 'bubiblock-slider'), slug: 'large', size: 52 },
                                                { name: __('Big', 'bubiblock-slider'), slug: 'large', size: 82 },
                                            ]}
                                            withSlider={true}
                                        />
                                        }
                                    {(df_resp=='table') &&
                                        <FontSizePicker
                                            value={fontsizetitle3table}
                                            onChange={(val) => setAttributes({fontsizetitle3table: val})}
                                            fontSizes={[
                                                { name: __('None', 'bubiblock-slider'), slug: 'none', size: 0 },
                                                { name: __('Small', 'bubiblock-slider'), slug: 'small', size: 22 },
                                                { name: __('Medium', 'bubiblock-slider'), slug: 'medium', size:32 },
                                                { name: __('Large', 'bubiblock-slider'), slug: 'large', size: 52 },
                                                { name: __('Big', 'bubiblock-slider'), slug: 'large', size: 82 },
                                            ]}
                                            withSlider={true}
                                        />
                                    }
                                    {(df_resp=='mobile') &&
                                        <FontSizePicker
                                            value={fontsizetitle3mobile}
                                            onChange={(val) => setAttributes({fontsizetitle3mobile: val})}
                                            fontSizes={[
                                                { name: __('None', 'bubiblock-slider'), slug: 'none', size: 0 },
                                                { name: __('Small', 'bubiblock-slider'), slug: 'small', size: 22 },
                                                { name: __('Medium', 'bubiblock-slider'), slug: 'medium', size:32 },
                                                { name: __('Large', 'bubiblock-slider'), slug: 'large', size: 52 },
                                                { name: __('Big', 'bubiblock-slider'), slug: 'large', size: 82 },
                                            ]}
                                            withSlider={true}
                                        />
                                    }
                                </ButtonGroup>
                                <RadioControl
                                    label={__('Align','bubiblock-slider')}
                                    selected={ alignment_title3 }
                                    options={ [
                                        { label: 'Left', value: 'left' },
                                        { label: 'Center', value: 'center' },
                                        { label: 'Right', value: 'right' },
                                    ] }
                                    onChange={ ( newAlign ) => setAttributes( { alignment_title3: newAlign } ) }
                                />
                                <SelectControl
                                    label={__("Effect","bubiblock-slider")}
                                    options={bubiOptionsEffectAnimate}
                                    onChange={this.onChangeEffectcaption3}
                                    value={effectcaption3}
                                />
                                <SelectControl
                                    label={__("Effect speed","bubiblock-slider")}
                                    options={bubiOptionEffectSpeed}
                                    onChange={this.onChangeDf_speed_effectcaption3}
                                    value={df_speed_effectcaption3}
                                />
                                <SelectControl
                                    label={__("Effect delay","bubiblock-slider")}
                                    options={bubiOptionEffectDalay}
                                    onChange={this.onChangeDf_delay_effectcaption3}
                                    value={df_delay_effectcaption3}
                                />
                                <SelectControl
                                    label={__("Effect repeat","bubiblock-slider")}
                                    options={bubiOptionEffectRepeat}
                                    onChange={this.onChangeDf_repeat_effectcaption3}
                                    value={df_repeat_effectcaption3}
                                />
                            </>
                            }
                            {info3 &&
                            <>
                                <h6 class="df-inspector">{ __('Info', 'bubiblock-slider')}</h6>
                                <ButtonGroup
                                    className={'df-button-group bubiblock-no-margin'}
                                >
                                    <div class="df-group-button-resp">
                                        <div class="bubi-col-6">
                                            <h6>{ __('Choose', 'bubiblock-slider')}</h6>
                                        </div>
                                        <div class="bubi-col-6">
                                            <Button
                                                icon={'laptop'}
                                                isSecondary
                                                className={'df-resp-button'}
                                                isPrimary={df_resp == 'desktop'} onClick={() => setAttributes({ df_resp: 'desktop' })}
                                            >
                                            </Button>
                                            <Button
                                                icon={'tablet'}
                                                isSecondary
                                                className={'df-resp-button'}
                                                isPrimary={df_resp == 'table'} onClick={() => setAttributes({ df_resp: 'table' })}
                                            >
                                            </Button>
                                            <Button
                                                icon={'smartphone'}
                                                isSecondary
                                                className={'df-resp-button'}
                                                isPrimary={df_resp == 'mobile'} onClick={() => setAttributes({ df_resp: 'mobile' })}
                                            >
                                            </Button>
                                        </div>
                                    </div>
                                    {(df_resp=='desktop') &&
                                        <RangeControl
                                            label={__('Margin','bubiblock-slider')}
                                            help={__('px Unit','bubiblock-slider')}
                                            beforeIcon={'arrow-down-alt'}
                                            afterIcon={'arrow-up-alt'}
                                            allowReset
                                            resetFallbackValue={40}
                                            step={1}
                                            withInputField={false}
                                            separatorType="none"
                                            trackColor="#007cba"
                                            isShiftStepEnabled
                                            marks={[
                                                {
                                                    value: -100,
                                                    label: __('-100','bubiblock-slider'),
                                                },
                                                {
                                                    value: 0,
                                                    label: __('0','bubiblock-slider'),
                                                },
                                                {
                                                    value: 100,
                                                    label: __('100','bubiblock-slider'),
                                                },
                                                {
                                                    value: 200,
                                                    label: __('200','bubiblock-slider'),
                                                },
                                                {
                                                    value: 300,
                                                    label: __('300','bubiblock-slider'),
                                                },
                                            ]}
                                            railColor="#02abff"
                                            value={ margin_bottom_info3 }
                                            onChange={ this.onChangeMargin_bottom_info3}
                                            min={ -100 }
                                            max={ 300}
                                        />
                                    }
                                    {(df_resp=='table') &&
                                        <RangeControl
                                            label={__('Margin','bubiblock-slider')}
                                            help={__('px Unit','bubiblock-slider')}
                                            beforeIcon={'arrow-down-alt'}
                                            afterIcon={'arrow-up-alt'}
                                            allowReset
                                            resetFallbackValue={30}
                                            step={1}
                                            withInputField={false}
                                            separatorType="none"
                                            trackColor="#007cba"
                                            isShiftStepEnabled
                                            marks={[
                                                {
                                                    value: -50,
                                                    label: __('-50','bubiblock-slider'),
                                                },
                                                {
                                                    value: 0,
                                                    label: __('0','bubiblock-slider'),
                                                },
                                                {
                                                    value: 50,
                                                    label: __('50','bubiblock-slider'),
                                                },
                                                {
                                                    value: 100,
                                                    label: __('100','bubiblock-slider'),
                                                },
                                                {
                                                    value: 150,
                                                    label: __('150','bubiblock-slider'),
                                                },
                                                {
                                                    value: 200,
                                                    label: __('200','bubiblock-slider'),
                                                },
                                            ]}
                                            railColor="#02abff"
                                            value={ margin_bottom_table_info3 }
                                            onChange={ this.onChangeMargin_bottom_table_info3}
                                            min={ -50 }
                                            max={ 200}
                                        />
                                    }
                                    {(df_resp=='mobile') &&
                                        <RangeControl
                                            label={__('Margin','bubiblock-slider')}
                                            help={__('px Unit','bubiblock-slider')}
                                            beforeIcon={'arrow-down-alt'}
                                            afterIcon={'arrow-up-alt'}
                                            allowReset
                                            resetFallbackValue={10}
                                            step={1}
                                            withInputField={false}
                                            separatorType="none"
                                            trackColor="#007cba"
                                            isShiftStepEnabled
                                            marks={[
                                                {
                                                    value: -50,
                                                    label: __('-50','bubiblock-slider'),
                                                },
                                                {
                                                    value: 0,
                                                    label: __('0','bubiblock-slider'),
                                                },
                                                {
                                                    value: 50,
                                                    label: __('50','bubiblock-slider'),
                                                },
                                                {
                                                    value: 100,
                                                    label: __('100','bubiblock-slider'),
                                                },
                                                {
                                                    value: 150,
                                                    label: __('150','bubiblock-slider'),
                                                },
                                                {
                                                    value: 200,
                                                    label: __('200','bubiblock-slider'),
                                                },
                                            ]}
                                            railColor="#02abff"
                                            value={ margin_bottom_mobile_info3 }
                                            onChange={ this.onChangeMargin_bottom_mobile_info3}
                                            min={ -50 }
                                            max={ 200}
                                        />
                                    }
                                    {(df_resp=='desktop') &&
                                        <FontSizePicker
                                            value={fontsizeinfo3}
                                            onChange={(val) => setAttributes({fontsizeinfo3: val})}
                                            fontSizes={[
                                                { name: __('None', 'bubiblock-slider'), slug: 'none', size: 0 },
                                                { name: __('Small', 'bubiblock-slider'), slug: 'small', size: 18 },
                                                { name: __('Medium', 'bubiblock-slider'), slug: 'medium', size:24 },
                                                { name: __('Large', 'bubiblock-slider'), slug: 'large', size: 32 },
                                                { name: __('Big', 'bubiblock-slider'), slug: 'large', size: 52 },
                                            ]}
                                            withSlider={true}
                                        />
                                        }
                                    {(df_resp=='table') &&
                                        <FontSizePicker
                                            value={fontsizeinfo3table}
                                            onChange={(val) => setAttributes({fontsizeinfo3table: val})}
                                            fontSizes={[
                                                { name: __('None', 'bubiblock-slider'), slug: 'none', size: 0 },
                                                { name: __('Small', 'bubiblock-slider'), slug: 'small', size: 18 },
                                                { name: __('Medium', 'bubiblock-slider'), slug: 'medium', size:24 },
                                                { name: __('Large', 'bubiblock-slider'), slug: 'large', size: 32 },
                                                { name: __('Big', 'bubiblock-slider'), slug: 'large', size: 52 },
                                            ]}
                                            withSlider={true}
                                        />
                                    }
                                    {(df_resp=='mobile') &&
                                        <FontSizePicker
                                            value={fontsizeinfo3mobile}
                                            onChange={(val) => setAttributes({fontsizeinfo3mobile: val})}
                                            fontSizes={[
                                                { name: __('None', 'bubiblock-slider'), slug: 'none', size: 0 },
                                                { name: __('Small', 'bubiblock-slider'), slug: 'small', size: 18 },
                                                { name: __('Medium', 'bubiblock-slider'), slug: 'medium', size:24 },
                                                { name: __('Large', 'bubiblock-slider'), slug: 'large', size: 32 },
                                                { name: __('Big', 'bubiblock-slider'), slug: 'large', size: 52 },
                                            ]}
                                            withSlider={true}
                                        />
                                    }
                                </ButtonGroup>
                                <RadioControl
                                    label={__('Align','bubiblock-slider')}
                                    selected={ alignment_info3 }
                                    options={ [
                                        { label: 'Left', value: 'left' },
                                        { label: 'Center', value: 'center' },
                                        { label: 'Right', value: 'right' },
                                    ] }
                                    onChange={ ( newAlign ) => setAttributes( { alignment_info3: newAlign } ) }
                                />
                                <SelectControl
                                    label={__("Effect","bubiblock-slider")}
                                    options={bubiOptionsEffectAnimate}
                                    onChange={this.onChangeEffectinfo3}
                                    value={effectinfo3}
                                />
                                <SelectControl
                                    label={__("Effect speed","bubiblock-slider")}
                                    options={bubiOptionEffectSpeed}
                                    onChange={this.onChangeDf_speed_effectinfo3}
                                    value={df_speed_effectinfo3}
                                />
                                <SelectControl
                                    label={__("Effect delay","bubiblock-slider")}
                                    options={bubiOptionEffectDalay}
                                    onChange={this.onChangeDf_delay_effectinfo3}
                                    value={df_delay_effectinfo3}
                                />
                                <SelectControl
                                    label={__("Effect repeat","bubiblock-slider")}
                                    options={bubiOptionEffectRepeat}
                                    onChange={this.onChangeDf_repeat_effectinfo3}
                                    value={df_repeat_effectinfo3}
                                />
                            </>
                            }
                            {button3 &&
                            <>
                                <h6 class="df-inspector">{ __('Button', 'bubiblock-slider')}</h6>
                                <ButtonGroup
                                    className={'df-button-group bubiblock-no-margin'}
                                >
                                    <div class="df-group-button-resp">
                                        <div class="bubi-col-6">
                                            <h6>{ __('Choose', 'bubiblock-slider')}</h6>
                                        </div>
                                        <div class="bubi-col-6">
                                            <Button
                                                icon={'laptop'}
                                                isSecondary
                                                className={'df-resp-button'}
                                                isPrimary={df_resp == 'desktop'} onClick={() => setAttributes({ df_resp: 'desktop' })}
                                            >
                                            </Button>
                                            <Button
                                                icon={'tablet'}
                                                isSecondary
                                                className={'df-resp-button'}
                                                isPrimary={df_resp == 'table'} onClick={() => setAttributes({ df_resp: 'table' })}
                                            >
                                            </Button>
                                            <Button
                                                icon={'smartphone'}
                                                isSecondary
                                                className={'df-resp-button'}
                                                isPrimary={df_resp == 'mobile'} onClick={() => setAttributes({ df_resp: 'mobile' })}
                                            >
                                            </Button>
                                        </div>
                                    </div>
                                    {(df_resp=='desktop') &&
                                        <RangeControl
                                            label={__('Margin','bubiblock-slider')}
                                            help={__('px Unit','bubiblock-slider')}
                                            beforeIcon={'arrow-down-alt'}
                                            afterIcon={'arrow-up-alt'}
                                            allowReset
                                            resetFallbackValue={5}
                                            step={1}
                                            withInputField={false}
                                            separatorType="none"
                                            trackColor="#007cba"
                                            isShiftStepEnabled
                                            marks={[
                                                {
                                                    value: -100,
                                                    label: __('-100','bubiblock-slider'),
                                                },
                                                {
                                                    value: 0,
                                                    label: __('0','bubiblock-slider'),
                                                },
                                                {
                                                    value: 100,
                                                    label: __('100','bubiblock-slider'),
                                                },
                                                {
                                                    value: 200,
                                                    label: __('200','bubiblock-slider'),
                                                },
                                                {
                                                    value: 300,
                                                    label: __('300','bubiblock-slider'),
                                                },
                                            ]}
                                            railColor="#02abff"
                                            value={ margin_bottom_button3 }
                                            onChange={ this.onChangeMargin_bottom_button3}
                                            min={ -100 }
                                            max={ 300}
                                        />
                                    }
                                    {(df_resp=='table') &&
                                        <RangeControl
                                            label={__('Margin','bubiblock-slider')}
                                            help={__('px Unit','bubiblock-slider')}
                                            beforeIcon={'arrow-down-alt'}
                                            afterIcon={'arrow-up-alt'}
                                            allowReset
                                            resetFallbackValue={5}
                                            step={1}
                                            withInputField={false}
                                            separatorType="none"
                                            trackColor="#007cba"
                                            isShiftStepEnabled
                                            marks={[
                                                {
                                                    value: -50,
                                                    label: __('-50','bubiblock-slider'),
                                                },
                                                {
                                                    value: 0,
                                                    label: __('0','bubiblock-slider'),
                                                },
                                                {
                                                    value: 50,
                                                    label: __('50','bubiblock-slider'),
                                                },
                                                {
                                                    value: 100,
                                                    label: __('100','bubiblock-slider'),
                                                },
                                                {
                                                    value: 150,
                                                    label: __('150','bubiblock-slider'),
                                                },
                                                {
                                                    value: 200,
                                                    label: __('200','bubiblock-slider'),
                                                },
                                            ]}
                                            railColor="#02abff"
                                            value={ margin_bottom_table_button3 }
                                            onChange={ this.onChangeMargin_bottom_table_button3}
                                            min={ -50 }
                                            max={ 200}
                                        />
                                    }
                                    {(df_resp=='mobile') &&
                                        <RangeControl
                                            label={__('Margin','bubiblock-slider')}
                                            help={__('px Unit','bubiblock-slider')}
                                            beforeIcon={'arrow-down-alt'}
                                            afterIcon={'arrow-up-alt'}
                                            allowReset
                                            resetFallbackValue={5}
                                            step={1}
                                            withInputField={false}
                                            separatorType="none"
                                            trackColor="#007cba"
                                            isShiftStepEnabled
                                            marks={[
                                                {
                                                    value: -50,
                                                    label: __('-50','bubiblock-slider'),
                                                },
                                                {
                                                    value: 0,
                                                    label: __('0','bubiblock-slider'),
                                                },
                                                {
                                                    value: 50,
                                                    label: __('50','bubiblock-slider'),
                                                },
                                                {
                                                    value: 100,
                                                    label: __('100','bubiblock-slider'),
                                                },
                                                {
                                                    value: 150,
                                                    label: __('150','bubiblock-slider'),
                                                },
                                                {
                                                    value: 200,
                                                    label: __('200','bubiblock-slider'),
                                                },
                                            ]}
                                            railColor="#02abff"
                                            value={ margin_bottom_mobile_button3 }
                                            onChange={ this.onChangeMargin_bottom_mobile_button3}
                                            min={ -50 }
                                            max={ 200}
                                        />
                                    }
                                    {(df_resp=='desktop') &&
                                        <FontSizePicker
                                            value={fontsizebutton3}
                                            onChange={(val) => setAttributes({fontsizebutton3: val})}
                                            fontSizes={[
                                                { name: __('Small', 'bubiblock-slider'), slug: 'small', size: 18 },
                                                { name: __('Medium', 'bubiblock-slider'), slug: 'medium', size:24 },
                                                { name: __('Large', 'bubiblock-slider'), slug: 'large', size: 32 },
                                                { name: __('Big', 'bubiblock-slider'), slug: 'large', size: 52 },
                                            ]}
                                            withSlider={true}
                                    />
                                        }
                                    {(df_resp=='table') &&
                                        <FontSizePicker
                                            value={fontsizebutton3table}
                                            onChange={(val) => setAttributes({fontsizebutton3table: val})}
                                            fontSizes={[
                                                { name: __('Small', 'bubiblock-slider'), slug: 'small', size: 18 },
                                                { name: __('Medium', 'bubiblock-slider'), slug: 'medium', size:24 },
                                                { name: __('Large', 'bubiblock-slider'), slug: 'large', size: 32 },
                                                { name: __('Big', 'bubiblock-slider'), slug: 'large', size: 52 },
                                            ]}
                                            withSlider={true}
                                        />
                                    }
                                    {(df_resp=='mobile') &&
                                        <FontSizePicker
                                            value={fontsizebutton3mobile}
                                            onChange={(val) => setAttributes({fontsizebutton3mobile: val})}
                                            fontSizes={[
                                                { name: __('Small', 'bubiblock-slider'), slug: 'small', size: 18 },
                                                { name: __('Medium', 'bubiblock-slider'), slug: 'medium', size:24 },
                                                { name: __('Large', 'bubiblock-slider'), slug: 'large', size: 32 },
                                                { name: __('Big', 'bubiblock-slider'), slug: 'large', size: 52 },
                                            ]}
                                            withSlider={true}
                                        />
                                    }
                                </ButtonGroup>
                                <RadioControl
                                    label={__('Align','bubiblock-slider')}
                                    selected={ alignment_button3 }
                                    options={ [
                                        { label: 'Left', value: 'left' },
                                        { label: 'Center', value: 'center' },
                                        { label: 'Right', value: 'right' },
                                    ] }
                                    onChange={ ( newAlign ) => setAttributes( { alignment_button3: newAlign } ) }
                                />
                                <SelectControl
                                    label={__("Effect","bubiblock-slider")}
                                    options={bubiOptionsEffectAnimate}
                                    onChange={this.onChangeEffectbutton3}
                                    value={effectbutton3}
                                />
                                <SelectControl
                                    label={__("Effect speed","bubiblock-slider")}
                                    options={bubiOptionEffectSpeed}
                                    onChange={this.onChangeDf_speed_effectbutton3}
                                    value={df_speed_effectbutton3}
                                />
                                <SelectControl
                                    label={__("Effect delay","bubiblock-slider")}
                                    options={bubiOptionEffectDalay}
                                    onChange={this.onChangeDf_delay_effectbutton3}
                                    value={df_delay_effectbutton3}
                                />
                                <SelectControl
                                    label={__("Effect repeat","bubiblock-slider")}
                                    options={bubiOptionEffectRepeat}
                                    onChange={this.onChangeDf_repeat_effectbutton3}
                                    value={df_repeat_effectbutton3}
                                />
                                <RangeControl
                                    label={__('Padding top/bottom','bubiblock-slider')}
                                    help={__('px Unit','bubiblock-slider')}
                                    beforeIcon={'arrow-down-alt'}
                                    afterIcon={'arrow-up-alt'}
                                    allowReset
                                    resetFallbackValue={8}
                                    step={1}
                                    withInputField={false}
                                    separatorType="none"
                                    trackColor="#007cba"
                                    isShiftStepEnabled
                                    marks={[
                                        {
                                            value: 0,
                                            label: __('0','bubiblock-slider'),
                                        },
                                        {
                                            value: 10,
                                            label: __('10','bubiblock-slider'),
                                        },
                                        {
                                            value: 20,
                                            label: __('20','bubiblock-slider'),
                                        },
                                        {
                                            value: 30,
                                            label: __('30','bubiblock-slider'),
                                        },
                                        {
                                            value: 40,
                                            label: __('40','bubiblock-slider'),
                                        },
                                        {
                                            value: 50,
                                            label: __('50','bubiblock-slider'),
                                        },
                                    ]}
                                    railColor="#02abff"
                                    value={ padding_link_button3 }
                                    onChange={(val) => setAttributes({ padding_link_button3: val })}
                                    min={ 0 }
                                    max={ 50}
                                />
                                <RangeControl
                                    label={__('Padding left/right','bubiblock-slider')}
                                    help={__('px Unit','bubiblock-slider')}
                                    beforeIcon={'arrow-left-alt'}
                                    afterIcon={'arrow-right-alt'}
                                    allowReset
                                    resetFallbackValue={20}
                                    step={1}
                                    withInputField={false}
                                    separatorType="none"
                                    trackColor="#007cba"
                                    isShiftStepEnabled
                                    marks={[
                                        {
                                            value: 0,
                                            label: __('0','bubiblock-slider'),
                                        },
                                        {
                                            value: 10,
                                            label: __('10','bubiblock-slider'),
                                        },
                                        {
                                            value: 20,
                                            label: __('20','bubiblock-slider'),
                                        },
                                        {
                                            value: 30,
                                            label: __('30','bubiblock-slider'),
                                        },
                                        {
                                            value: 40,
                                            label: __('40','bubiblock-slider'),
                                        },
                                        {
                                            value: 50,
                                            label: __('50','bubiblock-slider'),
                                        },
                                    ]}
                                    railColor="#02abff"
                                    value={ padding_right_link_button3 }
                                    onChange={(val) => setAttributes({ padding_right_link_button3: val })}
                                    min={ 0 }
                                    max={ 50}
                                />
                                <RangeControl
                                    label={__('Border solid','bubiblock-slider')}
                                    help={__('Px Unit','bubiblock-slider')}
                                    beforeIcon={'star-empty'}
                                    afterIcon={'star-filled'}
                                    allowReset
                                    resetFallbackValue={0}
                                    step={1}
                                    withInputField={false}
                                    separatorType="none"
                                    trackColor="#007cba"
                                    isShiftStepEnabled
                                    marks={[
                                        {
                                            value: 0,
                                            label: __('0','bubiblock-slider'),
                                        },
                                        {
                                            value: 10,
                                            label: __('10','bubiblock-slider'),
                                        },
                                        {
                                            value: 20,
                                            label: __('20','bubiblock-slider'),
                                        },
                                        {
                                            value: 30,
                                            label: __('30','bubiblock-slider'),
                                        },
                                        {
                                            value: 40,
                                            label: __('40','bubiblock-slider'),
                                        },
                                        {
                                            value: 50,
                                            label: __('50','bubiblock-slider'),
                                        },
                                    ]}
                                    railColor="#02abff"
                                    value={ border_size_link_button3 }
                                    onChange={(val) => setAttributes({ border_size_link_button3: val })}
                                    min={ 0 }
                                    max={ 50}
                                />
                                <RangeControl
                                    label={__('Border top left radius','bubiblock-slider')}
                                    help={__('% Unit','bubiblock-slider')}
                                    beforeIcon={'fullscreen-alt'}
                                    afterIcon={'fullscreen-exit-alt'}
                                    allowReset
                                    resetFallbackValue={0}
                                    step={1}
                                    withInputField={false}
                                    separatorType="none"
                                    trackColor="#007cba"
                                    isShiftStepEnabled
                                    marks={[
                                        {
                                            value: 0,
                                            label: __('0','bubiblock-slider'),
                                        },
                                        {
                                            value: 10,
                                            label: __('10','bubiblock-slider'),
                                        },
                                        {
                                            value: 20,
                                            label: __('20','bubiblock-slider'),
                                        },
                                        {
                                            value: 30,
                                            label: __('30','bubiblock-slider'),
                                        },
                                        {
                                            value: 40,
                                            label: __('40','bubiblock-slider'),
                                        },
                                        {
                                            value: 50,
                                            label: __('50','bubiblock-slider'),
                                        },
                                    ]}
                                    railColor="#02abff"
                                    value={ border_radius_top_left_link_button3 }
                                    onChange={(val) => setAttributes({ border_radius_top_left_link_button3: val })}
                                    min={ 0 }
                                    max={ 50}
                                />
                                <RangeControl
                                    label={__('Border top right radius','bubiblock-slider')}
                                    help={__('% Unit','bubiblock-slider')}
                                    beforeIcon={'fullscreen-alt'}
                                    afterIcon={'fullscreen-exit-alt'}
                                    allowReset
                                    resetFallbackValue={0}
                                    step={1}
                                    withInputField={false}
                                    separatorType="none"
                                    trackColor="#007cba"
                                    isShiftStepEnabled
                                    marks={[
                                        {
                                            value: 0,
                                            label: __('0','bubiblock-slider'),
                                        },
                                        {
                                            value: 10,
                                            label: __('10','bubiblock-slider'),
                                        },
                                        {
                                            value: 20,
                                            label: __('20','bubiblock-slider'),
                                        },
                                        {
                                            value: 30,
                                            label: __('30','bubiblock-slider'),
                                        },
                                        {
                                            value: 40,
                                            label: __('40','bubiblock-slider'),
                                        },
                                        {
                                            value: 50,
                                            label: __('50','bubiblock-slider'),
                                        },
                                    ]}
                                    railColor="#02abff"
                                    value={ border_radius_top_right_link_button3 }
                                    onChange={(val) => setAttributes({ border_radius_top_right_link_button3: val })}
                                    min={ 0 }
                                    max={ 50}
                                />
                                <RangeControl
                                    label={__('Border bottom left radius','bubiblock-slider')}
                                    help={__('% Unit','bubiblock-slider')}
                                    beforeIcon={'fullscreen-alt'}
                                    afterIcon={'fullscreen-exit-alt'}
                                    allowReset
                                    resetFallbackValue={0}
                                    step={1}
                                    withInputField={false}
                                    separatorType="none"
                                    trackColor="#007cba"
                                    isShiftStepEnabled
                                    marks={[
                                        {
                                            value: 0,
                                            label: __('0','bubiblock-slider'),
                                        },
                                        {
                                            value: 10,
                                            label: __('10','bubiblock-slider'),
                                        },
                                        {
                                            value: 20,
                                            label: __('20','bubiblock-slider'),
                                        },
                                        {
                                            value: 30,
                                            label: __('30','bubiblock-slider'),
                                        },
                                        {
                                            value: 40,
                                            label: __('40','bubiblock-slider'),
                                        },
                                        {
                                            value: 50,
                                            label: __('50','bubiblock-slider'),
                                        },
                                    ]}
                                    railColor="#02abff"
                                    value={ border_radius_bottom_left_link_button3 }
                                    onChange={(val) => setAttributes({ border_radius_bottom_left_link_button3: val })}
                                    min={ 0 }
                                    max={ 50}
                                />
                                <RangeControl
                                    label={__('Border bottom right radius','bubiblock-slider')}
                                    help={__('% Unit','bubiblock-slider')}
                                    beforeIcon={'fullscreen-alt'}
                                    afterIcon={'fullscreen-exit-alt'}
                                    allowReset
                                    resetFallbackValue={0}
                                    step={1}
                                    withInputField={false}
                                    separatorType="none"
                                    trackColor="#007cba"
                                    isShiftStepEnabled
                                    marks={[
                                        {
                                            value: 0,
                                            label: __('0','bubiblock-slider'),
                                        },
                                        {
                                            value: 10,
                                            label: __('10','bubiblock-slider'),
                                        },
                                        {
                                            value: 20,
                                            label: __('20','bubiblock-slider'),
                                        },
                                        {
                                            value: 30,
                                            label: __('30','bubiblock-slider'),
                                        },
                                        {
                                            value: 40,
                                            label: __('40','bubiblock-slider'),
                                        },
                                        {
                                            value: 50,
                                            label: __('50','bubiblock-slider'),
                                        },
                                    ]}
                                    railColor="#02abff"
                                    value={ border_radius_bottom_right_link_button3 }
                                    onChange={(val) => setAttributes({ border_radius_bottom_right_link_button3: val })}
                                    min={ 0 }
                                    max={ 50}
                                />
                                <h6 id={'bg'} class="df-inspector" >{ __('Background Color', 'bubiblock-slider')}
                                {(df_background_color_transparent_link_button3 == 'df-trasparent-color-button3-false') &&
                                    <>
                                    {df_background_color_link_button3 &&
                                        <ColorIndicator
                                            colorValue={ df_background_color_link_button3 }
                                        />
                                    }
                                    </>
                                }
                                {df_background_color_hover_link_button3 &&
                                    <ColorIndicator
                                        colorValue={ df_background_color_hover_link_button3 }
                                    />
                                }
                                </h6>
                                {(df_background_color_transparent_link_button3 == 'df-trasparent-color-button3-false') &&
                                    <div class={'legend-color-none'}>
                                        <ColorPaletteControl
                                            value={ df_background_color_link_button3}
                                            colors={ bubiColors }
                                            onChange={ (newValue) => setAttributes({df_background_color_link_button3: newValue}) }
                                        />
                                    </div>
                                }
                                <p className={"df-inspector bubi-mt-1"}>{__('Hover','bubiblock-slider')}</p>
                                <div class={'legend-color-none'}>
                                    <ColorPaletteControl
                                        value={ df_background_color_hover_link_button3}
                                        colors={ bubiColors }
                                        onChange={ (newValue) => setAttributes({df_background_color_hover_link_button3: newValue}) }
                                    />
                                </div>
                                <h6 className="df-inspector">{ __('Color', 'bubiblock-slider')}
                                {df_color_link_button3 &&
                                    <ColorIndicator
                                        colorValue={ df_color_link_button3 }
                                    />
                                }
                                {df_color_hover_link_button3 &&
                                    <ColorIndicator
                                        colorValue={ df_color_hover_link_button3 }
                                    />
                                }
                                {df_border_color_link_button3 &&
                                    <ColorIndicator
                                        colorValue={ df_border_color_link_button3 }
                                    />
                                }
                                </h6>
                                <div class={'legend-color-none'}>
                                    <p className="df-inspector">{__('Color','bubiblock-slider')}</p>
                                    <ColorPaletteControl
                                        value={ df_color_link_button3}
                                        colors={ bubiColors }
                                        onChange={ (newValue) => setAttributes({df_color_link_button3: newValue}) }
                                    />
                                    <p className="df-inspector">{__('Color hover','bubiblock-slider')}</p>
                                    <ColorPaletteControl
                                        value={ df_color_hover_link_button3}
                                        colors={ bubiColors }
                                        onChange={ (newValue) => setAttributes({df_color_hover_link_button3: newValue}) }
                                    />
                                    <p className="df-inspector">{__('Border Color','bubiblock-slider')}</p>
                                    <ColorPaletteControl
                                        value={ df_border_color_link_button3}
                                        colors={ bubiColors }
                                        onChange={ (newValue) => setAttributes({df_border_color_link_button3: newValue}) }
                                    />
                                </div>
                                <ButtonGroup
                                    className={'df-button-group bubiblock-no-margin'}
                                >
                                    <h6 className="df-inspector">{ __('Background color transparent', 'bubiblock-slider')}</h6>
                                    <div class="bubi-width-two">
                                    <Button
                                        isSecondary
                                        isPrimary={df_background_color_transparent_link_button3 == 'df-trasparent-color-button3-true'} onClick={() => setAttributes({ df_background_color_transparent_link_button3: 'df-trasparent-color-button3-true' })}
                                    >
                                        {__('True','bubiblock-slider')}
                                    </Button>
                                    <Button
                                        isSecondary
                                        isPrimary={df_background_color_transparent_link_button3 == 'df-trasparent-color-button3-false'} onClick={() => setAttributes({ df_background_color_transparent_link_button3: 'df-trasparent-color-button3-false' })}
                                    >
                                        {__('False','bubiblock-slider')}
                                    </Button>
                                    </div>
                                </ButtonGroup>
                            </>
                            }
                            </PanelBody>
                            <Panel
                                className={'bubiblock-add-slider'}
                            >
                                <ToggleControl
                                    label={__( 'Add Slides','bubiblock-slider' ) }
                                    help={__('Important: if you want to remove this slider make sure you are with the carousel on the first or second slider!','bubiblock-slider')}
                                    checked={bubiblock_add_slider_4}
                                    onChange={(val) => setAttributes({ bubiblock_add_slider_4: val })}
                                />
                        </Panel>
                        </>
                    }
                    {bubiblock_add_slider_4 &&
                        <>
                        <PanelBody // Slider 4
                            icon={'format-image'}
                            title={__('Slides 4', 'bubiblock-slider')}
                            initialOpen={false}
                            >
                            <h6 className="df-inspector bubi-mt-1">{ __('Background type', 'bubiblock-slider')}</h6>
                            <div class="bubi-width-three bubibutton-icon">
                                <ButtonGroup
                                    className={'df-button-group bubiblock-no-margin'}
                                >
                                    <Tooltip
                                        text= {__('Color','bubiblock-slider')}
                                    >
                                        <Button
                                            isPrimary={df_slider_chose_4 == 'df-slider-color-4'}
                                            icon="admin-appearance"
                                            onClick={() => setAttributes({ df_slider_chose_4: 'df-slider-color-4' })}
                                        >
                                        </Button>
                                    </Tooltip>
                                    <Tooltip
                                        text=  {__('Image','bubiblock-slider')}
                                    >
                                        <Button
                                            isPrimary={df_slider_chose_4 == 'df-slider-image-4'}
                                            icon="format-image"
                                            onClick={() => setAttributes({ df_slider_chose_4: 'df-slider-image-4' })}
                                        >
                                        </Button>
                                    </Tooltip>
                                </ButtonGroup>
                            </div>
                            {(df_slider_chose_4=='df-slider-image-4' ) &&
                                <>
                                    {imageUrl_4?
                                        <>
                                        <img src={imageUrl_4} className={'bubi-mt-2'}/>
                                        {isBlobURL(imageUrl_4) && <Spinner />}
                                        </>
                                        :
                                        <MediaPlaceholder
                                            className={'bubi-mt-2 bubi-mb-2'}
                                            icon="format-image df-icon-img-upload"
                                            onSelect={ media => { setAttributes({ imageAlt_4: media.alt, imageUrl_4: media.url }); } }
                                            onSelectURL={ this.onSelectURL4 }
                                            onError={this.onUploadError4}
                                            accept="image/*"
                                            allowedTypes={['image']}
                                            notices={ noticeUI4 }
                                        />
                                    }
                                    {imageUrl_4 &&
                                    <>
                                        <MenuItem
                                            icon={ 'trash' }
                                            className={'df-remov-img'}
                                            onClick={ this.removeImage4 }
                                        >
                                            { __('Remove Image','bubiblock-slider') }
                                        </MenuItem>
                                        <TextareaControl
                                            label={__('Alt Text (Alternative Text)','bubiblock-slider')}
                                            value={ alt4}
                                            onChange={ this.updateAlt4 }
                                            help={__('Alternative text describes your image to people who cant see it. Add a short description with its key details.','bubiblock-slider')}
                                        />
                                        <SelectControl
                                            label={__("Dispaly Size","bubiblock-slider")}
                                            options={[
                                                {label: __('None','bubiblock-slider'), value: 'none'},
                                                {label: __('Containe','bubiblock-slider'), value: 'contain'},
                                                {label: __('Cover','bubiblock-slider'), value: 'cover'},
                                                {label: __('Fill','bubiblock-slider'), value: 'fill'},
                                                {label: __('Scale down','bubiblock-slider'), value: 'scale-down'},
                                                {label: __('Unset','bubiblock-slider'), value: 'unset'},
                                            ]}
                                            onChange={(val) => setAttributes({ df_cover_img4: val })}
                                            value={df_cover_img4}
                                        />
                                        {(df_cover_img4=='none')&&
                                        <>
                                            <RangeControl
                                                label={__('Display Position','bubiblock-slider')}
                                                help={__('% Unit','bubiblock-slider')}
                                                beforeIcon={'arrow-left-alt'}
                                                afterIcon={'arrow-right-alt'}
                                                allowReset
                                                resetFallbackValue={50}
                                                step={1}
                                                withInputField={false}
                                                separatorType="none"
                                                trackColor="#007cba"
                                                isShiftStepEnabled
                                                marks={[
                                                    {
                                                        value: 0,
                                                        label: __('0','bubiblock-slider'),
                                                    },
                                                    {
                                                        value: 20,
                                                        label: __('20','bubiblock-slider'),
                                                    },
                                                    {
                                                        value: 40,
                                                        label: __('40','bubiblock-slider'),
                                                    },
                                                    {
                                                        value: 60,
                                                        label: __('60','bubiblock-slider'),
                                                    },
                                                    {
                                                        value: 80,
                                                        label: __('80','bubiblock-slider'),
                                                    },
                                                    {
                                                        value: 100,
                                                        label: __('100','bubiblock-slider'),
                                                    },
                                                ]}
                                                railColor="#02abff"
                                                value={ df_focalPoint_img_4 }
                                                onChange={(val) => setAttributes({ df_focalPoint_img_4: val })}
                                                min={ 0 }
                                                max={ 100}
                                            />
                                            <RangeControl
                                                label={__('Display Position','bubiblock-slider')}
                                                help={__('% Unit','bubiblock-slider')}
                                                beforeIcon={'arrow-down-alt'}
                                                afterIcon={'arrow-up-alt'}
                                                allowReset
                                                resetFallbackValue={50}
                                                step={1}
                                                withInputField={false}
                                                separatorType="none"
                                                trackColor="#007cba"
                                                isShiftStepEnabled
                                                marks={[
                                                    {
                                                        value: 0,
                                                        label: __('0','bubiblock-slider'),
                                                    },
                                                    {
                                                        value: 20,
                                                        label: __('20','bubiblock-slider'),
                                                    },
                                                    {
                                                        value: 40,
                                                        label: __('40','bubiblock-slider'),
                                                    },
                                                    {
                                                        value: 60,
                                                        label: __('60','bubiblock-slider'),
                                                    },
                                                    {
                                                        value: 80,
                                                        label: __('80','bubiblock-slider'),
                                                    },
                                                    {
                                                        value: 100,
                                                        label: __('100','bubiblock-slider'),
                                                    },
                                                ]}
                                                railColor="#02abff"
                                                value={ df_focalPoint_y_img_4 }
                                                onChange={(val) => setAttributes({ df_focalPoint_y_img_4: val })}
                                                min={ 0 }
                                                max={ 100}
                                            />
                                            </>
                                        }
                                        <ToggleControl
                                            label={ __( 'Show mask','bubiblock-slider' ) }
                                            checked={df_mask_slider_4}
                                            onChange={(val) => setAttributes({ df_mask_slider_4: val })}
                                        />
                                        {df_mask_slider_4 &&
                                            <>
                                            <Notice
                                                status="info"
                                                isDismissible={ false }
                                            >
                                                {__('If you have set the border radius for the slider this control will not work well!','bubiblock-slider')}
                                            </Notice>
                                            <ColorGradientControl
                                                colorValue={ background_color_solid_mask_4 }
                                                gradientValue={ background_color_gradient_mask_4 }
                                                colors={ bubiColors }
                                                gradients={ bubiGradients }
                                                onColorChange={ (newValue) => setAttributes({ background_color_solid_mask_4: newValue }) }
                                                onGradientChange={ (newValue) => setAttributes({ background_color_gradient_mask_4: newValue }) }
                                            />
                                            <RangeControl
                                                label={__('Opacity','bubiblock-slider')}
                                                beforeIcon={'hidden'}
                                                afterIcon={'visibility'}
                                                allowReset
                                                resetFallbackValue={.4}
                                                step={.1}
                                                withInputField={false}
                                                separatorType="none"
                                                trackColor="#007cba"
                                                isShiftStepEnabled
                                                marks={[
                                                    {
                                                        value: 0,
                                                        label: __('0','bubiblock-slider'),
                                                    },
                                                    {
                                                        value: 0.2,
                                                        label: __('2','bubiblock-slider'),
                                                    },
                                                    {
                                                        value: 0.4,
                                                        label: __('4','bubiblock-slider'),
                                                    },
                                                    {
                                                        value: 0.6,
                                                        label: __('6','bubiblock-slider'),
                                                    },
                                                    {
                                                        value: 0.8,
                                                        label: __('8','bubiblock-slider'),
                                                    },
                                                    {
                                                        value: 1.0,
                                                        label: __('10','bubiblock-slider'),
                                                    },
                                                ]}
                                                railColor="#02abff"
                                                value={ df_opacity_mask_4 }
                                                onChange={(val) => setAttributes({ df_opacity_mask_4: val })}
                                                min={ .0 }
                                                max={ 1.0}
                                            />
                                        </>
                                        }
                                        <TextControl
                                            label={__('Link Image','bubiblock-slider')}
                                            value={ bubiblock_link_slider_4 }
                                            onChange={ (newValue) => setAttributes({bubiblock_link_slider_4: newValue}) }
                                            type="url"
                                        />
                                        {bubiblock_link_slider_4 &&
                                            <ButtonGroup
                                                    className={'df-button-group bubiblock-no-margin bubi-mb-2'}
                                                >
                                                    <p className="df-inspector bubi-mt-1">{ __('Open in new tab', 'bubiblock-slider')}</p>
                                                    <div class="bubi-width-two">
                                                    <Button
                                                        isSecondary
                                                        isPrimary={bubiblock_link_tab_slider_4 == '_blank'} onClick={() => setAttributes({ bubiblock_link_tab_slider_4: '_blank' })}
                                                    >
                                                        {__('True','bubiblock-slider')}
                                                    </Button>
                                                    <Button
                                                        isSecondary
                                                        isPrimary={bubiblock_link_tab_slider_4 == ''} onClick={() => setAttributes({ bubiblock_link_tab_slider_4: '' })}
                                                    >
                                                        {__('False','bubiblock-slider')}
                                                    </Button>
                                                    </div>
                                            </ButtonGroup>
                                        }
                                    </>
                                    }
                                </>
                            }
                            {(df_slider_chose_4=='df-slider-color-4' ) &&
                                <>
                                <h6 className="df-inspector bubi-not-background">{ __('Background Color', 'bubiblock-slider')}
                                {df_background_color_slider_4 &&
                                    <ColorIndicator
                                        colorValue={ df_background_color_slider_4 }
                                    />
                                }
                                </h6>
                                <div class={'legend-color-none'}>
                                    <ColorPaletteControl
                                        value={ df_background_color_slider_4 }
                                        colors={ bubiColors }
                                        onChange={ (newValue) => setAttributes({df_background_color_slider_4 : newValue}) }
                                    />
                                </div>
                                </>
                            }
                            <ToggleControl
                                label={ __( 'Dividers Top','bubiblock-slider' ) }
                                checked={df_enable_divide_4}
                                onChange={ (newValue) => setAttributes({df_enable_divide_4: newValue}) }
                            />
                            {df_enable_divide_4 &&
                            <>
                                <RadioControl
                                    label={__('Choose', 'df-sidebar-gutenberg')}
                                    selected={divide_4}
                                    className={'bubiblock-radio-image'}
                                    onChange={(val) => setAttributes({divide_4: val})}
                                    options={bubiOptionsDivideTop}
                                />
                                <h6 className="df-inspector bubi-not-background">{ __('Color', 'bubiblock-slider')}
                                { df_color_divide_4 &&
                                    <ColorIndicator
                                        colorValue={ df_color_divide_4 }
                                    />
                                }
                                </h6>
                                <ColorPicker
                                    color={df_color_divide_4}
                                    onChangeComplete={(newval) => setAttributes({df_color_divide_4: ('rgba(' + newval.rgb.r + ', ' + newval.rgb.g + ', ' + newval.rgb.b + ', ' + newval.rgb.a + ')') })}
                                />
                                <ButtonGroup
                                    className={'df-button-group bubiblock-no-margin'}
                                >
                                    <div class="df-group-button-resp">
                                        <div class="bubi-col-6">
                                            <h6>{ __('Height', 'bubiblock-slider')}</h6>
                                        </div>
                                        <div class="bubi-col-6">
                                            <Button
                                                icon={'laptop'}
                                                isSecondary
                                                className={'df-resp-button'}
                                                isPrimary={df_resp == 'desktop'} onClick={() => setAttributes({ df_resp: 'desktop' })}
                                            >
                                            </Button>
                                            <Button
                                                icon={'tablet'}
                                                isSecondary
                                                className={'df-resp-button'}
                                                isPrimary={df_resp == 'table'} onClick={() => setAttributes({ df_resp: 'table' })}
                                            >
                                            </Button>
                                            <Button
                                                icon={'smartphone'}
                                                isSecondary
                                                className={'df-resp-button'}
                                                isPrimary={df_resp == 'mobile'} onClick={() => setAttributes({ df_resp: 'mobile' })}
                                            >
                                            </Button>
                                        </div>
                                    </div>
                                    {(df_resp=='desktop' ) &&
                                        <RangeControl
                                            label={__("Height(Desktop)","bubiblock-slider")}
                                            help={__('Px Unit','bubiblock-slider')}
                                            value={ df_height_divide_4 }
                                            onChange={(val) => setAttributes({df_height_divide_4: val})}
                                            min={20}
                                            max={1000}
                                        />
                                    }
                                    {(df_resp=='table' ) &&
                                        <RangeControl
                                            label={__("Height(Table)","bubiblock-slider")}
                                            help={__('Px Unit','bubiblock-slider')}
                                            value={ df_height_table_divide_4 }
                                            onChange={(val) => setAttributes({df_height_table_divide_4: val})}
                                            min={20}
                                            max={1000}
                                        />
                                    }
                                    {(df_resp=='mobile' ) &&
                                        <RangeControl
                                            label={__("Height(Mobile)","bubiblock-slider")}
                                            help={__('Px Unit','bubiblock-slider')}
                                            value={ df_height_mobile_divide_4 }
                                            onChange={(val) => setAttributes({df_height_mobile_divide_4 : val})}
                                            min={20}
                                            max={1000}
                                        />
                                    }
                                </ButtonGroup>
                                <RangeControl
                                    label={__('Delayed appearance','bubiblock-slider')}
                                    help={__('S Unit. In the Safari Browser this transition is not supported!','bubiblock-slider')}
                                    beforeIcon={'arrow-down-alt'}
                                    afterIcon={'arrow-up-alt'}
                                    allowReset
                                    resetFallbackValue={3}
                                    step={1}
                                    withInputField={false}
                                    separatorType="none"
                                    trackColor="#007cba"
                                    isShiftStepEnabled
                                    marks={[
                                        {
                                            value: 0,
                                            label: __('0','bubiblock-slider'),
                                        },
                                        {
                                            value: 5,
                                            label: __('5','bubiblock-slider'),
                                        },
                                        {
                                            value: 10,
                                            label: __('10','bubiblock-slider'),
                                        },
                                        {
                                            value: 15,
                                            label: __('15','bubiblock-slider'),
                                        },
                                        {
                                            value: 20,
                                            label: __('20','bubiblock-slider'),
                                        },
                                        {
                                            value: 25,
                                            label: __('25','bubiblock-slider'),
                                        },
                                        {
                                            value: 30,
                                            label: __('30','bubiblock-slider'),
                                        },
                                    ]}
                                    railColor="#02abff"
                                    value={ bubiblock_dalay_divide_4 }
                                    onChange={(val) => setAttributes({bubiblock_dalay_divide_4 : val})}
                                    min={ 0 }
                                    max={ 30}
                                />
                            </>
                            }
                            <ToggleControl
                                label={ __( 'Dividers Bottom','bubiblock-slider' ) }
                                checked={df_enable_divide_bottom_4}
                                onChange={(val) => setAttributes({df_enable_divide_bottom_4 : val})}
                            />
                            {df_enable_divide_bottom_4 &&
                            <>
                                <RadioControl
                                    label={__('Choose', 'df-sidebar-gutenberg')}
                                    selected={divide_bottom_4}
                                    className={'df-radio-control-divide-bottom'}
                                    onChange={(val) => setAttributes({divide_bottom_4: val})}
                                    options={bubiOptionsDivideBottom}
                                />
                                <h6 className="df-inspector bubi-not-background">{ __('Color', 'bubiblock-slider')}
                                { df_color_divide_bottom_4&&
                                    <ColorIndicator
                                        colorValue={ df_color_divide_bottom_4 }
                                    />
                                }
                                </h6>
                                <ColorPicker
                                    color={df_color_divide_bottom_4}
                                    onChangeComplete={(newval) => setAttributes({df_color_divide_bottom_4: ('rgba(' + newval.rgb.r + ', ' + newval.rgb.g + ', ' + newval.rgb.b + ', ' + newval.rgb.a + ')') })}
                                />
                                <ButtonGroup
                                    className={'df-button-group bubiblock-no-margin'}
                                >
                                    <div class="df-group-button-resp">
                                        <div class="bubi-col-6">
                                            <h6>{ __('Height', 'bubiblock-slider')}</h6>
                                        </div>
                                        <div class="bubi-col-6">
                                            <Button
                                                icon={'laptop'}
                                                isSecondary
                                                className={'df-resp-button'}
                                                isPrimary={df_resp == 'desktop'} onClick={() => setAttributes({ df_resp: 'desktop' })}
                                            >
                                            </Button>
                                            <Button
                                                icon={'tablet'}
                                                isSecondary
                                                className={'df-resp-button'}
                                                isPrimary={df_resp == 'table'} onClick={() => setAttributes({ df_resp: 'table' })}
                                            >
                                            </Button>
                                            <Button
                                                icon={'smartphone'}
                                                isSecondary
                                                className={'df-resp-button'}
                                                isPrimary={df_resp == 'mobile'} onClick={() => setAttributes({ df_resp: 'mobile' })}
                                            >
                                            </Button>
                                        </div>
                                    </div>
                                    {(df_resp=='desktop' ) &&
                                        <RangeControl
                                            label={__("Height(Desktop)","bubiblock-slider")}
                                            help={__('Px Unit','bubiblock-slider')}
                                            value={ df_height_divide_bottom_4 }
                                            onChange={(val) => setAttributes({df_height_divide_bottom_4: val})}
                                            min={20}
                                            max={1000}
                                        />
                                    }
                                    {(df_resp=='table' ) &&
                                        <RangeControl
                                            label={__("Height(Table)","bubiblock-slider")}
                                            help={__('Px Unit','bubiblock-slider')}
                                            value={ df_height_table_divide_bottom_4 }
                                            onChange={(val) => setAttributes({df_height_table_divide_bottom_4: val})}
                                            min={20}
                                            max={1000}
                                        />
                                    }
                                    {(df_resp=='mobile' ) &&
                                        <RangeControl
                                            label={__("Height(Mobile)","bubiblock-slider")}
                                            help={__('Px Unit','bubiblock-slider')}
                                            value={ df_height_mobile_divide_bottom_4}
                                            onChange={(val) => setAttributes({df_height_mobile_divide_bottom_4: val})}
                                            min={20}
                                            max={1000}
                                        />
                                    }
                                </ButtonGroup>
                                <RangeControl
                                    label={__('Delayed appearance','bubiblock-slider')}
                                    help={__('S Unit. In the Safari Browser this transition is not supported!','bubiblock-slider')}
                                    beforeIcon={'arrow-down-alt'}
                                    afterIcon={'arrow-up-alt'}
                                    allowReset
                                    resetFallbackValue={3}
                                    step={1}
                                    withInputField={false}
                                    separatorType="none"
                                    trackColor="#007cba"
                                    isShiftStepEnabled
                                    marks={[
                                        {
                                            value: 0,
                                            label: __('0','bubiblock-slider'),
                                        },
                                        {
                                            value: 5,
                                            label: __('5','bubiblock-slider'),
                                        },
                                        {
                                            value: 10,
                                            label: __('10','bubiblock-slider'),
                                        },
                                        {
                                            value: 15,
                                            label: __('15','bubiblock-slider'),
                                        },
                                        {
                                            value: 20,
                                            label: __('20','bubiblock-slider'),
                                        },
                                        {
                                            value: 25,
                                            label: __('25','bubiblock-slider'),
                                        },
                                        {
                                            value: 30,
                                            label: __('30','bubiblock-slider'),
                                        },
                                    ]}
                                    railColor="#02abff"
                                    value={ bubiblock_dalay_divide_4_bottom }
                                    onChange={(val) => setAttributes({bubiblock_dalay_divide_4_bottom: val})}
                                    min={ 0 }
                                    max={ 30}
                                />
                            </>
                            }
                            {title4 &&
                            <>
                                <h6 class="df-inspector">{ __('Title', 'bubiblock-slider')}</h6>
                                <ButtonGroup
                                    className={'df-button-group bubiblock-no-margin'}
                                >
                                    <div class="df-group-button-resp">
                                        <div class="bubi-col-6">
                                            <h6>{ __('Choose', 'bubiblock-slider')}</h6>
                                        </div>
                                        <div class="bubi-col-6">
                                            <Button
                                                icon={'laptop'}
                                                isSecondary
                                                className={'df-resp-button'}
                                                isPrimary={df_resp == 'desktop'} onClick={() => setAttributes({ df_resp: 'desktop' })}
                                            >
                                            </Button>
                                            <Button
                                                icon={'tablet'}
                                                isSecondary
                                                className={'df-resp-button'}
                                                isPrimary={df_resp == 'table'} onClick={() => setAttributes({ df_resp: 'table' })}
                                            >
                                            </Button>
                                            <Button
                                                icon={'smartphone'}
                                                isSecondary
                                                className={'df-resp-button'}
                                                isPrimary={df_resp == 'mobile'} onClick={() => setAttributes({ df_resp: 'mobile' })}
                                            >
                                            </Button>
                                        </div>
                                    </div>
                                    {(df_resp=='desktop') &&
                                        <RangeControl
                                            label={__('Margin','bubiblock-slider')}
                                            help={__('px Unit','bubiblock-slider')}
                                            beforeIcon={'arrow-down-alt'}
                                            afterIcon={'arrow-up-alt'}
                                            allowReset
                                            resetFallbackValue={35}
                                            step={1}
                                            withInputField={false}
                                            separatorType="none"
                                            trackColor="#007cba"
                                            isShiftStepEnabled
                                            marks={[
                                                {
                                                    value: -100,
                                                    label: __('-100','bubiblock-slider'),
                                                },
                                                {
                                                    value: 0,
                                                    label: __('0','bubiblock-slider'),
                                                },
                                                {
                                                    value: 100,
                                                    label: __('100','bubiblock-slider'),
                                                },
                                                {
                                                    value: 200,
                                                    label: __('200','bubiblock-slider'),
                                                },
                                                {
                                                    value: 300,
                                                    label: __('300','bubiblock-slider'),
                                                },
                                            ]}
                                            railColor="#02abff"
                                            value={ margin_bottom_caption4}
                                            onChange={(val) => setAttributes({margin_bottom_caption4: val})}
                                            min={ -100 }
                                            max={ 300}
                                        />
                                    }
                                    {(df_resp=='table') &&
                                        <RangeControl
                                            label={__('Margin','bubiblock-slider')}
                                            help={__('px Unit','bubiblock-slider')}
                                            beforeIcon={'arrow-down-alt'}
                                            afterIcon={'arrow-up-alt'}
                                            allowReset
                                            resetFallbackValue={25}
                                            step={1}
                                            withInputField={false}
                                            separatorType="none"
                                            trackColor="#007cba"
                                            isShiftStepEnabled
                                            marks={[
                                                {
                                                    value: -50,
                                                    label: __('-50','bubiblock-slider'),
                                                },
                                                {
                                                    value: 0,
                                                    label: __('0','bubiblock-slider'),
                                                },
                                                {
                                                    value: 50,
                                                    label: __('50','bubiblock-slider'),
                                                },
                                                {
                                                    value: 100,
                                                    label: __('100','bubiblock-slider'),
                                                },
                                                {
                                                    value: 150,
                                                    label: __('150','bubiblock-slider'),
                                                },
                                                {
                                                    value: 200,
                                                    label: __('200','bubiblock-slider'),
                                                },
                                            ]}
                                            railColor="#02abff"
                                            value={ margin_bottom_table_caption4 }
                                            onChange={(val) => setAttributes({margin_bottom_table_caption4: val})}
                                            min={ -50 }
                                            max={ 200}
                                        />
                                    }
                                    {(df_resp=='mobile') &&
                                        <RangeControl
                                            label={__('Margin','bubiblock-slider')}
                                            help={__('px Unit','bubiblock-slider')}
                                            beforeIcon={'arrow-down-alt'}
                                            afterIcon={'arrow-up-alt'}
                                            allowReset
                                            resetFallbackValue={15}
                                            step={1}
                                            withInputField={false}
                                            separatorType="none"
                                            trackColor="#007cba"
                                            isShiftStepEnabled
                                            marks={[
                                                {
                                                    value: -50,
                                                    label: __('-50','bubiblock-slider'),
                                                },
                                                {
                                                    value: 0,
                                                    label: __('0','bubiblock-slider'),
                                                },
                                                {
                                                    value: 50,
                                                    label: __('50','bubiblock-slider'),
                                                },
                                                {
                                                    value: 100,
                                                    label: __('100','bubiblock-slider'),
                                                },
                                                {
                                                    value: 150,
                                                    label: __('150','bubiblock-slider'),
                                                },
                                                {
                                                    value: 200,
                                                    label: __('200','bubiblock-slider'),
                                                },
                                            ]}
                                            railColor="#02abff"
                                            value={ margin_bottom_mobile_caption4 }
                                            onChange={(val) => setAttributes({ margin_bottom_mobile_caption4: val})}
                                            min={ -50 }
                                            max={ 200}
                                        />
                                    }
                                    {(df_resp=='desktop') &&
                                        <FontSizePicker
                                            className={'bubiblock-slider-inspectorcontrols'}
                                            value={fontsizetitle4}
                                            onChange={(val) => setAttributes({fontsizetitle4: val})}
                                            fontSizes={[
                                                { name: __('None', 'bubiblock-slider'), slug: 'none', size: 0 },
                                                { name: __('Small', 'bubiblock-slider'), slug: 'small', size: 22 },
                                                { name: __('Medium', 'bubiblock-slider'), slug: 'medium', size:32 },
                                                { name: __('Large', 'bubiblock-slider'), slug: 'large', size: 52 },
                                                { name: __('Big', 'bubiblock-slider'), slug: 'large', size: 82 },
                                            ]}
                                            withSlider={true}
                                        />
                                        }
                                    {(df_resp=='table') &&
                                        <FontSizePicker
                                            value={fontsizetitle4table}
                                            onChange={(val) => setAttributes({fontsizetitle4table: val})}
                                            fontSizes={[
                                                { name: __('None', 'bubiblock-slider'), slug: 'none', size: 0 },
                                                { name: __('Small', 'bubiblock-slider'), slug: 'small', size: 22 },
                                                { name: __('Medium', 'bubiblock-slider'), slug: 'medium', size:32 },
                                                { name: __('Large', 'bubiblock-slider'), slug: 'large', size: 52 },
                                                { name: __('Big', 'bubiblock-slider'), slug: 'large', size: 82 },
                                            ]}
                                            withSlider={true}
                                        />
                                    }
                                    {(df_resp=='mobile') &&
                                        <FontSizePicker
                                            value={fontsizetitle4mobile}
                                            onChange={(val) => setAttributes({fontsizetitle4mobile: val})}
                                            fontSizes={[
                                                { name: __('None', 'bubiblock-slider'), slug: 'none', size: 0 },
                                                { name: __('Small', 'bubiblock-slider'), slug: 'small', size: 22 },
                                                { name: __('Medium', 'bubiblock-slider'), slug: 'medium', size:32 },
                                                { name: __('Large', 'bubiblock-slider'), slug: 'large', size: 52 },
                                                { name: __('Big', 'bubiblock-slider'), slug: 'large', size: 82 },
                                            ]}
                                            withSlider={true}
                                        />
                                    }
                                </ButtonGroup>
                                <RadioControl
                                    label={__('Align','bubiblock-slider')}
                                    selected={ alignment_title4 }
                                    options={ [
                                        { label: 'Left', value: 'left' },
                                        { label: 'Center', value: 'center' },
                                        { label: 'Right', value: 'right' },
                                    ] }
                                    onChange={ ( newAlign ) => setAttributes( { alignment_title4: newAlign } ) }
                                />
                                <SelectControl
                                    label={__("Effect","bubiblock-slider")}
                                    options={bubiOptionsEffectAnimate}
                                    onChange={(val) => setAttributes({ effectcaption4: val})}
                                    value={effectcaption4}
                                />
                                <SelectControl
                                    label={__("Effect speed","bubiblock-slider")}
                                    options={bubiOptionEffectSpeed}
                                    onChange={(val) => setAttributes({ df_speed_effectcaption4: val})}
                                    value={df_speed_effectcaption4}
                                />
                                <SelectControl
                                    label={__("Effect delay","bubiblock-slider")}
                                    options={bubiOptionEffectDalay}
                                    onChange={(val) => setAttributes({ df_delay_effectcaption4: val})}
                                    value={df_delay_effectcaption4}
                                />
                                <SelectControl
                                    label={__("Effect repeat","bubiblock-slider")}
                                    options={bubiOptionEffectRepeat}
                                    onChange={(val) => setAttributes({ df_repeat_effectcaption4: val})}
                                    value={df_repeat_effectcaption4}
                                />
                            </>
                            }
                            {info4 &&
                            <>
                                <h6 class="df-inspector">{ __('Info', 'bubiblock-slider')}</h6>
                                <ButtonGroup
                                    className={'df-button-group bubiblock-no-margin'}
                                >
                                    <div class="df-group-button-resp">
                                        <div class="bubi-col-6">
                                            <h6>{ __('Choose', 'bubiblock-slider')}</h6>
                                        </div>
                                        <div class="bubi-col-6">
                                            <Button
                                                icon={'laptop'}
                                                isSecondary
                                                className={'df-resp-button'}
                                                isPrimary={df_resp == 'desktop'} onClick={() => setAttributes({ df_resp: 'desktop' })}
                                            >
                                            </Button>
                                            <Button
                                                icon={'tablet'}
                                                isSecondary
                                                className={'df-resp-button'}
                                                isPrimary={df_resp == 'table'} onClick={() => setAttributes({ df_resp: 'table' })}
                                            >
                                            </Button>
                                            <Button
                                                icon={'smartphone'}
                                                isSecondary
                                                className={'df-resp-button'}
                                                isPrimary={df_resp == 'mobile'} onClick={() => setAttributes({ df_resp: 'mobile' })}
                                            >
                                            </Button>
                                        </div>
                                    </div>
                                    {(df_resp=='desktop') &&
                                        <RangeControl
                                            label={__('Margin','bubiblock-slider')}
                                            help={__('px Unit','bubiblock-slider')}
                                            beforeIcon={'arrow-down-alt'}
                                            afterIcon={'arrow-up-alt'}
                                            allowReset
                                            resetFallbackValue={40}
                                            step={1}
                                            withInputField={false}
                                            separatorType="none"
                                            trackColor="#007cba"
                                            isShiftStepEnabled
                                            marks={[
                                                {
                                                    value: -100,
                                                    label: __('-100','bubiblock-slider'),
                                                },
                                                {
                                                    value: 0,
                                                    label: __('0','bubiblock-slider'),
                                                },
                                                {
                                                    value: 100,
                                                    label: __('100','bubiblock-slider'),
                                                },
                                                {
                                                    value: 200,
                                                    label: __('200','bubiblock-slider'),
                                                },
                                                {
                                                    value: 300,
                                                    label: __('300','bubiblock-slider'),
                                                },
                                            ]}
                                            railColor="#02abff"
                                            value={ margin_bottom_info4 }
                                            onChange={(val) => setAttributes({ margin_bottom_info4: val})}
                                            min={ -100 }
                                            max={ 300}
                                        />
                                    }
                                    {(df_resp=='table') &&
                                        <RangeControl
                                            label={__('Margin','bubiblock-slider')}
                                            help={__('px Unit','bubiblock-slider')}
                                            beforeIcon={'arrow-down-alt'}
                                            afterIcon={'arrow-up-alt'}
                                            allowReset
                                            resetFallbackValue={30}
                                            step={1}
                                            withInputField={false}
                                            separatorType="none"
                                            trackColor="#007cba"
                                            isShiftStepEnabled
                                            marks={[
                                                {
                                                    value: -50,
                                                    label: __('-50','bubiblock-slider'),
                                                },
                                                {
                                                    value: 0,
                                                    label: __('0','bubiblock-slider'),
                                                },
                                                {
                                                    value: 50,
                                                    label: __('50','bubiblock-slider'),
                                                },
                                                {
                                                    value: 100,
                                                    label: __('100','bubiblock-slider'),
                                                },
                                                {
                                                    value: 150,
                                                    label: __('150','bubiblock-slider'),
                                                },
                                                {
                                                    value: 200,
                                                    label: __('200','bubiblock-slider'),
                                                },
                                            ]}
                                            railColor="#02abff"
                                            value={ margin_bottom_table_info4 }
                                            onChange={(val) => setAttributes({ margin_bottom_table_info4 : val})}
                                            min={ -50 }
                                            max={ 200}
                                        />
                                    }
                                    {(df_resp=='mobile') &&
                                        <RangeControl
                                            label={__('Margin','bubiblock-slider')}
                                            help={__('px Unit','bubiblock-slider')}
                                            beforeIcon={'arrow-down-alt'}
                                            afterIcon={'arrow-up-alt'}
                                            allowReset
                                            resetFallbackValue={10}
                                            step={1}
                                            withInputField={false}
                                            separatorType="none"
                                            trackColor="#007cba"
                                            isShiftStepEnabled
                                            marks={[
                                                {
                                                    value: -50,
                                                    label: __('-50','bubiblock-slider'),
                                                },
                                                {
                                                    value: 0,
                                                    label: __('0','bubiblock-slider'),
                                                },
                                                {
                                                    value: 50,
                                                    label: __('50','bubiblock-slider'),
                                                },
                                                {
                                                    value: 100,
                                                    label: __('100','bubiblock-slider'),
                                                },
                                                {
                                                    value: 150,
                                                    label: __('150','bubiblock-slider'),
                                                },
                                                {
                                                    value: 200,
                                                    label: __('200','bubiblock-slider'),
                                                },
                                            ]}
                                            railColor="#02abff"
                                            value={ margin_bottom_mobile_info4 }
                                            onChange={(val) => setAttributes({ margin_bottom_mobile_info4 : val})}
                                            min={ -50 }
                                            max={ 200}
                                        />
                                    }
                                    {(df_resp=='desktop') &&
                                        <FontSizePicker
                                            value={fontsizeinfo4}
                                            onChange={(val) => setAttributes({fontsizeinfo4: val})}
                                            fontSizes={[
                                                { name: __('None', 'bubiblock-slider'), slug: 'none', size: 0 },
                                                { name: __('Small', 'bubiblock-slider'), slug: 'small', size: 18 },
                                                { name: __('Medium', 'bubiblock-slider'), slug: 'medium', size:24 },
                                                { name: __('Large', 'bubiblock-slider'), slug: 'large', size: 32 },
                                                { name: __('Big', 'bubiblock-slider'), slug: 'large', size: 52 },
                                            ]}
                                            withSlider={true}
                                        />
                                        }
                                    {(df_resp=='table') &&
                                        <FontSizePicker
                                            value={fontsizeinfo4table}
                                            onChange={(val) => setAttributes({fontsizeinfo4table: val})}
                                            fontSizes={[
                                                { name: __('None', 'bubiblock-slider'), slug: 'none', size: 0 },
                                                { name: __('Small', 'bubiblock-slider'), slug: 'small', size: 18 },
                                                { name: __('Medium', 'bubiblock-slider'), slug: 'medium', size:24 },
                                                { name: __('Large', 'bubiblock-slider'), slug: 'large', size: 32 },
                                                { name: __('Big', 'bubiblock-slider'), slug: 'large', size: 52 },
                                            ]}
                                            withSlider={true}
                                        />
                                    }
                                    {(df_resp=='mobile') &&
                                        <FontSizePicker
                                            value={fontsizeinfo4mobile}
                                            onChange={(val) => setAttributes({fontsizeinfo4mobile: val})}
                                            fontSizes={[
                                                { name: __('None', 'bubiblock-slider'), slug: 'none', size: 0 },
                                                { name: __('Small', 'bubiblock-slider'), slug: 'small', size: 18 },
                                                { name: __('Medium', 'bubiblock-slider'), slug: 'medium', size:24 },
                                                { name: __('Large', 'bubiblock-slider'), slug: 'large', size: 32 },
                                                { name: __('Big', 'bubiblock-slider'), slug: 'large', size: 52 },
                                            ]}
                                            withSlider={true}
                                        />
                                    }
                                </ButtonGroup>
                                <RadioControl
                                    label={__('Align','bubiblock-slider')}
                                    selected={ alignment_info4 }
                                    options={ [
                                        { label: 'Left', value: 'left' },
                                        { label: 'Center', value: 'center' },
                                        { label: 'Right', value: 'right' },
                                    ] }
                                    onChange={ ( newAlign ) => setAttributes( { alignment_info4: newAlign } ) }
                                />
                                <SelectControl
                                    label={__("Effect","bubiblock-slider")}
                                    options={bubiOptionsEffectAnimate}
                                    onChange={(val) => setAttributes({ effectinfo4 : val})}
                                    value={effectinfo4}
                                />
                                <SelectControl
                                    label={__("Effect speed","bubiblock-slider")}
                                    options={bubiOptionEffectSpeed}
                                    onChange={(val) => setAttributes({ df_speed_effectinfo4 : val})}
                                    value={df_speed_effectinfo4}
                                />
                                <SelectControl
                                    label={__("Effect delay","bubiblock-slider")}
                                    options={bubiOptionEffectDalay}
                                    onChange={(val) => setAttributes({ df_delay_effectinfo4 : val})}
                                    value={df_delay_effectinfo4}
                                />
                                <SelectControl
                                    label={__("Effect repeat","bubiblock-slider")}
                                    options={bubiOptionEffectRepeat}
                                    onChange={(val) => setAttributes({ df_repeat_effectinfo4 : val})}
                                    value={df_repeat_effectinfo4}
                                />
                            </>
                            }
                            {button4 &&
                            <>
                                <h6 class="df-inspector">{ __('Button', 'bubiblock-slider')}</h6>
                                <ButtonGroup
                                    className={'df-button-group bubiblock-no-margin'}
                                >
                                    <div class="df-group-button-resp">
                                        <div class="bubi-col-6">
                                            <h6>{ __('Choose', 'bubiblock-slider')}</h6>
                                        </div>
                                        <div class="bubi-col-6">
                                            <Button
                                                icon={'laptop'}
                                                isSecondary
                                                className={'df-resp-button'}
                                                isPrimary={df_resp == 'desktop'} onClick={() => setAttributes({ df_resp: 'desktop' })}
                                            >
                                            </Button>
                                            <Button
                                                icon={'tablet'}
                                                isSecondary
                                                className={'df-resp-button'}
                                                isPrimary={df_resp == 'table'} onClick={() => setAttributes({ df_resp: 'table' })}
                                            >
                                            </Button>
                                            <Button
                                                icon={'smartphone'}
                                                isSecondary
                                                className={'df-resp-button'}
                                                isPrimary={df_resp == 'mobile'} onClick={() => setAttributes({ df_resp: 'mobile' })}
                                            >
                                            </Button>
                                        </div>
                                    </div>
                                    {(df_resp=='desktop') &&
                                        <RangeControl
                                            label={__('Margin','bubiblock-slider')}
                                            help={__('px Unit','bubiblock-slider')}
                                            beforeIcon={'arrow-down-alt'}
                                            afterIcon={'arrow-up-alt'}
                                            allowReset
                                            resetFallbackValue={5}
                                            step={1}
                                            withInputField={false}
                                            separatorType="none"
                                            trackColor="#007cba"
                                            isShiftStepEnabled
                                            marks={[
                                                {
                                                    value: -100,
                                                    label: __('-100','bubiblock-slider'),
                                                },
                                                {
                                                    value: 0,
                                                    label: __('0','bubiblock-slider'),
                                                },
                                                {
                                                    value: 100,
                                                    label: __('100','bubiblock-slider'),
                                                },
                                                {
                                                    value: 200,
                                                    label: __('200','bubiblock-slider'),
                                                },
                                                {
                                                    value: 300,
                                                    label: __('300','bubiblock-slider'),
                                                },
                                            ]}
                                            railColor="#02abff"
                                            value={ margin_bottom_button4 }
                                            onChange={(val) => setAttributes({ margin_bottom_button4 : val})}
                                            min={ -100 }
                                            max={ 300}
                                        />
                                    }
                                    {(df_resp=='table') &&
                                        <RangeControl
                                            label={__('Margin','bubiblock-slider')}
                                            help={__('px Unit','bubiblock-slider')}
                                            beforeIcon={'arrow-down-alt'}
                                            afterIcon={'arrow-up-alt'}
                                            allowReset
                                            resetFallbackValue={5}
                                            step={1}
                                            withInputField={false}
                                            separatorType="none"
                                            trackColor="#007cba"
                                            isShiftStepEnabled
                                            marks={[
                                                {
                                                    value: -50,
                                                    label: __('-50','bubiblock-slider'),
                                                },
                                                {
                                                    value: 0,
                                                    label: __('0','bubiblock-slider'),
                                                },
                                                {
                                                    value: 50,
                                                    label: __('50','bubiblock-slider'),
                                                },
                                                {
                                                    value: 100,
                                                    label: __('100','bubiblock-slider'),
                                                },
                                                {
                                                    value: 150,
                                                    label: __('150','bubiblock-slider'),
                                                },
                                                {
                                                    value: 200,
                                                    label: __('200','bubiblock-slider'),
                                                },
                                            ]}
                                            railColor="#02abff"
                                            value={ margin_bottom_table_button4 }
                                            onChange={(val) => setAttributes({ margin_bottom_table_button4 : val})}
                                            min={ -50 }
                                            max={ 200}
                                        />
                                    }
                                    {(df_resp=='mobile') &&
                                        <RangeControl
                                            label={__('Margin','bubiblock-slider')}
                                            help={__('px Unit','bubiblock-slider')}
                                            beforeIcon={'arrow-down-alt'}
                                            afterIcon={'arrow-up-alt'}
                                            allowReset
                                            resetFallbackValue={5}
                                            step={1}
                                            withInputField={false}
                                            separatorType="none"
                                            trackColor="#007cba"
                                            isShiftStepEnabled
                                            marks={[
                                                {
                                                    value: -50,
                                                    label: __('-50','bubiblock-slider'),
                                                },
                                                {
                                                    value: 0,
                                                    label: __('0','bubiblock-slider'),
                                                },
                                                {
                                                    value: 50,
                                                    label: __('50','bubiblock-slider'),
                                                },
                                                {
                                                    value: 100,
                                                    label: __('100','bubiblock-slider'),
                                                },
                                                {
                                                    value: 150,
                                                    label: __('150','bubiblock-slider'),
                                                },
                                                {
                                                    value: 200,
                                                    label: __('200','bubiblock-slider'),
                                                },
                                            ]}
                                            railColor="#02abff"
                                            value={ margin_bottom_mobile_button4 }
                                            onChange={(val) => setAttributes({ margin_bottom_mobile_button4 : val})}
                                            min={ -50 }
                                            max={ 200}
                                        />
                                    }
                                    {(df_resp=='desktop') &&
                                        <FontSizePicker
                                            value={fontsizebutton4}
                                            onChange={(val) => setAttributes({fontsizebutton4: val})}
                                            fontSizes={[
                                                { name: __('Small', 'bubiblock-slider'), slug: 'small', size: 18 },
                                                { name: __('Medium', 'bubiblock-slider'), slug: 'medium', size:24 },
                                                { name: __('Large', 'bubiblock-slider'), slug: 'large', size: 32 },
                                                { name: __('Big', 'bubiblock-slider'), slug: 'large', size: 52 },
                                            ]}
                                            withSlider={true}
                                    />
                                        }
                                    {(df_resp=='table')  &&
                                        <FontSizePicker
                                            value={fontsizebutton4table}
                                            onChange={(val) => setAttributes({fontsizebutton4table: val})}
                                            fontSizes={[
                                                { name: __('Small', 'bubiblock-slider'), slug: 'small', size: 18 },
                                                { name: __('Medium', 'bubiblock-slider'), slug: 'medium', size:24 },
                                                { name: __('Large', 'bubiblock-slider'), slug: 'large', size: 32 },
                                                { name: __('Big', 'bubiblock-slider'), slug: 'large', size: 52 },
                                            ]}
                                            withSlider={true}
                                        />
                                    }
                                    {(df_resp=='mobile')  &&
                                        <FontSizePicker
                                            value={fontsizebutton4mobile}
                                            onChange={(val) => setAttributes({fontsizebutton4mobile: val})}
                                            fontSizes={[
                                                { name: __('Small', 'bubiblock-slider'), slug: 'small', size: 18 },
                                                { name: __('Medium', 'bubiblock-slider'), slug: 'medium', size:24 },
                                                { name: __('Large', 'bubiblock-slider'), slug: 'large', size: 32 },
                                                { name: __('Big', 'bubiblock-slider'), slug: 'large', size: 52 },
                                            ]}
                                            withSlider={true}
                                        />
                                    }
                                </ButtonGroup>
                                <RadioControl
                                    label={__('Align','bubiblock-slider')}
                                    selected={ alignment_button4 }
                                    options={ [
                                        { label: 'Left', value: 'left' },
                                        { label: 'Center', value: 'center' },
                                        { label: 'Right', value: 'right' },
                                    ] }
                                    onChange={ ( newAlign ) => setAttributes( { alignment_button4: newAlign } ) }
                                />
                                <SelectControl
                                    label={__("Effect","bubiblock-slider")}
                                    options={bubiOptionsEffectAnimate}
                                    onChange={(val) => setAttributes({ effectbutton4 : val})}
                                    value={effectbutton4}
                                />
                                <SelectControl
                                    label={__("Effect speed","bubiblock-slider")}
                                    options={bubiOptionEffectSpeed}
                                    onChange={(val) => setAttributes({ df_speed_effectbutton4 : val})}
                                    value={df_speed_effectbutton4}
                                />
                                <SelectControl
                                    label={__("Effect delay","bubiblock-slider")}
                                    options={bubiOptionEffectDalay}
                                    onChange={(val) => setAttributes({ df_delay_effectbutton4 : val})}
                                    value={df_delay_effectbutton4}
                                />
                                <SelectControl
                                    label={__("Effect repeat","bubiblock-slider")}
                                    options={bubiOptionEffectRepeat}
                                    onChange={(val) => setAttributes({ df_repeat_effectbutton4 : val})}
                                    value={df_repeat_effectbutton4}
                                />
                                <RangeControl
                                    label={__('Padding top/bottom','bubiblock-slider')}
                                    help={__('px Unit','bubiblock-slider')}
                                    beforeIcon={'arrow-down-alt'}
                                    afterIcon={'arrow-up-alt'}
                                    allowReset
                                    resetFallbackValue={8}
                                    step={1}
                                    withInputField={false}
                                    separatorType="none"
                                    trackColor="#007cba"
                                    isShiftStepEnabled
                                    marks={[
                                        {
                                            value: 0,
                                            label: __('0','bubiblock-slider'),
                                        },
                                        {
                                            value: 10,
                                            label: __('10','bubiblock-slider'),
                                        },
                                        {
                                            value: 20,
                                            label: __('20','bubiblock-slider'),
                                        },
                                        {
                                            value: 30,
                                            label: __('30','bubiblock-slider'),
                                        },
                                        {
                                            value: 40,
                                            label: __('40','bubiblock-slider'),
                                        },
                                        {
                                            value: 50,
                                            label: __('50','bubiblock-slider'),
                                        },
                                    ]}
                                    railColor="#02abff"
                                    value={ padding_link_button4 }
                                    onChange={(val) => setAttributes({ padding_link_button4: val })}
                                    min={ 0 }
                                    max={ 50}
                                />
                                <RangeControl
                                    label={__('Padding left/right','bubiblock-slider')}
                                    help={__('px Unit','bubiblock-slider')}
                                    beforeIcon={'arrow-left-alt'}
                                    afterIcon={'arrow-right-alt'}
                                    allowReset
                                    resetFallbackValue={20}
                                    step={1}
                                    withInputField={false}
                                    separatorType="none"
                                    trackColor="#007cba"
                                    isShiftStepEnabled
                                    marks={[
                                        {
                                            value: 0,
                                            label: __('0','bubiblock-slider'),
                                        },
                                        {
                                            value: 10,
                                            label: __('10','bubiblock-slider'),
                                        },
                                        {
                                            value: 20,
                                            label: __('20','bubiblock-slider'),
                                        },
                                        {
                                            value: 30,
                                            label: __('30','bubiblock-slider'),
                                        },
                                        {
                                            value: 40,
                                            label: __('40','bubiblock-slider'),
                                        },
                                        {
                                            value: 50,
                                            label: __('50','bubiblock-slider'),
                                        },
                                    ]}
                                    railColor="#02abff"
                                    value={ padding_right_link_button4 }
                                    onChange={(val) => setAttributes({ padding_right_link_button4: val })}
                                    min={ 0 }
                                    max={ 50}
                                />
                                <RangeControl
                                    label={__('Border solid','bubiblock-slider')}
                                    help={__('Px Unit','bubiblock-slider')}
                                    beforeIcon={'star-empty'}
                                    afterIcon={'star-filled'}
                                    allowReset
                                    resetFallbackValue={0}
                                    step={1}
                                    withInputField={false}
                                    separatorType="none"
                                    trackColor="#007cba"
                                    isShiftStepEnabled
                                    marks={[
                                        {
                                            value: 0,
                                            label: __('0','bubiblock-slider'),
                                        },
                                        {
                                            value: 10,
                                            label: __('10','bubiblock-slider'),
                                        },
                                        {
                                            value: 20,
                                            label: __('20','bubiblock-slider'),
                                        },
                                        {
                                            value: 30,
                                            label: __('30','bubiblock-slider'),
                                        },
                                        {
                                            value: 40,
                                            label: __('40','bubiblock-slider'),
                                        },
                                        {
                                            value: 50,
                                            label: __('50','bubiblock-slider'),
                                        },
                                    ]}
                                    railColor="#02abff"
                                    value={ border_size_link_button4 }
                                    onChange={(val) => setAttributes({ border_size_link_button4: val })}
                                    min={ 0 }
                                    max={ 50}
                                />
                                <RangeControl
                                    label={__('Border top left radius','bubiblock-slider')}
                                    help={__('% Unit','bubiblock-slider')}
                                    beforeIcon={'fullscreen-alt'}
                                    afterIcon={'fullscreen-exit-alt'}
                                    allowReset
                                    resetFallbackValue={0}
                                    step={1}
                                    withInputField={false}
                                    separatorType="none"
                                    trackColor="#007cba"
                                    isShiftStepEnabled
                                    marks={[
                                        {
                                            value: 0,
                                            label: __('0','bubiblock-slider'),
                                        },
                                        {
                                            value: 10,
                                            label: __('10','bubiblock-slider'),
                                        },
                                        {
                                            value: 20,
                                            label: __('20','bubiblock-slider'),
                                        },
                                        {
                                            value: 30,
                                            label: __('30','bubiblock-slider'),
                                        },
                                        {
                                            value: 40,
                                            label: __('40','bubiblock-slider'),
                                        },
                                        {
                                            value: 50,
                                            label: __('50','bubiblock-slider'),
                                        },
                                    ]}
                                    railColor="#02abff"
                                    value={ border_radius_top_left_link_button4 }
                                    onChange={(val) => setAttributes({ border_radius_top_left_link_button4: val })}
                                    min={ 0 }
                                    max={ 50}
                                />
                                <RangeControl
                                    label={__('Border top right radius','bubiblock-slider')}
                                    help={__('% Unit','bubiblock-slider')}
                                    beforeIcon={'fullscreen-alt'}
                                    afterIcon={'fullscreen-exit-alt'}
                                    allowReset
                                    resetFallbackValue={0}
                                    step={1}
                                    withInputField={false}
                                    separatorType="none"
                                    trackColor="#007cba"
                                    isShiftStepEnabled
                                    marks={[
                                        {
                                            value: 0,
                                            label: __('0','bubiblock-slider'),
                                        },
                                        {
                                            value: 10,
                                            label: __('10','bubiblock-slider'),
                                        },
                                        {
                                            value: 20,
                                            label: __('20','bubiblock-slider'),
                                        },
                                        {
                                            value: 30,
                                            label: __('30','bubiblock-slider'),
                                        },
                                        {
                                            value: 40,
                                            label: __('40','bubiblock-slider'),
                                        },
                                        {
                                            value: 50,
                                            label: __('50','bubiblock-slider'),
                                        },
                                    ]}
                                    railColor="#02abff"
                                    value={ border_radius_top_right_link_button4 }
                                    onChange={(val) => setAttributes({ border_radius_top_right_link_button4: val })}
                                    min={ 0 }
                                    max={ 50}
                                />
                                <RangeControl
                                    label={__('Border bottom left radius','bubiblock-slider')}
                                    help={__('% Unit','bubiblock-slider')}
                                    beforeIcon={'fullscreen-alt'}
                                    afterIcon={'fullscreen-exit-alt'}
                                    allowReset
                                    resetFallbackValue={0}
                                    step={1}
                                    withInputField={false}
                                    separatorType="none"
                                    trackColor="#007cba"
                                    isShiftStepEnabled
                                    marks={[
                                        {
                                            value: 0,
                                            label: __('0','bubiblock-slider'),
                                        },
                                        {
                                            value: 10,
                                            label: __('10','bubiblock-slider'),
                                        },
                                        {
                                            value: 20,
                                            label: __('20','bubiblock-slider'),
                                        },
                                        {
                                            value: 30,
                                            label: __('30','bubiblock-slider'),
                                        },
                                        {
                                            value: 40,
                                            label: __('40','bubiblock-slider'),
                                        },
                                        {
                                            value: 50,
                                            label: __('50','bubiblock-slider'),
                                        },
                                    ]}
                                    railColor="#02abff"
                                    value={ border_radius_bottom_left_link_button4 }
                                    onChange={(val) => setAttributes({ border_radius_bottom_left_link_button4: val })}
                                    min={ 0 }
                                    max={ 50}
                                />
                                <RangeControl
                                    label={__('Border bottom right radius','bubiblock-slider')}
                                    help={__('% Unit','bubiblock-slider')}
                                    beforeIcon={'fullscreen-alt'}
                                    afterIcon={'fullscreen-exit-alt'}
                                    allowReset
                                    resetFallbackValue={0}
                                    step={1}
                                    withInputField={false}
                                    separatorType="none"
                                    trackColor="#007cba"
                                    isShiftStepEnabled
                                    marks={[
                                        {
                                            value: 0,
                                            label: __('0','bubiblock-slider'),
                                        },
                                        {
                                            value: 10,
                                            label: __('10','bubiblock-slider'),
                                        },
                                        {
                                            value: 20,
                                            label: __('20','bubiblock-slider'),
                                        },
                                        {
                                            value: 30,
                                            label: __('30','bubiblock-slider'),
                                        },
                                        {
                                            value: 40,
                                            label: __('40','bubiblock-slider'),
                                        },
                                        {
                                            value: 50,
                                            label: __('50','bubiblock-slider'),
                                        },
                                    ]}
                                    railColor="#02abff"
                                    value={ border_radius_bottom_right_link_button4 }
                                    onChange={(val) => setAttributes({ border_radius_bottom_right_link_button4: val })}
                                    min={ 0 }
                                    max={ 50}
                                />
                                <h6 id={'bg'} class="df-inspector" >{ __('Background Color', 'bubiblock-slider')}
                                {(df_background_color_transparent_link_button4 == 'df-trasparent-color-button4-false') &&
                                    <>
                                    {df_background_color_link_button4 &&
                                        <ColorIndicator
                                            colorValue={ df_background_color_link_button4 }
                                        />
                                    }
                                    </>
                                }
                                {df_background_color_hover_link_button4 &&
                                    <ColorIndicator
                                        colorValue={ df_background_color_hover_link_button4 }
                                    />
                                }
                                </h6>
                                {(df_background_color_transparent_link_button4 == 'df-trasparent-color-button4-false') &&
                                    <div class={'legend-color-none'}>
                                        <ColorPaletteControl
                                            value={ df_background_color_link_button4 }
                                            colors={ bubiColors }
                                            onChange={ (newValue) => setAttributes({df_background_color_link_button4 : newValue}) }
                                        />
                                    </div>
                                }
                                <p className={"df-inspector bubi-mt-1"}>{__('Hover','bubiblock-slider')}</p>
                                <div class={'legend-color-none'}>
                                    <ColorPaletteControl
                                        value={ df_background_color_hover_link_button4}
                                        colors={ bubiColors }
                                        onChange={ (newValue) => setAttributes({df_background_color_hover_link_button4 : newValue}) }
                                    />
                                </div>
                                <h6 className="df-inspector">{ __('Color', 'bubiblock-slider')}
                                {df_color_link_button4 &&
                                    <ColorIndicator
                                        colorValue={ df_color_link_button4 }
                                    />
                                }
                                {df_color_hover_link_button4 &&
                                    <ColorIndicator
                                        colorValue={ df_color_hover_link_button4 }
                                    />
                                }
                                {df_border_color_link_button4 &&
                                    <ColorIndicator
                                        colorValue={ df_border_color_link_button4 }
                                    />
                                }
                                </h6>
                                <div class={'legend-color-none'}>
                                    <p className="df-inspector">{__('Color','bubiblock-slider')}</p>
                                    <ColorPaletteControl
                                        value={ df_color_link_button4}
                                        colors={ bubiColors }
                                        onChange={ (newValue) => setAttributes({df_color_link_button4: newValue}) }
                                    />
                                    <p className="df-inspector">{__('Color hover','bubiblock-slider')}</p>
                                    <ColorPaletteControl
                                        value={ df_color_hover_link_button4}
                                        colors={ bubiColors }
                                        onChange={ (newValue) => setAttributes({df_color_hover_link_button4: newValue}) }
                                    />
                                    <p className="df-inspector">{__('Border Color','bubiblock-slider')}</p>
                                    <ColorPaletteControl
                                        value={ df_border_color_link_button4}
                                        colors={ bubiColors }
                                        onChange={ (newValue) => setAttributes({df_border_color_link_button4: newValue}) }
                                    />
                                </div>
                                <ButtonGroup
                                    className={'df-button-group bubiblock-no-margin'}
                                >
                                    <h6 className="df-inspector">{ __('Background color transparent', 'bubiblock-slider')}</h6>
                                    <div class="bubi-width-two">
                                    <Button
                                        isSecondary
                                        isPrimary={df_background_color_transparent_link_button4 == 'df-trasparent-color-button4-true'} onClick={() => setAttributes({ df_background_color_transparent_link_button4: 'df-trasparent-color-button4-true' })}
                                    >
                                        {__('True','bubiblock-slider')}
                                    </Button>
                                    <Button
                                        isSecondary
                                        isPrimary={df_background_color_transparent_link_button4 == 'df-trasparent-color-button4-false'} onClick={() => setAttributes({ df_background_color_transparent_link_button4: 'df-trasparent-color-button4-false' })}
                                    >
                                        {__('False','bubiblock-slider')}
                                    </Button>
                                    </div>
                                </ButtonGroup>
                            </>
                            }
                            </PanelBody>
                            <Panel
                                className={'bubiblock-add-slider'}
                            >
                                <ToggleControl
                                    label={__( 'Add Slides','bubiblock-slider' ) }
                                    help={__('Important: if you want to remove this slider make sure you are with the carousel on the first or second slider!','bubiblock-slider')}
                                    checked={bubiblock_add_slider_5}
                                    onChange={(val) => setAttributes({ bubiblock_add_slider_5: val })}
                                />
                            </Panel>
                        </>
                    }
                    {bubiblock_add_slider_5 &&
                        <>
                        <PanelBody // Slider 5
                            icon={'format-image'}
                            title={__('Slides 5', 'bubiblock-slider')}
                            initialOpen={false}
                            >
                            <h6 className="df-inspector bubi-mt-1">{ __('Background type', 'bubiblock-slider')}</h6>
                            <div class="bubi-width-three bubibutton-icon">
                                <ButtonGroup
                                    className={'df-button-group bubiblock-no-margin'}
                                >
                                    <Tooltip
                                        text= {__('Color','bubiblock-slider')}
                                    >
                                        <Button
                                            isPrimary={df_slider_chose_5 == 'df-slider-color-5'}
                                            icon="admin-appearance"
                                            onClick={() => setAttributes({ df_slider_chose_5: 'df-slider-color-5' })}
                                        >
                                        </Button>
                                    </Tooltip>
                                    <Tooltip
                                        text=  {__('Image','bubiblock-slider')}
                                    >
                                        <Button
                                            isPrimary={df_slider_chose_5 == 'df-slider-image-5'}
                                            icon="format-image"
                                            onClick={() => setAttributes({ df_slider_chose_5: 'df-slider-image-5' })}
                                        >
                                        </Button>
                                    </Tooltip>
                                </ButtonGroup>
                            </div>
                            {(df_slider_chose_5=='df-slider-image-5' ) &&
                                <>
                                    {imageUrl_5?
                                        <>
                                        <img src={imageUrl_5} className={'bubi-mt-2'}/>
                                        {isBlobURL(imageUrl_5) && <Spinner />}
                                        </>
                                        :
                                        <MediaPlaceholder
                                            className={'bubi-mt-2 bubi-mb-2'}
                                            icon="format-image df-icon-img-upload"
                                            onSelect={ media => { setAttributes({ imageAlt_5: media.alt, imageUrl_5: media.url }); } }
                                            onSelectURL={ this.onSelectURL5 }
                                            onError={this.onUploadError5}
                                            accept="image/*"
                                            allowedTypes={['image']}
                                            notices={ noticeUI5 }
                                        />
                                    }
                                    {imageUrl_5 &&
                                    <>
                                        <MenuItem
                                            icon={ 'trash' }
                                            className={'df-remov-img'}
                                            onClick={ this.removeImage5 }
                                        >
                                            { __('Remove Image','bubiblock-slider') }
                                        </MenuItem>
                                        <TextareaControl
                                            label={__('Alt Text (Alternative Text)','bubiblock-slider')}
                                            value={ alt5}
                                            onChange={ this.updateAlt5 }
                                            help={__('Alternative text describes your image to people who cant see it. Add a short description with its key details.','bubiblock-slider')}
                                        />
                                        <SelectControl
                                            label={__("Dispaly Size","bubiblock-slider")}
                                            options={[
                                                {label: __('None','bubiblock-slider'), value: 'none'},
                                                {label: __('Containe','bubiblock-slider'), value: 'contain'},
                                                {label: __('Cover','bubiblock-slider'), value: 'cover'},
                                                {label: __('Fill','bubiblock-slider'), value: 'fill'},
                                                {label: __('Scale down','bubiblock-slider'), value: 'scale-down'},
                                                {label: __('Unset','bubiblock-slider'), value: 'unset'},
                                            ]}
                                            onChange={(val) => setAttributes({ df_cover_img5: val })}
                                            value={df_cover_img5}
                                        />
                                        {(df_cover_img5=='none')&&
                                        <>
                                            <RangeControl
                                                label={__('Display Position','bubiblock-slider')}
                                                help={__('% Unit','bubiblock-slider')}
                                                beforeIcon={'arrow-left-alt'}
                                                afterIcon={'arrow-right-alt'}
                                                allowReset
                                                resetFallbackValue={50}
                                                step={1}
                                                withInputField={false}
                                                separatorType="none"
                                                trackColor="#007cba"
                                                isShiftStepEnabled
                                                marks={[
                                                    {
                                                        value: 0,
                                                        label: __('0','bubiblock-slider'),
                                                    },
                                                    {
                                                        value: 20,
                                                        label: __('20','bubiblock-slider'),
                                                    },
                                                    {
                                                        value: 40,
                                                        label: __('40','bubiblock-slider'),
                                                    },
                                                    {
                                                        value: 60,
                                                        label: __('60','bubiblock-slider'),
                                                    },
                                                    {
                                                        value: 80,
                                                        label: __('80','bubiblock-slider'),
                                                    },
                                                    {
                                                        value: 100,
                                                        label: __('100','bubiblock-slider'),
                                                    },
                                                ]}
                                                railColor="#02abff"
                                                value={ df_focalPoint_img_5 }
                                                onChange={(val) => setAttributes({ df_focalPoint_img_5: val })}
                                                min={ 0 }
                                                max={ 100}
                                            />
                                            <RangeControl
                                                label={__('Display Position','bubiblock-slider')}
                                                help={__('% Unit','bubiblock-slider')}
                                                beforeIcon={'arrow-down-alt'}
                                                afterIcon={'arrow-up-alt'}
                                                allowReset
                                                resetFallbackValue={50}
                                                step={1}
                                                withInputField={false}
                                                separatorType="none"
                                                trackColor="#007cba"
                                                isShiftStepEnabled
                                                marks={[
                                                    {
                                                        value: 0,
                                                        label: __('0','bubiblock-slider'),
                                                    },
                                                    {
                                                        value: 20,
                                                        label: __('20','bubiblock-slider'),
                                                    },
                                                    {
                                                        value: 40,
                                                        label: __('40','bubiblock-slider'),
                                                    },
                                                    {
                                                        value: 60,
                                                        label: __('60','bubiblock-slider'),
                                                    },
                                                    {
                                                        value: 80,
                                                        label: __('80','bubiblock-slider'),
                                                    },
                                                    {
                                                        value: 100,
                                                        label: __('100','bubiblock-slider'),
                                                    },
                                                ]}
                                                railColor="#02abff"
                                                value={ df_focalPoint_y_img_5 }
                                                onChange={(val) => setAttributes({ df_focalPoint_y_img_5: val })}
                                                min={ 0 }
                                                max={ 100}
                                            />
                                            </>
                                        }
                                        <ToggleControl
                                            label={ __( 'Show mask','bubiblock-slider' ) }
                                            checked={df_mask_slider_5}
                                            onChange={(val) => setAttributes({ df_mask_slider_5: val })}
                                        />
                                        {df_mask_slider_5 &&
                                            <>
                                            <Notice
                                                status="info"
                                                isDismissible={ false }
                                            >
                                                {__('If you have set the border radius for the slider this control will not work well!','bubiblock-slider')}
                                            </Notice>
                                            <ColorGradientControl
                                                colorValue={ background_color_solid_mask_5 }
                                                gradientValue={ background_color_gradient_mask_5 }
                                                colors={ bubiColors }
                                                gradients={ bubiGradients }
                                                onColorChange={ (newValue) => setAttributes({ background_color_solid_mask_5: newValue }) }
                                                onGradientChange={ (newValue) => setAttributes({ background_color_gradient_mask_5: newValue }) }
                                            />
                                            <RangeControl
                                                label={__('Opacity','bubiblock-slider')}
                                                beforeIcon={'hidden'}
                                                afterIcon={'visibility'}
                                                allowReset
                                                resetFallbackValue={.4}
                                                step={.1}
                                                withInputField={false}
                                                separatorType="none"
                                                trackColor="#007cba"
                                                isShiftStepEnabled
                                                marks={[
                                                    {
                                                        value: 0,
                                                        label: __('0','bubiblock-slider'),
                                                    },
                                                    {
                                                        value: 0.2,
                                                        label: __('2','bubiblock-slider'),
                                                    },
                                                    {
                                                        value: 0.4,
                                                        label: __('4','bubiblock-slider'),
                                                    },
                                                    {
                                                        value: 0.6,
                                                        label: __('6','bubiblock-slider'),
                                                    },
                                                    {
                                                        value: 0.8,
                                                        label: __('8','bubiblock-slider'),
                                                    },
                                                    {
                                                        value: 1.0,
                                                        label: __('10','bubiblock-slider'),
                                                    },
                                                ]}
                                                railColor="#02abff"
                                                value={ df_opacity_mask_5 }
                                                onChange={(val) => setAttributes({ df_opacity_mask_5: val })}
                                                min={ .0 }
                                                max={ 1.0}
                                            />
                                        </>
                                        }
                                        <TextControl
                                            label={__('Link Image','bubiblock-slider')}
                                            value={ bubiblock_link_slider_5 }
                                            onChange={ (newValue) => setAttributes({bubiblock_link_slider_5: newValue}) }
                                            type="url"
                                        />
                                        {bubiblock_link_slider_5 &&
                                            <ButtonGroup
                                                    className={'df-button-group bubiblock-no-margin bubi-mb-2'}
                                                >
                                                    <p className="df-inspector bubi-mt-1">{ __('Open in new tab', 'bubiblock-slider')}</p>
                                                    <div class="bubi-width-two">
                                                    <Button
                                                        isSecondary
                                                        isPrimary={bubiblock_link_tab_slider_5 == '_blank'} onClick={() => setAttributes({ bubiblock_link_tab_slider_5: '_blank' })}
                                                    >
                                                        {__('True','bubiblock-slider')}
                                                    </Button>
                                                    <Button
                                                        isSecondary
                                                        isPrimary={bubiblock_link_tab_slider_5 == ''} onClick={() => setAttributes({ bubiblock_link_tab_slider_5: '' })}
                                                    >
                                                        {__('False','bubiblock-slider')}
                                                    </Button>
                                                    </div>
                                            </ButtonGroup>
                                        }
                                    </>
                                    }
                                </>
                            }
                            {(df_slider_chose_5=='df-slider-color-5' ) &&
                                <>
                                <h6 className="df-inspector bubi-not-background">{ __('Background Color', 'bubiblock-slider')}
                                {df_background_color_slider_5 &&
                                    <ColorIndicator
                                        colorValue={ df_background_color_slider_5 }
                                    />
                                }
                                </h6>
                                <div class={'legend-color-none'}>
                                    <ColorPaletteControl
                                        value={ df_background_color_slider_5}
                                        colors={ bubiColors }
                                        onChange={ (newValue) => setAttributes({df_background_color_slider_5 : newValue}) }
                                    />
                                </div>
                                </>
                            }
                            <ToggleControl
                                label={ __( 'Dividers Top','bubiblock-slider' ) }
                                checked={df_enable_divide_5}
                                onChange={ (newValue) => setAttributes({df_enable_divide_5: newValue}) }
                            />
                            {df_enable_divide_5 &&
                            <>
                                <RadioControl
                                    label={__('Choose', 'df-sidebar-gutenberg')}
                                    selected={divide_5}
                                    className={'bubiblock-radio-image'}
                                    onChange={(val) => setAttributes({divide_5: val})}
                                    options={bubiOptionsDivideTop}
                                />
                                <h6 className="df-inspector bubi-not-background">{ __('Color', 'bubiblock-slider')}
                                { df_color_divide_5 &&
                                    <ColorIndicator
                                        colorValue={ df_color_divide_5 }
                                    />
                                }
                                </h6>
                                <ColorPicker
                                    color={df_color_divide_5}
                                    onChangeComplete={(newval) => setAttributes({df_color_divide_5: ('rgba(' + newval.rgb.r + ', ' + newval.rgb.g + ', ' + newval.rgb.b + ', ' + newval.rgb.a + ')') })}
                                />
                                <ButtonGroup
                                    className={'df-button-group bubiblock-no-margin'}
                                >
                                    <div class="df-group-button-resp">
                                        <div class="bubi-col-6">
                                            <h6>{ __('Height', 'bubiblock-slider')}</h6>
                                        </div>
                                        <div class="bubi-col-6">
                                            <Button
                                                icon={'laptop'}
                                                isSecondary
                                                className={'df-resp-button'}
                                                isPrimary={df_resp == 'desktop'} onClick={() => setAttributes({ df_resp: 'desktop' })}
                                            >
                                            </Button>
                                            <Button
                                                icon={'tablet'}
                                                isSecondary
                                                className={'df-resp-button'}
                                                isPrimary={df_resp == 'table'} onClick={() => setAttributes({ df_resp: 'table' })}
                                            >
                                            </Button>
                                            <Button
                                                icon={'smartphone'}
                                                isSecondary
                                                className={'df-resp-button'}
                                                isPrimary={df_resp == 'mobile'} onClick={() => setAttributes({ df_resp: 'mobile' })}
                                            >
                                            </Button>
                                        </div>
                                    </div>
                                    {(df_resp=='desktop' ) &&
                                        <RangeControl
                                            label={__("Height(Desktop)","bubiblock-slider")}
                                            help={__('Px Unit','bubiblock-slider')}
                                            value={ df_height_divide_5 }
                                            onChange={(val) => setAttributes({df_height_divide_5: val})}
                                            min={20}
                                            max={1000}
                                        />
                                    }
                                    {(df_resp=='table' ) &&
                                        <RangeControl
                                            label={__("Height(Table)","bubiblock-slider")}
                                            help={__('Px Unit','bubiblock-slider')}
                                            value={ df_height_table_divide_5 }
                                            onChange={(val) => setAttributes({df_height_table_divide_5: val})}
                                            min={20}
                                            max={1000}
                                        />
                                    }
                                    {(df_resp=='mobile' ) &&
                                        <RangeControl
                                            label={__("Height(Mobile)","bubiblock-slider")}
                                            help={__('Px Unit','bubiblock-slider')}
                                            value={ df_height_mobile_divide_5 }
                                            onChange={(val) => setAttributes({df_height_mobile_divide_5 : val})}
                                            min={20}
                                            max={1000}
                                        />
                                    }
                                </ButtonGroup>
                                <RangeControl
                                    label={__('Delayed appearance','bubiblock-slider')}
                                    help={__('S Unit. In the Safari Browser this transition is not supported!','bubiblock-slider')}
                                    beforeIcon={'arrow-down-alt'}
                                    afterIcon={'arrow-up-alt'}
                                    allowReset
                                    resetFallbackValue={3}
                                    step={1}
                                    withInputField={false}
                                    separatorType="none"
                                    trackColor="#007cba"
                                    isShiftStepEnabled
                                    marks={[
                                        {
                                            value: 0,
                                            label: __('0','bubiblock-slider'),
                                        },
                                        {
                                            value: 5,
                                            label: __('5','bubiblock-slider'),
                                        },
                                        {
                                            value: 10,
                                            label: __('10','bubiblock-slider'),
                                        },
                                        {
                                            value: 15,
                                            label: __('15','bubiblock-slider'),
                                        },
                                        {
                                            value: 20,
                                            label: __('20','bubiblock-slider'),
                                        },
                                        {
                                            value: 25,
                                            label: __('25','bubiblock-slider'),
                                        },
                                        {
                                            value: 30,
                                            label: __('30','bubiblock-slider'),
                                        },
                                    ]}
                                    railColor="#02abff"
                                    value={ bubiblock_dalay_divide_5 }
                                    onChange={(val) => setAttributes({bubiblock_dalay_divide_5 : val})}
                                    min={ 0 }
                                    max={ 30}
                                />
                            </>
                            }
                            <ToggleControl
                                label={ __( 'Dividers Bottom','bubiblock-slider' ) }
                                checked={df_enable_divide_bottom_5}
                                onChange={(val) => setAttributes({df_enable_divide_bottom_5 : val})}
                            />
                            {df_enable_divide_bottom_5 &&
                            <>
                                <RadioControl
                                    label={__('Choose', 'df-sidebar-gutenberg')}
                                    selected={divide_bottom_5}
                                    className={'df-radio-control-divide-bottom'}
                                    onChange={(val) => setAttributes({divide_bottom_5: val})}
                                    options={bubiOptionsDivideBottom}
                                />
                                <h6 className="df-inspector bubi-not-background">{ __('Color', 'bubiblock-slider')}
                                { df_color_divide_bottom_5&&
                                    <ColorIndicator
                                        colorValue={ df_color_divide_bottom_5 }
                                    />
                                }
                                </h6>
                                <ColorPicker
                                    color={df_color_divide_bottom_5}
                                    onChangeComplete={(newval) => setAttributes({df_color_divide_bottom_5: ('rgba(' + newval.rgb.r + ', ' + newval.rgb.g + ', ' + newval.rgb.b + ', ' + newval.rgb.a + ')') })}
                                />
                                <ButtonGroup
                                    className={'df-button-group bubiblock-no-margin'}
                                >
                                    <div class="df-group-button-resp">
                                        <div class="bubi-col-6">
                                            <h6>{ __('Height', 'bubiblock-slider')}</h6>
                                        </div>
                                        <div class="bubi-col-6">
                                            <Button
                                                icon={'laptop'}
                                                isSecondary
                                                className={'df-resp-button'}
                                                isPrimary={df_resp == 'desktop'} onClick={() => setAttributes({ df_resp: 'desktop' })}
                                            >
                                            </Button>
                                            <Button
                                                icon={'tablet'}
                                                isSecondary
                                                className={'df-resp-button'}
                                                isPrimary={df_resp == 'table'} onClick={() => setAttributes({ df_resp: 'table' })}
                                            >
                                            </Button>
                                            <Button
                                                icon={'smartphone'}
                                                isSecondary
                                                className={'df-resp-button'}
                                                isPrimary={df_resp == 'mobile'} onClick={() => setAttributes({ df_resp: 'mobile' })}
                                            >
                                            </Button>
                                        </div>
                                    </div>
                                    {(df_resp=='desktop' ) &&
                                        <RangeControl
                                            label={__("Height(Desktop)","bubiblock-slider")}
                                            help={__('Px Unit','bubiblock-slider')}
                                            value={ df_height_divide_bottom_5 }
                                            onChange={(val) => setAttributes({df_height_divide_bottom_5: val})}
                                            min={20}
                                            max={1000}
                                        />
                                    }
                                    {(df_resp=='table' ) &&
                                        <RangeControl
                                            label={__("Height(Table)","bubiblock-slider")}
                                            help={__('Px Unit','bubiblock-slider')}
                                            value={ df_height_table_divide_bottom_5 }
                                            onChange={(val) => setAttributes({df_height_table_divide_bottom_5: val})}
                                            min={20}
                                            max={1000}
                                        />
                                    }
                                    {(df_resp=='mobile' ) &&
                                        <RangeControl
                                            label={__("Height(Mobile)","bubiblock-slider")}
                                            help={__('Px Unit','bubiblock-slider')}
                                            value={ df_height_mobile_divide_bottom_5}
                                            onChange={(val) => setAttributes({df_height_mobile_divide_bottom_5: val})}
                                            min={20}
                                            max={1000}
                                        />
                                    }
                                </ButtonGroup>
                                <RangeControl
                                    label={__('Delayed appearance','bubiblock-slider')}
                                    help={__('S Unit. In the Safari Browser this transition is not supported!','bubiblock-slider')}
                                    beforeIcon={'arrow-down-alt'}
                                    afterIcon={'arrow-up-alt'}
                                    allowReset
                                    resetFallbackValue={3}
                                    step={1}
                                    withInputField={false}
                                    separatorType="none"
                                    trackColor="#007cba"
                                    isShiftStepEnabled
                                    marks={[
                                        {
                                            value: 0,
                                            label: __('0','bubiblock-slider'),
                                        },
                                        {
                                            value: 5,
                                            label: __('5','bubiblock-slider'),
                                        },
                                        {
                                            value: 10,
                                            label: __('10','bubiblock-slider'),
                                        },
                                        {
                                            value: 15,
                                            label: __('15','bubiblock-slider'),
                                        },
                                        {
                                            value: 20,
                                            label: __('20','bubiblock-slider'),
                                        },
                                        {
                                            value: 25,
                                            label: __('25','bubiblock-slider'),
                                        },
                                        {
                                            value: 30,
                                            label: __('30','bubiblock-slider'),
                                        },
                                    ]}
                                    railColor="#02abff"
                                    value={ bubiblock_dalay_divide_5_bottom }
                                    onChange={(val) => setAttributes({bubiblock_dalay_divide_5_bottom: val})}
                                    min={ 0 }
                                    max={ 30}
                                />
                            </>
                            }
                            {title5 &&
                            <>
                                <h6 class="df-inspector">{ __('Title', 'bubiblock-slider')}</h6>
                                <ButtonGroup
                                    className={'df-button-group bubiblock-no-margin'}
                                >
                                    <div class="df-group-button-resp">
                                        <div class="bubi-col-6">
                                            <h6>{ __('Choose', 'bubiblock-slider')}</h6>
                                        </div>
                                        <div class="bubi-col-6">
                                            <Button
                                                icon={'laptop'}
                                                isSecondary
                                                className={'df-resp-button'}
                                                isPrimary={df_resp == 'desktop'} onClick={() => setAttributes({ df_resp: 'desktop' })}
                                            >
                                            </Button>
                                            <Button
                                                icon={'tablet'}
                                                isSecondary
                                                className={'df-resp-button'}
                                                isPrimary={df_resp == 'table'} onClick={() => setAttributes({ df_resp: 'table' })}
                                            >
                                            </Button>
                                            <Button
                                                icon={'smartphone'}
                                                isSecondary
                                                className={'df-resp-button'}
                                                isPrimary={df_resp == 'mobile'} onClick={() => setAttributes({ df_resp: 'mobile' })}
                                            >
                                            </Button>
                                        </div>
                                    </div>
                                    {(df_resp=='desktop') &&
                                        <RangeControl
                                            label={__('Margin','bubiblock-slider')}
                                            help={__('px Unit','bubiblock-slider')}
                                            beforeIcon={'arrow-down-alt'}
                                            afterIcon={'arrow-up-alt'}
                                            allowReset
                                            resetFallbackValue={35}
                                            step={1}
                                            withInputField={false}
                                            separatorType="none"
                                            trackColor="#007cba"
                                            isShiftStepEnabled
                                            marks={[
                                                {
                                                    value: -100,
                                                    label: __('-100','bubiblock-slider'),
                                                },
                                                {
                                                    value: 0,
                                                    label: __('0','bubiblock-slider'),
                                                },
                                                {
                                                    value: 100,
                                                    label: __('100','bubiblock-slider'),
                                                },
                                                {
                                                    value: 200,
                                                    label: __('200','bubiblock-slider'),
                                                },
                                                {
                                                    value: 300,
                                                    label: __('300','bubiblock-slider'),
                                                },
                                            ]}
                                            railColor="#02abff"
                                            value={ margin_bottom_caption5}
                                            onChange={(val) => setAttributes({margin_bottom_caption5: val})}
                                            min={ -100 }
                                            max={ 300}
                                        />
                                    }
                                    {(df_resp=='table') &&
                                        <RangeControl
                                            label={__('Margin','bubiblock-slider')}
                                            help={__('px Unit','bubiblock-slider')}
                                            beforeIcon={'arrow-down-alt'}
                                            afterIcon={'arrow-up-alt'}
                                            allowReset
                                            resetFallbackValue={25}
                                            step={1}
                                            withInputField={false}
                                            separatorType="none"
                                            trackColor="#007cba"
                                            isShiftStepEnabled
                                            marks={[
                                                {
                                                    value: -50,
                                                    label: __('-50','bubiblock-slider'),
                                                },
                                                {
                                                    value: 0,
                                                    label: __('0','bubiblock-slider'),
                                                },
                                                {
                                                    value: 50,
                                                    label: __('50','bubiblock-slider'),
                                                },
                                                {
                                                    value: 100,
                                                    label: __('100','bubiblock-slider'),
                                                },
                                                {
                                                    value: 150,
                                                    label: __('150','bubiblock-slider'),
                                                },
                                                {
                                                    value: 200,
                                                    label: __('200','bubiblock-slider'),
                                                },
                                            ]}
                                            railColor="#02abff"
                                            value={ margin_bottom_table_caption5 }
                                            onChange={(val) => setAttributes({margin_bottom_table_caption5: val})}
                                            min={ -50 }
                                            max={ 200}
                                        />
                                    }
                                    {(df_resp=='mobile') &&
                                        <RangeControl
                                            label={__('Margin','bubiblock-slider')}
                                            help={__('px Unit','bubiblock-slider')}
                                            beforeIcon={'arrow-down-alt'}
                                            afterIcon={'arrow-up-alt'}
                                            allowReset
                                            resetFallbackValue={15}
                                            step={1}
                                            withInputField={false}
                                            separatorType="none"
                                            trackColor="#007cba"
                                            isShiftStepEnabled
                                            marks={[
                                                {
                                                    value: -50,
                                                    label: __('-50','bubiblock-slider'),
                                                },
                                                {
                                                    value: 0,
                                                    label: __('0','bubiblock-slider'),
                                                },
                                                {
                                                    value: 50,
                                                    label: __('50','bubiblock-slider'),
                                                },
                                                {
                                                    value: 100,
                                                    label: __('100','bubiblock-slider'),
                                                },
                                                {
                                                    value: 150,
                                                    label: __('150','bubiblock-slider'),
                                                },
                                                {
                                                    value: 200,
                                                    label: __('200','bubiblock-slider'),
                                                },
                                            ]}
                                            railColor="#02abff"
                                            value={ margin_bottom_mobile_caption5 }
                                            onChange={(val) => setAttributes({ margin_bottom_mobile_caption5: val})}
                                            min={ -50 }
                                            max={ 200}
                                        />
                                    }
                                    {(df_resp=='desktop') &&
                                        <FontSizePicker
                                            className={'bubiblock-slider-inspectorcontrols'}
                                            value={fontsizetitle5}
                                            onChange={(val) => setAttributes({fontsizetitle5: val})}
                                            fontSizes={[
                                                { name: __('None', 'bubiblock-slider'), slug: 'none', size: 0 },
                                                { name: __('Small', 'bubiblock-slider'), slug: 'small', size: 22 },
                                                { name: __('Medium', 'bubiblock-slider'), slug: 'medium', size:32 },
                                                { name: __('Large', 'bubiblock-slider'), slug: 'large', size: 52 },
                                                { name: __('Big', 'bubiblock-slider'), slug: 'large', size: 82 },
                                            ]}
                                            withSlider={true}
                                        />
                                        }
                                    {(df_resp=='table') &&
                                        <FontSizePicker
                                            value={fontsizetitle5table}
                                            onChange={(val) => setAttributes({fontsizetitle5table: val})}
                                            fontSizes={[
                                                { name: __('None', 'bubiblock-slider'), slug: 'none', size: 0 },
                                                { name: __('Small', 'bubiblock-slider'), slug: 'small', size: 22 },
                                                { name: __('Medium', 'bubiblock-slider'), slug: 'medium', size:32 },
                                                { name: __('Large', 'bubiblock-slider'), slug: 'large', size: 52 },
                                                { name: __('Big', 'bubiblock-slider'), slug: 'large', size: 82 },
                                            ]}
                                            withSlider={true}
                                        />
                                    }
                                    {(df_resp=='mobile') &&
                                        <FontSizePicker
                                            value={fontsizetitle5mobile}
                                            onChange={(val) => setAttributes({fontsizetitle5mobile: val})}
                                            fontSizes={[
                                                { name: __('None', 'bubiblock-slider'), slug: 'none', size: 0 },
                                                { name: __('Small', 'bubiblock-slider'), slug: 'small', size: 22 },
                                                { name: __('Medium', 'bubiblock-slider'), slug: 'medium', size:32 },
                                                { name: __('Large', 'bubiblock-slider'), slug: 'large', size: 52 },
                                                { name: __('Big', 'bubiblock-slider'), slug: 'large', size: 82 },
                                            ]}
                                            withSlider={true}
                                        />
                                    }
                                </ButtonGroup>
                                <RadioControl
                                    label={__('Align','bubiblock-slider')}
                                    selected={ alignment_title5 }
                                    options={ [
                                        { label: 'Left', value: 'left' },
                                        { label: 'Center', value: 'center' },
                                        { label: 'Right', value: 'right' },
                                    ] }
                                    onChange={ ( newAlign ) => setAttributes( { alignment_title5: newAlign } ) }
                                />
                                <SelectControl
                                    label={__("Effect","bubiblock-slider")}
                                    options={bubiOptionsEffectAnimate}
                                    onChange={(val) => setAttributes({ effectcaption5: val})}
                                    value={effectcaption5}
                                />
                                <SelectControl
                                    label={__("Effect speed","bubiblock-slider")}
                                    options={bubiOptionEffectSpeed}
                                    onChange={(val) => setAttributes({ df_speed_effectcaption5: val})}
                                    value={df_speed_effectcaption5}
                                />
                                <SelectControl
                                    label={__("Effect delay","bubiblock-slider")}
                                    options={bubiOptionEffectDalay}
                                    onChange={(val) => setAttributes({ df_delay_effectcaption5: val})}
                                    value={df_delay_effectcaption5}
                                />
                                <SelectControl
                                    label={__("Effect repeat","bubiblock-slider")}
                                    options={bubiOptionEffectRepeat}
                                    onChange={(val) => setAttributes({ df_repeat_effectcaption5: val})}
                                    value={df_repeat_effectcaption5}
                                />
                            </>
                            }
                            {info5 &&
                            <>
                                <h6 class="df-inspector">{ __('Info', 'bubiblock-slider')}</h6>
                                <ButtonGroup
                                    className={'df-button-group bubiblock-no-margin'}
                                >
                                    <div class="df-group-button-resp">
                                        <div class="bubi-col-6">
                                            <h6>{ __('Choose', 'bubiblock-slider')}</h6>
                                        </div>
                                        <div class="bubi-col-6">
                                            <Button
                                                icon={'laptop'}
                                                isSecondary
                                                className={'df-resp-button'}
                                                isPrimary={df_resp == 'desktop'} onClick={() => setAttributes({ df_resp: 'desktop' })}
                                            >
                                            </Button>
                                            <Button
                                                icon={'tablet'}
                                                isSecondary
                                                className={'df-resp-button'}
                                                isPrimary={df_resp == 'table'} onClick={() => setAttributes({ df_resp: 'table' })}
                                            >
                                            </Button>
                                            <Button
                                                icon={'smartphone'}
                                                isSecondary
                                                className={'df-resp-button'}
                                                isPrimary={df_resp == 'mobile'} onClick={() => setAttributes({ df_resp: 'mobile' })}
                                            >
                                            </Button>
                                        </div>
                                    </div>
                                    {(df_resp=='desktop') &&
                                        <RangeControl
                                            label={__('Margin','bubiblock-slider')}
                                            help={__('px Unit','bubiblock-slider')}
                                            beforeIcon={'arrow-down-alt'}
                                            afterIcon={'arrow-up-alt'}
                                            allowReset
                                            resetFallbackValue={40}
                                            step={1}
                                            withInputField={false}
                                            separatorType="none"
                                            trackColor="#007cba"
                                            isShiftStepEnabled
                                            marks={[
                                                {
                                                    value: -100,
                                                    label: __('-100','bubiblock-slider'),
                                                },
                                                {
                                                    value: 0,
                                                    label: __('0','bubiblock-slider'),
                                                },
                                                {
                                                    value: 100,
                                                    label: __('100','bubiblock-slider'),
                                                },
                                                {
                                                    value: 200,
                                                    label: __('200','bubiblock-slider'),
                                                },
                                                {
                                                    value: 300,
                                                    label: __('300','bubiblock-slider'),
                                                },
                                            ]}
                                            railColor="#02abff"
                                            value={ margin_bottom_info5 }
                                            onChange={(val) => setAttributes({ margin_bottom_info5: val})}
                                            min={ -100 }
                                            max={ 300}
                                        />
                                    }
                                    {(df_resp=='table') &&
                                        <RangeControl
                                            label={__('Margin','bubiblock-slider')}
                                            help={__('px Unit','bubiblock-slider')}
                                            beforeIcon={'arrow-down-alt'}
                                            afterIcon={'arrow-up-alt'}
                                            allowReset
                                            resetFallbackValue={30}
                                            step={1}
                                            withInputField={false}
                                            separatorType="none"
                                            trackColor="#007cba"
                                            isShiftStepEnabled
                                            marks={[
                                                {
                                                    value: -50,
                                                    label: __('-50','bubiblock-slider'),
                                                },
                                                {
                                                    value: 0,
                                                    label: __('0','bubiblock-slider'),
                                                },
                                                {
                                                    value: 50,
                                                    label: __('50','bubiblock-slider'),
                                                },
                                                {
                                                    value: 100,
                                                    label: __('100','bubiblock-slider'),
                                                },
                                                {
                                                    value: 150,
                                                    label: __('150','bubiblock-slider'),
                                                },
                                                {
                                                    value: 200,
                                                    label: __('200','bubiblock-slider'),
                                                },
                                            ]}
                                            railColor="#02abff"
                                            value={ margin_bottom_table_info5 }
                                            onChange={(val) => setAttributes({ margin_bottom_table_info5 : val})}
                                            min={ -50 }
                                            max={ 200}
                                        />
                                    }
                                    {(df_resp=='mobile') &&
                                        <RangeControl
                                            label={__('Margin','bubiblock-slider')}
                                            help={__('px Unit','bubiblock-slider')}
                                            beforeIcon={'arrow-down-alt'}
                                            afterIcon={'arrow-up-alt'}
                                            allowReset
                                            resetFallbackValue={10}
                                            step={1}
                                            withInputField={false}
                                            separatorType="none"
                                            trackColor="#007cba"
                                            isShiftStepEnabled
                                            marks={[
                                                {
                                                    value: -50,
                                                    label: __('-50','bubiblock-slider'),
                                                },
                                                {
                                                    value: 0,
                                                    label: __('0','bubiblock-slider'),
                                                },
                                                {
                                                    value: 50,
                                                    label: __('50','bubiblock-slider'),
                                                },
                                                {
                                                    value: 100,
                                                    label: __('100','bubiblock-slider'),
                                                },
                                                {
                                                    value: 150,
                                                    label: __('150','bubiblock-slider'),
                                                },
                                                {
                                                    value: 200,
                                                    label: __('200','bubiblock-slider'),
                                                },
                                            ]}
                                            railColor="#02abff"
                                            value={ margin_bottom_mobile_info5 }
                                            onChange={(val) => setAttributes({ margin_bottom_mobile_info5 : val})}
                                            min={ -50 }
                                            max={ 200}
                                        />
                                    }
                                    {(df_resp=='desktop') &&
                                        <FontSizePicker
                                            value={fontsizeinfo5}
                                            onChange={(val) => setAttributes({fontsizeinfo5: val})}
                                            fontSizes={[
                                                { name: __('None', 'bubiblock-slider'), slug: 'none', size: 0 },
                                                { name: __('Small', 'bubiblock-slider'), slug: 'small', size: 18 },
                                                { name: __('Medium', 'bubiblock-slider'), slug: 'medium', size:24 },
                                                { name: __('Large', 'bubiblock-slider'), slug: 'large', size: 32 },
                                                { name: __('Big', 'bubiblock-slider'), slug: 'large', size: 52 },
                                            ]}
                                            withSlider={true}
                                        />
                                        }
                                    {(df_resp=='table') &&
                                        <FontSizePicker
                                            value={fontsizeinfo5table}
                                            onChange={(val) => setAttributes({fontsizeinfo5table: val})}
                                            fontSizes={[
                                                { name: __('None', 'bubiblock-slider'), slug: 'none', size: 0 },
                                                { name: __('Small', 'bubiblock-slider'), slug: 'small', size: 18 },
                                                { name: __('Medium', 'bubiblock-slider'), slug: 'medium', size:24 },
                                                { name: __('Large', 'bubiblock-slider'), slug: 'large', size: 32 },
                                                { name: __('Big', 'bubiblock-slider'), slug: 'large', size: 52 },
                                            ]}
                                            withSlider={true}
                                        />
                                    }
                                    {(df_resp=='mobile') &&
                                        <FontSizePicker
                                            value={fontsizeinfo5mobile}
                                            onChange={(val) => setAttributes({fontsizeinfo5mobile: val})}
                                            fontSizes={[
                                                { name: __('None', 'bubiblock-slider'), slug: 'none', size: 0 },
                                                { name: __('Small', 'bubiblock-slider'), slug: 'small', size: 18 },
                                                { name: __('Medium', 'bubiblock-slider'), slug: 'medium', size:24 },
                                                { name: __('Large', 'bubiblock-slider'), slug: 'large', size: 32 },
                                                { name: __('Big', 'bubiblock-slider'), slug: 'large', size: 52 },
                                            ]}
                                            withSlider={true}
                                        />
                                    }
                                </ButtonGroup>
                                <RadioControl
                                    label={__('Align','bubiblock-slider')}
                                    selected={ alignment_info5 }
                                    options={ [
                                        { label: 'Left', value: 'left' },
                                        { label: 'Center', value: 'center' },
                                        { label: 'Right', value: 'right' },
                                    ] }
                                    onChange={ ( newAlign ) => setAttributes( { alignment_info5: newAlign } ) }
                                />
                                <SelectControl
                                    label={__("Effect","bubiblock-slider")}
                                    options={bubiOptionsEffectAnimate}
                                    onChange={(val) => setAttributes({ effectinfo5 : val})}
                                    value={effectinfo5}
                                />
                                <SelectControl
                                    label={__("Effect speed","bubiblock-slider")}
                                    options={bubiOptionEffectSpeed}
                                    onChange={(val) => setAttributes({ df_speed_effectinfo5 : val})}
                                    value={df_speed_effectinfo5}
                                />
                                <SelectControl
                                    label={__("Effect delay","bubiblock-slider")}
                                    options={bubiOptionEffectDalay}
                                    onChange={(val) => setAttributes({ df_delay_effectinfo5 : val})}
                                    value={df_delay_effectinfo5}
                                />
                                <SelectControl
                                    label={__("Effect repeat","bubiblock-slider")}
                                    options={bubiOptionEffectRepeat}
                                    onChange={(val) => setAttributes({ df_repeat_effectinfo5 : val})}
                                    value={df_repeat_effectinfo5}
                                />
                            </>
                            }
                            {button5 &&
                            <>
                                <h6 class="df-inspector">{ __('Button', 'bubiblock-slider')}</h6>
                                <ButtonGroup
                                    className={'df-button-group bubiblock-no-margin'}
                                >
                                    <div class="df-group-button-resp">
                                        <div class="bubi-col-6">
                                            <h6>{ __('Choose', 'bubiblock-slider')}</h6>
                                        </div>
                                        <div class="bubi-col-6">
                                            <Button
                                                icon={'laptop'}
                                                isSecondary
                                                className={'df-resp-button'}
                                                isPrimary={df_resp == 'desktop'} onClick={() => setAttributes({ df_resp: 'desktop' })}
                                            >
                                            </Button>
                                            <Button
                                                icon={'tablet'}
                                                isSecondary
                                                className={'df-resp-button'}
                                                isPrimary={df_resp == 'table'} onClick={() => setAttributes({ df_resp: 'table' })}
                                            >
                                            </Button>
                                            <Button
                                                icon={'smartphone'}
                                                isSecondary
                                                className={'df-resp-button'}
                                                isPrimary={df_resp == 'mobile'} onClick={() => setAttributes({ df_resp: 'mobile' })}
                                            >
                                            </Button>
                                        </div>
                                    </div>
                                    {(df_resp=='desktop') &&
                                        <RangeControl
                                            label={__('Margin','bubiblock-slider')}
                                            help={__('px Unit','bubiblock-slider')}
                                            beforeIcon={'arrow-down-alt'}
                                            afterIcon={'arrow-up-alt'}
                                            allowReset
                                            resetFallbackValue={5}
                                            step={1}
                                            withInputField={false}
                                            separatorType="none"
                                            trackColor="#007cba"
                                            isShiftStepEnabled
                                            marks={[
                                                {
                                                    value: -100,
                                                    label: __('-100','bubiblock-slider'),
                                                },
                                                {
                                                    value: 0,
                                                    label: __('0','bubiblock-slider'),
                                                },
                                                {
                                                    value: 100,
                                                    label: __('100','bubiblock-slider'),
                                                },
                                                {
                                                    value: 200,
                                                    label: __('200','bubiblock-slider'),
                                                },
                                                {
                                                    value: 300,
                                                    label: __('300','bubiblock-slider'),
                                                },
                                            ]}
                                            railColor="#02abff"
                                            value={ margin_bottom_button5 }
                                            onChange={(val) => setAttributes({ margin_bottom_button5 : val})}
                                            min={ -100 }
                                            max={ 300}
                                        />
                                    }
                                    {(df_resp=='table') &&
                                        <RangeControl
                                            label={__('Margin','bubiblock-slider')}
                                            help={__('px Unit','bubiblock-slider')}
                                            beforeIcon={'arrow-down-alt'}
                                            afterIcon={'arrow-up-alt'}
                                            allowReset
                                            resetFallbackValue={5}
                                            step={1}
                                            withInputField={false}
                                            separatorType="none"
                                            trackColor="#007cba"
                                            isShiftStepEnabled
                                            marks={[
                                                {
                                                    value: -50,
                                                    label: __('-50','bubiblock-slider'),
                                                },
                                                {
                                                    value: 0,
                                                    label: __('0','bubiblock-slider'),
                                                },
                                                {
                                                    value: 50,
                                                    label: __('50','bubiblock-slider'),
                                                },
                                                {
                                                    value: 100,
                                                    label: __('100','bubiblock-slider'),
                                                },
                                                {
                                                    value: 150,
                                                    label: __('150','bubiblock-slider'),
                                                },
                                                {
                                                    value: 200,
                                                    label: __('200','bubiblock-slider'),
                                                },
                                            ]}
                                            railColor="#02abff"
                                            value={ margin_bottom_table_button5 }
                                            onChange={(val) => setAttributes({ margin_bottom_table_button5 : val})}
                                            min={ -50 }
                                            max={ 200}
                                        />
                                    }
                                    {(df_resp=='mobile') &&
                                        <RangeControl
                                            label={__('Margin','bubiblock-slider')}
                                            help={__('px Unit','bubiblock-slider')}
                                            beforeIcon={'arrow-down-alt'}
                                            afterIcon={'arrow-up-alt'}
                                            allowReset
                                            resetFallbackValue={5}
                                            step={1}
                                            withInputField={false}
                                            separatorType="none"
                                            trackColor="#007cba"
                                            isShiftStepEnabled
                                            marks={[
                                                {
                                                    value: -50,
                                                    label: __('-50','bubiblock-slider'),
                                                },
                                                {
                                                    value: 0,
                                                    label: __('0','bubiblock-slider'),
                                                },
                                                {
                                                    value: 50,
                                                    label: __('50','bubiblock-slider'),
                                                },
                                                {
                                                    value: 100,
                                                    label: __('100','bubiblock-slider'),
                                                },
                                                {
                                                    value: 150,
                                                    label: __('150','bubiblock-slider'),
                                                },
                                                {
                                                    value: 200,
                                                    label: __('200','bubiblock-slider'),
                                                },
                                            ]}
                                            railColor="#02abff"
                                            value={ margin_bottom_mobile_button5 }
                                            onChange={(val) => setAttributes({ margin_bottom_mobile_button5 : val})}
                                            min={ -50 }
                                            max={ 200}
                                        />
                                    }
                                    {(df_resp=='desktop') &&
                                        <FontSizePicker
                                            value={fontsizebutton5}
                                            onChange={(val) => setAttributes({fontsizebutton5: val})}
                                            fontSizes={[
                                                { name: __('Small', 'bubiblock-slider'), slug: 'small', size: 18 },
                                                { name: __('Medium', 'bubiblock-slider'), slug: 'medium', size:24 },
                                                { name: __('Large', 'bubiblock-slider'), slug: 'large', size: 32 },
                                                { name: __('Big', 'bubiblock-slider'), slug: 'large', size: 52 },
                                            ]}
                                            withSlider={true}
                                    />
                                        }
                                    {(df_resp=='table') &&
                                        <FontSizePicker
                                            value={fontsizebutton5table}
                                            onChange={(val) => setAttributes({fontsizebutton5table: val})}
                                            fontSizes={[
                                                { name: __('Small', 'bubiblock-slider'), slug: 'small', size: 18 },
                                                { name: __('Medium', 'bubiblock-slider'), slug: 'medium', size:24 },
                                                { name: __('Large', 'bubiblock-slider'), slug: 'large', size: 32 },
                                                { name: __('Big', 'bubiblock-slider'), slug: 'large', size: 52 },
                                            ]}
                                            withSlider={true}
                                        />
                                    }
                                    {(df_resp=='mobile') &&
                                        <FontSizePicker
                                            value={fontsizebutton5mobile}
                                            onChange={(val) => setAttributes({fontsizebutton5mobile: val})}
                                            fontSizes={[
                                                { name: __('Small', 'bubiblock-slider'), slug: 'small', size: 18 },
                                                { name: __('Medium', 'bubiblock-slider'), slug: 'medium', size:24 },
                                                { name: __('Large', 'bubiblock-slider'), slug: 'large', size: 32 },
                                                { name: __('Big', 'bubiblock-slider'), slug: 'large', size: 52 },
                                            ]}
                                            withSlider={true}
                                        />
                                    }
                                </ButtonGroup>
                                <RadioControl
                                    label={__('Align','bubiblock-slider')}
                                    selected={ alignment_button5 }
                                    options={ [
                                        { label: 'Left', value: 'left' },
                                        { label: 'Center', value: 'center' },
                                        { label: 'Right', value: 'right' },
                                    ] }
                                    onChange={ ( newAlign ) => setAttributes( { alignment_button5: newAlign } ) }
                                />
                                <SelectControl
                                    label={__("Effect","bubiblock-slider")}
                                    options={bubiOptionsEffectAnimate}
                                    onChange={(val) => setAttributes({ effectbutton5 : val})}
                                    value={effectbutton5}
                                />
                                <SelectControl
                                    label={__("Effect speed","bubiblock-slider")}
                                    options={bubiOptionEffectSpeed}
                                    onChange={(val) => setAttributes({ df_speed_effectbutton5 : val})}
                                    value={df_speed_effectbutton5}
                                />
                                <SelectControl
                                    label={__("Effect delay","bubiblock-slider")}
                                    options={bubiOptionEffectDalay}
                                    onChange={(val) => setAttributes({ df_delay_effectbutton5 : val})}
                                    value={df_delay_effectbutton5}
                                />
                                <SelectControl
                                    label={__("Effect repeat","bubiblock-slider")}
                                    options={bubiOptionEffectRepeat}
                                    onChange={(val) => setAttributes({ df_repeat_effectbutton5 : val})}
                                    value={df_repeat_effectbutton5}
                                />
                                <RangeControl
                                    label={__('Padding top/bottom','bubiblock-slider')}
                                    help={__('px Unit','bubiblock-slider')}
                                    beforeIcon={'arrow-down-alt'}
                                    afterIcon={'arrow-up-alt'}
                                    allowReset
                                    resetFallbackValue={8}
                                    step={1}
                                    withInputField={false}
                                    separatorType="none"
                                    trackColor="#007cba"
                                    isShiftStepEnabled
                                    marks={[
                                        {
                                            value: 0,
                                            label: __('0','bubiblock-slider'),
                                        },
                                        {
                                            value: 10,
                                            label: __('10','bubiblock-slider'),
                                        },
                                        {
                                            value: 20,
                                            label: __('20','bubiblock-slider'),
                                        },
                                        {
                                            value: 30,
                                            label: __('30','bubiblock-slider'),
                                        },
                                        {
                                            value: 40,
                                            label: __('40','bubiblock-slider'),
                                        },
                                        {
                                            value: 50,
                                            label: __('50','bubiblock-slider'),
                                        },
                                    ]}
                                    railColor="#02abff"
                                    value={ padding_link_button5 }
                                    onChange={(val) => setAttributes({ padding_link_button5: val })}
                                    min={ 0 }
                                    max={ 50}
                                />
                                <RangeControl
                                    label={__('Padding left/right','bubiblock-slider')}
                                    help={__('px Unit','bubiblock-slider')}
                                    beforeIcon={'arrow-left-alt'}
                                    afterIcon={'arrow-right-alt'}
                                    allowReset
                                    resetFallbackValue={20}
                                    step={1}
                                    withInputField={false}
                                    separatorType="none"
                                    trackColor="#007cba"
                                    isShiftStepEnabled
                                    marks={[
                                        {
                                            value: 0,
                                            label: __('0','bubiblock-slider'),
                                        },
                                        {
                                            value: 10,
                                            label: __('10','bubiblock-slider'),
                                        },
                                        {
                                            value: 20,
                                            label: __('20','bubiblock-slider'),
                                        },
                                        {
                                            value: 30,
                                            label: __('30','bubiblock-slider'),
                                        },
                                        {
                                            value: 40,
                                            label: __('40','bubiblock-slider'),
                                        },
                                        {
                                            value: 50,
                                            label: __('50','bubiblock-slider'),
                                        },
                                    ]}
                                    railColor="#02abff"
                                    value={ padding_right_link_button5 }
                                    onChange={(val) => setAttributes({ padding_right_link_button5: val })}
                                    min={ 0 }
                                    max={ 50}
                                />
                                <RangeControl
                                    label={__('Border solid','bubiblock-slider')}
                                    help={__('Px Unit','bubiblock-slider')}
                                    beforeIcon={'star-empty'}
                                    afterIcon={'star-filled'}
                                    allowReset
                                    resetFallbackValue={0}
                                    step={1}
                                    withInputField={false}
                                    separatorType="none"
                                    trackColor="#007cba"
                                    isShiftStepEnabled
                                    marks={[
                                        {
                                            value: 0,
                                            label: __('0','bubiblock-slider'),
                                        },
                                        {
                                            value: 10,
                                            label: __('10','bubiblock-slider'),
                                        },
                                        {
                                            value: 20,
                                            label: __('20','bubiblock-slider'),
                                        },
                                        {
                                            value: 30,
                                            label: __('30','bubiblock-slider'),
                                        },
                                        {
                                            value: 40,
                                            label: __('40','bubiblock-slider'),
                                        },
                                        {
                                            value: 50,
                                            label: __('50','bubiblock-slider'),
                                        },
                                    ]}
                                    railColor="#02abff"
                                    value={ border_size_link_button5 }
                                    onChange={(val) => setAttributes({ border_size_link_button5: val })}
                                    min={ 0 }
                                    max={ 50}
                                />
                                <RangeControl
                                    label={__('Border top left radius','bubiblock-slider')}
                                    help={__('% Unit','bubiblock-slider')}
                                    beforeIcon={'fullscreen-alt'}
                                    afterIcon={'fullscreen-exit-alt'}
                                    allowReset
                                    resetFallbackValue={0}
                                    step={1}
                                    withInputField={false}
                                    separatorType="none"
                                    trackColor="#007cba"
                                    isShiftStepEnabled
                                    marks={[
                                        {
                                            value: 0,
                                            label: __('0','bubiblock-slider'),
                                        },
                                        {
                                            value: 10,
                                            label: __('10','bubiblock-slider'),
                                        },
                                        {
                                            value: 20,
                                            label: __('20','bubiblock-slider'),
                                        },
                                        {
                                            value: 30,
                                            label: __('30','bubiblock-slider'),
                                        },
                                        {
                                            value: 40,
                                            label: __('40','bubiblock-slider'),
                                        },
                                        {
                                            value: 50,
                                            label: __('50','bubiblock-slider'),
                                        },
                                    ]}
                                    railColor="#02abff"
                                    value={ border_radius_top_left_link_button5 }
                                    onChange={(val) => setAttributes({ border_radius_top_left_link_button5: val })}
                                    min={ 0 }
                                    max={ 50}
                                />
                                <RangeControl
                                    label={__('Border top right radius','bubiblock-slider')}
                                    help={__('% Unit','bubiblock-slider')}
                                    beforeIcon={'fullscreen-alt'}
                                    afterIcon={'fullscreen-exit-alt'}
                                    allowReset
                                    resetFallbackValue={0}
                                    step={1}
                                    withInputField={false}
                                    separatorType="none"
                                    trackColor="#007cba"
                                    isShiftStepEnabled
                                    marks={[
                                        {
                                            value: 0,
                                            label: __('0','bubiblock-slider'),
                                        },
                                        {
                                            value: 10,
                                            label: __('10','bubiblock-slider'),
                                        },
                                        {
                                            value: 20,
                                            label: __('20','bubiblock-slider'),
                                        },
                                        {
                                            value: 30,
                                            label: __('30','bubiblock-slider'),
                                        },
                                        {
                                            value: 40,
                                            label: __('40','bubiblock-slider'),
                                        },
                                        {
                                            value: 50,
                                            label: __('50','bubiblock-slider'),
                                        },
                                    ]}
                                    railColor="#02abff"
                                    value={ border_radius_top_right_link_button5 }
                                    onChange={(val) => setAttributes({ border_radius_top_right_link_button5: val })}
                                    min={ 0 }
                                    max={ 50}
                                />
                                <RangeControl
                                    label={__('Border bottom left radius','bubiblock-slider')}
                                    help={__('% Unit','bubiblock-slider')}
                                    beforeIcon={'fullscreen-alt'}
                                    afterIcon={'fullscreen-exit-alt'}
                                    allowReset
                                    resetFallbackValue={0}
                                    step={1}
                                    withInputField={false}
                                    separatorType="none"
                                    trackColor="#007cba"
                                    isShiftStepEnabled
                                    marks={[
                                        {
                                            value: 0,
                                            label: __('0','bubiblock-slider'),
                                        },
                                        {
                                            value: 10,
                                            label: __('10','bubiblock-slider'),
                                        },
                                        {
                                            value: 20,
                                            label: __('20','bubiblock-slider'),
                                        },
                                        {
                                            value: 30,
                                            label: __('30','bubiblock-slider'),
                                        },
                                        {
                                            value: 40,
                                            label: __('40','bubiblock-slider'),
                                        },
                                        {
                                            value: 50,
                                            label: __('50','bubiblock-slider'),
                                        },
                                    ]}
                                    railColor="#02abff"
                                    value={ border_radius_bottom_left_link_button5 }
                                    onChange={(val) => setAttributes({ border_radius_bottom_left_link_button5: val })}
                                    min={ 0 }
                                    max={ 50}
                                />
                                <RangeControl
                                    label={__('Border bottom right radius','bubiblock-slider')}
                                    help={__('% Unit','bubiblock-slider')}
                                    beforeIcon={'fullscreen-alt'}
                                    afterIcon={'fullscreen-exit-alt'}
                                    allowReset
                                    resetFallbackValue={0}
                                    step={1}
                                    withInputField={false}
                                    separatorType="none"
                                    trackColor="#007cba"
                                    isShiftStepEnabled
                                    marks={[
                                        {
                                            value: 0,
                                            label: __('0','bubiblock-slider'),
                                        },
                                        {
                                            value: 10,
                                            label: __('10','bubiblock-slider'),
                                        },
                                        {
                                            value: 20,
                                            label: __('20','bubiblock-slider'),
                                        },
                                        {
                                            value: 30,
                                            label: __('30','bubiblock-slider'),
                                        },
                                        {
                                            value: 40,
                                            label: __('40','bubiblock-slider'),
                                        },
                                        {
                                            value: 50,
                                            label: __('50','bubiblock-slider'),
                                        },
                                    ]}
                                    railColor="#02abff"
                                    value={ border_radius_bottom_right_link_button5 }
                                    onChange={(val) => setAttributes({ border_radius_bottom_right_link_button5: val })}
                                    min={ 0 }
                                    max={ 50}
                                />
                                <h6 id={'bg'} class="df-inspector" >{ __('Background Color', 'bubiblock-slider')}
                                {(df_background_color_transparent_link_button5 == 'df-trasparent-color-button5-false') &&
                                    <>
                                    {df_background_color_link_button5 &&
                                        <ColorIndicator
                                            colorValue={ df_background_color_link_button5 }
                                        />
                                    }
                                    </>
                                }
                                {df_background_color_hover_link_button5 &&
                                    <ColorIndicator
                                        colorValue={ df_background_color_hover_link_button5 }
                                    />
                                }
                                </h6>
                                {(df_background_color_transparent_link_button5 == 'df-trasparent-color-button5-false') &&
                                    <div class={'legend-color-none'}>
                                        <ColorPaletteControl
                                            value={ df_background_color_link_button5}
                                            colors={ bubiColors }
                                            onChange={ (newValue) => setAttributes({df_background_color_link_button5 : newValue}) }
                                        />
                                    </div>
                                }
                                <p className={"df-inspector bubi-mt-1"}>{__('Hover','bubiblock-slider')}</p>
                                <div class={'legend-color-none'}>
                                    <ColorPaletteControl
                                        value={ df_background_color_hover_link_button5}
                                        colors={ bubiColors }
                                        onChange={ (newValue) => setAttributes({df_background_color_hover_link_button5 : newValue}) }
                                    />
                                </div>
                                <h6 className="df-inspector">{ __('Color', 'bubiblock-slider')}
                                {df_color_link_button5 &&
                                    <ColorIndicator
                                        colorValue={ df_color_link_button5 }
                                    />
                                }
                                {df_color_hover_link_button5 &&
                                    <ColorIndicator
                                        colorValue={ df_color_hover_link_button5 }
                                    />
                                }
                                {df_border_color_link_button5 &&
                                    <ColorIndicator
                                        colorValue={ df_border_color_link_button5 }
                                    />
                                }
                                </h6>
                                <div class={'legend-color-none'}>
                                    <p className="df-inspector">{__('Color','bubiblock-slider')}</p>
                                    <ColorPaletteControl
                                        value={ df_color_link_button5}
                                        colors={ bubiColors }
                                        onChange={ (newValue) => setAttributes({df_color_link_button5: newValue}) }
                                    />
                                    <p className="df-inspector">{__('Color hover','bubiblock-slider')}</p>
                                    <ColorPaletteControl
                                        value={ df_color_hover_link_button5}
                                        colors={ bubiColors }
                                        onChange={ (newValue) => setAttributes({df_color_hover_link_button5: newValue}) }
                                    />
                                    <p className="df-inspector">{__('Border Color','bubiblock-slider')}</p>
                                    <ColorPaletteControl
                                        value={ df_border_color_link_button5}
                                        colors={ bubiColors }
                                        onChange={ (newValue) => setAttributes({df_border_color_link_button5: newValue}) }
                                    />
                                </div>
                                <ButtonGroup
                                    className={'df-button-group bubiblock-no-margin'}
                                >
                                    <h6 className="df-inspector">{ __('Background color transparent', 'bubiblock-slider')}</h6>
                                    <div class="bubi-width-two">
                                    <Button
                                        isSecondary
                                        isPrimary={df_background_color_transparent_link_button5 == 'df-trasparent-color-button5-true'} onClick={() => setAttributes({ df_background_color_transparent_link_button5: 'df-trasparent-color-button5-true' })}
                                    >
                                        {__('True','bubiblock-slider')}
                                    </Button>
                                    <Button
                                        isSecondary
                                        isPrimary={df_background_color_transparent_link_button5 == 'df-trasparent-color-button5-false'} onClick={() => setAttributes({ df_background_color_transparent_link_button5: 'df-trasparent-color-button5-false' })}
                                    >
                                        {__('False','bubiblock-slider')}
                                    </Button>
                                    </div>
                                </ButtonGroup>
                            </>
                            }
                            </PanelBody>
                        </>
                    }
                </InspectorControls>

                <div id={'carouselDFControlslider'+bubiblock_id_slider} className={className+' df_height_carousel_block carousel slide caption-animate touch'+bubiblock_carousle_touch+' '+df_effect_slider +' '+df_resp+' '+df_pause_slider} data-ride="carousel" data-interval={df_interval_slider} style={{background:bubiblock_background_color_slider,backgroundImage:bubiblock_background_gradient_slider}}>
                    <ol className={df_dot_slider+' '+df_dot_slider_table+' '+df_dot_slider_mobile+' carousel-indicators'} style={{bottom:df_bottom_dot}}>
                        <li data-target={'#carouselDFControlslider'+bubiblock_id_slider} data-slide-to="0" className={ 'active '+df_dot_slider_type} style={{maxWidth:df_width_dot+'px',height:df_height_dot+'px',backgroundColor:df_color_dot}} onclick="move()"></li>
                        <li data-target={'#carouselDFControlslider'+bubiblock_id_slider} data-slide-to="1" className={df_dot_slider_type} style={{maxWidth:df_width_dot+'px',height:df_height_dot+'px',backgroundColor:df_color_dot}}></li>
                        {bubiblock_add_slider_3 &&
                            <li data-target={'#carouselDFControlslider'+bubiblock_id_slider} data-slide-to="2" className={df_dot_slider_type} style={{maxWidth:df_width_dot+'px',height:df_height_dot+'px',backgroundColor:df_color_dot}}></li>
                        }
                        {bubiblock_add_slider_4 &&
                            <li data-target={'#carouselDFControlslider'+bubiblock_id_slider} data-slide-to="3" className={df_dot_slider_type} style={{maxWidth:df_width_dot+'px',height:df_height_dot+'px',backgroundColor:df_color_dot}}></li>
                        }
                        {bubiblock_add_slider_5 &&
                            <li data-target={'#carouselDFControlslider'+bubiblock_id_slider} data-slide-to="4" className={df_dot_slider_type} style={{maxWidth:df_width_dot+'px',height:df_height_dot+'px',backgroundColor:df_color_dot}}></li>
                        }
                    </ol>
                    <div className={'carousel-inner'}>
                        {(bubi_block_content_slider == 'bubiblock-block-slider') ==! (bubi_block_content_slider =='bubiblock-blockcontent-slider') &&
                            <div className={df_resp+' bubiblock-block'} style={{backgroundColor:bubiblock_background_color_block_slider,opacity:bubiopacityblock_slider}}>
                                <InnerBlocks/>
                            </div>
                        }
                        <div className={'carousel-item '+df_effect_slider+' '+bubiblock_id_slider+' active '}>
                            { df_enable_divide_1 &&
                                <div className={'df-divide-1'} style={{color:df_color_divide_1}}>
                                    {(divide_1=='svg-1' ) &&
                                        <svg className={'df-flip'} viewBox="0 0 1000 100" height="100%" width="100%" preserveAspectRatio="none"><path d="M1000,40c0,0 -120.077,-38.076 -250,-38c-129.923,0.076 -345.105,78 -500,78c-154.895,0 -250,-30 -250,-30l0,50l1000,0l0,-60Z"></path></svg>
                                    }
                                    {(divide_1=='svg-2' ) &&
                                        <svg viewBox="0 0 500 65" height="100%" width="100%" preserveAspectRatio="none"><polygon points="500 0 0 0 0 65 250 25 500 65 500 0"/></svg>
                                    }
                                    {(divide_1=='svg-3' ) &&
                                        <svg viewBox="0 0 500 81" height="100%" width="100%" preserveAspectRatio="none"><path d="M0,45.68C59,60,146,81.07,250,81c103-.07,192-19,250-35.32V0H0Z" transform="translate(0 0)"/></svg>
                                    }
                                    {(divide_1=='svg-4' ) &&
                                        <svg viewBox="0 0 500 46.42" height="100%" width="100%" preserveAspectRatio="none"><g><path d="M500,22.64s-194.23,1.13-213,5.44c-34.74,8-37,18.34-37,18.34s-2-11.25-30.5-18.24C198.56,23.05,0,22.64,0,22.64V0H500Z"/></g></svg>
                                    }
                                </div>
                            }
                            { df_enable_divide_bottom_1 &&
                                <div className={'df-divide-bottom-1'} style={{color:df_color_divide_bottom_1}}>
                                    {(divide_bottom_1=='svg-1' ) &&
                                        <svg className={'df-flip-bottom'} viewBox="0 0 1000 100" height="100%" width="100%" preserveAspectRatio="none"><path d="M1000,40c0,0 -120.077,-38.076 -250,-38c-129.923,0.076 -345.105,78 -500,78c-154.895,0 -250,-30 -250,-30l0,50l1000,0l0,-60Z"></path></svg>
                                    }
                                    {(divide_bottom_1=='svg-2' ) &&
                                        <svg viewBox="0 0 500 65" height="100%" width="100%" preserveAspectRatio="none"><polygon points="500 0 0 0 0 65 250 25 500 65 500 0"/></svg>
                                    }
                                    {(divide_bottom_1=='svg-3' ) &&
                                        <svg viewBox="0 0 500 81" height="100%" width="100%" preserveAspectRatio="none"><path d="M0,45.68C59,60,146,81.07,250,81c103-.07,192-19,250-35.32V0H0Z" transform="translate(0 0)"/></svg>
                                    }
                                    {(divide_bottom_1=='svg-4' ) &&
                                        <svg viewBox="0 0 500 46.42" height="100%" width="100%" preserveAspectRatio="none"><g><path d="M500,22.64s-194.23,1.13-213,5.44c-34.74,8-37,18.34-37,18.34s-2-11.25-30.5-18.24C198.56,23.05,0,22.64,0,22.64V0H500Z"/></g></svg>
                                    }
                                </div>
                            }
                            {(df_slider_chose_1=='df-slider-image-1' ) &&
                                <>
                                {url ?
                                    <>
                                    <a href={bubiblock_link_slider_1} target={bubiblock_link_tab_slider_1} rel="noopener">
                                        <img src={url} alt={alt} className={'img-cap'} style={{objectFit:df_cover_img1,objectPosition:df_focalPoint_img_1+'% '+df_focalPoint_y_img_1+'%'}} />
                                    {isBlobURL(url) && <Spinner />}
                                    {df_mask_slider_1 &&
                                        <div className={'mask'} style={{backgroundColor:background_color_solid_mask_1,opacity:df_opacity_mask_1}}></div>
                                    }
                                    </a>
                                    </>
                                    :
                                    <div className={'df-upload-img'}></div>
                                }
                                </>
                            }
                            {(df_slider_chose_1=='df-slider-color-1') &&
                                <>
                                { df_background_color_slider_1 ?
                                    <div className={'df-slider-color bubiblock-color-slider-item'} style={{backgroundColor: df_background_color_slider_1}}></div>
                                    :
                                    <div className={'df-color-default-background-slider bubiblock-color-slider-item'}></div>
                                }
                                </>
                            }
                            {(bubi_block_content_slider == 'bubiblock-content-slider') ==! (bubi_block_content_slider =='bubiblock-blockcontent-slider') &&
                                <div className={'carousel-caption caption-1'}>
                                    <div className={'bubiblock-slider-row'}>
                                        <div className={'bubiblock-col-md-8'}>
                                            <RichText
                                                className={ 'wp-block-bubiblock-slider-slider__title  '+df_repeat_effectcaption1+' '+df_delay_effectcaption1+' '+df_speed_effectcaption1+' '+effectcaption1 }
                                                tagName= "h4"
                                                style={{textAlign:alignment_title1,fontSize:fontsizetitle1+'px',bottom:margin_bottom_caption1+'px'}}
                                                onChange= { this.onChangeTitle1 }
                                                value= { title1 }
                                                placeholder= { __("Title", "bubiblock-slider") }
                                                allowedFormats={ [ 'core/code','core/image','core/strikethrough','core/underline','core/text-color','core/subscript','core/superscript' ] }
                                            />
                                            <RichText
                                                className={ 'bubiblock-p-capt wp-block-bubiblock-slider-slider__info '+df_repeat_effectinfo1+' '+df_delay_effectinfo1+' '+df_speed_effectinfo1+' '+effectinfo1}
                                                tagName= "p"
                                                onChange= { this.onChangeInfo1 }
                                                value= { info1 }
                                                style={{textAlign:alignment_info1,fontSize:fontsizeinfo1+'px',bottom:margin_bottom_info1+'px'}}
                                                placeholder= { __("Info", "bubiblock-slider") }
                                                allowedFormats={ [ 'core/code','core/image','core/strikethrough','core/underline','core/text-color','core/subscript','core/superscript' ] }
                                            />
                                            <div className={'link-button-1 '+df_repeat_effectbutton1+' '+df_delay_effectbutton1+' '+df_speed_effectbutton1+' '+effectbutton1} style={{textAlign:alignment_button1,bottom:margin_bottom_button1+'px'}}>
                                                <button className={'button-slider '+df_background_color_transparent_link_button1} style={
                                                    {
                                                        paddingTop:padding_link_button1+'px',
                                                        paddingBottom:padding_link_button1+'px',
                                                        paddingLeft:padding_right_link_button1+'px',
                                                        paddingRight:padding_right_link_button1+'px',
                                                        borderTopLeftRadius: border_radius_top_left_link_button1+'px',
                                                        borderTopRightRadius: border_radius_top_right_link_button1+'px',
                                                        borderBottomLeftRadius: border_radius_bottom_left_link_button1+'px',
                                                        borderBottomRightRadius: border_radius_bottom_right_link_button1+'px',
                                                        border: border_size_link_button1+'px solid'+df_border_color_link_button1,
                                                        backgroundColor:df_background_color_link_button1,
                                                        background:df_background_color_link_button1,
                                                    }
                                                }
                                                >
                                                    <RichText
                                                        className={ 'wp-block-bubiblock-slider-slider__link' }
                                                        tagName= "p"
                                                        onChange= { this.onChangeButton1 }
                                                        value= { button1 }
                                                        placeholder= { __("Button", "bubiblock-slider") }
                                                        fotmattingControls= { [] }
                                                        style={{fontSize:fontsizebutton1+'px'}}
                                                        allowedFormats={ [ 'core/link', 'core/code','core/image','core/strikethrough','core/underline','core/subscript','core/superscript' ] }
                                                    />
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>

                        <div className={'carousel-item '+df_effect_slider+' '+bubiblock_id_slider}>
                            { df_enable_divide_2 &&
                                <div className={'df-divide-2'} style={{color:df_color_divide_2}}>
                                    {(divide_2=='svg-1' ) &&
                                        <svg className={'df-flip'} viewBox="0 0 1000 100" height="100%" width="100%" preserveAspectRatio="none"><path d="M1000,40c0,0 -120.077,-38.076 -250,-38c-129.923,0.076 -345.105,78 -500,78c-154.895,0 -250,-30 -250,-30l0,50l1000,0l0,-60Z"></path></svg>
                                    }
                                    {(divide_2=='svg-2' ) &&
                                        <svg viewBox="0 0 500 65" height="100%" width="100%" preserveAspectRatio="none"><polygon points="500 0 0 0 0 65 250 25 500 65 500 0"/></svg>
                                    }
                                    {(divide_2=='svg-3' ) &&
                                        <svg viewBox="0 0 500 81" height="100%" width="100%" preserveAspectRatio="none"><path d="M0,45.68C59,60,146,81.07,250,81c103-.07,192-19,250-35.32V0H0Z" transform="translate(0 0)"/></svg>
                                    }
                                    {(divide_2=='svg-4' ) &&
                                        <svg viewBox="0 0 500 46.42" height="100%" width="100%" preserveAspectRatio="none"><g><path d="M500,22.64s-194.23,1.13-213,5.44c-34.74,8-37,18.34-37,18.34s-2-11.25-30.5-18.24C198.56,23.05,0,22.64,0,22.64V0H500Z"/></g></svg>
                                    }
                                </div>
                            }
                            { df_enable_divide_bottom_2 &&
                                <div className={'df-divide-bottom-2'} style={{color:df_color_divide_bottom_2}}>
                                    {(divide_bottom_2=='svg-1' ) &&
                                        <svg className={'df-flip-bottom'} viewBox="0 0 1000 100" height="100%" width="100%" preserveAspectRatio="none"><path d="M1000,40c0,0 -120.077,-38.076 -250,-38c-129.923,0.076 -345.105,78 -500,78c-154.895,0 -250,-30 -250,-30l0,50l1000,0l0,-60Z"></path></svg>
                                    }
                                    {(divide_bottom_2=='svg-2' ) &&
                                        <svg viewBox="0 0 500 65" height="100%" width="100%" preserveAspectRatio="none"><polygon points="500 0 0 0 0 65 250 25 500 65 500 0"/></svg>
                                    }
                                    {(divide_bottom_2=='svg-3' ) &&
                                        <svg viewBox="0 0 500 81" height="100%" width="100%" preserveAspectRatio="none"><path d="M0,45.68C59,60,146,81.07,250,81c103-.07,192-19,250-35.32V0H0Z" transform="translate(0 0)"/></svg>
                                    }
                                    {(divide_bottom_2=='svg-4' ) &&
                                        <svg viewBox="0 0 500 46.42" height="100%" width="100%" preserveAspectRatio="none"><g><path d="M500,22.64s-194.23,1.13-213,5.44c-34.74,8-37,18.34-37,18.34s-2-11.25-30.5-18.24C198.56,23.05,0,22.64,0,22.64V0H500Z"/></g></svg>
                                    }
                                </div>
                            }
                            {(df_slider_chose_2=='df-slider-image-2' ) &&
                                <>
                                {imageUrl_2 ?
                                    <>
                                    <a href={bubiblock_link_slider_2} target={bubiblock_link_tab_slider_2} rel="noopener">
                                        <img src={imageUrl_2} alt={alt2} className={'img-cap image-slider-2'} style={{objectFit:df_cover_img2,objectPosition:df_focalPoint_img_2+'% '+df_focalPoint_y_img_2+'%'}} />
                                    {isBlobURL(imageUrl_2) && <Spinner />}
                                    {df_mask_slider_2 &&
                                        <div className={'mask'} style={{backgroundColor:background_color_solid_mask_2,background:background_color_gradient_mask_2,opacity:df_opacity_mask_2}}></div>
                                    }
                                    </a>
                                    </>
                                    :
                                    <div className={'df-upload-img'}></div>
                                }
                                </>
                            }
                            {(df_slider_chose_2=='df-slider-color-2') &&
                                <>
                                {df_background_color_slider_2 ?
                                    <div className={'df-slider-color bubiblock-color-slider-item'} style={{backgroundColor: df_background_color_slider_2}}></div>
                                    :
                                    <div className={'df-color-default-background-slider-2 bubiblock-color-slider-item'}></div>
                                }
                                </>
                            }
                            {(bubi_block_content_slider == 'bubiblock-content-slider') ==! (bubi_block_content_slider =='bubiblock-blockcontent-slider') &&
                                <div className={'carousel-caption caption-2'}>
                                    <div className={'bubiblock-slider-row'}>
                                        <div className={'bubiblock-col-md-8'}>
                                            <RichText
                                                className={ 'wp-block-bubiblock-slider-slider__title_2 '+df_repeat_effectcaption2+' '+df_delay_effectcaption2+' '+df_speed_effectcaption2+' '+effectcaption2 }
                                                tagName= "h4"
                                                style={{textAlign:alignment_title2,fontSize:fontsizetitle2+'px',bottom:margin_bottom_caption2+'px'}}
                                                onChange= { this.onChangeTitle2 }
                                                value= { title2 }
                                                placeholder= { __("Title", "bubiblock-slider") }
                                                allowedFormats={ [ 'core/code','core/image','core/strikethrough','core/underline','core/text-color','core/subscript','core/superscript' ] }
                                            />
                                            <RichText
                                                className={ 'bubiblock-p-capt wp-block-bubiblock-slider-slider__info_2 '+df_repeat_effectinfo2+' '+df_delay_effectinfo2+' '+df_speed_effectinfo2+' '+effectinfo2}
                                                tagName= "p"
                                                onChange= { this.onChangeInfo2 }
                                                value= { info2 }
                                                style={{textAlign:alignment_info2,fontSize:fontsizeinfo2+'px',bottom:margin_bottom_info2+'px'}}
                                                placeholder= { __("Info", "bubiblock-slider") }
                                                fotmattingControls= { [] }
                                                allowedFormats={ [ 'core/code','core/image','core/strikethrough','core/underline','core/text-color','core/subscript','core/superscript' ] }
                                            />
                                            <div className={'link-button-2 '+df_repeat_effectbutton2+' '+df_delay_effectbutton2+' '+df_speed_effectbutton2+' '+effectbutton2} style={{textAlign:alignment_button2,bottom:margin_bottom_button2+'px'}}>
                                                <button className={'button-slider2 '+df_background_color_transparent_link_button2} style={
                                                    {
                                                        paddingTop:padding_link_button2+'px',
                                                        paddingBottom:padding_link_button2+'px',
                                                        paddingLeft:padding_right_link_button2+'px',
                                                        paddingRight:padding_right_link_button2+'px',
                                                        borderTopLeftRadius: border_radius_top_left_link_button2+'px',
                                                        borderTopRightRadius: border_radius_top_right_link_button2+'px',
                                                        borderBottomLeftRadius: border_radius_bottom_left_link_button2+'px',
                                                        borderBottomRightRadius: border_radius_bottom_right_link_button2+'px',
                                                        border: border_size_link_button2+'px solid'+df_border_color_link_button2,
                                                        backgroundColor:df_background_color_link_button2,
                                                        background:df_background_color_link_button2,
                                                    }
                                                }
                                                >
                                                    <RichText
                                                        className={ 'wp-block-bubiblock-slider-slider__link_2' }
                                                        tagName= "p"
                                                        onChange= { this.onChangeButton2 }
                                                        value= { button2 }
                                                        placeholder= { __("Button", "bubiblock-slider") }
                                                        fotmattingControls= { [] }
                                                        allowedFormats={ [ 'core/link', 'core/code','core/image','core/strikethrough','core/underline','core/subscript','core/superscript' ] }
                                                        style={{fontSize:fontsizebutton2+'px'}}
                                                    />
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>

                        {bubiblock_add_slider_3 && // Slider 3
                        <div className={'carousel-item '+df_effect_slider}>
                            { df_enable_divide_3 &&
                                <div className={'df-divide-3'} style={{color:df_color_divide_3}}>
                                    {(divide_3=='svg-1' ) &&
                                        <svg className={'df-flip'} viewBox="0 0 1000 100" height="100%" width="100%" preserveAspectRatio="none"><path d="M1000,40c0,0 -120.077,-38.076 -250,-38c-129.923,0.076 -345.105,78 -500,78c-154.895,0 -250,-30 -250,-30l0,50l1000,0l0,-60Z"></path></svg>
                                    }
                                    {(divide_3=='svg-2' ) &&
                                        <svg viewBox="0 0 500 65" height="100%" width="100%" preserveAspectRatio="none"><polygon points="500 0 0 0 0 65 250 25 500 65 500 0"/></svg>
                                    }
                                    {(divide_3=='svg-3' ) &&
                                        <svg viewBox="0 0 500 81" height="100%" width="100%" preserveAspectRatio="none"><path d="M0,45.68C59,60,146,81.07,250,81c103-.07,192-19,250-35.32V0H0Z" transform="translate(0 0)"/></svg>
                                    }
                                    {(divide_3=='svg-4' ) &&
                                        <svg viewBox="0 0 500 46.42" height="100%" width="100%" preserveAspectRatio="none"><g><path d="M500,22.64s-194.23,1.13-213,5.44c-34.74,8-37,18.34-37,18.34s-2-11.25-30.5-18.24C198.56,23.05,0,22.64,0,22.64V0H500Z"/></g></svg>
                                    }
                                </div>
                            }
                            { df_enable_divide_bottom_3 &&
                                <div className={'df-divide-bottom-3'} style={{color:df_color_divide_bottom_3}}>
                                    {(divide_bottom_3=='svg-1' ) &&
                                        <svg className={'df-flip-bottom'} viewBox="0 0 1000 100" height="100%" width="100%" preserveAspectRatio="none"><path d="M1000,40c0,0 -120.077,-38.076 -250,-38c-129.923,0.076 -345.105,78 -500,78c-154.895,0 -250,-30 -250,-30l0,50l1000,0l0,-60Z"></path></svg>
                                    }
                                    {(divide_bottom_3=='svg-2' ) &&
                                        <svg viewBox="0 0 500 65" height="100%" width="100%" preserveAspectRatio="none"><polygon points="500 0 0 0 0 65 250 25 500 65 500 0"/></svg>
                                    }
                                    {(divide_bottom_3=='svg-3' ) &&
                                        <svg viewBox="0 0 500 81" height="100%" width="100%" preserveAspectRatio="none"><path d="M0,45.68C59,60,146,81.07,250,81c103-.07,192-19,250-35.32V0H0Z" transform="translate(0 0)"/></svg>
                                    }
                                    {(divide_bottom_3=='svg-4' ) &&
                                        <svg viewBox="0 0 500 46.42" height="100%" width="100%" preserveAspectRatio="none"><g><path d="M500,22.64s-194.23,1.13-213,5.44c-34.74,8-37,18.34-37,18.34s-2-11.25-30.5-18.24C198.56,23.05,0,22.64,0,22.64V0H500Z"/></g></svg>
                                    }
                                </div>
                            }
                            {(df_slider_chose_3=='df-slider-image-3' ) &&
                                <>
                                {imageUrl_3 ?
                                    <>
                                    <a href={bubiblock_link_slider_3} target={bubiblock_link_tab_slider_3} rel="noopener">
                                        <img src={imageUrl_3} alt={alt3} className={'img-cap image-slider-3'} style={{objectFit:df_cover_img3,objectPosition:df_focalPoint_img_3+'% '+df_focalPoint_y_img_3+'%'}} />
                                    {isBlobURL(imageUrl_3) && <Spinner />}
                                    {df_mask_slider_3 &&
                                        <div className={'mask'} style={{backgroundColor:background_color_solid_mask_3,background:background_color_gradient_mask_3,opacity:df_opacity_mask_3}}></div>
                                    }
                                    </a>
                                    </>
                                    :
                                    <div className={'df-upload-img'}></div>
                                }
                                </>
                            }
                            {(df_slider_chose_3=='df-slider-color-3') &&
                                <>
                                {df_background_color_slider_3 ?
                                    <div className={'df-slider-color bubiblock-color-slider-item'} style={{backgroundColor: df_background_color_slider_3}}></div>
                                    :
                                    <div className={'df-color-default-background-slider bubiblock-color-slider-item'}></div>
                                }
                                </>
                            }
                            {(bubi_block_content_slider == 'bubiblock-content-slider') ==! (bubi_block_content_slider =='bubiblock-blockcontent-slider') &&
                                <div className={'carousel-caption caption-3'}>
                                    <div className={'bubiblock-slider-row'}>
                                        <div className={'bubiblock-col-md-8'}>
                                            <RichText
                                                className={ 'wp-block-bubiblock-slider-slider__title_3 '+df_repeat_effectcaption3+' '+df_delay_effectcaption3+' '+df_speed_effectcaption3+' '+effectcaption3 }
                                                tagName= "h4"
                                                style={{textAlign:alignment_title3,fontSize:fontsizetitle3+'px',bottom:margin_bottom_caption3+'px'}}
                                                onChange= { this.onChangeTitle3 }
                                                value= { title3 }
                                                placeholder= { __("Title", "bubiblock-slider") }
                                                allowedFormats={ [ 'core/code','core/image','core/strikethrough','core/underline','core/text-color','core/subscript','core/superscript' ] }
                                            />
                                            <RichText
                                                className={ 'bubiblock-p-capt wp-block-bubiblock-slider-slider__info_3 '+df_repeat_effectinfo3+' '+df_delay_effectinfo3+' '+df_speed_effectinfo3+' '+effectinfo3}
                                                tagName= "p"
                                                onChange= { this.onChangeInfo3 }
                                                value= { info3 }
                                                style={{textAlign:alignment_info3,fontSize:fontsizeinfo3+'px',bottom:margin_bottom_info3+'px'}}
                                                placeholder= { __("Info", "bubiblock-slider") }
                                                fotmattingControls= { [] }
                                                allowedFormats={ [ 'core/code','core/image','core/strikethrough','core/underline','core/text-color','core/subscript','core/superscript' ] }
                                            />
                                            <div className={'link-button-3 '+df_repeat_effectbutton3+' '+df_delay_effectbutton3+' '+df_speed_effectbutton3+' '+effectbutton3} style={{textAlign:alignment_button3,bottom:margin_bottom_button3+'px'}}>
                                                <button className={'button-slider3 '+df_background_color_transparent_link_button3} style={
                                                    {
                                                        paddingTop:padding_link_button3+'px',
                                                        paddingBottom:padding_link_button3+'px',
                                                        paddingLeft:padding_right_link_button3+'px',
                                                        paddingRight:padding_right_link_button3+'px',
                                                        borderTopLeftRadius: border_radius_top_left_link_button3+'px',
                                                        borderTopRightRadius: border_radius_top_right_link_button3+'px',
                                                        borderBottomLeftRadius: border_radius_bottom_left_link_button3+'px',
                                                        borderBottomRightRadius: border_radius_bottom_right_link_button3+'px',
                                                        border: border_size_link_button3+'px solid'+df_border_color_link_button3,
                                                        backgroundColor:df_background_color_link_button3,
                                                        background:df_background_color_link_button3,
                                                    }
                                                }
                                                >
                                                    <RichText
                                                        className={ 'wp-block-bubiblock-slider-slider__link_3' }
                                                        tagName= "p"
                                                        onChange= { this.onChangeButton3 }
                                                        value= { button3 }
                                                        placeholder= { __("Button", "bubiblock-slider") }
                                                        fotmattingControls= { [] }
                                                        style={{fontSize:fontsizebutton3+'px'}}
                                                        allowedFormats={ [ 'core/link', 'core/code','core/image','core/strikethrough','core/underline','core/subscript','core/superscript' ] }
                                                    />
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                        }

                        {bubiblock_add_slider_4 && // Slider 4
                        <div className={'carousel-item '+df_effect_slider}>
                            { df_enable_divide_4 &&
                                <div className={'df-divide-4'} style={{color:df_color_divide_4}}>
                                    {(divide_4=='svg-1' ) &&
                                        <svg className={'df-flip'} viewBox="0 0 1000 100" height="100%" width="100%" preserveAspectRatio="none"><path d="M1000,40c0,0 -120.077,-38.076 -250,-38c-129.923,0.076 -345.105,78 -500,78c-154.895,0 -250,-30 -250,-30l0,50l1000,0l0,-60Z"></path></svg>
                                    }
                                    {(divide_4=='svg-2' ) &&
                                        <svg viewBox="0 0 500 65" height="100%" width="100%" preserveAspectRatio="none"><polygon points="500 0 0 0 0 65 250 25 500 65 500 0"/></svg>
                                    }
                                    {(divide_4=='svg-3' ) &&
                                        <svg viewBox="0 0 500 81" height="100%" width="100%" preserveAspectRatio="none"><path d="M0,45.68C59,60,146,81.07,250,81c103-.07,192-19,250-35.32V0H0Z" transform="translate(0 0)"/></svg>
                                    }
                                    {(divide_4=='svg-4' ) &&
                                        <svg viewBox="0 0 500 46.42" height="100%" width="100%" preserveAspectRatio="none"><g><path d="M500,22.64s-194.23,1.13-213,5.44c-34.74,8-37,18.34-37,18.34s-2-11.25-30.5-18.24C198.56,23.05,0,22.64,0,22.64V0H500Z"/></g></svg>
                                    }
                                </div>
                            }
                            { df_enable_divide_bottom_4 &&
                                <div className={'df-divide-bottom-4'} style={{color:df_color_divide_bottom_4}}>
                                    {(divide_bottom_4=='svg-1' ) &&
                                        <svg className={'df-flip-bottom'} viewBox="0 0 1000 100" height="100%" width="100%" preserveAspectRatio="none"><path d="M1000,40c0,0 -120.077,-38.076 -250,-38c-129.923,0.076 -345.105,78 -500,78c-154.895,0 -250,-30 -250,-30l0,50l1000,0l0,-60Z"></path></svg>
                                    }
                                    {(divide_bottom_4=='svg-2' ) &&
                                        <svg viewBox="0 0 500 65" height="100%" width="100%" preserveAspectRatio="none"><polygon points="500 0 0 0 0 65 250 25 500 65 500 0"/></svg>
                                    }
                                    {(divide_bottom_4=='svg-3' ) &&
                                        <svg viewBox="0 0 500 81" height="100%" width="100%" preserveAspectRatio="none"><path d="M0,45.68C59,60,146,81.07,250,81c103-.07,192-19,250-35.32V0H0Z" transform="translate(0 0)"/></svg>
                                    }
                                    {(divide_bottom_4=='svg-4' ) &&
                                        <svg viewBox="0 0 500 46.42" height="100%" width="100%" preserveAspectRatio="none"><g><path d="M500,22.64s-194.23,1.13-213,5.44c-34.74,8-37,18.34-37,18.34s-2-11.25-30.5-18.24C198.56,23.05,0,22.64,0,22.64V0H500Z"/></g></svg>
                                    }
                                </div>
                            }
                            {(df_slider_chose_4=='df-slider-image-4' ) &&
                                <>
                                {imageUrl_4 ?
                                    <>
                                    <a href={bubiblock_link_slider_4} target={bubiblock_link_tab_slider_4} rel="noopener">
                                        <img src={imageUrl_4} alt={alt4} className={'img-cap image-slider-4'} style={{objectFit:df_cover_img4,objectPosition:df_focalPoint_img_4+'% '+df_focalPoint_y_img_4+'%'}} />
                                    {isBlobURL(imageUrl_4) && <Spinner />}
                                    {df_mask_slider_4 &&
                                        <div className={'mask'} style={{backgroundColor:background_color_solid_mask_4,background:background_color_gradient_mask_4,opacity:df_opacity_mask_4}}></div>
                                    }
                                    </a>
                                    </>
                                    :
                                    <div className={'df-upload-img'}></div>
                                }
                                </>
                            }
                            {(df_slider_chose_4=='df-slider-color-4') &&
                                <>
                                {df_background_color_slider_4 ?
                                    <div className={'df-slider-color bubiblock-color-slider-item'} style={{backgroundColor: df_background_color_slider_4}}></div>
                                    :
                                    <div className={'df-color-default-background-slider-2 bubiblock-color-slider-item'}></div>
                                }
                                </>
                            }
                            {(bubi_block_content_slider == 'bubiblock-content-slider') ==! (bubi_block_content_slider =='bubiblock-blockcontent-slider') &&
                                <div className={'carousel-caption caption-4'}>
                                    <div className={'bubiblock-slider-row'}>
                                        <div className={'bubiblock-col-md-8'}>
                                            <RichText
                                                className={ 'wp-block-bubiblock-slider-slider__title_4 '+df_repeat_effectcaption4+' '+df_delay_effectcaption4+' '+df_speed_effectcaption4+' '+effectcaption4 }
                                                tagName= "h4"
                                                style={{textAlign:alignment_title4,fontSize:fontsizetitle4+'px',bottom:margin_bottom_caption4+'px'}}
                                                onChange= { this.onChangeTitle4 }
                                                value= { title4 }
                                                placeholder= { __("Title", "bubiblock-slider") }
                                                allowedFormats={ [ 'core/code','core/image','core/strikethrough','core/underline','core/text-color','core/subscript','core/superscript' ] }
                                            />
                                            <RichText
                                                className={ 'bubiblock-p-capt wp-block-bubiblock-slider-slider__info_4 '+df_repeat_effectinfo4+' '+df_delay_effectinfo4+' '+df_speed_effectinfo4+' '+effectinfo4}
                                                tagName= "p"
                                                onChange= { this.onChangeInfo4 }
                                                value= { info4 }
                                                style={{textAlign:alignment_info4,fontSize:fontsizeinfo4+'px',bottom:margin_bottom_info4+'px'}}
                                                placeholder= { __("Info", "bubiblock-slider") }
                                                fotmattingControls= { [] }
                                                allowedFormats={ [ 'core/code','core/image','core/strikethrough','core/underline','core/text-color','core/subscript','core/superscript' ] }
                                            />
                                            <div className={'link-button-4 '+df_repeat_effectbutton4+' '+df_delay_effectbutton4+' '+df_speed_effectbutton4+' '+effectbutton4} style={{textAlign:alignment_button4,bottom:margin_bottom_button4+'px'}}>
                                                <button className={'button-slider4 '+df_background_color_transparent_link_button4} style={
                                                    {
                                                        paddingTop:padding_link_button4+'px',
                                                        paddingBottom:padding_link_button4+'px',
                                                        paddingLeft:padding_right_link_button4+'px',
                                                        paddingRight:padding_right_link_button4+'px',
                                                        borderTopLeftRadius: border_radius_top_left_link_button4+'px',
                                                        borderTopRightRadius: border_radius_top_right_link_button4+'px',
                                                        borderBottomLeftRadius: border_radius_bottom_left_link_button4+'px',
                                                        borderBottomRightRadius: border_radius_bottom_right_link_button4+'px',
                                                        border: border_size_link_button4+'px solid'+df_border_color_link_button4,
                                                        backgroundColor:df_background_color_link_button4,
                                                        background:df_background_color_link_button4,
                                                    }
                                                }
                                                >
                                                    <RichText
                                                        className={ 'wp-block-bubiblock-slider-slider__link_4' }
                                                        tagName= "p"
                                                        onChange= { this.onChangeButton4 }
                                                        value= { button4 }
                                                        placeholder= { __("Button", "bubiblock-slider") }
                                                        fotmattingControls= { [] }
                                                        style={{fontSize:fontsizebutton4+'px'}}
                                                        allowedFormats={ [ 'core/link', 'core/code','core/image','core/strikethrough','core/underline','core/subscript','core/superscript' ] }
                                                    />
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                        }
                       {bubiblock_add_slider_5 && // Slider 5
                        <div className={'carousel-item '+df_effect_slider}>
                            { df_enable_divide_5 &&
                                <div className={'df-divide-5'} style={{color:df_color_divide_5}}>
                                    {(divide_5=='svg-1' ) &&
                                        <svg className={'df-flip'} viewBox="0 0 1000 100" height="100%" width="100%" preserveAspectRatio="none"><path d="M1000,40c0,0 -120.077,-38.076 -250,-38c-129.923,0.076 -345.105,78 -500,78c-154.895,0 -250,-30 -250,-30l0,50l1000,0l0,-60Z"></path></svg>
                                    }
                                    {(divide_5=='svg-2' ) &&
                                        <svg viewBox="0 0 500 65" height="100%" width="100%" preserveAspectRatio="none"><polygon points="500 0 0 0 0 65 250 25 500 65 500 0"/></svg>
                                    }
                                    {(divide_5=='svg-3' ) &&
                                        <svg viewBox="0 0 500 81" height="100%" width="100%" preserveAspectRatio="none"><path d="M0,45.68C59,60,146,81.07,250,81c103-.07,192-19,250-35.32V0H0Z" transform="translate(0 0)"/></svg>
                                    }
                                    {(divide_5=='svg-4' ) &&
                                        <svg viewBox="0 0 500 46.42" height="100%" width="100%" preserveAspectRatio="none"><g><path d="M500,22.64s-194.23,1.13-213,5.44c-34.74,8-37,18.34-37,18.34s-2-11.25-30.5-18.24C198.56,23.05,0,22.64,0,22.64V0H500Z"/></g></svg>
                                    }
                                </div>
                            }
                            { df_enable_divide_bottom_5 &&
                                <div className={'df-divide-bottom-5'} style={{color:df_color_divide_bottom_5}}>
                                    {(divide_bottom_5=='svg-1' ) &&
                                        <svg className={'df-flip-bottom'} viewBox="0 0 1000 100" height="100%" width="100%" preserveAspectRatio="none"><path d="M1000,40c0,0 -120.077,-38.076 -250,-38c-129.923,0.076 -345.105,78 -500,78c-154.895,0 -250,-30 -250,-30l0,50l1000,0l0,-60Z"></path></svg>
                                    }
                                    {(divide_bottom_5=='svg-2' ) &&
                                        <svg viewBox="0 0 500 65" height="100%" width="100%" preserveAspectRatio="none"><polygon points="500 0 0 0 0 65 250 25 500 65 500 0"/></svg>
                                    }
                                    {(divide_bottom_5=='svg-3' ) &&
                                        <svg viewBox="0 0 500 81" height="100%" width="100%" preserveAspectRatio="none"><path d="M0,45.68C59,60,146,81.07,250,81c103-.07,192-19,250-35.32V0H0Z" transform="translate(0 0)"/></svg>
                                    }
                                    {(divide_bottom_5=='svg-4' ) &&
                                        <svg viewBox="0 0 500 46.42" height="100%" width="100%" preserveAspectRatio="none"><g><path d="M500,22.64s-194.23,1.13-213,5.44c-34.74,8-37,18.34-37,18.34s-2-11.25-30.5-18.24C198.56,23.05,0,22.64,0,22.64V0H500Z"/></g></svg>
                                    }
                                </div>
                            }
                            {(df_slider_chose_5=='df-slider-image-5' ) &&
                                <>
                                {imageUrl_5 ?
                                    <>
                                    <a href={bubiblock_link_slider_5} target={bubiblock_link_tab_slider_5} rel="noopener">
                                        <img src={imageUrl_5} alt={alt5} className={'img-cap image-slider-5'} style={{objectFit:df_cover_img5,objectPosition:df_focalPoint_img_5+'% '+df_focalPoint_y_img_5+'%'}} />
                                    {isBlobURL(imageUrl_5) && <Spinner />}
                                    {df_mask_slider_5 &&
                                        <div className={'mask'} style={{backgroundColor:background_color_solid_mask_5,background:background_color_gradient_mask_5,opacity:df_opacity_mask_5}}></div>
                                    }
                                    </a>
                                    </>
                                    :
                                    <div className={'df-upload-img'}></div>
                                }
                                </>
                            }
                            {(df_slider_chose_5=='df-slider-color-5') &&
                                <>
                                {df_background_color_slider_5 ?
                                    <div className={'df-slider-color bubiblock-color-slider-item'} style={{backgroundColor: df_background_color_slider_5}}></div>
                                    :
                                    <div className={'df-color-default-background-slider bubiblock-color-slider-item'}></div>
                                }
                                </>
                            }
                            {(bubi_block_content_slider == 'bubiblock-content-slider') ==! (bubi_block_content_slider =='bubiblock-blockcontent-slider') &&
                                <div className={'carousel-caption caption-5'}>
                                    <div className={'bubiblock-slider-row'}>
                                        <div className={'bubiblock-col-md-8'}>
                                            <RichText
                                                className={ 'wp-block-bubiblock-slider-slider__title_5 '+df_repeat_effectcaption5+' '+df_delay_effectcaption5+' '+df_speed_effectcaption5+' '+effectcaption5 }
                                                tagName= "h4"
                                                style={{textAlign:alignment_title5,fontSize:fontsizetitle5+'px',bottom:margin_bottom_caption5+'px'}}
                                                onChange= { this.onChangeTitle5 }
                                                value= { title5 }
                                                placeholder= { __("Title", "bubiblock-slider") }
                                                allowedFormats={ [ 'core/code','core/image','core/strikethrough','core/underline','core/text-color','core/subscript','core/superscript' ] }
                                            />
                                            <RichText
                                                className={ 'bubiblock-p-capt wp-block-bubiblock-slider-slider__info_5 '+df_repeat_effectinfo5+' '+df_delay_effectinfo5+' '+df_speed_effectinfo5+' '+effectinfo5}
                                                tagName= "p"
                                                onChange= { this.onChangeInfo5 }
                                                value= { info5 }
                                                style={{textAlign:alignment_info5,fontSize:fontsizeinfo5+'px',bottom:margin_bottom_info5+'px'}}
                                                placeholder= { __("Info", "bubiblock-slider") }
                                                fotmattingControls= { [] }
                                                allowedFormats={ [ 'core/code','core/image','core/strikethrough','core/underline','core/text-color','core/subscript','core/superscript' ] }
                                            />
                                            <div className={'link-button-5 '+df_repeat_effectbutton5+' '+df_delay_effectbutton5+' '+df_speed_effectbutton5+' '+effectbutton5} style={{textAlign:alignment_button5,bottom:margin_bottom_button5+'px'}}>
                                                <button className={'button-slider5 '+df_background_color_transparent_link_button5} style={
                                                    {
                                                        paddingTop:padding_link_button5+'px',
                                                        paddingBottom:padding_link_button5+'px',
                                                        paddingLeft:padding_right_link_button5+'px',
                                                        paddingRight:padding_right_link_button5+'px',
                                                        borderTopLeftRadius: border_radius_top_left_link_button5+'px',
                                                        borderTopRightRadius: border_radius_top_right_link_button5+'px',
                                                        borderBottomLeftRadius: border_radius_bottom_left_link_button5+'px',
                                                        borderBottomRightRadius: border_radius_bottom_right_link_button5+'px',
                                                        border: border_size_link_button5+'px solid'+df_border_color_link_button5,
                                                        backgroundColor:df_background_color_link_button5,
                                                        background:df_background_color_link_button5,
                                                    }
                                                }
                                                >
                                                    <RichText
                                                        className={ 'wp-block-bubiblock-slider-slider__link_5' }
                                                        tagName= "p"
                                                        onChange= { this.onChangeButton5 }
                                                        value= { button5 }
                                                        placeholder= { __("Button", "bubiblock-slider") }
                                                        fotmattingControls= { [] }
                                                        style={{fontSize:fontsizebutton5+'px'}}
                                                        allowedFormats={ [ 'core/link', 'core/code','core/image','core/strikethrough','core/underline','core/subscript','core/superscript' ] }
                                                    />
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                        }

                    </div>
                    <a className={'carousel-control-prev df-carousel-control-prev bubi-img-3 '+bubi_arrow_position+' '+df_arrow_slider+' '+df_arrow_slider_table+' '+df_arrow_slider_mobile} type="button" data-target={'#carouselDFControlslider'+bubiblock_id_slider} data-slide="prev" style={{left:bubi_marginarrow+'px',opacity:bubiopacityarrow}}>
                        <i className={'bubi-icon '+df_arrow_slider_type} style={{color:df_color_arrow,padding:df_padding_arrow,borderRadius:df_radius_arrow,fontSize:df_size_arrow}} aria-hidden="true"></i>
                    </a>
                    <a className={'carousel-control-next df-carousel-control-next bubi-img-3 '+bubi_arrow_position+' '+df_arrow_slider+' '+df_arrow_slider_table+' '+df_arrow_slider_mobile} type="button" data-target={'#carouselDFControlslider'+bubiblock_id_slider} data-slide="next" style={{right:bubi_marginarrow+'px',opacity:bubiopacityarrow}}>
                        <i className={'bubi-icon '+df_arrow_slider_type} style={{color:df_color_arrow,padding:df_padding_arrow,borderRadius:df_radius_arrow,fontSize:df_size_arrow}} aria-hidden="true"></i>
                    </a>
                </div>
            </>
        )
    }
}

export default withSelect(

    (select, props) => {
        const id = props.attributes.id;
        const id2 = props.attributes.id2;
        const id3 = props.attributes. id3;
        const id4 = props.attributes. id4;
        const id5 = props.attributes. id5;

    return {
        image: id ? select('core').getMedia(id) : null,
        image: id2 ? select('core').getMedia(id2) : null,
        image: id3 ? select('core').getMedia(id3) : null,
        image: id4 ? select('core').getMedia(id4) : null,
        image: id5 ? select('core').getMedia(id5) : null,
    }
    }
)(SliderEdit);
